/**
 * Created by kumardivyarajat on 11/09/17.
 */
(function () {
    "use strict";
    var deps = ["app.home", "app.main.search", "app.cart", "ngAnimate", "ngAria", "ngMaterial",
        "ngSanitize", "app.categories", "app.products", "app.profile", "app.feeds",
        "app.customisation", "app.checkout", "app.address", "app.account", "app.wishlist", "vcRecaptcha"]
    if(confData.env === 'prod') {
        deps.push('ngRaven');
    }

    angular
        .module("app.main", deps)
})();

(function () {
    'use strict';


    ProductDetails.$inject = ["AddressManager", "$mdToast", "$window"];
    angular.module('app.main')
        .directive('shippingBox', ProductDetails);


    function ProductDetails(AddressManager, $mdToast, $window) {
        return {
            restrict: "E",
            replace: true,
            scope: {
                product: "="
            },
            link: function (scope, element, attrs) {
                scope.delivery = {
                    pinCode: '',
                    servicable: false,
                    codAvailable: '',
                    returnsAvailable : '',
                    shippingDays: '',
                    deliveryDays: '',
                    fetched: false
                };
                scope.DELIVERY = 'delivery';

                scope.checkAvailability = checkAvailability;
                scope.pushPinCodeToLocalStorage = pushPinCodeToLocalStorage;
                scope.checkPinCodeInStorage = checkPinCodeInStorage;

                function checkPinCodeInStorage() {
                    var delivery = $window.localStorage.getItem(scope.DELIVERY) || JSON.stringify({
                        pinCode: '',
                        servicable: false,
                        codAvailable: '',
                        returnsAvailable : '',
                        shippingDays: '',
                        deliveryDays: '',
                        fetched: false
                    });

                    scope.delivery = JSON.parse(delivery);
                }

                function pushPinCodeToLocalStorage() {
                    console.log('Pushing delivery to localstorage : ', scope.delivery);
                    $window.localStorage.setItem(scope.DELIVERY, JSON.stringify(scope.delivery));
                }

                function checkAvailability() {
                    scope.delivery.fetched = false;
                    scope.checkingAvailability = true;
                    if (scope.delivery.pinCode && scope.delivery.pinCode.length === 6) {
                        AddressManager.checkCodAvailability(scope.delivery.pinCode)
                            .then(function (data) {
                                scope.checkingAvailability = false;
                                scope.delivery.fetched = true;
                                if (data) {
                                    scope.delivery.servicable = data.hasPrepaid;
                                    scope.delivery.codAvailable = data.hasCod;
                                    scope.delivery.returnsAvailable = data.hasReverse;
                                    // if (data.courierPartners.length === 0) {
                                    //     scope.delivery.servicable = false;
                                    //     scope.delivery.codAvailable = false;
                                    // } else {
                                    //     scope.delivery.codAvailable = false;
                                    //     _.forEach(data.courierPartners, function (cp) {
                                    //         if (cp.isCodAvailable) {
                                    //             scope.delivery.codAvailable = true;
                                    //         }
                                    //     })
                                    // }
                                } else {
                                    scope.delivery.servicable = false;
                                    scope.delivery.codAvailable = false;
                                    scope.delivery.returnsAvailable = false;
                                }
                                scope.pushPinCodeToLocalStorage();
                            })
                            .catch(function (err) {
                                scope.checkingAvailability = false;
                                scope.delivery.fetched = false;
                                scope.deliveryError = err.message || 'Some error occurred';
                                scope.delivery.servicable = false;
                                scope.delivery.codAvailable = false;
                                scope.delivery.returnsAvailable = false;
                            })
                    } else {
                        $mdToast.showSimple('Please enter a valid 6 digit pin code')
                    }


                }

                scope.checkPinCodeInStorage();
            },
            templateUrl: "app/modules/base/directives/product/shipping-box/shipping-box.html"
        }
    }



})(angular);

(function () {
    'use strict';

    ProductPrice.$inject = ["$mdToast", "WishListManager", "$analytics", "$mdMedia"];
    angular.module('app.main')
        .directive('productPrice', ProductPrice);


    function ProductPrice($mdToast, WishListManager, $analytics, $mdMedia) {
        return {
            restrict: "E",
            replace: true,
            scope: {
                product: "=",
                totalPrice : '='
            },
            link: function ($scope, element, attrs) {
                $scope.isSmall = !$mdMedia("gt-sm");

                if($scope.product && $scope.product.productType === 1) {
                    $scope.product.isOnSale = false;
                }

                $scope.calculateDiscount= calculateDiscount;


                function calculateDiscount(mrp, price) {
                    return Math.floor(((mrp - price) / mrp) * 100).toFixed(0);
                }

            },
            templateUrl: "app/modules/base/directives/product/product-price/product-price.html"
        }
    }

})(angular);

(function () {
    'use strict';

    ProductDetails.$inject = ["$mdToast", "WishListManager", "$analytics", "$mdMedia"];
    angular.module('app.main')
        .directive('productOverview', ProductDetails);


    function ProductDetails($mdToast, WishListManager, $analytics, $mdMedia) {
        return {
            restrict: "E",
            replace: true,
            scope: {
                product: "=",
                productLoaded : '=',
                totalPrice : '='
            },
            link: function ($scope, element, attrs) {
                $scope.isSmall = !$mdMedia("gt-sm");

                $scope.isAHotAttribute = isAHotAttribute;
                $scope.calculateDiscount= calculateDiscount;


                function calculateDiscount(mrp, price) {
                    return Math.floor(((mrp - price) / mrp) * 100).toFixed(0);
                }


                function isAHotAttribute(attribute) {
                    return /(?:Color|Fabric|Fit|Occasion|Size|Styling Tip)/.test(attribute.meta_key)
                }


            },
            templateUrl: "app/modules/base/directives/product/product-overview/product-overview.html"
        }
    }

})(angular);

(function () {
    'use strict';

    ProductDetails.$inject = ["$mdMedia", "Base"];
    angular.module('app.main')
        .directive('productDetails', ProductDetails);


    function ProductDetails($mdMedia, Base) {
        return {
            restrict: "E",
            replace: true,
            scope: {
                product: "="
            },
            link: function (scope, element, attrs) {
                scope.isSmall = !$mdMedia("gt-sm");
                scope.mediaUrl = Base.getMediaUrl();
                scope.$watch('product.attributes', function (newVal) {
                    if (newVal) {
                        scope.imageAttributes = scope.product.attributes
                            .filter(function (attributeData) {
                                return _.some(attributeData.selectedValues, function (value) {
                                    return value.image
                                });
                            })
                            .map(function (attributeData) {
                                attributeData.selectedValues = attributeData.selectedValues.filter(function (value) {
                                    return value.image;
                                });
                                return attributeData;
                            });
                        console.log('image', scope.imageAttributes);
                    }
                });


            },
            templateUrl: "app/modules/base/directives/product/product-details/product-details.html"
        }
    }

})(angular);

(function () {
    'use strict';

    angular.module('app.main')
        .directive('addToWishlistButton', ProductDetails);


    function ProductDetails() {
        return {
            restrict: "E",
            replace: true,
            scope: {
                product: "=",
                click: '&'
            },
            link: function (scope, element, attrs) {
                scope.wishlistClick = wishlistClick;

                function wishlistClick(event) {
                    console.log('Even', event);
                    scope.click(event)
                }
            },
            templateUrl: "app/modules/base/directives/product/add-to-wishlist-button/add-to-wishlist-button.html"
        }
    }

})(angular);

(function () {
    'use strict';
  voteProductController.$inject = ["$scope", "$mdDialog", "RestManager", "$mdToast", "product"];
  angular.module("app.main")
      .controller("voteProduct.controller", voteProductController);

  function voteProductController($scope, $mdDialog, RestManager, $mdToast, product){
      $scope.product = product;

      $scope.close = close;
      $scope.saveSuggestedPrice = saveSuggestedPrice;
      $scope.preOrder = preOrder;


      function close(){
          $mdDialog.cancel();
      }

      function saveSuggestedPrice(price){
          RestManager.patch('/collections', {suggestedPrice: price}, "collections")
              .then(function(response){
                  console.log("voteProduct.controller.js", "RESPONSE", response);
              })
              .catch(function (err) {
                  $mdToast.showSimple('Oops, Something went South. Please contact our Customer Care at 080-4152-1574');
              })

      }

      function preOrder(){
          $mdDialog.show({
              locals: {
                  product: product
              },
              templateUrl: 'app/modules/static/promotions/preOrderDialog/preOrderDialog.tmpl.html',
              controller: "preOrderDialog.controller",
              clickOutsideToClose: true,
              escapeToClose: true
          })
              .then(function(response){
                  $scope.localCollections[index].preOrder = true;
              });
      }
  }

})(angular);

(function () {
    'use strict';
    preOrderDialogController.$inject = ["$scope", "product", "$mdDialog", "RestManager"];
    angular.module("app.main")
        .controller("preOrderDialog.controller", preOrderDialogController);

    function preOrderDialogController($scope, product, $mdDialog, RestManager) {
        $scope.product = product;
        $scope.sizes = ['S', 'M', 'L', 'XL', 'XXL', 'XXXL']

            $scope.cancel = cancel;
        $scope.preOrder = preOrder;

        function cancel() {
            $mdDialog.cancel();
        }

        function preOrder(product) {
            // RestManager.patchResource("/collections", {product: product, preOrder: true}, "collections")
            //     .then(function(response){
            //         console.log("promotions.controller.js", "response", response);
            //         $mdDialog.hide({updatedData: response});
            //     })
            //     .catch(function(err){
            //         $mdToast.showSimple('Oops, Something went South. Please contact our Customer Care at 080-4152-1574');
            //         $mdDialog.cancel();
            //
            //     });

            $mdDialog.hide();
        }

        $scope.fetchProduct();

    }

})(angular);

(function () {
    "use strict";

    angular
        .module("app.home", [])

})(angular);

(function () {
    "use strict";
    InstagramSection.$inject = ["RestManager"];
    angular.module("app.home")
        .directive("instagramSection", InstagramSection);

    /** @ngInject **/
    function InstagramSection(RestManager) {
        return {
            restrict: "E",
            transclude: false,
            replace: false,
            scope: {
                onComplete: "&",
                onError: "&"
            },
            link: function ($scope, element, attrs) {
                $scope.instafeedFetched = false;

                $scope.fetchInstaFeed = function () {
                    $scope.instafeedFetched = false;
                    RestManager.getResource("/feeds/instagram", "feed")
                        .then(function (feed) {
                            $scope.instafeedFetched = true;
                            $scope.instafeed = feed;
                            $scope.onComplete();
                        })
                        .catch(function (err) {
                            $scope.instafeedFetched = true;

                            $scope.onError(err, "INSTAGRAM");
                        })
                };
                $scope.fetchInstaFeed();
            },
            templateUrl: "app/modules/home/directives/instagram/instagram.tmpl.html"
        }
    }
})(angular);

/**
 * Created by kumardivyarajat on 03/11/16.
 */

/**
 * Created by kumardivyarajat on 03/11/16.
 */

(function () {

    angular.module('app.main')
        .directive("whatsappButton", ['$state', '$window', '$rootScope', function ($state, $window, $rootScope) {
            return {
                restrict: 'AE',
                templateUrl: 'app/modules/base/directives/whatsapp-button/whatsapp-button.html',
                scope: {
                    message: "@",
                    shape: '@'
                },
                link: function (scope, element, attrs) {
                    scope.supportNumber = '918073429952';
                    scope.defaultHelpText = 'Hey. Can you help me?';
                    scope.iconSrc = 'assets/images/whatsapp.svg';

                    if (scope.shape === 'square') {
                        scope.iconSrc = 'assets/images/whatsapp-square.svg';
                    }
                    scope.compiledMessage = scope.message || scope.defaultHelpText;
                    scope.url = 'https://api.whatsapp.com/send?phone=' + scope.supportNumber + '&text=' + scope.compiledMessage;
                }
            }
        }]);
})();

(function () {
    'use strict';

    Testimonials.$inject = ["$mdMedia", "$window"];
    angular.module('app.main')
        .directive('aaridaTestimonials', Testimonials);

    function Testimonials($mdMedia, $window) {
        return {
            restrict: "E",
            transclude: true,
            replace: false,
            scope: {},
            link: function (scope, element, attrs) {

                scope.testimonials = [
                    {
                        'id' : 0,
                        'title': 'Annie',
                        'subtitle': 'Blue Wedding Gown',
                        'image': 'https://blog.aarida.com/content/images/2019/01/Happycustomer_Annie3.jpeg',
                        'description': '"I was introduced to Aarida by one of my friends at an engagement ceremony. I fell in love with the line and recognized the fabric quality, along with the fashionable style immediately."',
                        'link': 'https://blog.aarida.com/testimonial-happy-customer/'
                    },
                    {
                        'id' : 1,
                        'title': 'Amrita',
                        'subtitle': 'Customised Kurti',
                        'image': 'https://blog.aarida.com/content/images/2019/01/Happycustomer_Amrita-1.jpeg',
                        'description': "\"I am so in LOVE with my dress and have worn it multiple times. I don't think I've gotten so many compliments for a single dress so far. Honestly, couldn't rave more about this dress...\"",
                        'link': 'https://blog.aarida.com/testimonial-happy-customer/'
                    },
                    {
                        'id' : 2,
                        'title': 'Pooja',
                        'subtitle': 'Customised Kurti',
                        'image': 'https://blog.aarida.com/content/images/2019/02/aarida-customer.jpeg',
                        'description': '"Amazing! I love the fact that I can purchase a product online which matches all my expectations. No issues with fitting, styling or quality. Will definitely purchase from Aarida again."',
                        'productLink': 'https://www.aarida.com/product/green-kurti-with-blue-yoke-and-embroidery',
                        'link': 'https://blog.aarida.com/testimonial-happy-customer/'
                    }
                ];
                scope.selectedTestimonial = scope.testimonials[0];

                scope.selectTestimonial = selectTestimonial;

                function selectTestimonial(testimonial) {
                    scope.selectedTestimonial = testimonial;
                }


                scope.isSmall = !$mdMedia("gt-sm");
                scope.width = ($window.innerWidth <= 1440) ? $window.innerWidth : 1440;
                scope.containerWidth = scope.width;
                scope.totalWidth = scope.isSmall ? (scope.containerWidth * scope.testimonials.length) : ((scope.containerWidth * scope.testimonials.length) / 2)
                scope.style = {
                    width: scope.totalWidth + 'px',
                    overflow: 'hidden',
                    display: 'flex'
                }
                scope.selectedIndex = 0;


                scope.moveLeft = moveLeft;
                scope.moveRight = moveRight;
                scope.move = move;

                function moveRight() {
                    if (scope.selectedIndex !== (scope.testimonials.length - 1)) {
                        scope.selectedIndex = scope.selectedIndex + 1;
                    } else {
                        scope.selectedIndex = 0
                    }
                    scope.move();
                }

                function moveLeft() {
                    if (scope.selectedIndex !== 0) {
                        scope.selectedIndex = scope.selectedIndex - 1;
                    } else {
                        scope.selectedIndex = (scope.testimonials.length - 1)
                    }
                    scope.move();
                }

                function move() {
                    scope.selectedImage = scope.testimonials[scope.selectedIndex];
                    scope.moveX = -(scope.selectedIndex * scope.width);
                }

                console.log('Style', scope.style);
            },
            templateUrl: "app/modules/base/directives/testimonials/testimonials.tmpl.html"
        }
    }

})(angular);

(function () {
    'use strict';

    newArrivals.$inject = ["$mdMedia"];
    angular.module("app.main")
        .directive("newArrivals", newArrivals);

    function newArrivals($mdMedia) {
        return {
            restrict: "E",
            replace: true,
            scope: {

            },
            link: function (scope, element, attrs) {
                scope.isSmall = !$mdMedia("gt-sm");
            },
            templateUrl: "app/modules/base/directives/new-arrivals/index.html"
        }
    }

})(angular);

(function () {
    'use strict';

    angular.module("app.main")
        .directive("handEmbroideryBadge", customisationProcess);

    function customisationProcess() {
        return {
            restrict: "E",
            transclude: true,
            replace: true,
            scope: {
                id : "@"
            },
            link: function (scope, attrs, element) {
                scope.shown = false;

                var observer = '';
                if (typeof IntersectionObserver !== "undefined") {
                    observer = new IntersectionObserver(loadImg, {
                        rootMargin: '100px 0px 100px 0px',
                        root: document.querySelector('#body')
                    });
                    observer.observe(element.$$element[0]);
                } else {
                    showTag()
                }

                function loadImg(changes) {
                    changes.forEach(function (change) {
                        if (change.intersectionRatio > 0) {
                            showTag();
                            // observer.unobserve(element.$$element[0]);
                        }
                    })
                }

                function showTag() {
                    if (!scope.shown) {
                        scope.shown = true;
                        setTimeout(function () {
                            scope.shown = false;
                        }, 3000);
                    }
                }


                scope.$on('$destroy', function () {
                    observer.unobserve(element.$$element[0]);
                })


            },
            templateUrl: "app/modules/base/directives/hand-embroidery-badge/hand-embroidery.html"
        }
    }

})(angular);

(function () {
    'use strict';

    angular.module("app.main")
        .directive("customisationProcess", customisationProcess);

    function customisationProcess() {
        return {
            restrict: "E",
            transclude: true,
            replace: true,
            scope: {
                hideGetStarted: "=",
            },
            link: function (scope, attrs, element) {

                scope.highlight = function (data) {
                    data.hover = true;
                };

                scope.howCustomisationWorks = [
                    {
                        id: 0,
                        active: false,
                        subText: "Browse &",
                        headText: "SELECT",
                        text: "Pick the dress you'd like to customise and viola! It's half job done",
                        image: "assets/images/home/computer.svg"
                    },
                    {
                        id: 1,
                        active: false,
                        subText: "Customise your",
                        headText: "DESIGN",
                        text: "Choose your fit, fabric and design from our easy to select options",
                        image: "assets/images/home/light-bulb.svg",
                        image_init: "assets/images/home/light-bulb.svg"
                    },
                    {
                        id: 2,
                        active: false,
                        subText: "Make the",
                        headText: "PAYMENT",
                        text: "Add the design to the cart, select your delivery address and the payment option",
                        image: "assets/images/home/credit-card.svg"
                    },
                    {
                        id: 3,
                        active: false,
                        subText: "Quick home",
                        headText: "DELIVERY",
                        text: "Get ready to be delighted when your bespoke dress arrives at your doorstep",
                        image: "assets/images/home/route.svg"
                    }
                ];
            },
            templateUrl: "app/modules/base/directives/customisation-process/customisation-process.html"
        }
    }

})(angular);

(function () {
    'use strict';

    customisationNotification.$inject = ["$mdMedia"];
    angular.module("app.main")
        .directive("customisationNotification", customisationNotification);

    function customisationNotification($mdMedia) {
        return {
            restrict: "E",
            transclude: true,
            replace: false,
            scope: {
                hideNotificationSection: "=",
                hideMainSection: "="
            },
            link: function (scope, element, attrs) {
                scope.isSmall = !$mdMedia("gt-sm");
            },
            templateUrl: "app/modules/base/directives/customisation-notification/index.html"
        }
    }

})(angular);

(function () {
    'use strict';
    customMeasurement.$inject = ["$mdDialog", "CartManager", "$rootScope", "$window", "$mdToast", "Utils", "AuthManager", "$analytics", "FullStory"];
    angular.module('app.main')
        .directive('customMeasurement', customMeasurement);

    function customMeasurement($mdDialog, CartManager, $rootScope, $window, $mdToast, Utils, AuthManager, $analytics,
                               FullStory) {
        return {
            restrict: "E",
            replace: false,
            scope: {
                product: "=",
                hideMainSection: "=",
                ucData: "=",
                openEditView: "=",
                variations: "=",
                sizeChart: "=",
                selectedVariation: "=",
                customMeasurementData: "=",
                onAdded: '&',
                beforeAddToCartValidation : '&',
                validate : '=',
                returnData: '=',
                ctx:"="
            },
            link: function (scope, element, attrs) {
                scope.variations = scope.variations.map(function (o) {
                    o.measurements = {};
                    o.inCart = CartManager.checkProductInCart(scope.product._id, o._id);
                    return o;
                });
                scope.sizeObj = {};
                scope.savingData = false;
                scope.checkVariationInCart = CartManager.checkProductInCart;

                scope.heightList = ["4.6", "4.7", "4.8", "4.9", "4.10", "4.11", "5.0", "5.1", "5.2", "5.3", "5.4", "5.5", "5.6", "5.7", "5.8", "5.9", "5.10", "5.11", "6.0", "6.1", "6.2", "6.3", "6.4", "6.5", "6.6", "6.7", "6.8", "6.9", "6.10", "6.11"];

                scope.getVariationValue = getVariationValue;
                scope.findvalue = findValue;
                scope.transform = transform;
                scope.reorderSizes = reorderSizes;
                scope.addToCart = addToCart;
                scope.sizePriority = Utils.getSizePriority;

                function reorderSizes() {
                    if (scope.variations.length && scope.variations[0].attributes && scope.variations[0].attributes.length && scope.variations[0].attributes.length > 0)
                        scope.variations = _.sortBy(scope.variations, [function (o) {
                            return scope.sizePriority[scope.getVariationValue(o)];
                        }]);
                }


                function getVariationValue(variation) {
                    if (variation.attributes && variation.attributes.length) {
                        var varId = variation.attributes[0].selectedValue[0];
                        var a = _.find(variation.attributes[0].attribute.meta_values, function (meta_value) {
                            return meta_value._id === varId;
                        });
                        if (a) {
                            return a.value;
                        } else {
                            return 'FS';
                        }
                    } else {
                        return 'FS';
                    }
                }


                function findValue(size, index, parent, key) {
                    try {
                        return size.values[parent].value ? size.values[parent].value : 0;
                    } catch (err) {
                        return 0;
                    }
                }

                function transform() {
                    var sizes = [];

                    if (scope.sizeChart) {
                        scope.sizeChart.values.values.charts[0].values.forEach(function (chart) {
                            sizes.push(chart.key);
                        });
                        var sizeObj = {};
                        sizes.forEach(function (value) {
                            sizeObj[value] = [];
                            scope.sizeChart.values.values.charts.forEach(function (chart) {
                                chart.values.forEach(function (sizeValue) {
                                    if (sizeValue.key === value) {
                                        var currentSizeObj = {
                                            key: chart.key,
                                            value: sizeValue.value
                                        };
                                        sizeObj[value].push(currentSizeObj);
                                    }
                                });
                            });
                        });
                        scope.sizeObj = sizeObj;
                        scope.variations = scope.variations.map(function (o) {
                            scope.sizeObj[scope.getVariationValue(o)].forEach(function (sizeVal) {
                                o.measurements[sizeVal.key] = sizeVal.value;
                            });
                            o.openEditView = !!scope.openEditView;
                            return o;
                        });

                        // console.log('Variations', scope.variations);

                        // if (!scope.selectedVariation) {
                        //     console.log('Size', scope.variations[1]._id);
                        //     scope.selectedVariation = scope.variations[0]._id;
                        // }
                    }
                }

                function addToCart(variation) {
                    console.log('Uc', scope.ucData, scope.beforeAddToCartValidation);
                    // if (scope.product.productType === 1 && !AuthManager.isUserLoggedIn) {
                    //     AuthManager.showLoginModal(null, scope, true);
                    //     $window.localStorage.setItem(scope.product._id, JSON.stringify(scope.product.customisation.data));
                    //     scope.selectedVariation = variation;
                    //     return;
                    // }

                    if(scope.validate && !scope.beforeAddToCartValidation({data : {product : scope.product}})) {
                        return
                    }

                    if (scope.returnData) {
                        console.log('Product before sending data back', scope.product);
                        scope.onAdded({data: {product: scope.product, variation: variation}})
                    } else {
                        scope.savingData = true;
                        console.log("custom-measurement.directive.js", "addToCart", scope.ctx);
                        CartManager.addToCart(scope.product, variation, 1, scope.ucData, scope.ctx)
                            .then(function (result) {
                                scope.savingData = false;
                                $analytics.eventTrack(
                                    "Added to Cart",
                                    {
                                        product: scope.product.name,
                                        productType: scope.product.productType,
                                        id: scope.product._id,
                                        sku: scope.product.sku
                                    }
                                );
                                FullStory.trackEvent('AddToCart', {
                                    value: scope.product.price,
                                    currency: 'INR',
                                    content_ids: [scope.product.sku],
                                    content_name: scope.product.name,
                                    content_category: scope.product.categoriesText,
                                    contents: [
                                        {
                                            id: scope.product.sku,
                                            quantity: 1,
                                            item_price: scope.product.price
                                        }
                                    ],
                                    content_type: 'product',
                                    product_type: scope.product.productType ? 'Customisable' : 'Simple',
                                    editor_type: scope.product.editorType,
                                    variation: scope.selectedVariation
                                });
                                $analytics.eventTrack(
                                    'AddToCart',
                                    {
                                        value: scope.product.price,
                                        currency: 'INR',
                                        content_ids: [scope.product.sku],
                                        content_name: scope.product.name,
                                        content_category: scope.product.categoriesText,
                                        contents: [
                                            {
                                                id: scope.product.sku,
                                                quantity: 1,
                                                item_price: scope.product.price
                                            }
                                        ],
                                        content_type: 'product',
                                        product_type: scope.product.productType ? 'Customisable' : 'Simple',
                                        editor_type: scope.product.editorType,
                                        variation: scope.selectedVariation
                                    }
                                );
                                scope.onAdded({data: {saved: true}})
                            })
                            .catch(function (err) {
                                scope.savingData = false;
                                if (err && err.code === 461) {
                                    $mdToast.show(
                                        $mdToast.simple({
                                            hideDelay: 3000,
                                            position: 'bottom left',
                                            content: "Product Already in Cart"
                                        })
                                    );
                                    scope.onAdded({data: {saved: true}});
                                }
                            });
                    }

                }

                $rootScope.$on('loggedIn', function (event) {
                    // if (scope.selectedVariation) {
                    //     scope.addToCart(scope.selectedVariation);
                    // }
                });


                scope.$on('$destroy', function () {

                });

                scope.transform();
                scope.reorderSizes();
            },
            templateUrl: "app/modules/base/directives/customisation-measurement/custom-measurement-directive.tpl.html"
        }
    }

})(angular);

(function () {
    'use strict';

    customisationNotification.$inject = ["$mdMedia", "RestManager"];
    angular.module("app.main")
        .directive("customisableProductCard", customisationNotification);

    function customisationNotification($mdMedia, RestManager) {
        return {
            restrict: "E",
            transclude: true,
            replace: true,
            scope: {
                product: '=?',
                slug: '@',
                sku: '@',
                onMainButtonClick: '&'
            },
            link: function (scope, element, attrs) {
                scope.isSmall = !$mdMedia("gt-sm");

                scope.init = init;

                function init() {
                    if (scope.product) {
                        var availableOptions = scope.product.cachedCustomisationOptions.reduce(function (acc, layer) {
                            return acc + layer.key + ', '
                        }, '');
                        scope.product.availableOptions = availableOptions.replace(/,([^,]*)$/, '$1')
                    } else if (scope.sku) {
                        RestManager.getResource("/products/category/all", "products", {
                            query: {
                                page: 1,
                                limit: 1,
                                skus: scope.sku,
                                sort: 'createdAt'
                            }
                        })
                            .then(function (product) {
                                scope.product = product[0];
                                var availableOptions = scope.product.cachedCustomisationOptions.reduce(function (acc, layer) {
                                    return acc + layer.key + ', '
                                }, '');
                                scope.product.availableOptions = availableOptions.replace(/,([^,]*)$/, '$1')
                            })
                            .catch(function (err) {
                                throw new Error('Product not found');
                            })
                    } else {
                        throw new Error('Config error. One of product or sku is required');
                    }
                }

                scope.onNavigate = function () {
                    scope.onMainButtonClick()
                };

                scope.init();
            },
            templateUrl: "app/modules/base/directives/customisable-product-card/customisable-product-card.html"
        }
    }

})(angular);

(function () {
    'use strict';

    newArrivals.$inject = ["$mdMedia", "$interval"];
    angular.module("app.main")
        .directive("countdownTimer", newArrivals);

    function newArrivals($mdMedia, $interval) {
        return {
            restrict: "E",
            replace: true,
            scope: {
                endDate: '@',
                titleText : '@'
            },
            link: function (scope, element, attrs) {
                try {
                    scope.isSmall = !$mdMedia("gt-sm");
                    if (!scope.endDate || !moment(scope.endDate).isValid()) {
                        scope.endDate = '2020-01-15T18:30:00.000Z';
                    }
                    if(!scope.titleText) {
                        scope.titleText = 'Offer Expires In: '
                    }
                    scope.showTimer = moment().isBefore(moment(scope.endDate));
                    scope.oldDuration = null;
                    scope.init = init;
                    scope.invalidate = invalidate;
                    scope.update = update;
                    scope.id = null;

                    function invalidate(elem, value) {
                        var that = this,
                            $top = elem.querySelector('.top'),
                            $bottom = elem.querySelector('.bottom'),
                            $back_top = elem.querySelector('.top-back'),
                            $back_bottom = elem.querySelector('.bottom-back');

                        // Before we begin, change the back value
                        $back_top.querySelector('span').innerHTML = value;

                        // Also change the back bottom value
                        $back_bottom.querySelector('span').innerHTML = value;

                        TweenMax.to($top, 0.8, {
                            rotationX: '-180deg',
                            transformPerspective: 300,
                            ease: Quart.easeOut,
                            onComplete: function () {

                                $top.innerHTML = (value);

                                $bottom.innerHTML = (value);

                                TweenMax.set($top, {rotationX: 0});
                            }
                        });

                        TweenMax.to($back_top, 0.8, {
                            rotationX: 0,
                            transformPerspective: 300,
                            ease: Quart.easeOut,
                            clearProps: 'all'
                        });
                    }

                    function calculateRemaining() {
                        var start_date = moment();
                        var end_date = moment(scope.endDate);
                        var duration = moment.duration(end_date.diff(start_date));
                        var milDuration = moment.utc(duration.asMilliseconds());
                        return {
                            hours: Math.floor(duration.asHours()).toString().padStart(2, '0'),
                            days : moment(scope.endDate).diff(moment(), 'days').toString().padStart(2, '0'),
                            min: milDuration.format('mm'),
                            sec: milDuration.format('ss'),
                        };
                    }


                    function init() {
                        // var duration = calculateRemaining();
                        // scope.update(duration);
                        scope.interval = $interval(function () {
                            var duration = calculateRemaining();
                            scope.update(duration)
                        }, 1000);
                        scope.id = scope.interval.$$intervalId;
                    }

                    function update(duration) {
                        if(duration.days !== '00') {
                            document.querySelectorAll('.days').forEach(function (node) {
                                node.style.display = 'block'
                            });
                            document.querySelectorAll('.sec').forEach(function (node) {
                                node.style.display = 'none';
                            });
                        } else {
                            document.querySelectorAll('.days').forEach(function (node) {
                                node.style.display = 'none';
                            });
                            document.querySelectorAll('.sec').forEach(function (node) {
                                node.style.display = 'block';
                            });
                        }
                        ['days','hours', 'min', 'sec'].forEach(function (selector) {
                            var newValue = duration[selector];
                            var oldValue = scope.oldDuration ? scope.oldDuration[selector] : null;
                            var newNumericals = newValue.split("");
                            var oldNumericals = oldValue ? oldValue.split("") : [null, null];

                            if (newNumericals[0] !== oldNumericals[0]) {
                                scope.invalidate(document.querySelector('#timer-' + scope.id + ' .' + selector + '-1'), newNumericals[0]);
                            }
                            if (newNumericals[1] !== oldNumericals[1]) {
                                scope.invalidate(document.querySelector('#timer-' + scope.id + ' .' + selector + '-2'), newNumericals[1]);
                            }

                        });
                        scope.oldDuration = duration;
                    }

                    scope.$on('$destroy', function () {
                        $interval.cancel(scope.interval);
                        console.log("count-down-timer.js", "cancelling");
                    });

                    if (scope.showTimer) {
                        scope.init();
                    }
                } catch (e) {
                    console.log("count-down-timer.js", "link", e);
                }

            },
            templateUrl: "app/modules/base/directives/count-down-timer/count-down-timer.html"
        }
    }

})(angular);

(function () {
    'use strict';

    angular.module('app.main')
        .directive('bubbleLoader', bubbleLoader);

    function bubbleLoader() {
        return {
            restrict: "E",
            replace : true,
            scope: {

            },
            link: function (scope, attrs, element) {
            },
            templateUrl: "app/modules/base/directives/bubble-loader/bubble-loader.html"
        }
    }
})(angular);

(function () {

    angular.module('app.main')
        .directive("backButton", ['$state', '$window', '$rootScope', function ($state, $window, $rootScope) {
            return {
                restrict: 'AE',
                templateUrl: 'app/modules/base/directives/back-button/back-button.directive.tpl.html',
                link: function (scope, element, attrs) {
                    scope.goBack = goBack;

                    function goBack() {
                        if ($rootScope.navigated) {
                            $window.history.back();
                        } else {
                            $state.go('app.home');
                        }
                    }
                }
            }
        }]);
})();

(function () {
    'use strict';

    angular.module('app.account.quotations', []);

})(angular);

(function () {
    'use strict';

    QuotationDetails.$inject = ["$scope", "$stateParams", "RestManager", "$analytics", "$rootScope", "Utils", "$mdToast", "$mdDialog", "$window"];
    angular.module('app.account.quotations')
        .controller('quotations.details.controller', QuotationDetails);

    function QuotationDetails($scope, $stateParams, RestManager, $analytics, $rootScope, Utils,
                              $mdToast, $mdDialog, $window) {

        $scope.loading = true;
        $scope.quotation = null;
        $scope.invalidSlug = false;
        $scope.dateAgo = Utils.dateAgo;
        $scope.message = null;
        $scope.reasons = [
            'Already purchased a product',
            'Made a request by mistake',
            "I don't have time",
            "I don't like the designs",
            "Others"
        ];

        $scope.fetchQuotationDetails = fetchQuotationDetails;
        $scope.publishComment = publishComment;
        $scope.openImages = openImages;
        $scope.cancelQuotationDialog = cancelQuotationDialog;
        $scope.cancelQuotation = cancelQuotation;
        $scope.close = close;

        function fetchQuotationDetails() {
            $scope.loading = true;
            $scope.error = null;
            RestManager.getResource('/quotations/' + $stateParams.slug, 'quotations')
                .then(function (quotations) {
                    $scope.quotation = quotations[0];
                    if (!$scope.quotation.notes) {
                        $scope.quotation.notes = [];
                    }
                    if(!$scope.quotation.gallery) {
                        $scope.quotation.gallery = [];
                    }
                    $scope.loading = false;
                    try {
                        $rootScope.pageMeta = {
                            title: $scope.quotation.quotationNumber + ' | View Quotation Details on Aarida',
                            description: "Buy customisable products"
                            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
                        };
                        $analytics.eventTrack('QuotationDetail', {
                            page: '/account/quotation/' + $stateParams.slug,
                            orderNumber: $scope.quotation.quotationNumber
                        });
                    } catch (e) {

                    }

                })
                .catch(function (error) {
                    $scope.loading = false;
                    $scope.error = error.message;
                    if (error.code === 403) {
                        $scope.unauthorized = true;
                    }
                })
        }

        function openImages(event, images) {
            $mdToast.showSimple('Support for image gallery is coming very soon. Thank you for your patience.')
        }

        function publishComment() {
            if ($scope.message) {
                $scope.publishingNote = true;

                var data = {
                    comment: $scope.message,
                    date: new Date(),
                    by: $scope.currentUser._id,
                    byName: $scope.currentUser.name,
                    saving: true
                };

                var index = $scope.quotation.notes.length;

                $scope.quotation.notes.push(data);

                RestManager.patchResource('/quotations/comment/' + $scope.quotation._id, data, 'quotations')
                    .then(function (quotations) {
                        $scope.quotation.notes[index].saving = false;
                        $scope.message = null;
                    })
                    .catch(function (err) {
                        $scope.order.notes[index].error = true;
                    });
            }

        }

        function close() {
            $mdDialog.cancel();
        }

        function cancelQuotationDialog(ev) {
            var confirm = {
                clickOutsideToClose: true,
                targetEvent: ev,
                scope: $scope,
                preserveScope: true,
                contentElement: '#cancel-quotation-dialog',
                fullscreen: true,
                parent: angular.element(document.body)
            };

            $mdDialog.show(confirm)
        }

        function cancelQuotation() {
            $scope.cancelling = true;
            var reason = $scope.cancelReason;
            if ($scope.cancelReason === 'Others') {
                reason += " - " + $scope.otherReason;
            }
            var status = "";


            $scope.promise = RestManager.patchResource("/quotations/status/" + $scope.quotation._id, {
                status: 'cancelled',
                reason: reason
            }, "quotations");
            $scope.promise
                .then(function (quotations) {
                    var quotation = quotations[0];
                    $scope.quotation.status = quotation.status;
                    $scope.quotation.notes = quotation.notes;
                    $scope.cancelling = false;
                    return $mdDialog.show(
                        $mdDialog.alert({
                            theme : 'black',
                            textContent: 'You quotation has been cancelled. If you have any requirements in the future, please request a quotation again or reach out to us. We would love to help you in picking your dress.',
                            title: 'Quotation Cancelled',
                            ok: 'Close'
                        })
                    )
                })
                .then(function () {

                })
                .catch(function (err) {
                    $scope.cancelling = false;
                    $mdToast.showSimple('Error cancelling the quotation : ' + err.message);
                })
        }

        if ($stateParams.slug) {
            $scope.fetchQuotationDetails();
        } else {
            $scope.invalidSlug = true;
        }
    }

})(angular);

(function () {
    'use strict';

    QuotationsController.$inject = ["$scope", "RestManager", "$rootScope", "$mdToast", "$analytics"];
    angular.module('app.account.quotations')
        .controller('quotations.controller', QuotationsController);


    function QuotationsController($scope, RestManager, $rootScope, $mdToast, $analytics) {
        $scope.quotationsLoading = true;
        $scope.query = {
            page: 1,
            limit: 10,
            sort: '-createdAt',
            status: 'created,processing,requested,completed'
        };
        $scope.init = init;
        $scope.fetchQuotations = fetchQuotations;

        function init() {
            $rootScope.pageMeta = {
                title: "All Quotations | Aarida - Customisable Clothing Store",
                description: "Buy customisable products",
                // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
            };

            $analytics.pageTrack('/account/quotations');
            $analytics.eventTrack('All Quotations', {page: "/account/quotations"});
        }

        function fetchQuotations() {
            $scope.quotationsLoading = true;
            RestManager.getResource('/quotations/me', 'quotations', {query: $scope.query})
                .then(function (quotations) {
                    $scope.quotationsLoading = false;
                    $scope.quotations = quotations;
                })
                .catch(function (error) {
                    $scope.quotationsLoading = false;

                })

        }

        $scope.init();
        $scope.fetchQuotations();

    }

})(angular);

/**
 * Created by kumardivyarajat on 16/11/16.
 */
angular.module("app.account.orders", [])
    .controller("orders.controller", ["$scope", "$analytics", "$rootScope", "OrdersManager", "$timeout", "RestManager", "$mdDialog", "$mdToast", "Utils", function ($scope, $analytics, $rootScope, OrdersManager, $timeout, RestManager, $mdDialog, $mdToast, Utils) {
        $scope.$parent.currentNavItem = "orders";
        $scope.$parent.currentActiveTitle = "My Orders";

        $scope.ordersLoaded = false;

        $rootScope.pageMeta = {
            title: "Orders",
            description: "Buy customisable products",
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };

        $analytics.pageTrack('/account/orders');
        $analytics.eventTrack('All Orders', {page: "/account/orders"});


        $scope.trackOrder = function (order, ev) {
            $scope.order = order;
            $scope.trackingData = {};
            $mdToast.show({
                hideDelay: 100000,
                position: 'bottom right',
                template: '<md-toast class="md-accent"><md-progress-circular md-mode="indeterminate" class="md-warn" md-diameter="20"></md-progress-circular> <span class="md-toast-text white-text" flex>Fetching Tracking Data</span> </md-toast>'
            });
            $scope.fetchingTracking = true;
            RestManager.getResource("/order/track/" + order.orderNumber, "tracking")
                .then(function (result) {
                    $scope.fetchingTracking = false;
                    $mdToast.hide();
                    $mdDialog.show({
                        scope: $scope,
                        preserveScope: true,
                        templateUrl: 'app/modules/account/orders/partials/trackingDialog.html',
                        parent: angular.element(document.body),
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        fullscreen: true
                    });
                    $analytics.eventTrack('Tracking Order', {orderNumber: $scope.order.orderNumber});
                    $scope.trackingData = result[0];

                })
                .catch(function (err) {
                    $mdToast.hide()
                        .then(function () {
                            $mdToast.showSimple("Error : " + err.message);
                        });
                    $scope.fetchingTracking = false;
                });

        };

        $scope.page = 0;
        $scope.count = 10;
        $scope.limit = 10;
        $scope.orders = [];

        $scope.fetchOrders = function () {
            $scope.page++;
            $scope.fetchingOrders = true;
            OrdersManager.fetchAllOrders($scope.count, $scope.limit, $scope.page)
                .then(function (result) {

                    $scope.fetchingOrders = false;
                    $scope.orders = $scope.orders.concat(result.orders);
                    $scope.totalOrders = result.total;
                    $timeout(function () {
                        $scope.ordersLoaded = true;
                    }, 500);
                })
                .catch(function (err) {
                    //

                })
        };

        $scope.fetchOrders();

        $scope.getVariation = function (product) {
            return Utils.getSelectedVariationFromCartProduct(product);
        };

        $scope.properName = function (string) {
            return Utils.getProperName(string);
        }

    }]);

(function () {
    'use strict';

    angular.module('app.account.orders')
        .service('ReviewService', reviewService);

    function reviewService() {

        function Rating(data) {
            this.key = data.key;
            this.value = data.value;
        }

        function Review(data) {
            this.ratings = data.ratings.map(function (r) {
                return new Rating(r);
            });
            this.lineItem = this.cleanProductData(data.lineItem);
            this.comment = data.comment;
            this.order = data.orderId;
            this.savingData = false;
            this.saveError = null;
            this.showOverlay = false;
            this.showThankyouPage = false;
            this.showTransition = false;
        }


        Review.prototype.cleanProductData = function (p) {
            var lineItem = p.product ? p.product : p;
            return {
                productId: lineItem.productId,
                _id : lineItem._id,
                originalIndex : lineItem.originalIndex,
                name: lineItem.name,
                isReviewDone : lineItem.reviews.isReviewDone,
                reviewPoints : lineItem.reviews.reviewPoints,
                price: lineItem.price,
                image: lineItem.image ? lineItem.image.urls.thumbnail: null,
                isCustomisable: lineItem.isCustomisable
            };
        };


        Review.prototype.json = function () {
            return {
                product: this.lineItem.isCustomisable ? null : this.lineItem.productId,
                lineItem : this.lineItem._id,
                comment: this.comment,
                order: this.order,
                ratings: this.ratings.map(function (r) {
                    return {
                        key: r.key,
                        value: r.value
                    };
                })
            };
        };


        var types = {
            Review: Review,
            Rating: Rating
        };


        return {
            types: types
        };
    }

})(angular);

/**
 * Created by kumardivyarajat on 16/11/16.
 */
angular.module("app.account.orders")
    .service("OrdersManager", ["$http", "$q", "$timeout", "Base", "AuthManager", "AddressManager", "ErrorHero", function ($http, $q, $timeout, Base, AuthManager, AddressManager, ErrorHero) {

        this.fetchSingleOrder = function (orderNumber) {
            return $q(function (resolve, reject) {
                $http.get(Base.getBaseUrl() + "/order/single/" + orderNumber)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            resolve(response.data.message.orders[0]);
                        } else {
                            reject(ErrorHero(response));
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };

        this.fetchAllOrders = function (count, limit, page) {
            return $q(function (resolve, reject) {
                $http.get(Base.getBaseUrl() + "/order?count=" + count + "&limit=" + limit + "&page=" + page)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            resolve({orders: response.data.message.orders, total: response.data.total});
                        } else {
                            reject(ErrorHero(response));
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };
    }]);
/**
 *Created by abhinav on 25/01/19.
 */

angular.module("app.account.orders")

    .directive('starRating', function () {
        return {
            restrict: 'AEC',
            templateUrl: 'app/modules/account/orders/directives/template/star-rating.html',
            scope: {
                ratingValue: '=',
                onRatingSelected: '&'
            },
            link: function (scope, elem, attrs) {

                scope.ratingValue = 1;
                scope.max = 5;
                scope.stars = [{filled: true}, {filled: false}, {filled: false}, {filled: false}, {filled: false}];

                var updateStars = function () {
                    scope.stars.forEach(function (star, index) {
                        scope.stars[index].filled = (index + 1) <= scope.ratingValue;
                    });
                };

                scope.toggle = function (index) {
                    scope.ratingValue = index + 1;
                    console.log(scope.ratingValue, "Hhhhhhhhhhh---------------")
                    updateStars()
                    scope.onRatingSelected({
                        data: {
                            rating: scope.ratingValue
                        }
                    });
                };

                scope.$watch('ratingValue', function (oldVal, newVal) {
                    if (newVal) {
                        updateStars();
                    }
                });
            },
        };
    });


/**
 * Created by kumardivyarajat on 17/11/16.
 */
angular.module("app.account.orders")
    .controller("thankyou.controller", ["$scope", "$analytics", "$rootScope", "order", "Utils", "OrdersManager", "CartManager", "Base", "FullStory", function ($scope, $analytics, $rootScope, order, Utils, OrdersManager, CartManager, Base, FullStory) {
        //
        $scope.order = order;
        $scope.$parent.currentActiveTitle = "Thank You";

        $rootScope.pageMeta = {
            title: "Order Placed - " + order.orderNumber,
            description: "Buy customisable products",
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };

        <!-- Event snippet for Website Purchase conversion page -->
        if (Base.getEnv() === 'prod') {
            if (typeof gtag !== "undefined") {
                gtag('event', 'conversion', {
                    'send_to': 'AW-768054061/i0l4COWD6aIBEK2mnu4C',
                    'transaction_id': $scope.order.orderNumber
                });
            }
            var contents = $scope.order.orderData.products.map(function (productData) {
                return {
                    id: productData.product.sku,
                    item_price: productData.totalPrice,
                    quantity: productData.quantity,
                    name: productData.product.name
                }
            });
            $analytics.pageTrack('/account/orders/success' + $scope.order.orderNumber);
            $analytics.eventTrack('Purchase', {
                orderNumber: $scope.order.orderNumber,
                value: $scope.order.orderData.amount,
                currency: 'INR',
                contents: contents,
                content_type: 'product'
            });
            FullStory.trackEvent('Purchase', {
                orderNumber: $scope.order.orderNumber,
                value: $scope.order.orderData.amount,
                currency: 'INR',
                contents: contents,
                content_type: 'product'
            });
        }


        CartManager.getUserCart(true)
            .then(function (cart) {

            })
            .catch(function (err) {

            });

        $scope.getProperName = function (str) {
            return _.startCase(_.toLower(str));
        };

        $scope.capitalize = function (cannotUse) {
            return _.startCase(_.camelCase(cannotUse));
        };

        $scope.getPmString = function (value) {
            return Utils.getPaymentOption(value);
        }
    }]);

(function () {
    'use strict';

    reviewController.$inject = ["$scope", "order", "lineItem", "index", "$mdDialog", "Base", "$mdToast", "ReviewService", "RestManager", "FullStory", "$timeout"];
    angular.module("app.account.orders")
        .controller("orders.review.dialog.controller", reviewController)

    function reviewController($scope, order, lineItem, index, $mdDialog, Base, $mdToast, ReviewService, RestManager, FullStory, $timeout) {
        // $scope.order = order;
        // if ($scope.order.hasCustOptions) {
        //     product = products.filter(function (productData) {
        //         return !productData.categories.includes('Customisation options');
        //     })
        //     products.push({
        //         product: {
        //             featured_image: {
        //                 urls: {
        //                     thumbnail: ''
        //                 }
        //             },
        //             name: "Customised Product From Store",
        //             _id: 12,
        //             isCustomisable: true
        //         }
        //     });
        // }

        console.log("review.dialog.controller.js", "reviewController", order, index);
        $scope.savingReview = false;
        // $scope.showOnlyWhileSavingReview =  false;
        $scope.order = order;

        $scope.close = close;

        function close() {
            $scope.goBack();
        }

        $scope.lineItems = order.lineItems.filter(function (product) {
            return !product.reviews.isReviewDone;
        });

        $scope.reviews = $scope.lineItems.map(function (p) {
            return new ReviewService.types.Review({
                productId: p.productId,
                lineItem: p,
                ratings: [{key: 'product_review', value: 1}],
                orderId: order._id,
                comment: null,
            });
        });
        $scope.allProductReviewed = false;
        $scope.trackingIndex = index;
        $scope.index = 0;
        $scope.allProductsReviewed = false;
        $scope.mediaUrl = Base.getMediaUrl();
        $scope.reviewedProductslist = [];


        // 1. Get template to render the lineItem clicked, set $scope.review = lineItem

        var productTobeReviewedIndex = _.findIndex($scope.reviews, function (review) {
            console.log("review.dialog.controller.js", "review.lineItem.originalIndex === index", review.lineItem._id, lineItem._id, review.lineItem._id === lineItem._id);
            return typeof index === 'undefined' ? review.lineItem._id === lineItem._id : review.lineItem.originalIndex === index;
        });
        if (productTobeReviewedIndex !== -1) {
            $scope.index = productTobeReviewedIndex;
        }

        $scope.review = $scope.reviews[$scope.index];

        console.log("review.dialog.controller.js", "reviewController", $scope.reviews, productTobeReviewedIndex, $scope.index);
        $scope.goBack = function () {
            if ($scope.reviewedProductslist.length) {
                $mdDialog.hide({updatedData: $scope.reviewedProductslist});
            } else {
                $mdDialog.cancel();
            }
        }

        $scope.changeProduct = function (index) {
            $scope.review.showTransition = true;
            $timeout(function () {
                if ($scope.trackingIndex === 0) {
                    $scope.trackingIndex += 2;
                } else {
                    $scope.trackingIndex += 1;
                }
                $scope.index = index;
                $scope.review = $scope.reviews[index];
                $scope.review.ratings[0].value = 1;
            }, 350);
        }

        $scope.updateRating = function (data) {
            $scope.review.ratings[0].value = data.rating;
        }

        $scope.saveReview = function (ev) {
            // $scope.showOnlyWhileSavingReview = true;
            $scope.savingReview = true;
            $scope.review.showOverlay = true;
            $scope.review.savingData = true;

            var reviewPoints;
            console.log("review.dialog.controller.js", "saveReview", $scope.review.json());

            RestManager.postResource('/review', $scope.review.json(), 'review', {service: 'reviews'})
                .then(function (data) {
                    $scope.savingReview = false;
                    reviewPoints = data[0].reviewPoints;
                    return !!data.length;
                })
                .then(function (data) {
                    if (data === false) {
                        console.log('Some error occurred');
                        throw new Error('Error while saving review. Some error is present.');
                    } else {
                        if ($scope.review.lineItem && !$scope.review.lineItem._id) {
                            return RestManager.putResource('/order/updateReview/' + order._id, {
                                index: $scope.review.lineItem.originalIndex,
                                points: reviewPoints
                            }, 'orders');
                        } else {
                            return RestManager.patchResource('/order/setLineItemReview/' + $scope.review.order, {
                                lineItemId: $scope.review.lineItem._id,
                                reviewPoints: reviewPoints
                            }, 'orders');
                        }
                    }
                })
                .then(function (result) {
                    // $timeout(function(){
                    //     $scope.showOnlyWhileSavingReview = false;
                    // }, 2000);
                    $scope.savingReview = false;

                    FullStory.trackEvent('Reviewed', {orderNumber: order.orderNumber, orderId: order._id});
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Thank you for your review")
                            .position("bottom right")
                            .hideDelay(1000)
                    );

                    $scope.review.showThankyouPage = true;
                    $scope.savingReview = false;
                    $scope.review.savingData = false;
                    $scope.reviews[$scope.index].lineItem.isReviewDone = true;
                    $scope.reviews[$scope.index].lineItem.reviewPoints = reviewPoints;
                    $scope.reviewedProductslist.push($scope.reviews[$scope.index].lineItem)

                    // Find if any of the lineItem.isReviewDone in reviews is falsy, if yes, set its index as $socpe.index and $scope.review{$scope.index}
                    $timeout(function () {
                        $scope.review.showOverlay = false;
                        var productsNotReviewedIndex = _.findIndex($scope.reviews, function (review) {
                            return !review.lineItem.isReviewDone;
                        });
                        if (productsNotReviewedIndex !== -1) {
                            $scope.changeProduct(productsNotReviewedIndex);
                        } else {
                            $scope.allProductReviewed = true;
                        }
                    }, 2000);
                })
                .catch(function (err) {
                    // $timeout(function(){
                    //     $scope.showOnlyWhileSavingReview = false;
                    // }, 2000);
                    $scope.savingReview = false;
                    $mdToast.showSimple('Error saving order review. Please try again later.');
                });
        };


    }

})(angular);

/**
 * Created by kumardivyarajat on 08/01/17.
 */
angular.module("app.account.orders")
    .controller("orders.details.controller", ["$scope", "$interval", "RestManager", "$mdDialog", "$log", "Utils", "$mdToast", "$analytics", "$stateParams", "$rootScope", "OrdersManager", "$timeout", function ($scope, $interval, RestManager, $mdDialog, $log, Utils, $mdToast, $analytics, $stateParams, $rootScope, OrdersManager, $timeout) {
        $scope.$parent.currentNavItem = "orders";
        $scope.$parent.currentActiveTitle = "My Orders";


        $scope.ordersLoaded = false;
        $scope.orderNumber = $stateParams.orderNum;
        $scope.isLineItemFormat = false;

        $scope.productReview = $stateParams.askForReview;
        $scope.range = _.range;
        $rootScope.pageMeta = {
            title: $scope.orderNumber + " - Details",
            description: "Buy customisable products"
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };

        $scope.openReviewDialog = openReviewDialog;

        $scope.viewOrderInDashboard = function () {
            if ($scope.currentUser.contextData) {
                window.open($scope.currentUser.contextData.orderViewUrl.replace('${orderId}', $scope.order._id), '_blank');
            } else {
                $mdToast.showSimple('Context Data not set. Please contact your Wordpress admin to integrate Magento into the website.')
            }
        }


        $scope.fetchOrder = function () {
            OrdersManager.fetchSingleOrder($scope.orderNumber)
                .then(function (orders) {
                    $scope.order = orders;
                    console.log("order.details.controller.js", "ORDER", $scope.order);
                    $scope.ordersLoaded = true;
                    $scope.totalOrderValue = orders.orderData.products.reduce(function (a, o) {
                        return a + o.totalPrice;
                    }, 0);
                    if (!$scope.order.lineItems || ($scope.order.lineItems && !$scope.order.lineItems.length)) {
                        $scope.order.lineItems = $scope.order.orderData.products.map(function (productData, index) {
                            return {
                                originalIndex: index,
                                quantity: productData.quantity,
                                name: productData.product.name,
                                image: productData.product.featured_image,
                                selectedVariationText: productData.selectedVariationText || productData.selectedVariation,
                                price: productData.price,
                                totalPrice: productData.totalPrice,
                                isProductDataFormat: true,
                                productId: productData.product._id,
                                reviews: productData.reviews || {
                                    isReviewDone : false,
                                    reviewPoints : 1
                                },
                                isReviewDone: $scope.order.isReviewDone
                            };
                        });
                    }else{
                        _.forEach($scope.order.lineItems, function(lineItem){
                            lineItem.isReviewDone = $scope.order.isReviewDone;
                            return lineItem;
                        });
                    }
                    console.log("order.details.controller.js", "LINE ITEM FORMAT", $scope.order);
                    // console.log("NOW HERE");
                    // if ($scope.productReview  === 'true') {
                    //$scope.openReviewModal();
                    //}
                    if ($scope.order.status === "delivered") {
                        $scope.deliveryDate = $scope.getCompletionDate("delivered");
                        if ($scope.deliveryDate) {
                            var today = moment().add(6, "days");
                            var maxReturnDate = $scope.deliveryDate = moment($scope.deliveryDate);
                            if ($scope.order.paymentMode === 1) {
                                maxReturnDate.add(7, "days");
                            } else {
                                maxReturnDate.add(14, "days");
                            }

                            $scope.order.returnable = today.isSameOrBefore(maxReturnDate);

                        }
                        if ($scope.productReview === 'true') {
                            $scope.order.hasCustOptions = $scope.order.orderData.products.reduce(function (a, p) {
                                return a ? a : !!_.find(p.product.categories, function (c) {
                                    return c.name === 'Customisation options';
                                });
                            }, false);

                            if (!$scope.order.isReviewDone) {
                                $scope.openReviewModal();
                            }
                        }
                    }
                    $analytics.pageTrack('/account/orders/' + $scope.order.orderNumber);
                    $analytics.eventTrack('Order Detail', {
                        page: '/account/orders/' + $scope.order.orderNumber,
                        orderNumber: $scope.order.orderNumber
                    });
                    $scope.getOrderStatusValue();
                })
                .catch(function (err) {
                    $scope.ordersLoaded = true;

                    if (err.code === 403) {
                        $analytics.eventTrack(
                            'Unauthorized',
                            {
                                orderNumber: $scope.orderNumber,
                                reason: "Invalid Order Requested"
                            });
                        $scope.unauthorized = true;
                    }
                });

        };


        $scope.showCancellationDialog = function (ev) {
            $mdDialog.show({
                locals: {
                    order: $scope.order,
                    options: {
                        cancellation: !$scope.order.returnable
                    }
                },
                templateUrl: 'app/modules/account/orders/partials/cancellation-dialog.html',
                parent: angular.element(document.body),
                fullscreen: false,
                targetEvent: ev,
                controller: "cancellationCtrl",
                clickOutsideToClose: true,
                escapeToClose: true
            })
                .then(function (orders) {

                    $scope.order = orders[0];
                    $scope.getOrderStatusValue();
                })
                .catch(function (err) {
                    if (err[0]) {
                        if (err[0].orderNumber) {
                            $scope.order = orders[0];
                        }
                    }

                });
        };

        $scope.getOrderStatusValue = function () {
            $scope.orderStatusValue = 0;
            $scope.a = $timeout(function () {
                console.log("Order Status:", $scope.order.status)
                switch ($scope.order.status) {
                    case "placed" :
                        $scope.orderStatusValue = 0;
                        $scope.placedSuccess = true;
                        break;

                    case "approved" :
                        $scope.orderStatusValue = 30;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        break;


                    case "processing" :
                        $scope.orderStatusValue = 40;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        break;


                    case "packed":
                        $scope.orderStatusValue = 50;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        $scope.packedSuccess = true;
                        break;


                    case "shipped":
                        $scope.orderStatusValue = 70;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        $scope.packedSuccess = true;
                        $scope.shippedSuccess = true;
                        break;

                    case "delivered":
                        $scope.orderStatusValue = 100;
                        $scope.placedSuccess = true;
                        $scope.approvedSuccess = true;
                        $scope.packedSuccess = true;
                        $scope.shippedSuccess = true;
                        $scope.deliveredSuccess = true;
                        break;
                }

                var i = 0;
                $scope.b = $interval(function () {
                    switch (i) {
                        case 0:
                            $scope.showPlacedSuccess = true;
                            break;

                        case 1 :
                            $scope.showApprovedSuccess = true;
                            break;

                        case 2:
                            $scope.showPackedSuccess = true;
                            break;

                        case 3:
                            $scope.showShippedSuccess = true;
                            break;

                        case 4:
                            $scope.showDeliveredSuccess = true;
                            break;

                        case 5:
                            $interval.cancel($scope.b);
                            break;
                    }
                    i++;
                }, 50);
            }, 1000);
        }


        $scope.getCompletionDate = function (status) {
            return $scope.order.statusHistory.filter(function (o) {
                return o.status === status
            })[0].date;
        };

        $scope.capitalize = function (cannotUse) {
            return _.startCase(_.camelCase(cannotUse));
        };

        $scope.properProductName = function (string) {
            return Utils.getProperName(string);
        };

        $scope.paymentOption = function (opt) {
            return Utils.getPaymentOption(opt, 50);
        };


        $scope.$on("$destroy", function () {
            $timeout.cancel($scope.a);
            $interval.cancel($scope.b);
        });


        function openReviewDialog(ev, product, i) {
            var order = {};
            var lineItemFormatProductIndex = _.findIndex($scope.order.lineItems, function(lineItem){
                return lineItem.productId === product.productId;
            })
            angular.copy($scope.order, order);
            $mdDialog.show({
                templateUrl: 'app/modules/account/orders/partials/review-dialog.html',
                parent: angular.element(document.body),
                fullscreen: false,
                targetEvent: ev,
                controller: "orders.review.dialog.controller",
                clickOutsideToClose: true,
                escapeToClose: true,
                locals: {
                    order: order,
                    lineItem: product,
                    index: product.originalIndex || product.originalIndex === 0 ? product.originalIndex : lineItemFormatProductIndex
                }
            })
                .then(function (data) {
                    //Todo: How to update view without reloading the order??
                    //$scope.reviewPoinst = data.updatedData.reviewPoints;

                    $scope.fetchOrder();
                });


        }


        $scope.fetchOrder();

    }])
;

/**
 * Created by kumardivyarajat on 28/04/17.
 */
angular.module("app.account.orders")
    .controller("cancellationCtrl", ["$scope", "RestManager", "order", "options", "$mdDialog", "$mdToast", function ($scope, RestManager, order, options, $mdDialog, $mdToast) {

        $scope.cancelReason = "";
        $scope.otherReason = "";

        if (options.cancellation) {
            $scope.title = "Cancel";
            $scope.textDesc = "cancellation";


            $scope.reasons = [
                "Ordered wrong size",
                "Ordered wrong product",
                "Got a better deal elsewhere",
                "Found a better product",
                "Changed my mind",
                "Others"
            ];
        } else {
            $scope.title = "Return";
            $scope.textDesc = "returning";

            $scope.reasons = [
                "Size Issue",
                "Defective Product",
                "Product is different from what I ordered",
                "Others"
            ];
        }

        $scope.close = function () {
            $mdDialog.cancel();
        };


        $scope.cancelTheOrder = function () {
            var reason = $scope.cancelReason;
            // angular.copy($scope.cancelReason, reason);
            if ($scope.cancelReason === 'Others') {
                reason += " - " + $scope.otherReason;
            }

            var status = "";

            if (options.cancellation) {
                status = "cancelled";
            } else {
                status = "return requested";
            }
            $scope.promise = RestManager.putResource("/order/" + status, {
                reason: reason,
                orderNumber: order.orderNumber
            }, "orders");
            $scope.promise.then(function (orders) {
                $mdDialog.hide(orders);
            }).catch(function (err) {

            })
        };
    }]);

/**
 * Created by kumardivyarajat on 16/11/16.
 */
angular.module("app.account.creations", [])
    .controller("creations.controller", ["$scope", "$rootScope", "$timeout", "CustomisationManager", function ($scope, $rootScope, $timeout, CustomisationManager) {
        $scope.$parent.currentNavItem = "creations";
        $scope.$parent.currentActiveTitle = "My Creations";
        $scope.ucLoaded = false;

        $rootScope.pageMeta = {
            title: "Creations",
            description: "Buy customisazable products",
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };

        CustomisationManager.getAllUCForUser()
            .then(function (ucData) {
                $scope.ucData = ucData;
                _.forEach($scope.ucData, function (data) {
                    _.forEach(data.customisation.data, function (datum, i) {
                        var a = _.find(data.data, function (o) {
                            return o.dataId === datum._id;
                        });
                        data.customisation.data[i].default = c = _.findIndex(data.customisation.data[i].options, function (o) {
                            return a.selectedValues[0] === o._id;
                        });
                    });
                });

                $scope.ucLoaded = true;
            })
            .catch(function (err) {
                $scope.ucLoaded = true;
                //
            });
    }]);

/**
 * Created by kumardivyarajat on 29/12/16.
 */
angular.module("app.wishlist", []);

/**
 * Created by kumardivyarajat on 29/12/16.
 */
angular.module("app.wishlist")
    .service("WishListManager", ["RestManager", "$log", "$window", "Base", "$q", "$rootScope", "AuthManager", "$exceptionHandler", "ErrorHero", "FullStory", function (RestManager, $log, $window, Base, $q, $rootScope, AuthManager, $exceptionHandler, ErrorHero,
                                          FullStory) {

        this.wishList = '';

        /**
         * @memberOf WishListManager
         * @param product
         * @returns {*}
         */
        this.addToWishList = function (product) {
            var self = this;
            FullStory.trackEvent('AddToWishlist', {product : product.name, productId : product._id});
            return $q(function (resolve, reject) {
                if (AuthManager.isUserLoggedIn) {
                    RestManager.getResource("/wishlist/add/" + product._id, "wishlist")
                        .then(function (wishlist) {
                            self._emitChanges(wishlist[0]);
                            self.wishList = wishlist[0];
                            resolve(self.wishList);
                        })
                        .catch(function (err) {
                            //
                            reject(ErrorHero(err));
                        })
                } else {
                    var wishlist = self.saveToLocalWishlist(product);
                    console.log(wishlist);
                    self._emitChanges(wishlist);
                    self.wishList = wishlist;
                    resolve(self.wishList);
                }

            });

        };

        this.saveToLocalWishlist = function (product) {
            var wishlist = JSON.parse($window.localStorage.getItem('wishlist'));
            if (!wishlist) {
                wishlist = {products: []};
            }
            var productAndVariationIdx = _.findIndex(wishlist.products, function (p) {
                return p._id === product._id;
            });

            if (productAndVariationIdx === -1) {
                wishlist.products.push(product);
            } else {
                wishlist.products.splice(productAndVariationIdx, 1);
            }
            $window.localStorage.setItem('wishlist', JSON.stringify(wishlist));
            return wishlist;
        };

        /**
         * @memberOf WishListManager
         * @returns {*}
         */
        this.getWishlist = function () {
            var self = this;
            if (!AuthManager.isUserLoggedIn) {
                try {
                    self.wishlist = JSON.parse($window.localStorage.getItem('wishlist') || {products: []});
                } catch (e) {
                    self.wishlist = {products: []};
                }
                return $q.resolve(self.wishlist);
            } else {
                return $q(function (resolve, reject) {
                    RestManager.getResource("/wishList", "wishlist")
                        .then(function (wishlist) {
                            self.wishlist = wishlist[0];
                            resolve(wishlist[0])
                        })
                        .catch(function (err) {
                            $exceptionHandler(err, err.cause);
                            reject(err);
                        });
                });
            }
        };


        /**
         * @memberOf WishListManager
         * @returns {*}
         */
        this.getWishlistOutline = function () {
            return $q(function (resolve, reject) {
                if (!AuthManager.isUserLoggedIn) {
                    var wishlist = {products: []};
                    try {
                        console.log('Gere');
                        wishlist = JSON.parse($window.localStorage.getItem('wishlist'));
                        wishlist.products = wishlist.products.map(function (product) {
                            return product._id;
                        });
                        resolve(wishlist);
                    } catch (e) {
                        resolve({products: []})
                    }
                } else {
                    RestManager.getResource("/wishList/outline", "wishlist")
                        .then(function (wishlist) {
                            resolve(wishlist[0])
                        })
                        .catch(function (err) {
                            $exceptionHandler(err, err.cause);
                            reject(err);
                        });
                }
            });
        };

        /**
         * @memberOf WishListManager
         * @param product
         * @returns {*}
         */
        this.removeFromWishlist = function (product) {
            var self = this;
            FullStory.trackEvent('RemoveFromWishlist', {product : product.name, productId : product._id});
            return $q(function (resolve, reject) {
                if (AuthManager.isUserLoggedIn) {
                    RestManager.getResource("/wishlist/remove/" + product._id, "wishlist")
                        .then(function (wishlist) {
                            //
                            self._emitChanges(wishlist[0]);
                            self.wishList = wishlist[0];
                            resolve(self.wishList);
                        })
                        .catch(function (err) {
                            //
                            reject(ErrorHero(err));
                        })
                } else {
                    var wishlist = self.saveToLocalWishlist(product);
                    self._emitChanges(wishlist);
                    self.wishList = wishlist;
                    resolve(self.wishList);
                }

            });

        };

        /**
         * @memberOf WishListManager
         * @returns {*}
         */
        this.mergeWishlist = function () {

            var wishlist = {products: []};

            try {
                wishlist = JSON.parse($window.localStorage.getItem('wishlist'));
            } catch (e) {
            }
            if (!wishlist) {
                wishlist = {products: []};
            }

            if (wishlist.length) {
                var data = wishlist.products.map(function (product) {
                    return product._id;
                });
                return $q(function (resolve, reject) {
                    RestManager.postResource("/wishlist/merge", {p: data}, "wishlist")
                        .then(function (wishlist) {
                            $window.localStorage.removeItem('wishlist');
                            resolve();
                        })
                        .catch(function (reason) {
                            reject(err);
                        })
                });
            } else {
                return $q.resolve()
            }

        };

        this._emitChanges = function (data) {
            $rootScope.$emit('wishlistChanged', data);
        };

    }]);

/**
 * Created by kumardivyarajat on 29/12/16.
 */
angular.module("app.wishlist")
    .controller("wishlist.controller", ["$scope", "WishListManager", "$rootScope", "RestManager", "$exceptionHandler", function ($scope, WishListManager, $rootScope, RestManager, $exceptionHandler) {

        $rootScope.pageMeta = {
            title: "Wishlist",
            description: "Add products to your wishlist only on aarida.com",
            keywords: "Wishlist, aarida, aarida.com, aarida wishlist, Add products to your wishlist only on aarida.com"
        };

        $scope.removeFromWishlist = removeFromWishlist;


        function removeFromWishlist(product, ev) {
            ev.stopPropagation();
            WishListManager.removeFromWishlist(product)
                .then(function (wishlist) {
                    $scope.wishlist = wishlist;
                })
                .catch(function (reason) {
                    console.log(reason)
                })
        }

        $scope.fetchWishlist = function () {
            WishListManager.getWishlist()
                .then(function (wishlist) {
                    $scope.wishlist = wishlist;
                })
                .catch(function (err) {
                    $exceptionHandler(err);
                })
        };

        $scope.fetchWishlist();

        $rootScope.$on("wishlistChanged", function ($event, data) {
            $scope.fetchWishlist();
        });

        $rootScope.$on("userSetup", function ($event, data) {
            $scope.fetchWishlist();
        });


        $rootScope.$on("loggedIn", function ($event, data) {
            $scope.fetchWishlist();
        });

        $scope.cancel = function () {
            $mdDialog.hide();
        };



        $scope.getProperName = function (str) {
            return _.startCase(_.toLower(_.truncate(str, {'length': 40, 'separator': ' '})));
        }
    }]);

/**
 * Created by kumardivyarajat on 06/11/16.
 */
angular.module("app.main.search", [])
    .controller("app.main.search.Controller", ["$scope", "$stateParams", "$state", "$log", "$q", "$timeout", "TagsManager", "$rootScope", function ($scope, $stateParams, $state, $log, $q, $timeout, TagsManager, $rootScope) {
        var self = this;

        self.products = [];
        $rootScope.$broadcast("showToolbar",{});
        $rootScope.$on("search", onQueryChange);

        self.querySearch = querySearch;
        self.onQueryChange = onQueryChange;
        self.getProperName = getProperName;
        self.getLinkUrl = getLinkUrl;

        $rootScope.pageMeta = {
            title: "Searching " + ($stateParams.q ? $stateParams.q : ""),
            description: "We are largest Customised Women Clothing Online women fashion online store India," +
            "offering widest collection of latest bespoke women’s clothing at discounted prices.",
            keywords: "Best place to customise women’s wear, Bespoke women’s wear India, Top site for " +
            "customising women’s dresses Bespoke women’s fashion , Bespoke fashion for women, Customised " +
            "fashion for women, Women Customised Clothing Online, Customised women’s wear India, Buy " +
            "Customised dresses online, Buy customised womens wear"
        };

        if ($stateParams.q) {
            self.query = $stateParams.q;

            $scope.$parent.searchInput = self.query;
            self.querySearch(self.query);
        }
        // ******************************
        // Internal methods
        // ******************************

        function querySearch(query) {
            TagsManager.searchQuery(query)
                .then(function (products) {
                    // $log.info("Products", products);
                    self.products = products;
                })
                .catch(function (err) {

                })
        }

        function getLinkUrl(product) {
            if (product.productType && product.editorType !== 'simple' && $scope.isSmall) {
                return $state.href('app.customisationEditor', {slug: product.slug, flags: 'none'});
            } else {
                return $state.href('app.product', {productSlug: product.slug, product: product});
            }
        }

        function onQueryChange(e, data) {

            self.query = data;
            $state.go("app.search", {q: data}, {reload: false, notify: false, location: 'replace'})
                .then(function (d) {

                    self.querySearch(data);
                })
                .catch(function (err) {

                });

        }

        function getProperName(str) {
            return _.startCase(_.toLower(_.truncate(str, {'length': 40, 'separator': ' '})));
        }


    }]);

/**
 * Created by kumardivyarajat on 27/11/16.
 */
angular.module("app.main.search")
    .service("TagsManager", ["$http", "$log", "ErrorHero", "$q", "Base", function ($http, $log, ErrorHero, $q, Base) {

        this.searchQuery = function (queryTerm) {
            return $q(function (resolve, reject) {
                $http.get(Base.getBaseUrl() + "/tags/search/" + queryTerm)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            // resolve(response.data.message.result);
                            var tags = response.data.message.tags;
                            // var products = [];
                            // _.forEach(tags, function (tag) {
                            //     _.forEach(tag.products, function (product, i) {
                            //         var index = _.findIndex(products, function (x) {
                            //             return x._id == product._id;
                            //         });
                            //         // //
                            //         if (index == -1) {
                            //             products.push(product);
                            //         } else {
                            //             products.splice(index, 1);
                            //             products.unshift(product);
                            //         }
                            //     })
                            // });
                            resolve(tags);

                        } else {
                            reject(ErrorHero(response));
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        }
    }]);

(function () {
    'use strict';
  promotionsController.$inject = ["$scope", "$mdDialog", "RestManager", "$mdToast"];
  angular.module("app.main")
  .controller("promotions.controller", promotionsController);

  function promotionsController($scope, $mdDialog, RestManager, $mdToast) {
      $scope.localCollections = [
          {
              name: "Product 1",
              image: "https://cdn.aarida.com/uploads_dev/16-Jan-19/2-1547674673797-thumbnail.jpg",
              price: "499",
              sku: "ADRJAN0002",
              _id: '1',
              preOrder: false
          },
          {
              name: "Product 2",
              image: "https://cdn.aarida.com/uploads_dev/16-Jan-19/2-1547674673797-thumbnail.jpg",
              price: "499",
              sku: "ADRJAN0002",
              _id: '2',
              preOrder: false

          },
          {
              name: "Product 3",
              image: "https://cdn.aarida.com/uploads_dev/16-Jan-19/2-1547674673797-thumbnail.jpg",
              price: "499",
              sku: "ADRJAN0002",
              _id: '3',
              preOrder: false

          },
          {
              name: "Product 3",
              image: "https://cdn.aarida.com/uploads_dev/16-Jan-19/2-1547674673797-thumbnail.jpg",
              price: "499",
              sku: "ADRJAN0002",
              _id: '3',
              preOrder: false

          },
          {
              name: "Product 3",
              image: "https://cdn.aarida.com/uploads_dev/16-Jan-19/2-1547674673797-thumbnail.jpg",
              price: "499",
              sku: "ADRJAN0002",
              _id: '3',
              preOrder: false

          },
          {
              name: "Product 3",
              image: "https://cdn.aarida.com/uploads_dev/16-Jan-19/2-1547674673797-thumbnail.jpg",
              price: "499",
              sku: "ADRJAN0002",
              _id: '3',
              preOrder: false

          }
      ];


      $scope.fetchUpcomingCollections = fetchUpcomingCollections;
      $scope.upvote = upvote;
      $scope.preOrder = preOrder;


      function fetchUpcomingCollections(){
          RestManager.getResource('/collections/upcoming', "collections")
              .then(function(response){
                  $scope.collections = response;
              })
              .catch(function(err){
                  $mdToast.showSimple('Oops, Something went South. Please contact our Customer Care at 080-4152-1574');
              });
      }

      function upvote(index, collection) {
          // RestManager.patchResource("/collections", {product: collection, upvote: true}, "collections")
          //     .then(function(response){
          //         console.log("promotions.controller.js", "response", response);
          //     })
          //     .catch(function(err){
          //         $mdToast.showSimple('Oops, Something went South. Please contact our Customer Care at 080-4152-1574')
          //     });

          $mdDialog.show({
              locals: {
                  product: collection
              },
              templateUrl: 'app/modules/static/promotions/voteProductDialog/voteProduct.tmpl.html',
              controller: "voteProduct.controller",
              clickOutsideToClose: true,
              escapeToClose: true
          })
              .then(function(response){
                  $scope.localCollections[index].preOrder = true;
              })
      };


      function preOrder(index, collection){
          $mdDialog.show({
              locals: {
                  product: collection
              },
              templateUrl: 'app/modules/static/promotions/preOrderDialog/preOrderDialog.tmpl.html',
              controller: "preOrderDialog.controller",
              clickOutsideToClose: true,
              escapeToClose: true
          })
              .then(function(response){
                  $scope.localCollections[index].preOrder = true;
              });
      }

      // $scope.fetchUpcomingCollections();


  }

})(angular);

(function () {
    'use strict';
    allPromotionsController.$inject = ["$scope", "RestManager", "$mdToast"];
    angular.module("app.main")
        .controller("allPromotions.controller", allPromotionsController);

    function allPromotionsController($scope, RestManager, $mdToast) {
        $scope.fetchAllPromotions = fetchAllPromotions;


        function fetchAllPromotions(){
            RestManager.getResource('/promotions', "promotions")
                .then(function(response){
                    $scope.promotions = response;
                })
                .catch(function(err){
                    $mdToast.showSimple('Oops, Something went South. Please contact our Customer Care at 080-4152-1574')
                });
        }

        $scope.fetchAllPromotions();
    }

})(angular);

(function () {
    'use strict';


    OnboardingController.$inject = ["$scope", "$rootScope", "AddressManager", "RestManager"];
    angular.module('app.main')
        .controller('influencer-onboarding', OnboardingController);

    function OnboardingController($scope, $rootScope, AddressManager, RestManager) {
        $rootScope.pageMeta = {
            title: "Sign Up as Fashion Expert",
            description: "We are largest Customised Women Clothing Online women fashion online store India," +
                "offering widest collection of latest bespoke women’s clothing at discounted prices.",
            keywords: "Best place to customise women’s wear, Bespoke women’s wear India, Top site for " +
                "customising women’s dresses Bespoke women’s fashion , Bespoke fashion for women, Customised " +
                "fashion for women, Women Customised Clothing Online, Customised women’s wear India, Buy " +
                "Customised dresses online, Buy customised womens wear"
        };
        $scope.user = {};

        $scope.queryPinCode = queryPinCode;
        $scope.saveApplication = saveApplication;

        function queryPinCode(query) {
            console.log("influencer-onboarding.controller.js", "queryPinCode", query, query.length, query.length !== 6, !query, !query || query.length !== 6);
            if(query) {
                query = query + '';
            }
            if(!query || query.length !== 6) {
                return;
            }
            console.log("influencer-onboarding.controller.js", "queryPinCode");
            $scope.populatingCity = true;
            AddressManager.queryPinCode(query)
                .then(function (data) {
                    console.log("influencer-onboarding.controller.js", "data", data);
                    $scope.populatingCity = false;
                    if (data) {
                        $scope.user.city = data.city;
                        $scope.user.state = data.state;
                    }
                })
                .catch(function (err) {
                    $scope.populatingCity = false;

                })
        }


        function saveApplication() {
            $scope.applying = true;
            RestManager.postResource('/users/apply', $scope.user, 'result')
                .then(function (result) {
                    $scope.applying = false;
                    $scope.applied = !!(result && result[0] && result[0].applied);
                })
                .catch(function (err) {
                    $scope.applying = false;
                })
        }


    }

})(angular);

/**
 * Created by kumardivyarajat on 13/06/17.
 */
angular.module("app.main")
    .controller("staticController", ["$scope", "$stateParams", "RestManager", "$state", "$rootScope", "$compile", "$window", function ($scope, $stateParams, RestManager, $state, $rootScope, $compile,
                                              $window) {


        $scope.fetchData = function () {
            RestManager.getResource("/static/" + $stateParams.slug, "pages")
                .then(function (data) {
                    if (!data && $stateParams.slug) {
                        $state.go("app.404client", {path: "error"})
                    } else {
                        var element = angular.element(document.getElementById('aarida-dyn'));
                        element.html(data[0].content);
                        $compile(element.contents())($scope);
                        $scope.data = data[0];
                        $rootScope.pageMeta = {
                            title: $scope.data.seo.title,
                            description: $scope.data.seo.description,
                            keywords: $scope.data.seo.keywords
                        };

                    }
                })
                .catch(function (err) {
                    console.log("static.controller.js", "er", err);
                })
        };

        $scope.openPage = function ($event, src, id, requireLogin) {
            if(requireLogin && !$scope.isUserLoggedIn) {
                $scope.openLoginModal($event);
            } else {
                $window.open(src, '_blank');
                var element = angular.element(document.getElementById(id));
                element.html('<div class="layout-row layout-align-center-center" >\n' +
                    '                            <md-icon>check_circle</md-icon>\n' +
                    '                            <span style="margin-left: 8px">Done</span>\n' +
                    '                        </div>');
                element.addClass('green');
                $compile(element.contents())($scope);
                $event.preventDefault();
                $event.stopPropagation();
            }
        };


        $scope.fetchData();
    }]);

(function () {
    'use strict';


    locatorCtrl.$inject = ["$scope", "uiGmapGoogleMapApi", "$rootScope", "uiGmapIsReady", "uiGmapLogger"];
    angular.module('app.main')
        .controller('locatorCtrl', locatorCtrl);

    /** @ngInject **/
    function locatorCtrl($scope, uiGmapGoogleMapApi, $rootScope, uiGmapIsReady, uiGmapLogger) {

        $rootScope.pageMeta = {
            title: "Store Locator",
            description: "Find aarida stores located all across India",
            keywords: "Best place to customise women’s wear, Bespoke women’s wear India, Top site for " +
            "customising women’s dresses Bespoke women’s fashion , Bespoke fashion for women, Customised " +
            "fashion for women, Women Customised Clothing Online, Customised women’s wear India, Buy " +
            "Customised dresses online, Buy customised womens wear"
        };

        uiGmapIsReady.promise(1).then(function (instance) {

        });

        uiGmapGoogleMapApi.then(function (maps) {
            $scope.showMap = true;
            $scope.selected = $scope.cities[0].stores[0];
            $scope.map = {
                center: {
                    latitude: 12.971887791631689, longitude: 77.6409786590956
                },
                zoom: 16,
                options: {scrollwheel: false, draggable: true}
            };


            $scope.marker = {
                id: "0",
                coords: {
                    latitude: 12.971887791631689,
                    longitude: 77.6409786590956
                },
                window: {
                    title: "Aarida Flagship Store, 759, 1st Floor, 100 Feet Rd, Indiranagar, Bengaluru, Karnataka 560038"
                },
                options: {
                    draggable: false,
                    animation: true,
                    visible: true
                }
            };
        });


        $scope.cities = [
            {
                cityName: "Bengaluru",
                stores: [
                    {
                        contactNumber :'080 4152 1574',
                        name: "Aarida Flagship Store",
                        address1: "759, 1st Floor, 100 Feet Rd, Indiranagar,",
                        address2: "Bengaluru, Karnataka - 560038",
                        latitude: 12.971887791631689,
                        longitude: 77.6409786590956,
                        title: "Aarida Flagship Store, 759, 1st Floor, 100 Feet Rd, Indiranagar, Bengaluru, Karnataka 560038",
                    }
                ]
            },
            {
                cityName: "Deoghar",
                stores: [
                    {
                        contactNumber :'080 4152 1574',
                        name: "Aarida Experience Store",
                        address1: "Central Mall, Netaji Subhash Road,",
                        address2: "Williams Town, Deoghar, Jharkhand - 814112",
                        latitude: 20.8766129,
                        longitude: 80.5404962,
                        title: "Aarida Experience Store, Central Mall, Williams Town, Deoghar, Jharkhand 814112",
                    }
                ]
            }
        ];


        $scope.selectAddress = function (store) {
            $scope.marker.coords.latitude = store.latitude;
            $scope.map.center.latitude = store.latitude;
            $scope.marker.coords.longitude = store.longitude;
            $scope.map.center.longitude = store.longitude;
            $scope.marker.window.title = store.title;
            $scope.selected = store;
        }

    }

})(angular);

(function () {
    'use strict';
    angular.module("app.main")
        .controller("faqCtrl", ["$scope", "$rootScope", "RestManager", function ($scope, $rootScope, RestManager) {
            $rootScope.pageMeta = {
                title: "Frequently Asked Questions",
                description: "We are largest Customised Women Clothing Online women fashion online store India," +
                "offering widest collection of latest bespoke women’s clothing at discounted prices.",
                keywords: "Best place to customise women’s wear, Bespoke women’s wear India, Top site for " +
                "customising women’s dresses Bespoke women’s fashion , Bespoke fashion for women, Customised " +
                "fashion for women, Women Customised Clothing Online, Customised women’s wear India, Buy " +
                "Customised dresses online, Buy customised womens wear"
            };

            $scope.faqs = [{
                "id": 0,
                "question": "HOW TO USE DISCOUNT COUPONS?",
                "answer": "Make sure the coupon has not expired (most will show the expiry date). During the checkout process, first make sure that you are logged in, then go to your shopping cart and enter your coupon code. Enter the full promotion code and click “Apply Code”\nYou can only use one coupon code per order. A coupon can only be used to cover the value of goods, they cannot be used to discount shipping fees or insurance.\n"
            }, {
                "id": 1,
                "question": "Successful Transactions",
                "answer": "All successful transactions are followed up by a confirmation email that contains an order number within an hour of purchase. If you have not received confirmation via email, please try placing your order again.\nYou can also verify if a transaction was successful by searching under ‘Orders & Tracking’ under ‘My Account’. All past and present successful transactions will be reflected in the list shown.\n"
            }, {
                "id": 2,
                "question": "How do I cancel an order?",
                "answer": "Call us on 080 4152 1574 (Mon- Sat @ 11:00 – 6:00) and we’ll help you cancel your order. Do remember that you can only cancel orders that are in the Processing stage. Go to the Orders section in My Account to check the status of your\n        order.\n      \n"
            }, {
                "id": 3,
                "question": "WHAT SHOULD I DO IF AN ITEM IS MISSING FROM MY ORDER?",
                "answer": "First, please carefully check and review your order list to make sure whether the order was sent using only one package instead of a split delivery with more than one package. If items are sent separately, please be patient and wait for the rest\n        of the split delivery to arrive.\nIf all of the packages for the order have been delivered but you are still missing an item, please check the contents of all the sent packages very carefully, especially if it is a small item that can be misplaced.\nPlease contact our Customer Service staff after you have confirmed that the item is definitely missing.\n"
            }, {
                "id": 4,
                "question": "IF I ORDER A WRONG SIZE, WHAT CAN I DO?",
                "answer": "You can send it back to exchange, however you are responsible for the shipping fee both ways. Usually the double shipping cost is more than the item price, so we strongly advise you to check the size information carefully when you make the order.\n"
            }, {
                "id": 5,
                "question": "HOW SOON WILL I RECEIVE A REFUND FOR MY RETURN?",
                "answer": "We will process the refund after we receive your package, to confirm whether your items adhere to our Return Policy. Following confirmation, we will\n        authorize the refund for you, this usually takes 3 working days for us to process following receipt of your package and we will send email notification. The payment method and policy of the respective payment providers determine when the refund\n        will appear in your account balance.\n"
            }, {
                "id": 6,
                "question": "What should I do if my payment attempt fails?",
                "answer": "If your payment has failed, please try again after checking whether or not your account details, billing address, Debit or Credit Card details, Net Banking details or any other payment-related information is accurate.\nCheck that your internet connection is working.\nIf any amount has been debited during the failed transaction, it will be credited back to your bank account or Credit Card within seven business days.\n"
            }, {
                "id": 7,
                "question": "How do I pay if the Cash on Delivery option is not available for my address?",
                "answer": "If our courier partner cannot offer Cash on Delivery for your address, try Net Banking or pay with your Debit or Credit Card. If you do not have these facilities, do get in touch with your bank to activate them easily.\n"
            }, {
                "id": 8,
                "question": "Why isn’t Cash on Delivery a payment option for me?",
                "answer": "Our courier partners are unable to offer the Cash on Delivery service at a few locations. If you live in one of these locations, you can still choose to pay via Net Banking or by Debit or Credit card.\n"
            }, {
                "id": 9,
                "question": "Is there a price limit on Cash on Delivery purchases?",
                "answer": "The maximum order value for Cash on Delivery purchases is Rs. 1000. If you wish to shop for more than Rs. 1000, you can either use your Debit or Credit Card, or pay via Net Banking.\n"
            }, {
                "id": 10,
                "question": "What payment methods do you accept?",
                "answer": "We accept a variety of payment methods: Debit cart, Credit card, Netbanking, UPI, wallets - PayTm, Mobikwik, Freecharge and Cash On Delivery*.\n"
            }, {
                "id": 11,
                "question": "Can I add an item after I have placed my order?",
                "answer": "No. You cannot add any item to an existing order.\n"
            }, {
                "id": 12,
                "question": "Do I need to register to shop?",
                "answer": "Yes. You need to register on our website to place an order.\n"
            }, {
                "id": 13,
                "question": "CAN I TRACK MY ORDER?",
                "answer": "Tracking your order is easy! Enter your 8 digit order number into the ‘Track my order’ facility at the top of this page.\n"
            }, {
                "id": 14,
                "question": "CAN I MAKE CHANGES TO MY ORDER?",
                "answer": "Unfortunately, once you’ve placed your order, our warehouse team will have already started processing your order!\n"
            }, {
                "id": 15,
                "question": "How can I ask a question about ordering?",
                "answer": "If you can’t find an answer to your question here, then please use our support@aarida.com  or call Customer Service at 080 4152 1574.\n"
            }, {
                "id": 16,
                "question": "Do you charge sales tax?",
                "answer": "The calculation of sales tax is based on applicable state and local taxes.\n"
            }, {
                "id": 17,
                "question": "How do I know if ordering online is secure?",
                "answer": "At aarida.com protecting your information is a priority. With regard to overall security, we always use industry standard encryption technologies when transferring and receiving data exchanged with our site. The facilities that house our servers\n        are physically secured to protect against the loss, misuse or alteration of all data and information collected.\n"
            }, {
                "id": 18,
                "question": "Can I place an order for a product that’s out of stock?",
                "answer": "We regularly update our product range with new items, but every once in a while you may miss out on something. Enter your email address in the aarida.com next to the product, and you’ll be the first to know when it’s back in stock.\n"
            }, {
                "id": 19,
                "question": "HOW DO I CHANGE MY ACCOUNT INFORMATION?",
                "answer": "Under My Account> Edit Profile, click Personal Information. You will arrive at a screen that will allow you to change your phone number, Gender, and/or the nickname associated with your account.\n"
            }, {
                "id": 20,
                "question": "ADD/REMOVE AN ADDRESS",
                "answer": "Under My Account>Personal data, click “Address Book”. Here, you can add a new address, remove an existing address, or edit an existing address.\n"
            }, {
                "id": 21,
                "question": "CHANGE YOUR PASSWORD",
                "answer": "Under My Account> Edit Profile, click “Change Password”. You will be prompted to enter a new password.\n"
            }, {
                "id": 22,
                "question": "Can I track my order?",
                "answer": "If you have a registered account with aarida.com, please select My Account, sign into your account and click the ‘Order’ tab.\n         Once your order has been shipped you can also track it at ————–using the tracking number located in your shipping confirmation email.\n"
            }, {
                "id": 23,
                "question": "Do I have to sign for my shipment when it arrives?",
                "answer": "We do not require a signature. However, depending on the quantity of items ordered and delivery area, this may be at the discretion of the carrier.\n"
            }, {
                "id": 24,
                "question": "Will I be charged for delivery?",
                "answer": "Delivery is free on orders of Rs. 1,000 and above. If your total order is less than Rs. 1,000, you will be charged Nominal Amount for delivery.\nYour delivery charges will be displayed during the checkout process.\n"
            }, {
                "id": 25,
                "question": "What if I am not at home when my order arrives?",
                "answer": "Once our delivery partner receives your order, they will dispatch it directly to your address. Our delivery partner will make a call to your registered Mobile number. So, please verify your address and inform the person at what time you will be\n        available\n      \n"
            }, {
                "id": 26,
                "question": "When will I receive my order?",
                "answer": "Orders placed before 3:00 PM from Monday to Saturday will be delivered in two to three business days, and orders placed after 3:00 PM will be delivered in four to five business days.\n"
            }];

            setTimeout(function () {
                var acc = document.getElementsByClassName("accordion");
                var i;

                for (i = 0; i < acc.length; i++) {
                    acc[i].addEventListener("click", function () {
                        this.classList.toggle("active");
                        var panel = this.nextElementSibling;
                        if (panel.style.maxHeight) {
                            panel.style.maxHeight = null;
                        } else {
                            panel.style.maxHeight = panel.scrollHeight + "px";
                        }
                    });
                }
            });
        }]);


})(angular);

/**
 * Created by kumardivyarajat on 05/03/17.
 */
angular.module("app.main")
    .controller("contactCtrl", ["$scope", "$rootScope", "RestManager", function ($scope, $rootScope, RestManager) {

        $rootScope.pageMeta = {
            title: "Contact Us",
            description: "We are largest Customised Women Clothing Online women fashion online store India," +
            "offering widest collection of latest bespoke women’s clothing at discounted prices.",
            keywords: "Best place to customise women’s wear, Bespoke women’s wear India, Top site for " +
            "customising women’s dresses Bespoke women’s fashion , Bespoke fashion for women, Customised " +
            "fashion for women, Women Customised Clothing Online, Customised women’s wear India, Buy " +
            "Customised dresses online, Buy customised womens wear"
        };


        // $scope.map = {
        //     center: {
        //         latitude: 12.9695652, longitude: 77.6402573
        //     },
        //     zoom: 16,
        //     options : {scrollwheel: false, draggable : false}
        // };

        $scope.message = {};

        $scope.send = function () {
            $scope.error = "";
            $scope.sendingMsg = true;
            RestManager.postResource("/contact", $scope.message, "result")
                .then(function (result) {
                    $scope.messageSent = true;
                    $scope.sendingMsg = false;
                })
                .catch(function (err) {
                    $scope.sendingMsg = false;
                    $scope.error = err.code + "Error while sending message";
                })
        };

        $scope.verifyCaptcha = function (some) {

        };

        $scope.resetCaptcha = function () {

        };

        //
        // $scope.marker = {
        //     id: "0",
        //     coords: {
        //         latitude: 12.9695652,
        //         longitude: 77.6402573
        //     },
        //     window: {
        //         title: "aarida"
        //     },
        //     options: {
        //         draggable: false
        //     }
        // };
    }]);

/**
 * Created by kumardivyarajat on 05/03/17.
 */
angular.module("app.main")
    .controller("careersCtrl", ["$scope", "$rootScope", "$mdDialog", "$mdToast", "RestManager", function ($scope, $rootScope, $mdDialog, $mdToast, RestManager) {

        $rootScope.pageMeta = {
            title: "Careers",
            description: "Interested in Joining aarida | aarida Careers | aarida Jobs | aarida Openings",
            keywords: "Best place to customise women’s wear, Bespoke women’s wear India, Top site for " +
            "customising women’s dresses Bespoke women’s fashion , Bespoke fashion for women, Customised " +
            "fashion for women, Women Customised Clothing Online, Customised women’s wear India, Buy " +
            "Customised dresses online, Buy customised womens wear"
        };


        // $scope.jobs = [];
        $scope.jobs = [
            {
                title: "Fashion Designer",
                parent: "Fashion",
                city: "Bangalore",
                fullTime: true,
                salary: "₹2.4L to ₹3.0L",
                minExperience: 2,
                languages: "English",
                experience: " 2 - 4 Years ",
                description: "",
                skills: "Sketching, Corel Draw, Photoshop",
                responsibilities: [
                    "Fashion Illustration",
                    "Co-ordinating with the sampling team",
                    "Fabric Sourcing",
                    "Embroidery artworks",
                    "Photoshoot Styling",
                    "Product Description"
                ],
                skillSet: [
                    "Should be a Team Player",
                    "Sound Knowledge of Photoshop",
                    "Sound Knowledge of Corel Draw",
                    "Fashion Contenet Writing",
                    "Sketching"
                ],
                url: "http://www.indeed.co.in/job/fashion-designer-abae9f01ad618bbb?_ga=2.141232507.838511549.1495701112-1738332618.1494221417"
            },
            {
                title: "Merchandiser",
                parent: "Fashion",
                city: "Bangalore",
                fullTime: true,
                salary: "₹1.8L to ₹2.64L",
                minExperience: 1,
                languages: "English, Kannada",
                experience: " 1 - 3 Years ",
                description: "",
                skills: "Fabrics, Corel Draw",
                responsibilities: [
                    "Sourcing Fabrics and Trims",
                    "Co-ordinating with the Manufacturing Unit",
                    "Co-ordinating with the Designing Team",
                    "Should mind the changing Fashion Trends",
                    "Vendor Development"
                ],
                skillSet: [
                    "Should be a Team Player",
                    "Sound Knowledge about Fabrics",
                    "Knowledge about Garment Construction",
                    "Knowledge about Photoshop/Illustrator/Corel Draw would be an advantage"
                ],
                url: "http://www.indeed.co.in/job/merchandiser-addec6ca711fe23c?_ga=2.77923677.838511549.1495701112-1738332618.1494221417"
            },
            {
                title: "Customer Support Executive",
                parent: "Support",
                city: "Bangalore",
                fullTime: true,
                salary: "₹1.2L to ₹2.4L",
                minExperience: 1,
                languages: "English, Hindi, Kannada",
                experience: " 0 - 2 Years ",
                description: "",
                skills: "Articulate Communication, Software handling",
                responsibilities: [
                    "To address the calls and emails from the Customers/Vendors",
                    "Co-ordinating with the Operations Unit",
                    "Co-ordinating with the Marketing Team",
                    "Maintenance of Data"
                ],
                skillSet: [
                    "Should be a Team Player",
                    "Should have great communication skills",
                    "Should know to address Customer Queries/Problems with ease"
                ],
                url: "http://www.indeed.co.in/job/sales-executive-47a172be69658139?_ga=2.77923677.838511549.1495701112-1738332618.1494221417"
            },
            {
                title: "Backend Developer",
                parent: "Developer",
                city: "Bangalore",
                fullTime: true,
                salary: "₹2.4L to ₹7.2L",
                minExperience: 1,
                languages: "English, Hindi, Kannada",
                experience: " 1 - 3 Years ",
                description: "",
                skills: "NodeJs, MongoDB, ExpressJs",
                responsibilities: [
                    "Integration of user-facing elements developed by front-end developers with server side logic",
                    "Writing reusable, testable, scalable and efficient code",
                    "Design and implementation of low-latency, high-availability, and performant applications",
                    "Implementation of security and data protection",
                    "Integration of data storage solutions"
                ],
                skillSet: [
                    "Strong proficiency with JavaScript",
                    "Ability to create, manage, maintain, improve and query from MongoDB",
                    "Good understanding of MongoDB Aggregation Pipeline",
                    "Knowledge of Node.js, Express.js, Mongoose.js, JWT",
                    "Understanding of how payment gateways work and how they are integrated",
                    "Understanding the nature of asynchronous programming and its quirks and workarounds(Promises)",
                    "Basic understanding of front-end technologies, such as HTML5, and CSS3",
                    "Understanding accessibility and security compliance",
                    "User authentication and authorization between multiple systems, servers, and environments",
                    "Integration of multiple data sources and databases into one system",
                    "Understanding fundamental design principles behind a scalable application",
                    "Understanding differences between multiple delivery platforms, such as mobile vs. desktop, and optimizing output to match the specific platform",
                    "Creating and managing database schemas that represent and support business processes",
                    "Implementing automated testing platforms and unit tests",
                    "Proficient understanding of code versioning tools, Git"
                ],
                url: "https://www.indeed.co.in/viewjob?t=backend+developer&jk=04176629c4898d47&_ga=2.107152715.838511549.1495701112-1738332618.1494221417"
            },
            {
                title: "Front End Developer",
                parent: "Developer",
                city: "Bangalore",
                fullTime: true,
                salary: "₹2.4L to ₹7.2L",
                minExperience: 1,
                languages: "English, Hindi, Kannada",
                experience: " 1 - 3 Years ",
                description: "",
                skills: "AngularJS, SASS, Angular Material",
                responsibilities: [
                    "Delivering a complete front end application",
                    "Ensuring high performance on mobile and desktop",
                    "Writing tested, idiomatic, and documented JavaScript, HTML and CSS",
                    "Cooperating with the back-end developer in the process of building the RESTful API",
                    "Communicating with external web services"
                ],
                skillSet: [
                    "Proficiency with JavaScript and HTML5",
                    "Good understanding of modern CSS preprocessors (Sass, Scss,Less, etc.)",
                    "Professional, precise communication skills",
                    "Deep knowledge of AngularJS practices and commonly used modules based on extensive work experience",
                    " Good understanding of the Material Design Concepts",
                    "Creating self-contained, reusable, and testable modules and components",
                    "Ensuring a clear dependency chain, in regard to the app logic as well as the file system",
                    "Ability to provide SEO solutions for single page apps",
                    "Extensive knowledge of CSS and JS methods for providing performant visual effects and keeping the frame rate above 60 fps at all times",
                    "Thorough understanding of the responsibilities of the platform, database, API, caching layer, proxies, and other web services used in the system",
                    " Validating user actions on the client side and providing responsive feedback",
                    "Writing non-blocking code, and resorting to advanced techniques such as multi-threading, when needed",
                    "Creating custom, general use modules and components which extend the elements and modules of core AngularJS",
                    "Experience with all levels of operation available to the front-end, such as from creating XHRs in vanilla JS to using a custom wrapper around $resource",
                    "Experience with building the infrastructure for serving the front-end app and assets",
                    "Creating the architecture and automating the build process for production, using task runners or scripts",
                    "Documenting the code inline using JSDoc or other conventions",
                    "Writing extensive unit tests using automated TDD tasks",
                    "Creating e2e test suites for all components, and running them with Protractor (or a well reasoned alternative)",
                    "Creating configuration, build, and test scripts for Continuous Integration environments"
                ],

                url: "http://www.indeed.co.in/job/front-end-web-developer-b555428b86b8af5a?_ga=2.73771355.838511549.1495701112-1738332618.1494221417"
            }
        ];

        $scope.tabs = $scope.jobs.reduce(function (tab, job) {
            tab.push(job.parent);
            tab = _.uniq(tab);
            return tab;
        }, []);


        $scope.onTabSelected = function (tab) {
            $scope.jobsInTabs = $scope.jobs.filter(function (job) {
                return job.parent === tab;
            });
        };

        $scope.showApplyDialog = function () {
            $scope.populateTimes();
            $scope.apply = {};
            $mdDialog.show({
                templateUrl: 'careersApplyDialog.html',
                parent: angular.element(document.body),
                fullscreen: true,
                targetEvent: $scope.$ev,
                scope: $scope,        // use parent scope in template
                preserveScope: true,  // do not forget this if use parent scope
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        $scope.doSecondaryAction = function (job, ev) {
            $scope.selectedJob = job;
            $scope.$ev = ev;
            $mdDialog.show({
                contentElement: '#careersDialog',
                parent: angular.element(document.body),
                fullscreen: true,
                targetEvent: ev,
                scope: $scope,        // use parent scope in template
                preserveScope: true,  // do not forget this if use parent scope
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };


        $scope.applyForJob = function () {
            // var fd = new FormData();
            // fd.append('file', $scope.apply.file);
            // fd.append('job', $scope.selectedJob);
            // fd.append('user', $scope.apply);
            //
            // RestManager.postResource("/jobs/apply", {
            //     fd
            // }, "job")
            //     .then(function (data) {
            //
            //     })
            //     .catch(function (err) {
            //
            //     })
        };

        $scope.populateTimes = function () {
            $scope.times = [];
            for (var i = $scope.selectedJob.minExperience; i < 24; i++) {
                $scope.times.push(i);
            }
        };
    }])
    .directive('chooseFile', function () {
        return {
            scope: {
                ngModel: "="
            },
            link: function (scope, elem, attrs) {
                var button = elem.find('button');
                var input = angular.element(elem[0].querySelector('input#fileInput'));
                button.bind('click', function () {
                    input[0].click();
                });
                input.bind('change', function (e) {
                    scope.$apply(function () {
                        var files = e.target.files;
                        if (files[0]) {
                            scope.fileName = files[0].name;
                            scope.ngModel = files[0];
                        } else {
                            scope.fileName = null;
                            scope.ngModel = null;
                        }
                    });
                });
            }
        };
    });
;

(function () {
    'use strict';

    angular.module('app.profile', [])

})(angular);

(function () {
    'use strict';

    ProfileImage.$inject = ["Base"];
    angular.module("app.profile")
        .directive("profileImage", ProfileImage);

    /** @ngInject **/
    function ProfileImage(Base) {
        return {
            restrict: "E",
            transclude: false,
            replace: false,
            scope: {
                imageUrl: "@",
                userName: '@',
                small: '=',
                medium: '='
            },
            link: function ($scope, element, attrs) {
                $scope.mediaUrl = Base.getMediaUrl();

                $scope.class = 'large';

                if ($scope.medium) {
                    $scope.class = 'medium';
                }
                if ($scope.small) {
                    $scope.class = 'small';
                }

            },
            templateUrl: "app/modules/profile/profile-image/profile-image.tmpl.html"
        }
    }

})(angular);

(function () {
    'use strict';

    PostViewer.$inject = ["$scope", "$mdDialog", "postId", "index", "posts", "backState", "backParams", "mode", "RestManager", "$state", "$rootScope", "$mdMedia", "$stateParams", "$analytics"];
    angular.module('app.profile')
        .controller('post-viewer.controller', PostViewer);

    function PostViewer($scope, $mdDialog, postId, index, posts, backState, backParams, mode, RestManager, $state,
                        $rootScope, $mdMedia, $stateParams, $analytics) {
        $scope.selectedIndex = index || 0;
        $scope.posts = posts || [];
        $scope.postId = postId;
        $scope.gallery = $scope.posts.map(function (post) {
            return post.image;
        });
        $scope.mode = mode;
        $scope.isSmall = !$mdMedia('gt-sm');

        $scope.close = close;
        $scope.fetchPost = fetchPost;
        $scope.onPostChange = onPostChange;
        $scope.triggerAnalytics = triggerAnalytics;

        function triggerAnalytics(post, product) {
            $analytics.eventTrack(
                "PostProductClicked",
                {
                    postOwnerName: post.user.name,
                    postOwnerId: post.user._id,
                    ref: $stateParams.ref,
                    postId: post._id,
                    productId : product._id,
                    productSku : product.sku,
                    productPrice : product.price
                }
            );
        }

        function fetchPost(postId, event) {
            $scope.fetchingPost = true;
            RestManager.getResource('/posts/single/' + postId, 'posts')
                .then(function (posts) {
                    $scope.fetchingPost = false;
                    $scope.selectedPost = posts[0];
                    if (!$scope.posts.length && $scope.mode === 'page') {
                        $scope.posts = posts;
                        $scope.gallery = $scope.posts.map(function (post) {
                            return post.image;
                        });
                    }
                    $analytics.eventTrack(
                        "PostViewed",
                        {
                            postOwnerName: $scope.selectedPost.user.name,
                            postOwnerId: $scope.selectedPost.user._id,
                            ref: $stateParams.ref,
                            postId: $scope.selectedPost._id,
                            prevPostId: event ? $scope.posts[event.previousIndex]._id : null,
                            prevPostOwnerId: event ? $scope.posts[event.previousIndex].user._id : null,
                            eventType: event ? event.eventType : null,
                            eventAction: event ? event.eventAction : null
                        }
                    );
                    $rootScope.pageMeta = {
                        title: $scope.selectedPost.user.name + " (" + $scope.selectedPost.user.userName + ") | Aarida Fashion Profile",
                        description: "Follow " + $scope.selectedPost.user.userName + " on Aarida",
                        // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
                    };
                })
                .catch(function (err) {
                    console.log("post-viewer.controller.js", "err", err);
                    $scope.fetchingPost = false;
                })
        }

        $scope.$watch('selectedIndex', function (newVal) {
            if (newVal >= 0 && $scope.posts && $scope.posts.length && $scope.posts.length >= newVal) {
                $state.transitionTo('app.singlePost', {postId: $scope.posts[newVal]._id}, {
                    notify: false,
                    reload: false
                });
            }
        });

        function close() {
            if (!backParams) {
                backParams = {};
            }
            if (!backState) {
                backState = 'app.home';
            }
            if ($scope.mode === 'page' && $scope.posts && $scope.posts.length) {
                backState = 'app.profile';
                backParams = {userName: $scope.posts[0].user.userName}
            }
            if (backState) {
                $state.transitionTo(
                    backState,
                    backParams,
                    {
                        notify: $scope.mode === 'page',
                        reload: $scope.mode === 'page'
                    }
                )
            }
            $mdDialog.cancel();
        }

        function onPostChange(event) {
            setTimeout(function () {
                $scope.postId = $scope.posts[$scope.selectedIndex]._id;
                $scope.fetchPost($scope.postId, event);
            }, 0);
        }

        $scope.fetchPost(postId, null);
    }

})(angular);

/**
 * Created by kumardivyarajat on 02/11/16.
 */
angular.module("app.products", [])
    .controller("productController", ["Base", "$scope", "$analytics", "$rootScope", "$stateParams", "$window", "ProductsManager", "ProductSync", "$log", "$state", "$mdDialog", "RestManager", "$mdToast", "$mdMedia", "CartManager", "Utils", "AddressManager", "AuthManager", "WishListManager", "$timeout", "CustomisationManager", "FullStory", function (Base, $scope, $analytics, $rootScope, $stateParams, $window,
                                               ProductsManager, ProductSync, $log, $state, $mdDialog,
                                               RestManager, $mdToast, $mdMedia, CartManager, Utils, AddressManager,
                                               AuthManager, WishListManager, $timeout, CustomisationManager, FullStory) {
        $scope.product = '';
        $scope.mediaUrl = Base.getMediaUrl();
        $scope.cachedCopyLoaded = false;
        $scope.productLoaded = false;
        $scope.loadingUpsells = true;
        $scope.loadingProduct = true;
        $scope.loadingViews = true;
        $scope.views = 0;
        $scope.totalPrice = 0;
        $scope.hasViewCount = false;
        $scope.showPromoteButton = false;
        $scope.imageSize = 'medium';
        $scope.break = $mdMedia('gt-sm');
        $scope.viewDisplayPromise = '';
        $scope.zoomedIn = false;
        $scope.showFullScreenModal = false;
        $scope.loadingProduct = true;
        $scope.ucData = {
            name: '',
            customisation: '',
            data: [],
            product: ''
        };
        $scope.ctx = {
            refUser: $stateParams.RFX,
            refId: $stateParams.RFID,
            refType: $stateParams.RTYPE,
        };
        console.log("product.controller.js", "$scope.ctx", $scope.ctx);


        $scope.fetchProduct = fetchProduct;
        $scope.fetchCachedProduct = fetchCachedProduct;
        $scope.setPageMeta = setPageMeta;
        $scope.setVariation = setVariation;
        $scope.openCustomMeasurements = openCustomMeasurements;
        $scope.fetchWishList = fetchWishList;
        $scope.checkVariationInCart = checkVariationInCart;
        $scope.fetchSocialProof = fetchSocialProof;
        $scope.saveSelection = saveSelection;
        $scope.initCustomisation = initCustomisation;
        $scope.evaluateCustomisation = evaluateCustomisation;
        $scope.onAddToCart = onAddToCart;
        $scope.editProduct = editProduct;
        $scope.toggleZoomer = toggleZoomer;
        $scope.hideProgress = hideProgress;
        $scope.loadCachedProductData = loadCachedProductData;
        $scope.promoteProduct = promoteProduct;
        $scope.fetchPromoters = fetchPromoters;
        $scope.validateProduct = validateProduct;
        $scope.beforeAddToCartValidator = beforeAddToCartValidator;


        $rootScope.pageMeta = {
            title: 'Product Details'
        };

        function editProduct() {
            if ($scope.currentUser.contextData) {
                window.open($scope.currentUser.contextData.productEditUrl.replace('${productId}', $scope.product._id), '_blank');
            } else {
                $mdToast.showSimple('Context Data not set. Please contact your Wordpress admin to integrate Magento into the website.');
            }
        }

        function promoteProduct() {
            if ($scope.currentUser.contextData) {
                RestManager
                    .patchResource($scope.currentUser.contextData.productPromoteUrl + $scope.currentUser._id + '/' + $scope.product._id, {}, 'result')
                    .then(function (result) {
                        $scope.promoted = result[0].isPromoted;
                        $mdToast.showSimple($scope.promoted ? 'You are now promoting this product' : 'You are no longer promoting this product');
                    })
            } else {
                $mdToast.showSimple('Context Data not set. Please contact your Wordpress admin to integrate Magento into the website.');
            }
        }

        function fetchPromoters() {
            $scope.loadingPromoters = true;
            RestManager.getResource('/products/promoters/' + $scope.product._id, 'promoters')
                .then(function (promoters) {
                    $scope.product.promoters = promoters;
                    $scope.loadingPromoters = false;
                })
                .catch(function (err) {
                    $scope.loadingPromoters = false;
                })
        }


        function onAddToCart(data) {
            if (data.saved) {
                $scope.saving = false;
                $scope.addedToCart = true;
                $scope.addedNow = true;
                $scope.openCart();
                $scope.selectedVariation = undefined;
            } else {
                console.log(data);
            }

        }

        function fetchCachedProduct() {
            if ($stateParams.product) {
                $scope.loadCachedProductData($stateParams.product);
            } else {
                ProductSync.get($stateParams.productSlug)
                    .then(function (product) {
                        $scope.loadCachedProductData(product);
                    })
                    .catch(function (err) {
                        console.log('Error while fetching the cached copy of ' + $stateParams.productSlug, err);
                        $scope.fetchProduct();
                    })
            }
        }

        function loadCachedProductData(product) {
            if (product) {
                product.gallery = product.gallery.filter(function (o) {
                    return o._id !== product.featured_image._id;
                });
                product.gallery.unshift(product.featured_image);
                $scope.totalPrice = product.price;
                $scope.product = product;
                $scope.cachedCopyLoaded = true;
                $scope.loadingProduct = false;
            }
            $scope.fetchProduct();
        }

        $scope.fetchCachedProduct();

        function saveSelection(data, option, index) {
            data.error = null;
            $scope.product.customisation.data[index].default = option;

            $scope.ucData.data[index].selectedValues = [option._id];

            // var salePrice = 0;
            // if (option.stockAndPrice.price.salePrice !== null) {
            //     salePrice = option.stockAndPrice.price.salePrice;
            // }
            // $scope.product.price = $scope.product.customisation.basePrice + salePrice;
            $scope.evaluateCustomisation();
        }

        function fetchSocialProof(productName) {
            RestManager.getResource('', "count", {query: {productName: productName}, service: "socialProof"})
                .then(function (data) {
                    $scope.views = data[0];
                    if ($scope.views > 0) {
                        $scope.hasViewCount = true;
                        $scope.viewDisplayPromise = $timeout(function () {
                            $scope.hasViewCount = false;
                        }, 3000);
                    }
                    $scope.loadingViews = false;
                })
                .catch(function (err) {
                    console.log('Error loading social proof', err);
                    $scope.loadingViews = false;
                })
        }

        function fetchProduct() {
            ProductsManager.fetchSingleProduct($stateParams.productSlug)
                .then(function (product) {
                    product.gallery = product.gallery.filter(function (o) {
                        return o._id !== product.featured_image._id;
                    });

                    product.gallery.unshift(product.featured_image);
                    $scope.product = product;
                    $scope.totalPrice = product.price;
                    $scope.product.name = _.startCase(_.toLower($scope.product.name));
                    $scope.selectedImage = product.gallery[0];
                    $scope.selectedIndex = 0;
                    $scope.selectedVariationFull = '';
                    $scope.variations = $scope.product.variations;
                    $scope.product.attributes = $scope.product.attributes.map(function (attr) {
                        attr.valueText = '';
                        attr.key = attr.attribute.meta_key;
                        attr.selectedValues.forEach(function (val, i) {
                            attr.valueText += val.value.trim() + ((i !== attr.selectedValues.length - 1) ? ', ' : '')
                        });
                        return attr;
                    });
                    $scope.fetchRecommendedProducts();
                    $scope.setPageMeta($scope.product.name);
                    $scope.setVariation();
                    $scope.reorderSizes();
                    if (Base.getEnv() === 'prod') {
                        $scope.fetchSocialProof($scope.product.name);
                    }
                    //TODO : Call the code to reorder layers before initCustomisation
                    if ($scope.product.productType === 1) {
                        $scope.initCustomisation();
                    }
                    $scope.productLoaded = true;
                    $scope.loadingProduct = false;
                    $scope.imageSize = 'large';
                    $scope.currentUser = AuthManager.getCurrentUser();
                    if ($stateParams.preview === 'true') {
                        // $scope.openFullScreenZoomer();
                    } else {
                        $scope.cancel();
                    }
                    $scope.loadingProduct = false;
                    $scope.showPromoteButton = ['admin', 'influencer'].includes($scope.currentUser.role);
                    $scope.promoted = _.findIndex($scope.product.promoters, function (p) {
                        return p.user === $scope.currentUser._id;
                    }) !== -1;
                    $scope.fetchPromoters();

                })
                .catch(function (err) {
                    $scope.loadingProduct = false;
                    if (err.code === 404) {
                        $scope.productLoadError = "Something went wrong. Looks like this product does not exist anymore.";
                    } else {
                        $scope.productLoadError = 'Oops. Looks like a snag. Please try after some time.';
                    }
                });
        }

        function initCustomisation() {
            if ($scope.product.editorType === 'simple') {
                $scope.ucData.name = $scope.product.name;
                $scope.ucData.product = $scope.product._id;
                $scope.ucData.customisation = $scope.product.customisation._id;
                $scope.product.customisation.data = $scope.product.customisation.data
                    .map(function (data) {
                        if (!data.options.length) {
                            data.hide = true;
                        } else {
                            if (data.default && data.default.outOfStock) {
                                data.default = null;
                            }
                            // data.default = data.default || data.options[0];
                        }
                        return data;
                    })
                    .filter(function (data) {
                        return !data.hide;
                    });

                $scope.ucData.data = $scope.product.customisation.data.map(function (data) {
                    return {
                        dataId: data._id,
                        selectedValues: [data.default ? data.default._id : null]
                    };
                });

                $scope.evaluateCustomisation();
            } else {
                $scope.ucData = 'default';
            }
        }

        function evaluateCustomisation() {
            $scope.totalPrice = $scope.product.customisation.basePrice;
            _.forEach($scope.product.customisation.data, function (datum, i) {
                if (datum.default) {
                    $scope.totalPrice += Utils.getPrice(datum.default.stockAndPrice, true);
                }
            });
        }

        function setPageMeta(productName) {
            $rootScope.pageMeta = {
                title: productName + ' | Free Shipping * 14 day Returns * COD',
                image: $scope.mediaUrl + $scope.product.featured_image.urls.medium,
                description: "Buy " + productName + " available from Rs. " + $scope.product.price + " only on Aarida",
                price: $scope.product.price,
                sku: $scope.product.sku,
                outOfStock: $scope.product.outOfStock,
                availability: $scope.product.outOfStock ? 'out of stock' : 'in stock',
                keywords: productName + ", aarida, Shop Customised clothing, Buy " + productName + " only on Aarida.com."
            };

            $analytics.eventTrack(
                'ViewContent',
                {
                    value: $scope.product.price,
                    currency: 'INR',
                    content_ids: [$scope.product.sku],
                    content_name: $scope.product.name,
                    content_category: $scope.product.categoriesText,
                    contents: [
                        {
                            id: $scope.product.sku,
                            quantity: 1,
                            item_price: $scope.product.price
                        }
                    ],
                    content_type: 'product',
                    product_type: $scope.product.productType ? 'Customisable' : 'Simple',
                    editor_type: $scope.product.editorType
                }
            )


            $analytics.eventTrack(
                "Product Page",
                {
                    page: "/product/" + $scope.product.slug,
                    id: $scope.product._id,
                    name: $scope.product.name,
                    auth: AuthManager.isUserLoggedIn
                }
            );
        }

        function validateProduct(product) {
            var hasError = false;
            if(!product.customisation) {
                return true;
            }
            product.customisation.data = product.customisation.data.map(function (datum, index) {
                datum.index = index;
                if (!datum.default) {
                    datum.error = 'Please select ' + datum.name + ' first';
                    hasError = true;
                } else {
                    datum.error = null;
                }
                return datum;
            });
            if (hasError) {
                var scrollTarget = _.find(product.customisation.data, function (datum) {
                    return datum.error;
                });
                var scrollPosition = document.getElementById('layer-' + scrollTarget.index).offsetTop;
                var finalPosition = $scope.isSmall ? scrollPosition + 500 :  scrollPosition;
                Base.scrollToPosition(finalPosition, 500);
                // document.getElementById('body').scrollTop = finalPosition;
                return false;
            } else {
                return true;
            }
        }

        function beforeAddToCartValidator(event) {
            return $scope.validateProduct(event.product);
        }


        function openCustomMeasurements(ev, openEditView) {
            if (!$scope.validateProduct($scope.product)) {
                return;
            }
            $mdDialog.show({
                // contentElement: '#openCustomMeasurementsDialog',
                templateUrl: 'app/main/custom-measurement-dialog/measurements-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                controller: 'measurement.controller',
                locals: {
                    ucData: $scope.product.productType === 1 ? $scope.ucData : null,
                    product: $scope.product,
                    variations: $scope.product.variations,
                    sizeChart: $scope.product.sizeChart,
                    selectedVariation: null,
                    customMeasurement: null,
                    openEditView: openEditView,
                    returnData: false,
                    ctx: $scope.ctx
                },
                fullscreen: false,
                clickOutsideToClose: true,
                escapeToClose: true
            })
                .then(function (result) {
                    $scope.saving = false;
                    $scope.addedToCart = true;
                    $scope.addedNow = true;
                    // $mdToast.show(
                    //     $mdToast.simple({
                    //         hideDelay: 3000,
                    //         position: 'bottom left',
                    //         content: "Product Added to Cart"
                    //     })
                    // );
                    $scope.openCart();
                    $scope.selectedVariation = undefined;
                })
                .catch(function (err) {

                });
        }

        function fetchWishList() {
            WishListManager.getWishlistOutline()
                .then(function (wishlist) {
                    $scope.wishListProducts = wishlist.products;
                    $scope.checkIfProductIsInWishlist();
                })
                .catch(function (reason) {
                    console.log(reason);
                })
        }

        function setVariation() {
            if ($scope.product.variations.length === 1) {
                $scope.selectedVariation = $scope.product.variations[0]._id;
                $scope.selectedVariationFull = $scope.product.variations[0];
            }
        }

        function checkVariationInCart(vid) {
            return CartManager.checkProductInCart($scope.product._id, vid);
        }


        $scope.getVariationValue = function (variation) {
            var varId = variation.attributes[0].selectedValue[0];

            var a = _.find(variation.attributes[0].attribute.meta_values, function (meta_value) {
                return meta_value._id === varId;
            });
            if (a) {
                return a.value;
            }
        };

        $scope.checkIfProductIsInWishlist = function () {
            if ($scope.wishListProducts) {
                var a = _.find($scope.wishListProducts, function (o) {
                    return o === $scope.product._id;
                });
                //
                if (a) {
                    $scope.product.inWishlist = true;
                }
                return a;
            } else {
                return false;
            }
        };


        $scope.fetchRecommendedProducts = function () {
            $scope.loadingUpsells = true;
            RestManager.getResource("/products/recommendations/" + $scope.product._id, "products")
                .then(function (products) {
                    $scope.loadingUpsells = false;
                    $scope.recommendedProducts = products;
                })
                .catch(function (err) {
                    $scope.loadingUpsells = false;

                })
        };


        $scope.perfomWishListAction = function (ev) {
            // if (AuthManager.isUserLoggedIn) {
            ev.stopPropagation();
            var promise, message;
            var product = $scope.product;
            if (product.inWishlist) {
                promise = WishListManager.removeFromWishlist(product);
                message = "Removed " + product.name + " from wishlist";
            } else {
                promise = WishListManager.addToWishList(product);
                message = "Added " + product.name + " to wishlist";
            }

            promise
                .then(function (data) {
                    //
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position("bottom right")
                            .capsule(true)
                            .hideDelay(3000)
                    );

                    if (product.inWishlist) {
                        $analytics.eventTrack(
                            "Removed From Wishlist",
                            {product: product.name}
                        );
                    } else {
                        $analytics.eventTrack(
                            "Added To Wishlist",
                            {product: product.name}
                        );
                    }
                    product.inWishlist = !product.inWishlist;
                })
                .catch(function (err) {
                    message = "Unable to connect to server.";
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .highlightClass('red')// Accent is used by default, this just demonstrates the usage.
                            .position("bottom right")
                            .hideDelay(3000)
                    );
                });
        };

        $scope.showSizeChart = function (ev) {

            $mdDialog.show({
                contentElement: '#sizeChartDialog',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,        // use parent scope in template
                preserveScope: true,  // do not forget this if use parent scope
                clickOutsideToClose: true
            });
        };

        $scope.findValue = function (size, index, parent, key) {
            try {
                return size.values[parent].value ? size.values[parent].value : 0;
            } catch (err) {
                return 0;
            }
        };

        $scope.cancel = function () {
            $mdDialog.hide();
        };


        $scope.selectVariation = function (variation) {
            $scope.selectedVariation = variation._id;
            $scope.selectedVariationFull = variation;
            $scope.a = variation;
            $analytics.eventTrack(
                "Variation Selected",
                {
                    page: "/product/" + $scope.product.slug,
                    name: $scope.product.name,
                    id: $scope.product._id,
                    size: $scope.getVariationValue(variation)
                }
            );
        };


        $scope.selectModalImage = function (image) {
            $scope.modalImage = image;
            $scope.modalImage.zoomProgressLoader = true;
        };

        $scope.showSimpleToast = function () {
            $mdToast.show(
                $mdToast.simple()
                    .position("bottom right")
                    .textContent('Please select a size first.')
                    .hideDelay(3000)
            );
        };

        $scope.evaluteCustomisationState = function () {
            var a = [];
            $scope.product.customisation.data
                .map(function (datum) {
                    if (datum.default !== undefined) {
                        if (typeof datum.default === "number") {
                            a.push({
                                dataId: datum._id,
                                selectedValues: [datum.options[datum.default]._id]
                            })
                        } else if (typeof datum.default === "string") {
                            a.push({
                                dataId: datum._id,
                                selectedValues: [datum.default]
                            })
                        }
                    }
                    return datum;
                });
            return a;
        };

        $scope.addToCart = function (ev) {
            // $log.info("Addtocart", $scope.selectedVariation, $scope.product.variations);
            if ($scope.product.productType === 1 && !AuthManager.isUserLoggedIn) {
                AuthManager.showLoginModal(ev, $scope, true);
                return;
            }
            if (!$scope.selectedVariation) {
                $scope.showSimpleToast();
                $analytics.eventTrack(
                    "Variation Not Selected",
                    {product: $scope.product.name}
                );

                $mdDialog.show({
                    clickOutsideToClose: true,
                    targetEvent: ev,
                    scope: $scope,
                    preserveScope: true,
                    contentElement: '#variationsDialog',
                    parent: angular.element(document.body)
                });
            } else {
                if (!$scope.validateProduct($scope.product)) {
                    return;
                }
                if (AuthManager.isUserLoggedIn) {
                    $scope.promise = CartManager.addToCart($scope.product._id, $scope.selectedVariation, 1, $scope.product.productType === 1 ? "default" : undefined, $scope.ctx)
                } else {
                    $scope.promise = CartManager.addToCart($scope.product, $scope.selectedVariationFull, 1, $scope.product.productType === 1 ? "default" : undefined, $scope.ctx)
                }
                $scope.promise
                    .then(function (cart) {
                        // $log.info("response sdf", cart);
                        $scope.addedToCart = true;
                        // $mdToast.show(
                        //     $mdToast.simple()
                        //         .position("bottom left")
                        //         .textContent('Done adding to cart')
                        //         .hideDelay(3000)
                        // );

                        $scope.openCart();
                        $scope.selectedVariation = "undefined";
                        $analytics.eventTrack(
                            "Added to Cart",
                            {
                                product: $scope.product.name,
                                variation: $scope.product.variations.length > 1 ? $scope.getVariationValue($scope.a) : "NONE",
                                productType: $scope.product.productType,
                                id: $scope.product._id,
                                sku: $scope.product.sku
                            }
                        );
                        FullStory.trackEvent('AddToCart', {
                            value: $scope.totalPrice,
                            currency: 'INR',
                            content_ids: [$scope.product.sku],
                            content_name: $scope.product.name,
                            content_category: $scope.product.categoriesText,
                            contents: [
                                {
                                    id: $scope.product.sku,
                                    quantity: 1,
                                    item_price: $scope.product.price
                                }
                            ],
                            content_type: 'product',
                            product_type: $scope.product.productType ? 'Customisable' : 'Simple',
                            editor_type: $scope.product.editorType,
                            variation: $scope.selectedVariation
                        });
                    })
                    .catch(function (err) {
                        // $log.info("err", err);
                        $mdToast.show(
                            $mdToast.simple()
                                .position("bottom right")
                                .textContent(err.message)
                                .hideDelay(3000)
                        );
                    });
                // } else {
                //     $scope.openLoginModal(ev, $scope, true);
                // }
            }
        };

        $scope.openLoginModal = function (ev) {
            AuthManager.showLoginModal(ev, $scope);
        };

        $scope.zoomX = 0;
        $scope.zoomY = 0;

        $scope.showZoomTool = function (ev) {
            $scope.showPopup = true;

            $scope.zoomX = -1.5 * ev.offsetX;
            $scope.zoomY = -1.75 * ev.offsetY;

        };

        $scope.hideZoomTool = function (ev) {
            $scope.showPopup = false;
        };


        $scope.sizePriority = Utils.getSizePriority;

        $scope.reorderSizes = function () {
            if ($scope.product.variations.length && $scope.product.variations[0].attributes.length > 0)
                $scope.product.variations = _.sortBy($scope.product.variations, [function (o) {
                    var a = $scope.sizePriority[$scope.getVariationValue(o)];

                    return a;
                }]);

        };


        $scope.loginUser = function () {
            // $log.info("loggged in", $scope.user);
            AuthManager.loginUser($scope.user.mobile, $scope.user.password)
                .then(function (user) {
                    $scope.isUserLoggedIn = true;
                    $scope.currentUser = user;
                    return CartManager.getUserCart()
                })
                .then(function (cart) {

                    $scope.cancel();
                })
                .catch(function (err) {

                })
        };

        $scope.logout = function () {
            $scope.currentUser = "";
            $scope.isUserLoggedIn = AuthManager.isUserLoggedIn;
            AuthManager.logout();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.getProperName = function (str) {
            return _.startCase(_.toLower(_.truncate(str, {'length': 40, 'separator': ' '})));
        };

        $scope.gotoDetailsPage = function (slug, product) {
            if (product.productType && product.editorType !== 'simple' && $scope.isSmall) {
                return $state.transitionTo('app.customisationEditor', {slug: product.slug, flags: 'none'});
            } else {
                return $state.transitionTo('app.product', {productSlug: product.slug, product: product});
            }
        };


        $scope.openFullScreenZoomer = function (e) {
            $scope.modalImage = $scope.selectedImage;
            $scope.modalImage.zoomProgressLoader = true;
            $state.transitionTo("app.product", {productSlug: $stateParams.productSlug, preview: true}, {
                reload: false,
                notify: false,
                location: true
            });
            $mdDialog.show({
                clickOutsideToClose: true,
                targetEvent: e,
                scope: $scope,
                preserveScope: true,
                fullScreen: true,
                contentElement: '#imageBoxDialog',
                parent: angular.element(document.body)
            })
                .catch(function () {
                    // $window.history.back();
                    $state.transitionTo("app.product", {productSlug: $stateParams.productSlug}, {
                        reload: false,
                        notify: false,
                        location: 'replace'
                    })
                });
        };

        var maxScale = 2.0;
        var minScale = 1.0, currentScale = 1.0;
        var element = angular.element(document.getElementById("showcaseImage"))[0];
        $scope.zoom = function (direction) {
            if (direction && (currentScale <= maxScale)) {
                currentScale += 0.2;
            } else if (!direction && (currentScale > minScale)) {
                currentScale -= 0.2;
            }
            element.style.transform = "scale(" + currentScale + ")";
        };

        function hideProgress() {
            $scope.modalImage.zoomProgressLoader = false;
        }

        function toggleZoomer() {
            var element = angular.element(document.getElementById("showcaseImage"))[0];
            if (!$scope.zoomedIn) {
                currentScale += 1;
            } else {
                currentScale -= 1;
            }
            $scope.zoomedIn = !$scope.zoomedIn;
            element.style.transform = "scale(" + currentScale + ")";
        }

        $scope.changeSelectedImage = function (s) {
            $scope.selectedImage = s;
        };

        $scope.getSizeLabel = function () {
            if ($scope.productLoaded &&
                $scope.product.productType === 1 &&
                $scope.product.editorType === 'simple' &&
                $scope.product.customisation.data) {
                return 'Step ' + ($scope.product.customisation.data.length + 1) + ' : Select Size';
            } else {
                return 'Select Size';
            }
        };


        $scope.$on('$destroy', function (event) {
            if ($scope.viewDisplayPromise) {
                $timeout.cancel($scope.viewDisplayPromise);
            }
        });

        // $rootScope.$on("loggedIn", function ($event, data) {
        //
        //     $scope.addToCart($event);
        // });

        $scope.fetchWishList();
    }]);

/**
 * Created by kumardivyarajat on 04/11/16.
 */
angular.module("app.products")
    .service("ProductsManager", ["$http", "$q", "Base", "Utils", function ($http, $q, Base, Utils) {
        var Products = this;
        this._products = [];
        this._allProductsLoaded = false;
        this._productsBaseUrl = Base.getBaseUrl() + "/products";

        /***
         * @author - Kumar Divya Rajat
         * @date - 04/11/16
         * @method - fetchProductsByCategory
         * @description - Fetches the products related to a category
         ***/
        Products.fetchProductsByCategory = function (id) {
            return $q(function (resolve, reject) {
                $http.get(Products._productsBaseUrl + "/category/" + id)
                    .then(function (response) {
                        //
                        if (response.data.code == 200) {
                            // Products._products = response.data.message.products;
                            resolve({products: response.data.message.products, count: response.data.totalCount, attributes : response.data.attributes});
                        } else {
                            //
                            reject();
                        }
                    })
                    .catch(function (err) {
                        //
                        reject(err);
                    });
            });
        };

        Products.fetchAllProducts = function () {
            return $q(function (resolve, reject) {
                $http.get(Products._productsBaseUrl)
                    .then(function (response) {
                        //
                        if (response.data.code == 200) {
                            // Products._products = response.data.message.products;
                            // Products._allProductsLoaded = true;
                            resolve({products: response.data.message.products, count: response.data.totalCount});
                        } else {
                            //
                            reject();
                        }
                    })
                    .catch(function (err) {
                        //
                        reject(err);
                    });
            });
        };


        Products.fetchSingleProduct = function (slug) {
            var deferred = $q.defer();
            //
            if (Products._products.length > 0) {
                var a = Utils.performSearchBySlug(slug, Products._products);
                if (!a) {
                    performFetchSingleProduct(slug, deferred);
                } else {
                    //
                    deferred.resolve(a);
                }
            } else {
                performFetchSingleProduct(slug, deferred);
            }
            return deferred.promise;
        };

        function performFetchSingleProduct(slug, deferred) {
            $http.get(Products._productsBaseUrl + "/slug/f/" + slug)
                .then(function (response) {
                    //
                    if (response.data.code === 200) {
                        // Products._products.push(response.data.message.products[0]);
                        deferred.resolve(response.data.message.products[0]);
                    } else {
                        //
                        deferred.reject(response.data);
                    }
                })
                .catch(function (err) {
                    //
                    deferred.reject(err);
                })
        }

    }]);

/**
 * Created by kumardivyarajat on 02/11/16.
 */
angular.module("app.products")
    .directive("mdProductCard", ["Base", function (Base) {
        return {
            restrict: "E",
            transclude: true,
            scope: {
                product: "="
            },
            link: function (scope, attrs, element) {
                //
                scope.baseUrl = Base.getBase();
            },
            templateUrl: "app/modules/products/partials/productCard.html",
            controller: ["$scope", function ($scope) {
                var vm = $scope;


                vm.getProperName = getProperName;
                vm.checkIfNew = checkIfNew;


                function getProperName(str) {
                    return _.startCase(_.toLower(_.truncate(str, {'length': 40, 'separator': ' '})));
                }

                function checkIfNew(createdAtDate) {
                    return moment().diff(moment(createdAtDate), "days") <= 120;
                }

            }]
        }
    }]);

/**
 * Created by kumardivyarajat on 22/11/16.
 */
angular.module("app.main")
    .controller("login.controller", ["$scope", "$stateParams", "$rootScope", "$timeout", "AuthManager", "$log", "ErrorHero", "CartManager", "$state", function ($scope, $stateParams, $rootScope, $timeout, AuthManager, $log, ErrorHero, CartManager, $state) {
        //
        $scope.showRegistrationForm = false;
        $scope.hideCloseBtn = true;

        console.log($stateParams);

        if (AuthManager.isUserLoggedIn) {
            $state.go("app.account.home");
        }

        $scope.showForgotPassword = function () {
            $scope.showForgotPasswordForm = true;
            $scope.showRegistrationForm = false;
            $scope.showOtpForm = false;
        };

        $scope.backToLogin = function () {
            $scope.showForgotPasswordForm = false;
            $scope.showRegistrationForm = false;
            $scope.showOtpForm = false;
        };

        $scope.checkDetail = function (e) {
            authLoading = true;
            $scope.authPromise = RestManager.postResource("/users/getAccountDetail", {mobile: $scope.user.mobile}, "data");
            $scope.authPromise
                .then(function (result) {
                    $scope.initi = true;
                    authLoading = false;
                    $scope.hasAccount = result[0].hasAccount;
                    $scope.onboardUser = result[0].onBoardUser;
                })
                .catch(function (err) {
                    authLoading = false;
                    $scope.formError = err.message;
                })
        };


        $scope.generateOTP = function ($event) {
            //
            try {
                $scope.authPromise = AuthManager.requestOTP($scope.user.mobile, $scope.newUser.email);
                $scope.authPromise
                    .then(function () {
                        $timeout(function () {
                            $scope.showRegistrationForm = false;
                            $scope.showOtpForm = true;
                            $scope.changingPassword = false;
                        });
                    })
                    .catch(function (err) {
                        //
                        $scope.formError = err.message;
                    })
            } catch (er) {

            }
        };

        $scope.forgotPassword = function () {

            $scope.formError = "";
            $scope.authPromise = AuthManager.forgotPassword($scope.newUser.mobile);

            $scope.authPromise.then(function () {
                $analytics.eventTrack(
                    "Forgot Password",
                    {"completed": "true"},
                    {"mobile": $scope.newUser.mobile}
                );
                $scope.showForgotPasswordForm = false;
                $scope.showRegistrationForm = false;
                $scope.showOtpForm = true;
                $scope.changingPassword = true;
                $scope.newUser.password = "";

            })
                .catch(function (err) {

                    if (err.code === 436) {
                        $analytics.eventTrack(
                            "Forgot Password",
                            {"completed": "false"},
                            {"reason": err.message},
                            {"mobile": $scope.newUser.mobile}
                        );
                        $scope.formError = err.message;
                    }
                })

        };

        $scope.signUp = function () {
            if (!$scope.newUser.otp) {
                $mdToast.show({
                    hideDelay: 3000,
                    position: 'bottom right',
                    content: "Please enter your otp"
                });
            } else {
                $scope.authPromise = AuthManager.signup($scope.newUser);
                $scope.authPromise
                    .then(function (user) {
                        $scope.isUserLoggedIn = true;
                        $scope.currentUser = user;
                        return CartManager.getUserCart()
                    })
                    .then(function (cart) {
                        //
                        $scope.fetchWishList();
                        $scope.cancel();
                        $scope.user = {};
                    })
                    .catch(function (err) {
                        // $log.error(err);
                        $scope.formError = err.message;

                    })
            }
        };

        $scope.changePassword = function (e) {

            if (!$scope.newUser.otp || !$scope.newUser.mobile || !$scope.newUser.password || !$scope.newUser.confirmPassword ||
                $scope.newUser.confirmPassword !== $scope.newUser.password) {
                $mdToast.show({
                    hideDelay: 3000,
                    position: 'bottom right',
                    content: "Some details are either missing or wrong. Please re-check the form."
                });
            } else {
                $scope.authPromise = AuthManager.resetPassword($scope.newUser);
                $scope.authPromise
                    .then(function (user) {
                        $analytics.eventTrack("Password Change", {
                            // "mobile": $scope.newUser.mobile,
                            "completed": true
                        });
                        $mdToast.show({
                            hideDelay: 3000,
                            position: 'bottom right',
                            theme: "white-toast",
                            content: "Password changed successfully. Please login with your new credentials."
                        });
                        $scope.showForgotPasswordForm = false;
                        $scope.showRegistrationForm = false;
                        $scope.showOtpForm = false;
                        $scope.changingPassword = false;
                        $scope.newUser = "";

                    })
                    .catch(function (err) {
                        $scope.formError = err.message;
                        $analytics.eventTrack("Password Change", {
                            // "mobile": $scope.newUser.mobile,
                            "completed": false,
                            reason: err.message
                        });
                        $mdToast.show({
                            hideDelay: 3000,
                            position: 'bottom right',
                            content: err.message
                        });
                    })
            }

        };


        $scope.loginUser = function () {
            // $log.info("loggged in", $scope.user);
            $scope.authLoading = true;
            AuthManager.loginUser($scope.user.mobile, $scope.user.password)
                .then(function (user) {
                    $scope.isUserLoggedIn = true;
                    $scope.currentUser = user;
                    return CartManager.getUserCart()
                })
                .then(function (cart) {
                    //
                    $scope.fetchWishList();
                    $scope.authLoading = false;
                    $scope.cancel();
                    $scope.user = {};
                })
                .catch(function (err) {
                    $scope.formError = err.message;
                    //
                    $scope.authLoading = false;
                    $scope.errorText = err.message;
                })
        };
    }]);

/**
 * Created by kumardivyarajat on 14/03/17.
 */
angular.module("app.main")
    .controller("authCallbackCtrl", ["$scope", "$stateParams", "$cookies", "RestManager", "$rootScope", "$timeout", "AuthManager", "$log", "ErrorHero", "CartManager", "$state", function ($scope, $stateParams, $cookies, RestManager, $rootScope, $timeout, AuthManager, $log, ErrorHero, CartManager, $state) {
        var platform = $stateParams.platform;
        var code = $stateParams.code;
        $scope.loading = !!$stateParams.loading;

        console.log(code);
        $scope.authLoading = true;
        RestManager.getResource("/users/auth/google/callback?code=" + code, "users")
            .then(function (users) {
                console.log('Usre',users);
                var state = $cookies.getObject("mlnState");
                var params = $cookies.getObject("mlnParams");
                $scope.authLoading = false;
                AuthManager.setCurrentUser(users[0]);

                $rootScope.backState = state || 'app.home';
                console.log('----------------------', $rootScope.backState)
                $rootScope.backParams = params;
                console.log('-------------0000000000---------', $rootScope.backParams)
                $rootScope.$broadcast("loggedIn", users[0]);
            })
            .catch(function (err) {

            });
    }]);

(function () {
    "use strict";
    angular.module("app.home")
        .component('aadiraActions', actions);

    function actions() {
        return {
            transclude: false,
            replace: true,
            require: {},
            bindings: {
                howCustomisationWorks: "<"
            },
            controller: function () {
                this.$onInit = function () {

                };
            },
            templateUrl: './actions.html'
        }
    }
})(angular);

/**
 * Created by Nidhu on 12/11/16.
 */
angular.module("app.customisation", ["ng.deviceDetector"])
    .controller("customisation.home.controller", ["$scope", "RestManager", "$rootScope", "Utils", "$mdDialog", function ($scope, RestManager, $rootScope, Utils, $mdDialog) {

        // $scope.products = [];

        $rootScope.pageMeta = {
            title: "Customisable Products",
            description: "Customise your dresses on aarida."
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };

        // $scope.fetchTemplates = function () {
        //     RestManager.getResource("/ucData/templates", "ucData")
        //         .then(function (templates) {
        //             $scope.products = templates;
        //             // var a = _.groupBy(templates, function (o) {
        //             //     return o.product._id;
        //             // });
        //             //
        //             // _.forOwn(a, function (val, key) {
        //             //     //
        //             //     var b = _.find($scope.products, function (o) {
        //             //         return o.parent && o._id === key;
        //             //     });
        //             //
        //             //     if (!b) {
        //             //         var p = {};
        //             //         angular.copy(val[0], p);
        //             //         p.parent = true;
        //             //         p.isTemplate = false;
        //             //         p.data = "";
        //             //         p.templates = val;
        //             //         $scope.products.push(p);
        //             //     }
        //             // });
        //
        //             //
        //         })
        //         .catch(function (err) {
        //
        //         })
        // };
        //
        // $scope.cancel = function () {
        //     $mdDialog.hide();
        // };
        //
        // $scope.fetchTemplates();
        //
        // $scope.sortPosition = function (name) {
        //     switch (name) {
        //         case "Fabric" :
        //             return 0;
        //
        //         case "Neck" :
        //             return 1;
        //
        //         case "Sleeves" :
        //             return 2;
        //
        //         case "Length" :
        //             return 3;
        //
        //         default :
        //             return 4;
        //     }
        // };
        //
        // $scope.getCustomisationFromTemplate = function (template) {
        //     template.data.forEach(function (datum) {
        //         var a = _.find(template.customisation.data, function (cData) {
        //             return cData._id === datum.dataId;
        //         });
        //
        //         var b;
        //         if (datum.selectedValues.length > 0) {
        //             b = datum.selectedValues[0];
        //         } else {
        //             b = a.default;
        //         }
        //
        //         a.default = _.findIndex(a.options, function (option) {
        //             return option._id === b;
        //         });
        //     });
        //
        //
        //     template.customisation.data = _.sortBy(template.customisation.data, function (o) {
        //         return $scope.sortPosition(o.name);
        //     });
        //
        //     return template.customisation;
        // };
        //
        // $scope.getIcon = function (name) {
        //   return Utils.getIcon(name);
        // };


    }]);

/**
 * Created by Kumar Divya Rajat on 12/11/16.
 */
angular.module("app.customisation")
    .service("CustomisationManager", ["$q", "$log", "$http", "Base", "AuthManager", "ErrorHero", function ($q, $log, $http, Base, AuthManager, ErrorHero) {

        this._customisableProducts = [];
        this.getCustomisableProducts = function () {
            var that = this;
            return $q(function (resolve, reject) {
                if (that._customisableProducts.length > 0) {
                    resolve(that._customisableProducts);
                } else {
                    $http.get(Base.getBaseUrl() + "/products/customisation")
                        .then(function (response) {
                            //
                            if (response.data.code == 200) {
                                resolve(response.data.message.products);
                            } else {
                                reject(ErrorHero(response));
                            }
                        })
                        .catch(function (err) {
                            reject(err);
                        })

                }
            })
        };

        this.createCustomisation = function (data) {
            return $q(function (resolve, reject) {
                $http.post(Base.getBaseUrl() + "/ucData", data)
                    .then(function (response) {
                        //
                        if (response.data.code == 200) {
                            resolve(response.data.message.ucData[0]);
                        } else {
                            reject(ErrorHero(response));
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };

        this.getAllUCForUser = function () {
            return $q(function (resolve, reject) {
                $http.get(Base.getBaseUrl() + "/ucData")
                    .then(function (response) {
                        //
                        if (response.data.code == 200) {
                            resolve(response.data.message.ucData);
                        } else {
                            reject(ErrorHero(response));
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };


        this.getSinlgeUcDataBySlug = function (slug) {
            return $q(function (resolve, reject) {
                $http.get(Base.getBaseUrl() + "/ucData/" + slug)
                    .then(function (response) {
                        //
                        if (response.data.code == 200) {
                            resolve(response.data.message.ucData[0]);
                        } else {
                            reject(ErrorHero(response));
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };

        this.updateCustomisation = function (slug, data) {
            return $q(function (resolve, reject) {
                $http.put(Base.getBaseUrl() + "/ucData/" + slug, data)
                    .then(function (response) {
                        //
                        if (response.data.code == 200) {
                            resolve(response.data.message.ucData[0]);
                        } else {
                            reject(ErrorHero(response));
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };

    }]);

(function () {
    WebWorkerService.$inject = ["$rootScope", "$q"];
    var service = angular.module('app.main');

    service.factory('WebWorkerService', WebWorkerService);

    function WebWorkerService($rootScope, $q) {

        return {
            evalCustomisationState: evalCustomisationState
        };


        function evalCustomisationState(values, layerIndex, optionIndex) {
            // var webWorker = new Worker('assets/js/workers/customisation-state-worker.js');
            var webWorker = new Worker('polyfills/customisation-state-worker.min.js');
            var defer = $q.defer();
            webWorker.postMessage(
                JSON.stringify([
                    'evalCustomisationState',
                    values,
                    layerIndex,
                    optionIndex
                ])
            );

            webWorker.onmessage = function (message) {
                var data = JSON.parse(message.data);
                defer.resolve(data[0]);
                webWorker.terminate();
            };

            return defer.promise;
        }

    }
})();

/**
 * Created by kumardivyarajat on 12/11/16.
 */
angular.module("app.customisation")
    .directive("customisableProduct", ["$mdMedia", "Base", function ($mdMedia, Base) {
        return {
            restrict: "AE",
            replace: true,
            scope: {
                customisation: "=",
                size: "@",
                name: "@",
                whiteFrame: "=",
                isMobile: "=",
                fallback: "@"
            },
            link: function (scope, element, attrs) {


                scope.mediaUrl = Base.getMediaUrl();

                switch (scope.size) {
                    case 'x-large' :
                        scope.style = {'width': '600px', 'height': '900px'};
                        scope.key = "c_x_large";
                        break;

                    case 'large' :
                        scope.style = {'width': '400px', 'height': '600px'};
                        scope.key = "c_large";
                        break;


                    case 'medium-2x' :
                        scope.style = {'width': '300px', 'height': '450px'};
                        scope.key = "c_large";
                        break;

                    case 'medium' :
                        scope.style = {'width': '300px', 'height': '450px'};
                        scope.key = "c_medium";
                        break;

                    case 'small-2x' :
                        scope.style = {'width': '200px', 'height': '300px'};
                        scope.key = "c_large";
                        break;

                    case 'small' :
                        scope.style = {'width': '200px', 'height': '300px'};
                        scope.key = "c_medium";
                        break;

                    case 'x-small' :
                        scope.style = {'width': '150px', 'height': '225px'};
                        scope.key = "c_thumbnail";
                        break;

                    case 'x-small-2x' :
                        scope.style = {'width': '150px', 'height': '225px'};
                        scope.key = "c_medium";
                        break;

                    case 'thumbnail' :
                        scope.style = {'width': '100px', 'height': '150px'};
                        scope.key = "c_thumbnail";
                        break;

                    case 'thumbnail-2x' :
                        scope.style = {'width': '100px', 'height': '150px'};
                        scope.key = "c_medium";
                        break;

                    case 'responsive' :
                        angular.element(function () {
                            var height = (element[0].parentElement.clientHeight);
                            var width = (element[0].parentElement.clientWidth);

                            if (!scope.isMobile) {
                                height -= 80;
                                width -= 80;
                            }
                            var w, h, key;
                            if ($mdMedia('xs')) {
                                h = width * (600 / 400);
                                w = width;
                                key = "c_large";
                            } else if ($mdMedia('sm')) {
                                key = "c_x_large";
                                w = width * 0.75
                                h = w * (600 / 400);
                            } else {
                                h = width * (600 / 400);
                                w = width;
                                key = "c_x_large"
                            }

                            scope.style = {'width': w + 'px', 'height': h + 'px', 'max-width': w + 'px'};
                            scope.key = key;
                        });
                        // var a = scope.$watch('element', function () {
                        //     // if (element[0].parentElement.clientHeight > 0) {
                        //
                        //
                        //         a();
                        //     }
                        // // });

                        break;

                    default:
                        scope.key = "c_medium";
                        break;
                }

                if (scope.whiteFrame) {
                    scope.whiteFrameValue = 1;
                } else {
                    scope.whiteFrameValue = -1;
                }
            },
            templateUrl: "app/modules/customisation/directives/templates/cp.tpl.html"
        }
    }]);

/**
 * Created by kumardivyarajat on 13/11/16.
 */

angular.module("app.customisation")
    .directive("customisableProductView", ["Base", "WebWorkerService", function (Base, WebWorkerService) {
        return {
            restrict: "AE",
            replace: true,
            scope: {
                customisation: "=",
                size: "@",
                selectedIndex: "=",
                currentIndex: "=",
                position: "=",
                backgroundScale: '='
            },

            // SelectedIndex - The index of the selected data option i.e the pattern, neck or some other data
            // currentIndex - The current populated index
            link: function (scope, attrs, element) {
                scope.mediaUrl = Base.getMediaUrl();

                scope.backgroundScale = scope.backgroundScale || "175%";
                scope.baseLayerIndex = _.findIndex(scope.customisation.data, function (datum) {
                    return datum.isBaseLayer;
                });

                scope.previewsData = [];
                scope.composeWatchGroup = [];
                scope.hasBaseLayer = scope.baseLayerIndex !== -1;
                scope.currentOption = scope.customisation.data[scope.selectedIndex].options[scope.currentIndex];

                scope.getLimit = getLimit;
                scope.init = init;
                scope.evalState = evalState;

                if(scope.currentOption.watchList) {
                    scope.composeWatchGroup = scope.currentOption.watchList.map(function (value) {
                        return 'customisation.data[' + scope.customisation.layerMap[value] + '].default'
                    });
                }

                if (scope.composeWatchGroup.length) {
                    scope.$watchGroup(scope.composeWatchGroup, function (newVal) {
                        scope.evalState();
                    }, true);
                }

                // scope.$watch('customisation', function (newVal) {
                //     scope.init();
                // }, true);


                function init() {
                    scope.previewsData = scope.customisation.data.map(function (layer, i) {
                        return layer.preview;
                    });
                }

                function evalState() {
                    WebWorkerService
                        .evalCustomisationState(
                            scope.customisation,
                            scope.selectedIndex,
                            scope.currentIndex
                        )
                        .then(function (result) {
                            scope.previewsData = result;
                            console.log('Updated', scope.currentOption.name, scope.previewsData)
                        })
                }

                function getLimit() {
                    if (scope.customisation.data[0].name === 'Fabric') {
                        return (1 - scope.customisation.data.length)
                    } else if (scope.hasBaseLayer && scope.selectedIndex === scope.baseLayerIndex) {
                        return scope.baseLayerIndex + 1;
                    } else {
                        return scope.customisation.data.length
                    }
                }

                switch (scope.size) {
                    case 'x-large' :
                        scope.style = {'width': '600px', 'height': '900px'};
                        scope.key = "c_x_large";
                        break;

                    case 'large' :
                        scope.style = {'width': '400px', 'height': '600px'};
                        scope.key = "c_large";
                        break;


                    case 'medium-2x' :
                        scope.style = {'width': '300px', 'height': '450px'};
                        scope.key = "c_large";
                        break;

                    case 'medium' :
                        scope.style = {'width': '300px', 'height': '450px'};
                        scope.key = "c_medium";
                        break;

                    case 'small-2x' :
                        scope.style = {'width': '200px', 'height': '300px'};
                        scope.key = "c_large";
                        break;

                    case 'small' :
                        scope.style = {'width': '200px', 'height': '300px'};
                        scope.key = "c_medium";
                        break;

                    case 'x-small' :
                        scope.style = {'width': '150px', 'height': '225px'};
                        scope.key = "c_thumbnail";
                        break;

                    case 'x-small-2x' :
                        scope.style = {'width': '150px', 'height': '225px'};
                        scope.key = "c_medium";
                        break;

                    case 'thumbnail' :
                        scope.style = {'width': '100px', 'height': '150px'};
                        scope.key = "c_thumbnail";
                        break;

                    case 'thumbnail-2x' :
                        scope.style = {'width': '100%', 'height': '150px'};
                        scope.key = "c_large";
                        break;


                    default:
                        scope.key = "c_large";
                        break;

                }

                scope.init()
            },
            templateUrl: "app/modules/customisation/directives/templates/cp-view.tpl.html"
        }
    }]);

/**
 * Created by kumardivyarajat on 03/11/16.
 */

angular.module("app.customisation")

    .filter('customisationLayerList', function () {
        return function (data) {
            return data.filter(function (datum) {
                return datum.options.length > 1;
            });
        };
    })
    .controller("customisation.controller", ["$scope", "$log", "$window", "$mdColors", "$mdInkRipple", "$state", "$timeout", "$mdToast", "$mdSidenav", "Base", "$stateParams", "AuthManager", "ImagePreloader", "$rootScope", "$mdDialog", "$mdMenu", "Utils", "$analytics", "CartManager", "$mdMedia", "product", "CustomisationManager", "Onboarding", "FullStory", function ($scope, $log, $window, $mdColors, $mdInkRipple, $state, $timeout, $mdToast, $mdSidenav, Base,
                                                      $stateParams, AuthManager, ImagePreloader, $rootScope, $mdDialog, $mdMenu, Utils, $analytics,
                                                      CartManager, $mdMedia, product, CustomisationManager, Onboarding, FullStory) {

        /** Variables  **/
        var openTimeout;
        // Load the product
        $scope.product = product;
        // Variable to check if this editor has been loaded with a user created data
        $scope.isUserData = false;
        $scope.showGallery = true;
        $scope.showPreviewButton = false;
        // $scope.selectedColor = $mdColors.getThemeColor($scope.$parent.dynamicTheme + '-primary-500-1');
        // $scope.normalColor = $mdColors.getThemeColor($scope.$parent.dynamicTheme + '-primary-100-1');

        // Init the uc data. If not loaded with a already present data, this will be the default.
        $scope.baseUc = {
            name: $scope.product.name,
            customisation: $scope.product.customisation._id,
            data: [],
            product: $scope.product._id
        };
        $scope.previewImageKey = "";
        $scope.layerImageKey = "";
        $scope.isOpen = false;
        $scope.editMode = false;
        $scope.showOnbaording = false;
        $scope.allowOnboarding = false;
        $scope.app = {
            selectedIndex: 0
        };
        $scope.initExpanded = true;
        $scope.zoomProgressLoader = false;
        $scope.productLoaded = true;
        $scope.CUSTOMISABLE_PRODUCT_SIZE = $scope.isSmall ? 'c_large' : 'c_x_large';
        if ($mdMedia('sm')) {
            //    Tablet
            console.log('Tablet...');
            $scope.CUSTOMISABLE_PRODUCT_SIZE = 'c_x_large';
        }
        $scope.optionsLayerActive = false;
        $scope.imageSize = 'large';
        $scope.sizeExpanded = $scope.initExpanded;

        $scope.mobileStyles = {
            bottomBar: {
                'position': 'fixed',
                'bottom': 0,
                'height': '44px',
                'line-height': '44px',
                'min-height': '44px'
            }
        };

        $scope.ctx = {
            refUser: $stateParams.RFX,
            refId: $stateParams.RFID,
            refType: $stateParams.RTYPE,
        };

        $scope.product.attributes = $scope.product.attributes.map(function (attr) {
            attr.valueText = '';
            attr.selectedValues.forEach(function (val, i) {
                attr.valueText += val.value.trim() + ((i !== attr.selectedValues.length - 1) ? ', ' : '')
            });
            return attr;
        });

        $scope.product.gallery = $scope.product.gallery.filter(function (o) {
            return o._id !== product.featured_image._id;
        });

        if (product.featured_image &&
            product.featured_image.urls &&
            product.featured_image.urls.full &&
            product.featured_image.urls.full.indexOf('.gif') !== -1) {
            $scope.product.gallery.push($scope.product.featured_image);
        } else {
            $scope.product.gallery.unshift($scope.product.featured_image);
        }


        /** Method Declarations  **/
        $scope.sortPosition = sortPosition;
        $scope.fetchUCData = fetchUCData;
        $scope.updateLayer = updateLayer;
        $scope.getVariationValue = getVariationValue;
        $scope.addToCart = addToCart;
        $scope.createNewCustomisation = createNewCustomisation;
        $scope.selectVariation = selectVariation;
        $scope.showSidebar = showSidebar;
        $scope.getPrice = getPrice;
        $scope.toggleMobileToolbarWidth = toggleMobileToolbarWidth;
        $scope.isAHotAttribute = isAHotAttribute;
        $scope.hasNeighbour = hasNeighbour;
        $scope.getPrevLayerName = getPrevLayerName;
        $scope.getNextLayerName = getNextLayerName;
        $scope.showSizeChart = sizeChart;
        $scope.checkVariationInCart = checkVariationInCart;
        $scope.updateDataLayer = updateDataLayer;
        $scope.openCustomMeasurements = openCustomMeasurements;
        $scope.restoreStateIfAvailable = restoreStateIfAvailable;
        $scope.saveStateToLocalStorage = saveState;
        $scope.onAddToCart = onAddToCart;
        $scope.executeSingleTrigger = executeSingleTrigger;
        $scope.executeTriggers = executeTriggers;
        $scope.revertTriggers = revertTriggers;
        $scope.checkTotalPrice = checkTotalPrice;
        $scope.hideOnboarding = hideOnboarding;
        $scope.toggleSection = toggleSection;
        $scope.scrollToTop = scrollToTop;
        $scope.changeSelectedImage = changeSelectedImage;
        $scope.selectModalImage = selectModalImage;
        $scope.openFullScreenZoomer = openFullScreenZoomer;
        $scope.hideProgress = hideProgress;
        $scope.toggleGallery = toggleGallery;

        /** Initial Method Calls  **/
        $scope.fetchUCData();
        $scope.restoreStateIfAvailable();

        function scrollToTop() {
            $timeout(function () {
                $scope.showPreviewButton = false;
                $scope.$apply();
            });
            $scope.showGallery = false;
            Utils.scrollToTopOfThePage();
        }

        function toggleGallery(value) {
            $scope.showGallery = value;
        }

        function changeSelectedImage(s) {
            $scope.selectedImage = s;
        }

        function selectModalImage(image) {
            $scope.modalImage = image;
            $scope.zoomProgressLoader = true;
        }

        function openFullScreenZoomer(e) {
            $scope.modalImage = $scope.selectedImage || $scope.product.gallery[0];
            $scope.zoomProgressLoader = true;
            $mdDialog
                .show({
                    clickOutsideToClose: true,
                    targetEvent: e,
                    scope: $scope,
                    preserveScope: true,
                    fullScreen: false,
                    contentElement: '#imageBoxDialog',
                    parent: angular.element(document.body)
                })
                .catch(function () {

                });
        }

        function hideProgress() {
            $scope.zoomProgressLoader = false;
        }

        function toggleSection(datum) {
            datum.expanded = !datum.expanded;
            console.log('e', datum, $scope.product.customisation);
        }

        function hideOnboarding() {
            $scope.allowOnboarding = false;
            Onboarding.complete('customisationPanel');
            $scope.cancel();
        }


        function saveState() {
            $window.localStorage.setItem($scope.product._id, JSON.stringify($scope.product.customisation.data));
        }


        function restoreStateIfAvailable() {
            var data = $window.localStorage.getItem($scope.product._id);
            if (data) {
                $scope.product.customisation.data = JSON.parse(data);
            }
            if ($stateParams.layerData) {
                var customisationDataFromLandingPage = JSON.parse($stateParams.layerData);

                $scope.product.customisation.data = $scope.product.customisation.data.map(function (d) {
                    var selectedOptionId = customisationDataFromLandingPage[d._id];
                    var selectedOption = _.find(d.options, function (option) {
                        return option._id === selectedOptionId;
                    });
                    d.default = selectedOption;
                    $scope.executeTriggers(d.default);
                    return d;
                });


            }
        }

        $scope.product.customisation.data = _.chain($scope.product.customisation.data)
            .map(function (o) {
                try {
                    o.selectedIndex = _.findIndex(o.options, function (option) {
                        return option._id === o.default._id;
                    });
                } catch (e) {
                    o.selectedIndex = 0;
                    o.default = o.options[0];
                }
                o.expanded = $scope.initExpanded;
                return o;
            })
            .value();

        $scope.$watch(function () {
            if (!$scope.isSmall) {
                angular.element(document.querySelector("#footer")).addClass('hide');
            }
            // angular.element(document.querySelector("#header")).addClass('hide');
        });

        $rootScope.pageMeta = {
            title: "Customise " + $scope.product.name + " on Aarida | Free Shipping * 14 day Returns * COD",
            description: "Customise " + $scope.product.name + " on Aarida. Now available in custom sizes. Say bye bye to all your fitting problems.",
            image: $scope.mediaUrl + $scope.product.featured_image.urls.medium,
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };

        $analytics.eventTrack(
            "Product Page",
            {
                page: "/product/" + $scope.product.slug,
                id: $scope.product._id,
                name: $scope.product.name,
                auth: AuthManager.isUserLoggedIn
            }
        );

        $analytics.eventTrack(
            "Customisation Page",
            {product: product.name, id: $scope.product._id,}
        );

        $analytics.eventTrack(
            'ViewContent',
            {
                value: $scope.product.price,
                currency: 'INR',
                content_ids: [$scope.product.sku],
                content_name: $scope.product.name,
                content_category: $scope.product.categoriesText,
                contents: [
                    {
                        id: $scope.product.sku,
                        quantity: 1,
                        item_price: $scope.product.price
                    }
                ],
                content_type: 'product',
                product_type: $scope.product.productType ? 'Customisable' : 'Simple',
                editor_type: $scope.product.editorType
            }
        )


        if ($stateParams.flags === "plain") {
            $scope.plainMode = true;
        }


        var images = [];
        if (product.customisation.baseImage) {
            images.push(Base.getMediaUrl() + product.customisation.baseImage.urls[$scope.CUSTOMISABLE_PRODUCT_SIZE]);
        }

        $scope.product.customisation.layerMap = {};
        _.forEach(product.customisation.data, function (layer, i) {
            $scope.product.customisation.layerMap[layer._id] = i;
            _.forEach(layer.options, function (option) {

                // if (option.image) {
                //     images.push(Base.getMediaUrl() + option.image.urls[$scope.CUSTOMISABLE_PRODUCT_SIZE]);
                //     if (!$scope.isSmall) {
                //         images.push(Base.getMediaUrl() + option.image.urls.c_medium);
                //     }
                // }

                option.watchList = [];
                if (option.triggers && option.triggers.length) {
                    option.watchList = _.map(option.triggers, 'linkedLayer');
                }

                if (layer.default && layer.default._id === option._id) {
                    $scope.executeTriggers(option);
                }
            })
        });

        console.log('Custom', $scope.product.customisation);

        // $log.info("Started Preload", images);
        $scope.everythingLoaded = false;
        ImagePreloader.preloadImages(images)
            .then(function () {
                $timeout(function () {
                    $scope.loadEditor = true;
                }, 100);

                $timeout(function () {
                    $scope.selectData($scope.product.customisation.data[0], 0);
                    $scope.initComplete = true;
                    $scope.everythingLoaded = true;
                }, 250);

                if (!Onboarding.isComplete('customisationPanel')) {
                    console.log("customisation.controller.js", "sd");
                    $timeout(function () {
                        $mdDialog.show({
                            contentElement: '#onboardingGuide',
                            scope: $scope,
                            fullscreen: true,
                            preserveScope: true,
                            parent: angular.element(document.body),
                            disableParentScroll: true,
                            clickOutsideToClose: false,
                            multiple: true
                        })
                    }, 1000);
                }


                // $log.info("Pre-loaded all images");
            })
            .catch(function (err) {
                $scope.everythingLoaded = true;
                console.log("customisation.controller.js", "err", err);
                // $log.error("Error while pre loading", err);
            });

        CartManager.getUserCart(false)
            .then(function (cart) {
                _.forEach(cart.products, function (o) {
                    if (o.product._id === $scope.product._id) {
                        $scope.addedToCart = true;
                    }
                });

            })
            .catch(function (err) {
                // $log.error(err);
            });


        $scope.setMedia = function () {
            $scope.screenIsSmall = $mdMedia('xs') || $mdMedia('sm');
            $scope.screenIsMedium = $mdMedia('md');
            $scope.screenIsLarge = $mdMedia('lg');
            $scope.screenIsExtraLarge = $mdMedia('gt-lg');
            $scope.customQuery = $mdMedia('(min-width: 1234px)');
            $scope.anotherCustom = $mdMedia('max-width: 300px');
        };

        $scope.setMedia();


        function checkTotalPrice() {
            //

            $scope.baseUc.data = {data: evaluteCustomisationState()};
            $scope.totalPrice = $scope.product.customisation.basePrice;
            console.log('Tota', $scope.totalPrice);
            _.forEach($scope.product.customisation.data, function (datum, i) {
                if (datum.default !== undefined) {
                    $scope.totalPrice += Utils.getPrice(datum.default.stockAndPrice, true);
                }
            });
            console.log('Tota', $scope.baseUc.data);
        }


        // if (!$scope.isUserData) {
        //     $scope.product.customisation.data
        //         .map(function (data) {
        //             var defaultId = data.default;
        //             var a = _.findIndex(data.options, function (option) {
        //                 return String(option._id) === String(defaultId);
        //             });
        //             if (a !== -1) {
        //
        //                 data.default = a;
        //             } else {
        //                 data.default = 0;
        //             }
        //         });
        // }

        $scope.cancel = function () {
            $mdDialog.hide();
        };


        $scope.getBaseSize = function () {
            if ($scope.screenIsSmall) {
                $scope.baseSize = "large";
            } else if ($scope.screenIsMedium) {
                $scope.baseSize = "large"
            } else if ($scope.screenIsLarge) {
                $scope.baseSize = "x-large"
            } else if ($scope.screenIsExtraLarge) {
                $scope.baseSize = "x-large"
            }
            return $scope.baseSize;
        };

        $scope.getBackgroundScale = function (datum) {
            if (datum && datum.extras && datum.extras.backgroundScale) {
                return datum.extras.backgroundScale + '%';
            }
            var name = datum ? datum.name : $scope.selectedData.name;
            switch (name) {
                case "Pattern" :
                    return "100%";

                case "Sleeves" :
                    return "175%";

                case "Length" :
                    return "100%";

                case "Neck" :
                    return "175%";

                case "Necks":
                    return "175%";

                case "Product Type":
                    return "100%";

                default :
                    return "center";
            }
        };

        $scope.getSelectedPosition = function (datum) {
            if (datum && datum.extras && datum.extras.backgroundPosition) {
                return datum.extras.backgroundPosition;
            }
            var name = datum ? datum.name : $scope.selectedData.name;
            switch (name) {
                case "Pattern" :
                    return "center";

                case "Sleeves" :
                    return "top";

                case "Length" :
                    return "bottom";

                case "Neck" :
                    return "top";

                case "Necks":
                    return "top";

                default :
                    return "center";
            }
        };


        $scope.openOption = function (e) {
            $mdMenu.open(e);
            e.stopPropagation();
        };

        function sizeChart(ev) {

            $mdDialog.show({
                contentElement: '#sizeChartDialog',
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: $scope,        // use parent scope in template
                preserveScope: true,  // do not forget this if use parent scope
                clickOutsideToClose: true
            });
        }

        function openCustomMeasurements(ev, openEditView) {
            if (!AuthManager.isUserLoggedIn) {
                $scope.saveStateToLocalStorage();
                AuthManager.showLoginModal(ev, $scope, true);
                return;
            }

            if ($window.localStorage.getItem($scope.product._id)) {
                $window.localStorage.removeItem($scope.product._id);
            }

            var copiedUc = {};
            angular.copy($scope.baseUc, copiedUc);
            if (copiedUc._id) {
                delete copiedUc._id;
            }
            copiedUc.data = evaluteCustomisationState();
            var copiedProduct = {};
            angular.copy($scope.product, copiedProduct);
            copiedProduct.price = $scope.totalPrice;
            $mdDialog.show({
                // contentElement: '#openCustomMeasurementsDialog',
                templateUrl: 'app/main/custom-measurement-dialog/measurements-dialog.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                controller: 'measurement.controller',
                locals: {
                    ucData: copiedUc,
                    product: copiedProduct,
                    variations: copiedProduct.variations,
                    sizeChart: copiedProduct.sizeChart,
                    selectedVariation: null,
                    customMeasurement: null,
                    ctx: $scope.ctx,
                    openEditView: openEditView,
                    returnData: false
                },
                fullscreen: true,
                clickOutsideToClose: true,
                escapeToClose: true
            })
                .then(function (result) {
                    $scope.saving = false;
                    $scope.addedToCart = true;
                    $scope.addedNow = true;
                    // $mdToast.show(
                    //     $mdToast.simple({
                    //         hideDelay: 3000,
                    //         position: 'bottom left',
                    //         content: "Product Added to Cart"
                    //     })
                    // );
                    $scope.openCart();
                    $scope.selectedVariation = undefined;
                })
                .catch(function (err) {

                });
        }

        function onAddToCart(data) {
            console.log('Data', data);
            if (data.saved) {
                $scope.saving = false;
                $scope.addedToCart = true;
                $scope.addedNow = true;
                $scope.openCart();
                $scope.selectedVariation = undefined;
            } else if (data.product) {
                console.log('onAddToCart', data);
                // $scope.product = data.product;
                $scope.selectedVariation = data.variation;
                $scope.addToCart();
            }

        }

        $scope.hideLayerPanel = function () {
            $scope.optionsLayerActive = false;
        };

        $scope.showLayerPanel = function () {
            $scope.optionsLayerActive = true;
        };


        // $scope.selectedData = $scope.product.customisation.data[0];
        $scope.selectData = function (data, index, ctx) {
            if (!$scope.selectedData) {
                $scope.optionsLayerActive = true;
            } else {
                if ($scope.selectedData._id === data._id) {
                    $scope.optionsLayerActive = !$scope.optionsLayerActive;
                } else {
                    $scope.optionsLayerActive = true;
                }
            }

            $scope.selectedData = data;
            $scope.app.selectedIndex = index;


            // $scope.optionsLayerActive = !!(!$scope.selectedData || ($scope.selectedData && $scope.selectedData._id !== data._id));

            // if ($scope.isSmall && $scope.selectedData.options.slice(-1)[0].image) {
            //     $scope.selectedData.options.push({stockAndPrice: ""});
            // }
            //
        };


        $scope.getIcon = function (name) {
            var backSpace = "assets/images/";
            switch (name) {
                case "Fabric" :
                    return backSpace + "colours-palette.svg";

                case "Sleevs" :
                    return backSpace + "sweater.svg";

                case "Sleeves" :
                    return backSpace + "sweater.svg";

                case "Length" :
                    return backSpace + "height.svg";

                case "Necks" :
                    return backSpace + "cocktail-dress.svg";

                case "Neck":
                    return backSpace + "cocktail-dress.svg";

                default :
                    return backSpace + "two-hole-button.svg";
            }
        };

        function showSidebar() {
            // if ($mdSidenav('left').isOpen()) {
            //     $scope.closeSidebar()
            //         .then(function () {
            //             // $log.debug("close LEFT is done");
            //             return $mdSidenav('left').open();
            //         })
            //         .then(function () {
            //             // $log.debug("open LEFT is done");
            //         });
            // } else {
            //     $mdSidenav('left').open()
            //         .then(function () {
            //             // $log.debug("open LEFT is done");
            //         });
            // }
            $mdSidenav('left').toggle()
                .then(function () {

                })
                .catch(function (err) {

                })
        }

        function getPrevLayerName() {

            return $scope.product.customisation.data[($scope.app.selectedIndex - 1)].name;
            // $scope.selectedData = data;
            // $scope.app.selectedIndex = index;
        }


        function getNextLayerName() {
            return $scope.product.customisation.data[($scope.app.selectedIndex + 1)].name;
        }

        function checkVariationInCart(vid) {
            return CartManager.checkProductInCart($scope.product._id, vid, $scope.ucSlug ? $scope.ucData._id : null);
        }

        function fetchUCData() {
            if ($stateParams.ucSlug) {
                // if ($scope.editMode === true) {
                // $scope.checkVariationInCart();
                $scope.ucSlug = $stateParams.ucSlug;
                CustomisationManager.getSinlgeUcDataBySlug($scope.ucSlug)
                    .then(function (ucData) {
                        if (!ucData.isTemplate) {
                            $scope.isUserData = true;
                        }
                        $scope.ucData = ucData;
                        $scope.baseUc._id = ucData._id;


                        $scope.product.customisation.data = $scope.product.customisation.data.map(function (datum) {
                            var a = _.find(ucData.data, function (o) {
                                return o.dataId === datum._id;
                            });
                            // TODO- Will not work for multiple customisation options at all. RED FLAG!!!!
                            var selectedValueId = null;
                            if (a) {
                                selectedValueId = a.selectedValues[0]._id;
                            }

                            datum.default = _.find(datum.options, function (o) {
                                return o._id === selectedValueId;
                            });

                            $scope.executeTriggers(datum.default);

                            return datum;
                        });
                        // _.forEach($scope.product.customisation.data, function (datum, i) {
                        //     var a = _.find(ucData.data, function (o) {
                        //         return o.dataId === datum._id;
                        //     });
                        //     $scope.product.customisation.data[i].default = _.findIndex($scope.product.customisation.data[i].options, function (o) {
                        //         return a.selectedValues[0] === o._id;
                        //     });
                        // });
                        $scope.checkTotalPrice();

                    })
                    .catch(function (err) {
                        //
                    })
                // }
            }
        }

        function evaluteCustomisationState() {
            var a = [];
            _.forEach($scope.product.customisation.data, function (datum, i) {
                if (datum.default !== undefined) {
                    a.push({
                        dataId: datum._id,
                        selectedValues: [datum.default._id]
                    });
                }
            });
            return a;
        }


        function selectVariation(variation) {
            $scope.selectedVariation = variation._id;
        };


        function onResize() {
            $scope.setMedia();
            $scope.$digest();
        }

        function cleanUp() {
            angular.element($window).off('resize', onResize);
        }


        function getVariationValue(variation) {
            var varId = variation.attributes[0].selectedValue[0];
            var a = _.find(variation.attributes[0].attribute.meta_values, function (meta_value) {
                return meta_value._id === varId;
            });
            if (a) {
                return a.value;
            }
        }

        function sortPosition(name) {
            switch (name) {
                case "Fabric" :
                    return 0;

                case "Product Type" :
                    return 0;

                case "Base Fabric" :
                    return 1;

                case "Neck" :
                    return 2;

                case "Sleeves" :
                    return 3;

                case "Length" :
                    return 4;

                default :
                    return 5;
            }
        }

        function getPrice(stockAndPrice) {
            return Utils.getPrice(stockAndPrice);
        }


        function createNewCustomisation() {
            var copiedUc = {};
            angular.copy($scope.baseUc, copiedUc);
            if (copiedUc._id) {
                delete copiedUc._id;
            }
            copiedUc.data = evaluteCustomisationState();
            $scope.savingData = true;

            CustomisationManager.createCustomisation(copiedUc)
                .then(function (ucData) {
                    $scope.savingData = false;
                    //
                    $scope.baseUc._id = ucData._id;
                    $state.go('app.customisationEditor', {
                        slug: $scope.product.slug,
                        ucSlug: ucData.slug
                    }, {notify: true, reload: true});

                })
                .catch(function (err) {
                    $scope.savingData = false;
                    //

                })
        }

        function addToCart(e) {
            // if (!AuthManager.isUserLoggedIn) {
            //     $scope.saveStateToLocalStorage();
            //     AuthManager.showLoginModal(e, $scope, true);
            //     return;
            // }
            if ($scope.product.variations.length > 0 && typeof $scope.selectedVariation === "undefined") {
                $mdToast.show(
                    $mdToast.simple({
                        hideDelay: 3000,
                        position: 'bottom right',
                        content: "Please select a variation first"
                    })
                );

                $mdDialog.show({
                    clickOutsideToClose: true,
                    targetEvent: e,
                    scope: $scope,
                    preserveScope: true,
                    contentElement: '#variationsDialog',
                    parent: angular.element(document.body)
                });
            } else {
                var copiedUc = {};
                angular.copy($scope.baseUc, copiedUc);
                if (copiedUc._id) {
                    delete copiedUc._id;
                }
                copiedUc.data = evaluteCustomisationState();
                $log.info("Add to cart clicked", $scope.baseUc);
                $scope.saving = true;
                var promise;
                if (AuthManager.isUserLoggedIn) {
                    promise = CartManager.addToCart($scope.product._id, $scope.selectedVariation, 1, copiedUc, $scope.ctx)
                } else {
                    promise = CartManager.addToLocalCart($scope.product, $scope.selectedVariation, 1, copiedUc, $scope.ctx)
                }
                promise
                    .then(function (cart) {
                        if ($window.localStorage.getItem($scope.product._id)) {
                            $window.localStorage.removeItem($scope.product._id);
                        }
                        $analytics.eventTrack(
                            "Added to Cart",
                            {
                                product: $scope.product.name,
                                productType: $scope.product.productType,
                                id: $scope.product._id,
                                sku: $scope.product.sku
                            }
                        );
                        FullStory.trackEvent('AddToCart', {
                            value: $scope.totalPrice,
                            currency: 'INR',
                            content_ids: [$scope.product.sku],
                            content_name: $scope.product.name,
                            content_category: $scope.product.categoriesText,
                            contents: [
                                {
                                    id: $scope.product.sku,
                                    quantity: 1,
                                    item_price: $scope.product.price
                                }
                            ],
                            content_type: 'product',
                            product_type: $scope.product.productType ? 'Customisable' : 'Simple',
                            editor_type: $scope.product.editorType,
                            variation: $scope.selectedVariation
                        });
                        $analytics.eventTrack(
                            'AddToCart',
                            {
                                value: $scope.totalPrice,
                                currency: 'INR',
                                content_ids: [$scope.product.sku],
                                content_name: $scope.product.name,
                                content_category: $scope.product.categoriesText,
                                contents: [
                                    {
                                        id: $scope.product.sku,
                                        quantity: 1,
                                        item_price: $scope.product.price
                                    }
                                ],
                                content_type: 'product',
                                product_type: $scope.product.productType ? 'Customisable' : 'Simple',
                                editor_type: $scope.product.editorType,
                                variation: $scope.selectedVariation
                            }
                        )
                        $scope.saving = false;
                        $scope.addedToCart = true;
                        $scope.addedNow = true;
                        $mdDialog.hide();
                        $mdToast.show(
                            $mdToast.simple({
                                hideDelay: 3000,
                                position: 'bottom left',
                                content: "Product Added to Cart"
                            })
                        );
                        $scope.openCart();
                        $scope.selectedVariation = undefined;
                    })
                    .catch(function (err) {
                        $scope.saving = false;
                        if (err.code === 1000) {
                            AuthManager.showLoginModal(e, $scope, true);
                        }
                    })
            }
        }


        function toggleMobileToolbarWidth() {
            if ($scope.isOpen) {
                openTimeout = $timeout(function () {
                    $scope.isOpen = !$scope.isOpen;
                }, 2000);
            } else {
                $scope.isOpen = !$scope.isOpen;
            }
        }

        function isAHotAttribute(attribute) {
            return /(?:Color|Fabric|Size)/.test(attribute.meta_key)
        }

        function hasNeighbour(direction) {
            if (direction === "left") {
                $scope.leftEnabled = $scope.app.selectedIndex !== 0;
            } else if (direction === "right") {
                $scope.rightEnabled = $scope.app.selectedIndex !== ($scope.product.customisation.data.length - 1);
            }
        }

        function updateLayer(option, index, layerIndex) {

            $scope.showLoader = true;
            // TODO : Clear the timeout
            $timeout(function () {
                $scope.showLoader = false;
            }, 500);

            if (typeof layerIndex === 'undefined') {
                layerIndex = $scope.app.selectedIndex;
            }

            $scope.revertTriggers($scope.product.customisation.data[layerIndex].default)
            $scope.product.customisation.data[layerIndex].default = option;
            $scope.product.customisation.data[layerIndex].selectedIndex = index;
            $scope.executeTriggers(option);
            $scope.checkTotalPrice();

            $scope.showPreviewButton = true;
            $scope.showGallery = false;


            if ($scope.isUserData) {
                $scope.savingData = true;
                var data = evaluteCustomisationState();

                CustomisationManager.updateCustomisation($scope.ucSlug, {data: data})
                    .then(function (ucSlug) {

                        return CartManager.getUserCart(true);
                    })
                    .then(function () {
                        $scope.savingData = false;
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Product Updated in Cart')
                                .position("bottom left")
                                .hideDelay(1000)
                        );
                    })
                    .catch(function (err) {
                        $scope.savingData = false;
                        //
                    })
            }
            // $mdInkRipple.attach($scope, angular.element(document.getElementById("customisable-main")), {center: true});
        }

        function executeTriggers(option) {
            if (option && option.triggers && option.triggers.length) {
                console.log('Executing', option.name);
                option.triggers.forEach(function (trigger) {
                    $scope.executeSingleTrigger(trigger.triggerType, trigger.linkedLayer, trigger.options)
                })
            }
        }

        function revertTriggers(option) {
            if (option && option.triggers && option.triggers.length) {
                option.triggers.forEach(function (trigger) {
                    var selectedLayer = _.find($scope.product.customisation.data, function (datum) {
                        return datum._id === trigger.linkedLayer;
                    });
                    selectedLayer.allOptionsDisabled = false;
                    if (selectedLayer) {
                        var shouldChangeDefault = false;
                        selectedLayer.options.forEach(function (option) {
                            if (trigger.options.includes(option._id) && trigger.triggerType === 'disable') {
                                option.disabled = false;
                            }
                        });
                    }
                });
            }

        }

        function executeSingleTrigger(triggerType, layer, options) {
            // console.log('EXECUTE', {triggerType, layer, options});
            var selectedLayerIdx = _.findIndex($scope.product.customisation.data, function (datum) {
                return datum._id === layer;
            });

            console.log('selectedLayerIdx', selectedLayerIdx);
            if (selectedLayerIdx) {
                var selectedLayer = $scope.product.customisation.data[selectedLayerIdx];
                var shouldChangeDefault = false;
                selectedLayer.allOptionsDisabled = false;
                selectedLayer.options.forEach(function (option) {
                    if (triggerType === 'disable') {
                        option.disabled = options.includes(option._id);
                    } else if (triggerType === 'enable') {
                        option.disabled = !options.includes(option._id);
                    }
                    shouldChangeDefault = shouldChangeDefault || option.disabled && (option._id === selectedLayer.default._id);
                });
                selectedLayer.options = _.orderBy(selectedLayer.options, ['disabled'], ['asc']);
                if (shouldChangeDefault) {
                    selectedLayer.activeOptions = selectedLayer.options.filter(function (option) {
                        return !option.disabled;
                    });
                    if (selectedLayer.activeOptions.length) {
                        $scope.updateLayer(selectedLayer.activeOptions[0], 0, selectedLayerIdx)
                        // selectedLayer.default = selectedLayer.activeOptions[0];
                    } else {
                        selectedLayer.allOptionsDisabled = true;
                    }
                }
            }
        }

        function updateDataLayer(dir) {
            var selectedData = $scope.product.customisation.data[$scope.app.selectedIndex];
            var currentSelectedIndex = selectedData.selectedIndex;
            var updateIndex = null;
            switch (dir) {
                case 'left':
                    if (currentSelectedIndex !== (selectedData.options.length - 1)) {
                        updateIndex = currentSelectedIndex + 1;
                    }
                    break;

                case 'right':
                    if (currentSelectedIndex !== 0) {
                        updateIndex = currentSelectedIndex - 1;
                    }
                    break;
            }
            if (updateIndex !== null) {
                $scope.updateLayer(selectedData.options[updateIndex], updateIndex);
            }
            // $scope.updateLayer()
        }

        $scope.optionsLayerActive = true;
        $scope.checkTotalPrice();

        // Clean Up Logic
        $scope.$on('$destroy', function () {
            angular.element(document.querySelector("#footer")).removeClass('hide');
            // angular.element(document.querySelector("#header")).removeClass('hide');
            $timeout.cancel(openTimeout);
        });

        angular.element($window).on('resize', onResize);
        $scope.$on('$destroy', cleanUp);

        function UserCData(data_id, index, selectedOption_id) {
            this.data_id = data_id;
            this.selectedIndex = index;
            this.selectedOption_id = selectedOption_id;
        }
    }])
;

/**
 * Created by kumardivyarajat on 24/05/17.
 */
angular.module("app.main")
    .controller("contest.controller", ["$scope", "$rootScope", "$stateParams", "$analytics", "$cookies", "CartManager", "$mdDialog", function ($scope, $rootScope, $stateParams, $analytics, $cookies, CartManager, $mdDialog) {

        // var looper = function () {
        //     TweenLite.to("#blue-balloon", 0, {
        //         y: 200, onComplete: anime()
        //     })
        // };


        var options = {expires: new Date("06/10/2017")};

        $rootScope.pageMeta = {
            title: "Spinwheel Contest",
            description: "Play the spinwheel contest and get a chance to win upto 50% discount coupon on your next purchase. We are largest Customised Women Clothing Online women fashion online store India," +
            "offering widest collection of latest bespoke women’s clothing at discounted prices.",
            keywords: "Best place to customise women’s wear, Bespoke women’s wear India, Top site for " +
            "customising women’s dresses Bespoke women’s fashion , Bespoke fashion for women, Customised " +
            "fashion for women, Women Customised Clothing Online, Customised women’s wear India, Buy " +
            "Customised dresses online, Buy customised womens wear"
        };

        $scope.rules = [
            "One user can spin the wheel only three times",
            "The coupon with the highest discount in 3 attempts can be redeemed",
            "Only one coupon can be redeemed per user",
            "The offer cannot be clubbed with any other offer",
            "The coupons are generated arbitrarily and in no way controlled by the system or by anyone associated with aarida.com",
            "This is a promotional offer only for aarida.com and cannot be used elsewhere",
            "The contest ends on 5th June 2017",
            "We reserve the right to cancel the contest anytime"
        ];

        $analytics.eventTrack("SpinWheel Page", {
            referrer: $stateParams.ref
        });

        $scope.showTCDialog = function () {
            $mdDialog.show({
                templateUrl: "contestTC.tmpl.html",
                scope: $scope,
                preserveScope: true,
            })
        };

        $scope.contestStatus = $cookies.getObject("spinwheel");
        if ($scope.contestStatus) {
            if (!$scope.contestStatus.referrer) {
                $cookies.putObject({
                    cancelled: $scope.contestStatus.cancelled,
                    viewed: $scope.contestStatus.viewed,
                    viewDate: $scope.contestStatus.viewDate,
                    played: $scope.contestStatus.played,
                    referrer: $stateParams.ref
                }, options)
            }
            if ($scope.contestStatus.played) {
                if (!$scope.contestStatus.redeemed) {
                    $scope.couponCode = $scope.contestStatus.couponCode.splice(-2);
                    $scope.contestComplete = true;
                    $scope.contestPlayed = true;
                } else if ($scope.contestStatus.redeemed) {
                    $scope.contestComplete = true;
                    $scope.redeemed = true;
                    $scope.contestPlayed = true;
                }
            } else {
                // $scope.showTCDialog();
            }
            // $scope.contestPlayed = $scope.contestStatus.played;

        } else {
            $cookies.putObject("spinwheel", {
                cancelled: true,
                viewed: true,
                viewDate: new Date(),
                played: false,
                referrer: $stateParams.ref
            }, options);
            $scope.contestPlayed = false;
            // $scope.showTCDialog();
        }


        $scope.onContestComplete = function (maxCoupon) {

            $scope.contestComplete = true;
            $scope.couponCode = "BVMDXNMP" + maxCoupon;
            $analytics.eventTrack("Contest", {
                name: "Spinwheel",
                complete: true,
                coupon: $scope.couponCode
            });
            var con = $cookies.getObject("spinwheel");
            $cookies.putObject("spinwheel", {
                cancelled: true,
                viewed: true,
                viewDate: con.viewDate,
                played: true,
                referrer: con.referrer,
                playDate: con.playDate,
                coupon: $scope.couponCode
            }, options);
            // $scope.contestPlayed = true;
        };

        $scope.redeem = function () {
            var con = $cookies.getObject("spinwheel");
            $scope.redeeming = true;
            CartManager.applyCoupon($scope.couponCode)
                .then(function (cart) {
                    $scope.redeeming = false;
                    $scope.cart = cart;
                    $scope.redeemed = true;
                    $cookies.putObject("spinwheel", {
                        cancelled: true,
                        viewed: true,
                        viewDate: con.viewDate,
                        played: true,
                        referrer: con.referrer,
                        playDate: con.playDate,
                        coupon: $scope.couponCode,
                        redeemed: true,
                        redeemDate: new Date()
                    }, options);
                    $analytics.eventTrack(
                        "Coupon Applied",
                        {couponCode: $scope.couponCode, success: true, campaign: "SPINWHEEL"}
                    );
                    //
                })
                .catch(function (err) {
                    $scope.redeeming = false;
                    // if (err.code === 441) {
                    //     $scope.couponError = err.message;
                    // }
                    // $analytics.eventTrack(
                    //     "Coupon Applied",
                    //     {couponCode: $scope.couponCode, success: false, reason: err.message}
                    // );
                    //
                })
        };
    }]);

/**
 * Created by kumardivyarajat on 15/11/16.
 */
angular.module("app.checkout", [])
    .controller("checkout.controller", ["$scope", "$cookies", "$mdToast", "$stateParams", "$log", "$timeout", "$analytics", "RestManager", "$rootScope", "cart", "$state", "CartManager", "$mdDialog", "AddressManager", "AuthManager", "Checkout", function ($scope, $cookies, $mdToast, $stateParams, $log, $timeout, $analytics, RestManager, $rootScope, cart, $state, CartManager, $mdDialog, AddressManager, AuthManager, Checkout) {
        $scope.currentNavItem = 'checkout';
        $scope.cartLoaded = false;
        $scope.shippingFee = 0;
        $scope.cart = cart;
        $scope.loadingUser = true;
        $scope.newAddress = {};
        $scope.checked = [];
        $scope.applyingGiftCard = false;
        $scope.disableOnlinePayments = false;
        $scope.servicable = false;
        $rootScope.pageMeta = {
            title: "Aarida.com : Secure Checkout",
            description: "Buy customisable products",
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };


        $scope.fetchUsersGiftCards = fetchUsersGiftCards;
        $scope.applyGiftCard = applyGiftCard;
        $scope.removeGiftCard = removeGiftCard;
        $scope.calculateTotalAmount = calculateTotalAmount;


        function removeGiftCard(card) {
            $scope.applyingGiftCard = true;

            CartManager.removeGiftCard(card.code)
                .then(function (cart) {
                    $scope.applyingGiftCard = false;
                    $scope.cart = cart;
                    $scope.checkAvailability();
                    $analytics.eventTrack(
                        "Gift Card Removed",
                        {cardCode: card.code, success: true}
                    );
                })
                .catch(function (err) {
                    $scope.applyingGiftCard = false;
                    if (err.code === 441) {
                        $scope.cardError = err.message;
                    } else {
                        $mdToast.showSimple('Some error occurred. Please contact customer support team at 080 4152 1574.')
                    }
                    $analytics.eventTrack(
                        "Gift Card Removed",
                        {cardCode: card.code, success: false, reason: err.message}
                    );
                    //
                })
        }

        function applyGiftCard(card) {
            console.log(card);
            $scope.applyingGiftCard = true;
            CartManager.applyGiftCard(card.code)
                .then(function (cart) {
                    $scope.applyingGiftCard = false;
                    $scope.cart = cart;
                    if($scope.selectedAddress) {
                        $scope.checkAvailability();
                    } else {
                        $scope.calculateTotalAmount();
                    }

                    $analytics.eventTrack(
                        "Gift Card Applied",
                        {cardCode: card.code, success: true}
                    );
                    //
                })
                .catch(function (err) {
                    $scope.applyingGiftCard = false;
                    if (err.code === 441) {
                        $scope.cardError = err.message;
                    } else {
                        $mdToast.showSimple('Some error occurred. Please contact customer support team at 080 4152 1574.')
                    }
                    $analytics.eventTrack(
                        "Gift Card Applied",
                        {cardCode: card.code, success: false, reason: err.message}
                    );
                    //
                })
        }

        function fetchUsersGiftCards() {
            $scope.loadingGiftCards = true;
            RestManager
                .getResource('/giftCards', 'cards')
                .then(function (cards) {
                    $scope.cards = cards;
                    $scope.loadingGiftCards = false;
                })
                .catch(function (err) {
                    console.log(err);
                    $scope.loadingGiftCards = false;
                })
        }

        function calculateTotalAmount() {
            $scope.totalAmount = $scope.cart.amount - $scope.creditDiscount;
            if ($scope.totalAmount <= $scope.cart.giftCardAmount) {
                $scope.cart.giftCardAmount = $scope.totalAmount;
            }

            if ($scope.cart.giftCardAmount) {
                $scope.totalAmount = $scope.totalAmount - $scope.cart.giftCardAmount;
            }



            if($scope.cart.giftCardAmount && $scope.totalAmount !== 0) {
                $scope.codAvaiable = false;
                $scope.codReason = 'COD not allowed for orders with Gift Cards applied'
            } else {
                $scope.codReason = '';
                if($scope.cart.hideAddressForm) {
                    $scope.codAvaiable = true;
                    $scope.order.paymentMode = 1;
                }
            }

            if($scope.cart.cashBackAmount) {
                $scope.codAvaiable = false;
                $scope.codReason = 'COD not valid with the Cashback Offer applied. Please pay online.'
            }

            $scope.disableOnlinePayments = $scope.totalAmount === 0;
            if($scope.disableOnlinePayments) {
                $scope.order.paymentMode = 1;
            }
        }

        $scope.runCheckoutLogic = function () {
            if (!AuthManager.isUserLoggedIn) {
                $analytics.eventTrack(
                    "Checkout Page - Invalid Auth");
                $rootScope.backState = "app.cart";
                console.log('Checkout : ', AuthManager.isUserLoggedIn);
                $state.transitionTo("app.login", {returnTo: window.location.href}, {location: 'replace'});
            } else if ($scope.cart.products.length === 0) {
                $analytics.eventTrack(
                    "Checkout Page - Invalid Cart");
                console.log('Checkout : ', $scope.cart);
                $state.transitionTo("app.cart");
            } else {
                $scope.user = AuthManager.getCurrentUser();
                $scope.order = {
                    paymentMode: "",
                    address: ""
                };
                var d = {
                    productsCount: $scope.cart.products.length,
                };
                if ($stateParams.failed) {
                    d.failed = $stateParams.failed === 'true';
                }

                if ($stateParams.orderNumber) {
                    d.orderNumber = $stateParams.orderNumber;
                    $scope.order.orderNumber = $stateParams.orderNumber;
                }
                $analytics.eventTrack("Checkout Page ", d);

                $scope.cartLoaded = true;

                if ($scope.user.virtualMobile || !$scope.user.mobile) {
                    $scope.showInfoDialog();
                }

                AddressManager.getAddresses()
                    .then(function (addresses) {
                        if (addresses.length === 0) {
                            addresses = [];
                        }
                        $scope.addresses = addresses;

                        _.forEach($scope.addresses, function (a, i) {
                            if (a.isDefault) {
                                $scope.addresses.splice(i, 1);
                                $scope.addresses.unshift(a);
                                $scope.checked[0] = true;
                                $scope.selectedAddress = a;
                                $scope.order.address = a._id;
                            } else {
                                $scope.checked[i] = false;
                            }
                        });

                        $scope.checkAvailability();
                    })
                    .catch(function (err) {
                        // $log.error(err);
                    });

                RestManager.getResource("/users/credits", "user")
                    .then(function (users) {
                        $scope.userCredits = users[0].points;
                        if ($scope.userCredits >= 250) {
                            if ($scope.cart.amount >= 250)
                                $scope.creditDiscount = 250;
                            else
                                $scope.creditDiscount = $scope.cart.amount;
                        } else if ($scope.userCredits < 250 && $scope.userCredits > 0) {
                            if ($scope.cart.amount < $scope.userCredits) {
                                $scope.creditDiscount = $scope.cart.amount;
                            } else {
                                $scope.creditDiscount = $scope.userCredits;
                            }
                        } else {
                            $scope.creditDiscount = 0;
                        }

                        $scope.calculateTotalAmount();
                        $scope.valueLimitCOD = false;

                        // $scope.creditDiscount = $scope.userCredits >= 200 ? 200 : $scope.userCredits;
                    })
                    .catch(function (err) {
                        // $log.error(err);
                    });
            }
        };


        if ($cookies.getObject('tkn')) {
            $scope.loadingUser = true;
            AuthManager.getCurrentUserAsync()
                .then(function (currentUser) {
                    console.log('Checkout : ', currentUser);
                    return CartManager.getUserCart(true);
                })
                .then(function (cart) {
                    $scope.cart = cart;
                    console.log('Checkout :::::::', $scope.cart);
                    $scope.loadingUser = false;
                    $scope.runCheckoutLogic();
                })
        } else {
            $scope.loadingUser = false;
            $scope.runCheckoutLogic();
        }

        $scope.resetSearch = function () {
            $scope.searchText = "";
            $scope.selectedItem = "";
        };

        $scope.populateCity = function () {
            $scope.populatingCity = true;
            $scope.querySearch($scope.newAddress.pinCode)
                .then(function (data) {
                    $scope.populatingCity = false;
                    if (data) {
                        $scope.newAddress.city = data.city;
                    }
                    console.log(data)
                })
                .catch(function (err) {
                    $scope.populatingCity = false;
                    console.log(err)
                })
        }

        $scope.querySearch = function (query) {
            return AddressManager.queryPinCode(query);
        };

        $scope.saveAddress = function () {
            $scope.addressSaving = true;
            //
            AddressManager.addNewAddress($scope.newAddress)
                .then(function (address) {
                    $scope.addressSaving = false;
                    $scope.addresses.push(address);
                    $scope.resetDialog();
                })
                .catch(function (err) {
                    $scope.addressSaving = false;
                    // $log.error(err);
                })

        };

        $scope.showAddressSelectDialog = function ($event) {
            $mdDialog.show({
                clickOutsideToClose: true,
                targetEvent: $event,
                contentElement: '#addressSelectDialog',
                fullscreen: true,
                parent: angular.element(document.body)
            });

        };


        $scope.showInfoDialog = function () {
            if ($scope.user.virtualMobile) {
                $scope.user.mobile = "";
            }

            $scope.disableMobileForm = !!$scope.user.mobile;
            $scope.disableEmailForm = !!$scope.user.email;

            $timeout(function () {
                $mdDialog.show({
                    clickOutsideToClose: false,
                    scope: $scope,
                    preserveScope: true,
                    contentElement: '#infoDialog',
                    fullscreen: false,
                    parent: angular.element(document.body)
                });
            }, 0);
        };


        $scope.saveUserDetails = function () {
            AuthManager.updateUser($scope.user)
                .then(function (user) {

                    $scope.user = AuthManager.getCurrentUser();
                    $rootScope.$emit("updatedUser", user);
                    $mdDialog.hide();
                })
                .catch(function (err) {
                    $scope.error = err.message;

                })
        };

        $scope.showAddressDialog = function ($event) {
            //
            // $scope.addressForm.$setPristine();
            $mdDialog.show({
                clickOutsideToClose: true,
                targetEvent: $event,
                locals: {
                    address: null
                },
                controller: "address.add.controller",
                templateUrl: 'app/modules/address/partials/address.add.dialog.html',
                fullscreen: true,
                parent: angular.element(document.body)
            })
                .then(function (result) {
                    if (result.data) {
                        $scope.addresses.unshift(result.data);
                        $scope.selectAddress(result.data, 0);
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
        };

        $scope.capitalize = function (cannotUse) {
            return _.startCase(_.camelCase(cannotUse));
        };


        $scope.selectAddress = function (address, index) {
            $scope.selectedAddress = address;
            $scope.order.address = address._id;
            _.forEach($scope.checked, function (a, i) {
                $scope.checked[i] = false;
            });
            $scope.checked[index] = true;
            //
            $scope.checkAvailability();
            $scope.cancel();
        };

        $scope.checkAvailability = function () {
            $scope.order.paymentMode = "";
            if ($scope.selectedAddress) {
                AddressManager.checkCodAvailability($scope.selectedAddress.pinCode)
                    .then(function (data) {
                        if (data) {
                            $scope.servicable = data.hasPrepaid;
                            $scope.codAvaiable = data.hasCod;
                            // if (data.courierPartners.length === 0) {
                            //     $scope.servicable = false;
                            //     $scope.codAvaiable = false;
                            // } else {
                            //     $scope.codAvaiable = false;
                            //     _.forEach(data.courierPartners, function (cp) {
                            //         if (cp.isCodAvailable) {
                            //             //
                            //             $scope.codAvaiable = true;
                            //         }
                            //     })
                            // }
                        } else {
                            $scope.servicable = false;
                            $scope.codAvaiable = false;
                        }
                        $scope.calculateTotalAmount();
                    })
                    .catch(function (err) {

                    })
            }
        };

        $scope.createNewOrder = function () {
            $scope.process = true;
            $scope.placingOrder = true;
            console.log("checkout.controller.js", "createNewOrder", $scope.order);
            Checkout.createNewOrder($scope.order)
                .then(function (data) {
                    $scope.process = false;
                    // $log.info(data);
                    $scope.placingOrder = false;
                })
                .catch(function (err) {
                    $log.error(err);
                    $scope.placingOrder = false;
                    $mdToast.showSimple('Error placing the order => ' + err);
                })
        };

        $scope.capitalize = function (cannotUse) {
            return _.startCase(_.camelCase(cannotUse));
        };


        $scope.selectedItemChange = function (item) {
            //
            $scope.newAddress.city = item.city;
            $scope.newAddress.state = item.state;
            $scope.newAddress.pinCode = item.pinCode;
        };

        $scope.resetDialog = function () {
            $scope.newAddress = {};
            $scope.resetSearch();
            $scope.cancel();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.fetchUsersGiftCards();


    }]);

/**
 * Created by kumardivyarajat on 16/11/16.
 */
angular.module("app.checkout")
    .service("Checkout", ["$http", "$q", "$log", "Base", "$httpParamSerializerJQLike", "AuthManager", "$window", "$state", function ($http, $q, $log, Base, $httpParamSerializerJQLike, AuthManager, $window, $state) {

        this.currentPaymentMode = 0;
        this.createNewOrder = function (data) {
            var that = this;
            return $q(function (resolve, reject) {
                var a = {};
                angular.copy(data, a);
                a.paymentMode = parseInt(a.paymentMode);
                $http.post(Base.getBaseUrl() + "/order", a)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            // $log.info(response, a.paymentMode);
                            if (a.paymentMode == 1) {
                                $state.go("app.account.thankyou", {orderNumber: response.data.message.data[0].orderNumber})
                                resolve(response.data.message.data[0]);
                            } else if (a.paymentMode == 2) {
                                that.openNewPage(response.data.message.data);
                            } else if (a.paymentMode == 3) {
                                that.postData(response.data.message.data[0]);
                            } else if (a.paymentMode == 4) {
                                that.postData(response.data.message.data[0]);
                            } else if (a.paymentMode == 5) {
                                that.postData(response.data.message.data[0]);
                            } else if (a.paymentMode == 6) {
                                that.postData(response.data.message.data[0]);
                            }
                        } else {
                            reject(response.data.message.error);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            });
        };

        this.postData = function (data) {
            var form = document.createElement("form");
            form.method = "POST";
            form.action = data.url;
            _.forOwn(data.payload, function (value, key) {
                //
                var input = document.createElement("input");
                input.name = key;
                input.value = value;
                form.appendChild(input);
            });
            document.body.appendChild(form);
            form.submit();
        };
        this.openNewPage = function (data) {
            $window.open(data, '_self');
        }
    }]);

/**
 * Created by kumardivyarajat on 01/11/16.
 */
angular.module("app.categories", [])
    .service("CategoriesManager", ["$http", "Base", "$q", "ErrorHero", "$timeout", "RestManager", function ($http, Base, $q, ErrorHero, $timeout, RestManager) {
        var Categories = this;
        this._categories = [];
        this._categoriesBaseUrl = Base.getBaseUrl() + "/categories";


        /***
         * @author - Kumar Divya Rajat
         * @date - 21/10/16
         * @method - _setCategories (private)
         * @description - Sets the categories into the local resource pool.
         ***/
        this._setCategories = function (categories) {
            this._categories = categories;
        };


        /***
         * @author - Kumar Divya Rajat
         * @date - 21/10/16
         * @method - loadAllCategories
         * @description - Loads all the categories and keeps it in the memory.
         ***/
        Categories._loadAllCategories = function (deferred) {
            $http.get(Categories._categoriesBaseUrl)
                .then(function (response) {
                    if (response.data.code == 200) {
                        var cat = response.data.message.categories;
                        //
                        Categories._setCategories(cat);
                        deferred.resolve(cat);
                    } else {
                        throw ErrorHero(response);
                    }
                })
                .catch(function (err) {
                    deferred.reject(err);
                })
        };


        /***
         * @author - Kumar Divya Rajat
         * @date - 21/10/16
         * @method - _searchCategory
         * @description - This method iterates over the local resource pool to search for the
         *                requested resource.
         ***/
        Categories._searchCategory = function (slug) {
            var categories = Categories._categories;
            var cat = "";
            angular.forEach(categories, function (category, i) {
                if (category.slug == slug) {
                    cat = category;
                }
            });
            return cat;
        };


        /***
         * @author - Kumar Divya Rajat
         * @date - 21/10/16
         * @method - _handleSearch (private)
         * @description - This method handles the search result.
         *
         ***/
        Categories._handleSearch = function (slug, deferred) {
            var category = Categories._searchCategory(slug);
            if (!category) {
                //TODO handle this condition
            } else {
                deferred.resolve(category);
            }
        };


        /***
         * @author - Kumar Divya Rajat
         * @date - 21/10/16
         * @method - fetchAllCategories
         * @description - The public interface for the CategoriesManager service. This method
         *                checks if the requested resource is available in memory. If yes,
         *                it sends out the local version else it fetches new resources,
         *                saves it to the local resource pool and then resolves the
         *                promise with requested resource.
         ***/
        Categories.fetchAllCategories = function () {
            var deferred = $q.defer();
            if (Categories._categories.length > 0) {
                deferred.resolve(Categories._categories);
            } else {
                Categories._loadAllCategories(deferred);
            }
            return deferred.promise;
        };


        /***
         * @author - Kumar Divya Rajat
         * @date - 11/01/17
         * @method - fetchFeatured
         * @description - The public interface for the CategoriesManager service. This method
         *                checks if the requested resource is available in memory. If yes,
         *                it sends out the local version else it fetches new resources,
         *                saves it to the local resource pool and then resolves the
         *                promise with requested resource.
         ***/
        Categories.fetchFeatured = function () {
            return RestManager.getResource("/categories/featured", "categories");
        };


        /***
         * @author - Kumar Divya Rajat
         * @date - 21/10/16
         * @method - fetchSingleCategory
         * @description - Fetches a single category by searching the local resource pool. If the
         *                local resource pool is empty, it fetches all the categories from the
         *                server as it will be a faster operation. Then it searches the resource
         *                pool again to find the requested resource.
         ***/
        Categories.fetchSingleCategory = function (slug) {
            var deferred = $q.defer();
            if (slug === "all") {
                //
                $timeout(function () {
                    deferred.resolve();
                }, 100);
                return deferred.promise;
            } else {
                if (Categories._categories.length > 0) {
                    Categories._handleSearch(slug, deferred);
                } else {
                    Categories.fetchAllCategories()
                        .then(function () {
                            Categories._handleSearch(slug, deferred);
                        })
                        .catch(function (err) {
                            deferred.reject(err);
                        })
                }
                return deferred.promise;
            }

        };
    }]);

(function () {
    'use strict';


    angular.module('app.categories')
        .factory('ProductSync', productSync);

    productSync.$inject = ['$q'];

    function productSync($q) {

        var productSync = localforage.createInstance({
            // driver: localforage.INDEXEDDB, // if you want to force a driver
            name: 'aarida', // name of the database and prefix for your data
            version: 1.0, // version of the database, you shouldn't have to use this
            storeName: "productsOffline" // Should be alphanumeric, with underscores.
        });

        var service = {
            get: get,
            getAll: getAll,
            getAllByKeys: getAllByKeys,
            getAllKeys: getAllKeys,
            set: set,
            setItems: setItems,
            removeItem: removeItem,
            clear: clear
        };

        return service;

        /**
         * @memberOf ProductSync#
         * @param key
         * @returns {*}
         */
        function get(key) {
            var deferred = $q.defer();
            productSync.getItem(key).then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf ProductSync
         * @returns {*}
         */
        function getAll() {
            var deferred = $q.defer();
            productSync.getItems().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf ProductSync
         * @returns {*}
         */
        function getAllByKeys() {
            var deferred = $q.defer();
            productSync.getItems().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf ProductSync
         * @returns {*}
         */
        function getAllKeys() {
            var deferred = $q.defer();
            productSync.keys().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf ProductSync
         * @param key
         * @param value
         * @returns {*}
         */
        function set(key, value) {
            var deferred = $q.defer();

            value = JSON.parse(JSON.stringify(value));

            productSync.setItem(key, value).then(function (result) {
                deferred.resolve(result);
            }).catch(function (err) {
                // This code runs if there were any errors
                console.log(err);
                deferred.reject(err);
            });


            return deferred.promise;
        }

        /**
         * @memberOf ProductSync
         * @param products
         * @returns {*}
         */
        function setItems(products) {
            var deferred = $q.defer();

            Promise
                .map(products, function (item) {
                    return new Promise(function (resolve, reject) {
                        productSync.removeItem(item.slug)
                            .then(function (value) {
                                return productSync.setItem(item.slug, item);
                            })
                            .then(resolve)
                            .catch(reject)
                    })
                })
                .then(function (value) {
                    deferred.resolve(value);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            // productSync.setItems(items).then(function (result) {
            //     deferred.resolve(result);
            // }).catch(function (err) {
            //     // This code runs if there were any errors
            //     console.log(err);
            //     deferred.reject(err);
            // });
            //
            return deferred.promise;
        }

        /**
         * @memberOf ProductSync
         * @param key
         * @returns {*}
         */
        function removeItem(key) {
            var deferred = $q.defer();

            productSync.removeItem(key).then(function (result) {
                deferred.resolve(result);
            });

            return deferred.promise;
        }

        /**
         * @memberOf ProductSync
         * @returns {*}
         */
        function clear() {

            var deferred = $q.defer();

            productSync.clear().then(function (result) {
                deferred.resolve(result);
            })
                .catch(function (err) {
                    deferred.reject(err)
                });

            return deferred.promise;

        }
    }

})(angular);

(function () {
    'use strict';


    angular.module('app.categories')
        .factory('CategorySync', categorySync);

    categorySync.$inject = ['$q'];

    function categorySync($q) {

        var categorySync = localforage.createInstance({
            name: 'aarida_categories', // name of the database and prefix for your data
            // driver: localforage.LOCALSTORAGE, // if you want to force a driver
            version: 1.0, // version of the database, you shouldn't have to use this
            storeName: "categoriesOffline" // Should be alphanumeric, with underscores.
        });

        var service = {
            get: get,
            getAll: getAll,
            getAllByKeys: getAllByKeys,
            getAllKeys: getAllKeys,
            set: set,
            setItems: setItems,
            removeItem: removeItem,
            clear: clear
        };

        return service;

        /**
         * @memberOf CategorySync#
         * @param key
         * @returns {*}
         */
        function get(key) {
            var deferred = $q.defer();
            categorySync.getItem(key).then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf CategorySync
         * @returns {*}
         */
        function getAll() {
            var deferred = $q.defer();
            categorySync.getItems().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf CategorySync
         * @returns {*}
         */
        function getAllByKeys() {
            var deferred = $q.defer();
            categorySync.getItems().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf CategorySync
         * @returns {*}
         */
        function getAllKeys() {
            var deferred = $q.defer();
            categorySync.keys().then(function (result) {
                deferred.resolve(result);
            });
            return deferred.promise;
        }

        /**
         * @memberOf CategorySync
         * @param key
         * @param value
         * @returns {*}
         */
        function set(key, value) {
            var deferred = $q.defer();

            value = JSON.parse(JSON.stringify(value));

            categorySync.setItem(key, value).then(function (result) {
                deferred.resolve(result);
            }).catch(function (err) {
                // This code runs if there were any errors
                console.log(err);
                deferred.reject(err);
            });


            return deferred.promise;
        }

        /**
         * @memberOf CategorySync
         * @param categoryName
         * @param totalProducts
         * @param query
         * @param products
         * @returns {*}
         */
        function setItems(categoryName, totalProducts, query, products) {
            var deferred = $q.defer();

            categorySync.clear()
                .then(function (value) {
                    return categorySync.setItem(categoryName, {products : products, query : query, totalProducts : totalProducts})
                })
                .then(function (value) {
                    deferred.resolve(value);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });

            // categorySync.setItems(items).then(function (result) {
            //     deferred.resolve(result);
            // }).catch(function (err) {
            //     // This code runs if there were any errors
            //     console.log(err);
            //     deferred.reject(err);
            // });
            //
            return deferred.promise;
        }

        /**
         * @memberOf CategorySync
         * @param key
         * @returns {*}
         */
        function removeItem(key) {
            var deferred = $q.defer();

            categorySync.removeItem(key).then(function (result) {
                deferred.resolve(result);
            });

            return deferred.promise;
        }

        /**
         * @memberOf CategorySync
         * @returns {*}
         */
        function clear() {

            var deferred = $q.defer();

            categorySync.clear().then(function (result) {
                deferred.resolve(result);
            });

            return deferred.promise;

        }
    }

})(angular);

/**
 * Created by kumardivyarajat on 02/11/16.
 */
angular.module("app.categories")
    .controller("categoryController", ["$scope", "WishListManager", "$log", "$rootScope", "$mdToast", "$mdDialog", "AuthManager", "Base", "ProductSync", "CategorySync", "$stateParams", "$mdMedia", "$state", "$timeout", "$element", "$mdInkRipple", "$analytics", "$mdBottomSheet", "$interval", "$window", "ProductsManager", "Utils", "RestManager", "CategoriesManager", "CookiesManager", "$document", function ($scope, WishListManager, $log, $rootScope, $mdToast, $mdDialog, AuthManager, Base, ProductSync, CategorySync,
                                                $stateParams, $mdMedia, $state, $timeout, $element, $mdInkRipple, $analytics, $mdBottomSheet, $interval,
                                                $window, ProductsManager, Utils, RestManager, CategoriesManager, CookiesManager, $document) {
        var vm = $scope;
        var z, init, promise;
        vm.isCollection = $stateParams.collection === "true";
        vm.aloading = true;
        vm.filteringAttributes = [];
        vm.mediaUrl = Base.getMediaUrl();
        vm.inifinteLoadingElement = '';
        vm.inifinteLoadingElementObserver = '';
        vm.products = [];
        vm.concatMode = true;
        vm.hasError = false;
        vm.grid = 0;
        vm.shouldChangeState = false;

        vm.sortOptions = [
            {
                icon: 'sort_by_alpha',
                value: 'name',
                text: 'Name'
            },
            {
                icon: 'arrow_upward',
                value: 'price',
                text: 'Price(Low to High)'
            },
            {
                icon: 'arrow_downward',
                value: '-price',
                text: 'Price(High to Low)'
            },
            {
                icon: 'fiber_new',
                value: '-createdAt',
                text: 'Newest First'
            }
        ];
        vm.scrollToTop = Utils.scrollToTopOfThePage;
        vm.showSortBottomSheet = showSortBottomSheet;
        vm.loadNextPage = loadNextPage;
        vm.applySorting = applySorting;
        vm.clearObserver = clearObserver;
        vm.initializeInfiniteLoader = initializeInfiniteLoader;
        vm.saveState = saveState;
        vm.clearStorageData = clearStorageData;
        vm.getLinkUrl = getLinkUrl;
        vm.applyValue = applyValue;
        vm.showCustomisableCard = showCustomisableCard;
        vm.getProductCardClass = getProductCardClass;
        vm.initController = initController;
        vm.isCustomisableAdvancedProduct = Utils.isCustomisableAdvancedProduct;
        // vm.showCopiedNotification = showCopiedNotification;

        // Restores the scroll position to the top of the page
        vm.scrollToTop();
        vm.initController();

        function initController() {
            if ($mdMedia('xs')) {
                vm.grid = 2;
            } else if ($mdMedia('gt-xs') && !$mdMedia('xl')) {
                vm.grid = 4;
            } else {
                vm.grid = 5;
            }
        }

        function getProductCardClass(product) {
            // flex-xl="25" flex-lg="33" flex-gt-md="33" flex-gt-xs="33" flex="50"
            var classes = '';
            if (vm.showCustomisableCard(product)) {
                classes = 'flex-lg-100 flex-gt-md-100 flex-gt-xs-100 flex-100'
            } else {
                classes = 'flex-xl-20 flex-lg-25 flex-gt-md-25 flex-gt-xs-25 flex-50'
            }
            return classes;
        }

        function showCustomisableCard(product) {
            return product.productType === 1 && product.editorType === 'intermediate'
        }

        function applyValue(option) {
            $scope.query.sort = option.value;
            $scope.applySorting();
        }

        function getLinkUrl(product) {
            if (product.productType && product.editorType !== 'simple' && $scope.isSmall) {
                return $state.href('app.customisationEditor', {slug: product.slug, flags: 'none'});
            } else {
                return $state.href('app.product', {productSlug: product.slug, product: product});
            }
        }

        function saveState(index, product) {
            // if ($scope.isSmall) {
            vm.query.y = $scope.scrolledY;
            vm.query.index = index;
            vm.query.currentTotal = vm.products.length;
            vm.query.totalProducts = vm.totalCount;
            vm.query.pageToLoad = Math.ceil(index / vm.query.limit);
            vm.query.pageToLoad === 0 && (vm.query.pageToLoad += 1);
            $window.localStorage.setItem($stateParams.categoryName, JSON.stringify(vm.query));
            // ProductSync.setItems([product])
            // }
        }

        angular.element(document.getElementById('body')).on('scroll', function (ev) {
            // do your things like logging the Y-axis
            $scope.scrolledY = ev.target.scrollTop;
        });

        function showSortBottomSheet() {
            $mdBottomSheet.show({
                templateUrl: 'sort-bottom-sheet',
                scope: $scope,
                preserveScope: true
            }).then(function (clickedItem) {
                $scope.alert = clickedItem['name'] + ' clicked!';
            }).catch(function (error) {
                // User clicked outside or hit escape
            });
        }

        function applySorting() {
            vm.concatMode = false;
            vm.query.page = 1;
            vm.scrollToTop();
            vm.shouldChangeState = true;
            vm.fetchProducts(true);
        }

        function loadNextPage(changes) {
            changes.forEach(function (change) {
                if (change.intersectionRatio > 0) {
                    vm.query.page += 1;
                    vm.fetchProducts();
                }
            })
        }

        function clearStorageData() {
            CategorySync.clear()
                .then(function (result) {
                    console.log('Cleared Categories');
                    return ProductSync.clear();
                })
                .then(function (results) {
                    console.log('Cleared Products');
                })
                .catch(function (err) {
                    console.log('Error clearing data', err);
                })
        }

        vm.fetchProducts = function (force, page) {
            $mdBottomSheet.hide();
            if (!force && !vm.hasFilters && (vm.totalCount <= vm.products.length)) {
                console.log('Limit Reached');
                return;
            }
            if (vm.query.attributes && Object.keys(vm.query.attributes).length) {
                vm.hasFilters = true;
            }
            vm.aloading = true;
            var query = {};
            angular.copy(vm.query, query);
            query.attributes = JSON.stringify(query.attributes);
            var options = {
                extras: ["totalCount", "indexStart", "hasNextPage", "page", "limit", "count"],
                query: query
            };

            if (page) {
                options.query.page = page;
            }

            if (vm.isCollection) {
                vm.promise = RestManager.getResource("/products/collection/" + vm.category._id, "products", options);
            } else {
                vm.promise = RestManager.getResource("/products/category/" + vm.category._id, "products", options);
            }
            $rootScope.showRefreshLoader = true;
            vm.promise
                .then(function (result) {
                    // $log.info("Products Fetched", result);
                    vm.totalCount = result.totalCount;
                    vm.initData = true;
                    if (vm.shouldChangeState) {
                        vm.changeState();
                        vm.shouldChangeState = false;
                    }
                    var hasANormalProduct = _.findIndex(result.products, function (product) {
                        return !vm.isCustomisableAdvancedProduct(product);
                    });
                    console.log('Has', hasANormalProduct);
                    // Why waste a loop when the products can't be reordered?
                    if (hasANormalProduct !== -1) {
                        var customCount = 0;
                        result.products.forEach(function (product, index) {
                            if (vm.isCustomisableAdvancedProduct(product)) {
                                if ((index % vm.grid) !== (customCount % vm.grid)) {
                                    var normalIndex = _.findIndex(result.products.slice(index), function (product) {
                                        return !vm.isCustomisableAdvancedProduct(product);
                                    });
                                    if (normalIndex) {
                                        result.products.splice(index, 0, result.products[normalIndex + index]);
                                        result.products.splice(normalIndex + index + 1, 1);
                                    }
                                } else {
                                    customCount += 1;
                                }
                            }
                        });
                    }

                    if (!vm.concatMode) {
                        vm.concatMode = true;
                        vm.products = result.products;
                    } else {
                        vm.products = vm.products.concat(result.products);
                    }

                    vm.aloading = false;

                    vm.initializeInfiniteLoader();
                    $rootScope.showRefreshLoader = false;

                    $window.localStorage.removeItem($stateParams.categoryName);


                    CategorySync.setItems($stateParams.categoryName, vm.totalCount, vm.query, vm.products)
                        .then(function (val) {
                            console.log('Offline category data set', val)
                        })
                        .catch(function (err) {
                            console.log('Error setting the category data in Localforage')
                        })

                    ProductSync.setItems(vm.products)
                        .then(function (val) {
                            console.log('Offline product data set', val)
                        })
                        .catch(function (err) {
                            console.log('Error setting the product offline data in Localforage', err);
                        })

                })
                .catch(function (err) {
                    $log.error(err);
                    vm.aloading = false;
                    vm.hasError = true
                    $rootScope.showRefreshLoader = false;
                })
        };

        function initializeInfiniteLoader() {
            if (!vm.inifinteLoadingElement) {
                vm.inifinteLoadingElementObserver = new IntersectionObserver(loadNextPage, {
                    root: document.querySelector('#body'),
                    rootMargin: '200px 0px 200px 0px'
                });
                vm.inifinteLoadingElement = document.querySelector('#infinite-load-trigger');
                if (vm.inifinteLoadingElement) {
                    vm.inifinteLoadingElementObserver.observe(vm.inifinteLoadingElement);
                }
            }
            // else {
            //     vm.clearObserver();
            //     vm.initializeInfiniteLoader();
            // }
        }

        function clearObserver() {
            if (vm.inifinteLoadingElementObserver && vm.inifinteLoadingElement) {
                vm.inifinteLoadingElementObserver.unobserve(vm.inifinteLoadingElement);
                vm.inifinteLoadingElement = null;
            }
        }


        vm.fetchCorrespondingAttributes = function () {
            vm.attributesLoading = true;
            if (vm.isCollection) {
                vm.attributesPromise = RestManager.getResource("/products/attributes/collection/" + vm.category._id, "attributes");
            } else {
                vm.attributesPromise = RestManager.getResource("/products/attributes/category/" + vm.category._id, "attributes");
            }
            vm.attributesPromise
                .then(function (result) {
                    if (!init) {
                        vm.filteringAttributes = result;
                        var keys = Object.keys(vm.query.attributes);
                        if (vm.query.attributes) {

                        }
                        _.forEach(vm.filteringAttributes, function (o) {

                            o.shown = [];
                        });
                        init = true;
                    }

                })
                .catch(function (err) {
                    // $log.error(err);
                })
        };

        if (vm.isCollection) {
            promise = RestManager.getResource("/collections/" + $stateParams.categoryName, "collections");
        } else {
            promise = CategoriesManager.fetchSingleCategory($stateParams.categoryName);
        }
        promise
            .then(function (category) {

                if (vm.isCollection) {
                    if ($stateParams.categoryName === "new_arrivals") {
                        category = {};
                        category.name = "New Arrivals";
                        category.description = "Buy all new products from the best collection of Dresses, Tops, Kurtis only on aarida";
                        category.slug = "new_arrivals";
                        category._id = "new_arrivals";
                    } else {
                        category = category[0];
                        if ($stateParams.categoryName === "customisable_products") {
                            category.name = "Customisable Products";
                            category.description = "Choose your own neck type, sleeves, fabric and much more.";
                            category.slug = "customisable_products";
                        }
                    }
                }
                if (!category) {
                    category = {};
                    category.name = "All Products";
                    category.description = "Buy the best collection of Dresses, Tops, Kurtis only on aarida";
                    category.slug = "all";
                    category._id = "all";
                }

                var pageTitle, description, keywords;

                // if ($scope.isSmall) {
                //     category.headerImage = {
                //         urls: {
                //             h_x_large: '/assets/images/category/new15@2x.jpg'
                //         }
                //     };
                // }


                // if (!category.headerImage && ['bottoms', 'dresses', 'gowns', 'kurti', 'tops'].includes($stateParams.categoryName))
                //     category.headerImage = {
                //         urls: {
                //             h_x_large: '/assets/images/' + $stateParams.categoryName + ".jpg"
                //         }
                //     };


                if (category.seo) {
                    if (category.seo.title) {
                        pageTitle = category.seo.title;
                    }

                    if (category.seo.description) {
                        description = category.seo.description;
                    }

                    if (category.seo.keywords) {
                        keywords = category.seo.keywords;
                    }
                } else {
                    pageTitle = category.name;
                    description = category.description;
                    keywords = category.name + ', Aarida Fashion, Aarida';
                }

                $rootScope.pageMeta = {
                    title: pageTitle,
                    description: description,
                    keywords: keywords
                };

                $analytics.eventTrack(
                    (vm.isCollection ? "Collection" : "Category") + "-" + category.name,
                    {page: (vm.isCollection ? "/collection/" : "/category/") + category.slug}
                );

                vm.category = category;


                if (vm.category.sortBy) {
                    vm.query.sort = vm.category.sortBy;
                }

                var entry = $window.localStorage.getItem($stateParams.categoryName);

                if (entry) {
                    vm.cachedQuery = JSON.parse(entry);
                    console.time('fetchCachedCategory');
                    CategorySync.get($stateParams.categoryName)
                        .then(function (result) {
                            if (result && result.products && result.products.length) {
                                vm.products = result.products;
                                vm.query = result.query;
                                vm.totalCount = result.totalProducts;
                                vm.scrollTimeout = $timeout(function () {
                                    // document.getElementById('body').scrollTo(0, vm.cachedQuery.y);
                                    Base.scrollBy(vm.cachedQuery.y, 500)
                                    $window.localStorage.removeItem($stateParams.categoryName);
                                    console.timeEnd('fetchCachedCategory');
                                }, 0);
                                vm.initializeInfiniteLoader();
                            } else {
                                console.log('No data in the store. Fetching from network');
                                vm.clearStorageData();
                                vm.fetchProducts();
                            }
                        })
                        .catch(function (err) {
                            console.log('Error fetching data from categorySync', err);
                            vm.clearStorageData();
                            vm.fetchProducts();
                        })
                } else {
                    vm.clearStorageData();
                    vm.fetchProducts();
                }
                vm.fetchCorrespondingAttributes();

            })
            .catch(function (err) {

            });

        // function scrollBy(distance, duration) {
        //
        //     var initialY = document.getElementById('body').scrollTop;
        //     var y = initialY + distance;
        //     var baseY = (initialY + y) * 0.5;
        //     var difference = initialY - baseY;
        //     var startTime = performance.now();
        //
        //     function step() {
        //         var normalizedTime = (performance.now() - startTime) / duration;
        //         if (normalizedTime > 1) normalizedTime = 1;
        //
        //         document.getElementById('body').scrollTo(0, baseY + difference * Math.cos(normalizedTime * Math.PI));
        //         if (normalizedTime < 1) window.requestAnimationFrame(step);
        //     }
        //
        //     window.requestAnimationFrame(step);
        // }

        vm.isLarge = $mdMedia('lg');

        vm.query = {
            sort: "-createdAt",
            page: 1,
            limit: 24,
            attributes: {}
        };

        vm.showFilterFor = "";
        vm.showFilter = false;
        init = z = false;
        vm.action = function ($event) {
            $event.stopPropagation();
        };

        // if ($stateParams.page) {
        //     vm.query.page = parseInt($stateParams.page);
        // }
        //
        // if ($stateParams.limit) {
        //     vm.query.limit = parseInt($stateParams.limit);
        // }

        if ($stateParams.sort) {
            vm.query.sort = $stateParams.sort;
        }


        if ($stateParams.attributes) {
            vm.query.attributes = JSON.parse($stateParams.attributes);
        }

        if ($stateParams.customisable) {
            vm.query.customisable = $stateParams.customisable === 'true';
        }


        vm.getTotalPages = function () {
            return (Math.floor(vm.totalCount / vm.query.limit) + 1);
        };

        vm.isLastPage = function () {
            return vm.query.page === vm.getTotalPages();
        };

        vm.pagination = function (page) {
            z = true;
            vm.query.page = page;
            vm.fetchProducts();
        };


        vm.checkIfProductIsInWishlist = function (productId) {
            if (vm.wishListProducts) {
                return _.find(vm.wishListProducts, function (o) {
                    return o === productId;
                });
            } else {
                return false;
            }
        };

        vm.fetchWishList = function () {
            WishListManager.getWishlistOutline()
                .then(function (wishlist) {
                    vm.wishListProducts = wishlist.products;
                })
                .catch(function (err) {

                })
        };

        vm.changeState = function () {
            // $log.info("State changed");
            if (vm.isCollection) {
                $state.go("app.collection", {
                        categoryName: vm.category.slug,
                        y: $scope.scrolledY,
                        // page: vm.query.page,
                        // limit: vm.query.limit,
                        sort: vm.query.sort,
                        customisable: vm.query.customisable,
                        attributes: JSON.stringify(vm.query.attributes)
                    },
                    {notify: false, reload: false})
            } else {
                $state.go("app.category", {
                        categoryName: vm.category.slug,
                        y: $scope.scrolledY,
                        // page: vm.query.page,
                        // limit: vm.query.limit,
                        sort: vm.query.sort,
                        customisable: vm.query.customisable,
                        attributes: JSON.stringify(vm.query.attributes)
                    },
                    {notify: false, reload: false})
            }
        };

        vm.checkIfNew = function (createdAtDate) {
            return moment().diff(moment(createdAtDate), "days") <= 180;
        };


        vm.filter = function (meta_value, index, attribute, fromModal) {
            //
            //

            z = true;
            vm.shouldChangeState = true;
            //

            vm.query.page = 1;
            var a = _.some(vm.query, function (o) {
                return _.has(o, attribute._id);
            });
            //
            if (!a) {
                vm.query.attributes[attribute._id] = [meta_value._id];
            } else {
                var contains = _.findIndex(vm.query.attributes[attribute._id], function (o) {
                    return o === meta_value._id;
                });
                //

                if (contains !== -1) {
                    vm.query.attributes[attribute._id].splice(contains, 1);
                } else {
                    vm.query.attributes[attribute._id].push(meta_value._id);
                }
            }
            vm.hasFilters = false;
            _.forOwn(vm.query.attributes, function (val, key) {
                if (val.length > 0) {
                    vm.hasFilters = true;
                }
            });

            // //

            // //

            if (!fromModal) {
                vm.concatMode = false;
                vm.scrollToTop();
                vm.fetchProducts();
            }
        };

        vm.clearFilters = function () {
            _.forEach(vm.filteringAttributes, function (o) {
                o.shown = [];
            });
            vm.hasFilters = false;
            vm.query.attributes = {};
            vm.concatMode = false;
            vm.scrollToTop();
            vm.shouldChangeState = true;
            vm.fetchProducts(true);

            try {
                vm.close();
            } catch (e) {
                //
            }
        };

        vm.openFilters = function (event) {
            vm.filterIndex = 0;
            vm.attribute = vm.filteringAttributes[vm.filterIndex];
            $mdDialog.show({
                contentElement: '#filtersDialog',
                scope: $scope,
                fullscreen: true,
                targetEvent: event,
                preserveScope: true,
                parent: angular.element(document.body),
                disableParentScroll: true,
                clickOutsideToClose: true
            });
        };

        vm.close = function () {
            //TODO Revert all clicks
            $mdDialog.hide();
        };

        vm.select = function (index) {
            vm.filterIndex = index;
            vm.attribute = vm.filteringAttributes[index];
        };

        vm.apply = function () {
            $mdDialog.hide()
                .then(function () {
                    vm.concatMode = false;
                    vm.fetchProducts();
                })
                .catch(function (err) {

                });
        };


        vm.getNumber = function () {
            return new Array(vm.getTotalPages() > 0 ? vm.getTotalPages() : 0);
        };

        vm.gotoDetailsPage = function (slug, ev) {
            $state.transitionTo('app.product', {productSlug: slug})
        };

        vm.calculateHeight = function () {
            vm.timeout = $timeout(function () {
                try {
                    var docHeight = angular.element(document.getElementById("filter-container"))[0].clientHeight;
                    // if ($scope.isSmall) {
                    //     vm.height = docHeight + "px";
                    // } else {
                    vm.height = Math.max($window.innerHeight, docHeight) + "px";
                    // }
                } catch (err) {

                }

                // document.documentElement.clientHeight * 0.65;
            }, 1000);
        };

        vm.calculateHeight();

        vm.perfomWishListAction = function (product, e) {
            var promise, message;

            // if (AuthManager.isUserLoggedIn) {

            product.serverConn = true;
            if (product.inWishlist) {
                promise = WishListManager.removeFromWishlist(product);
                message = "Removed " + product.name + " from wishlist";
            } else {
                promise = WishListManager.addToWishList(product);
                message = "Added " + product.name + " to wishlist";
            }

            promise
                .then(function (data) {
                    //
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position("bottom right")
                            .hideDelay(3000)
                    );
                    product.serverConn = false;
                    product.inWishlist = !product.inWishlist;
                })
                .catch(function (err) {
                    product.serverConn = false;
                    message = "Unable to connect to server.";
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .highlightClass('red')// Accent is used by default, this just demonstrates the usage.
                            .position("bottom right")
                            .hideDelay(3000)
                    );
                });
            // } else {
            //     $mdToast.show(
            //         $mdToast.simple()
            //             .textContent("Login to continue")
            //             .position("bottom right")
            //             .hideDelay(3000)
            //     );
            //     AuthManager.showLoginModal(e, $scope, true);
            // }
            e.preventDefault();
            e.stopPropagation();
        };

        vm.getProperName = function (str) {
            return _.startCase(_.toLower(_.truncate(str, {'length': 40, 'separator': ' '})));
        };

        vm.calculatePrice = function (mrp, price) {
            return Math.floor(((mrp - price) / mrp) * 100);
        };

        vm.fetchWishList();

        vm.$on('$destroy', function () {
            $timeout.cancel(vm.timeout);
            $timeout.cancel(vm.scrollTimeout);
        })

    }]);

/**
 * Created by kumardivyarajat on 10/11/16.
 */

angular.module("app.cart", [])
    .controller("cartController", ["$scope", "$stateParams", "$rootScope", "$mdToast", "$analytics", "$mdDialog", "AuthManager", "RestManager", "$interval", "CartManager", "Utils", "ErrorHero", "$state", function ($scope, $stateParams, $rootScope, $mdToast, $analytics, $mdDialog, AuthManager, RestManager, $interval, CartManager, Utils, ErrorHero, $state) {
        $scope.cart = {};
        $scope.currentNavItem = 'cart';
        $scope.couponCode = "";
        $scope.updating = false;
        $scope.loadingCart = true;
        if (!$scope.isUserLoggedIn) {
            $scope.couponError = "Login/Register to be able to apply coupons";
        }

        $rootScope.pageMeta = {
            title: "Shopping Cart | Aarida.com "
            // description: "Add prod.",
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };

        $analytics.eventTrack(
            "Cart",
            {page: "/cart"}
        );


        $scope.getProperName = getProperName;
        $scope.goToCustomisationEditor = goToCustomisationEditor;
        $scope.applyCoupon = applyCoupon;
        $scope.removeCoupon = removeCoupon;
        $scope.clearError = clearError;
        $scope.updateQuantity = updateQuantity;
        $scope.removeFromCart = removeFromCart;
        $scope.getVariationValue = getVariationValue;
        $scope.showCopiedNotification = showCopiedNotification;
        $scope.clearCart = clearCart;
        $scope.fetchUsersGiftCards = fetchUsersGiftCards;
        $scope.showGiftCardRedirectDialog = showGiftCardRedirectDialog;
        $scope.applyDefaultCoupon = applyDefaultCoupon;

        $scope.cancel = function () {
            $mdDialog.hide();
        };

        function clearCart() {
            $scope.clearingCart = true;
            console.log('aa')
            CartManager.clearCart()
                .then(function (cart) {
                    $scope.cart = cart;
                    $scope.clearingCart = false;
                })
                .catch(function (err) {
                    $scope.clearingCart = false;
                    console.log('Error clearing cart', err);
                    $mdToast.showSimple('Error clearing cart : ' + err.message);
                })
        }

        function fetchUsersGiftCards() {
            $scope.loadingGiftCards = true;
            RestManager
                .getResource('/giftCards', 'cards')
                .then(function (cards) {
                    $scope.cards = cards;
                    $scope.loadingGiftCards = false;
                })
                .catch(function (err) {
                    console.log(err);
                    $scope.loadingGiftCards = false;
                })
        }

        function showCopiedNotification() {
            $mdToast.showSimple('Copied coupon code NEW15 to clipboard');
        }


        (function () {

            CartManager.getUserCart(true)
                .then(function (cart) {
                    console.log("cart.controller.js", "cart", cart);
                    if (cart && cart.discountAmount === 0 && cart.cashBackAmount) {
                        cart.discountText = cart.cashBackText;
                    }
                    $scope.cart = cart;
                    $scope.loadingCart = false
                    setTimeout(function () {
                        if ($stateParams.fa === 'true' || $stateParams.fa === true) {
                            $scope.openLoginModal()
                        }
                    }, 1500);

                })
                .catch(function (err) {
                    $scope.loadingCart = false
                    ErrorHero(err);
                });

        })();

        function applyDefaultCoupon(coupon) {
            $scope.couponCode = coupon;
            $scope.applyCoupon();
        }


        function applyCoupon() {
            $scope.couponError = "";
            if (!$scope.couponCode) {
                $scope.couponError = "Enter a coupon first"
            } else if ($scope.couponCode.length > 12) {
                $scope.showGiftCardRedirectDialog()
            } else {
                //
                $scope.checkingStatus = true;
                // $scope.coupon.disabled = true;
                CartManager.applyCoupon($scope.couponCode)
                    .then(function (cart) {
                        $scope.checkingStatus = false;
                        if (cart.discountAmount === 0 && cart.cashBackAmount) {
                            cart.discountText = cart.cashBackText;
                        }
                        $scope.cart = cart;

                        $analytics.eventTrack(
                            "Coupon Applied",
                            {couponCode: $scope.couponCode, success: true}
                        );
                        //
                    })
                    .catch(function (err) {
                        $scope.checkingStatus = false;
                        if (err.code === 441) {
                            $scope.couponError = err.message;
                        }
                        $analytics.eventTrack(
                            "Coupon Applied",
                            {couponCode: $scope.couponCode, success: false, reason: err.message}
                        );
                        //
                    })
            }
        }

        function removeCoupon() {
            $scope.checkingStatus = true;
            CartManager.removeCoupon()
                .then(function (cart) {
                    $scope.checkingStatus = false;
                    $scope.cart = cart;
                    //
                    $analytics.eventTrack(
                        "Coupon Removed",
                        {success: true}
                    );
                })
                .catch(function (err) {
                    $scope.checkingStatus = false;
                    if (err.code === 441) {
                        $scope.couponError = err.message;
                    }
                    $analytics.eventTrack(
                        "Coupon Removed",
                        {success: false, reason: err.message}
                    );
                    //
                })
        }

        function clearError() {
            if ($scope.couponError) {
                $scope.couponError = "";
            }

            $scope.couponCode = _.toUpper($scope.couponCode);

        }

        function showGiftCardRedirectDialog() {
            $mdDialog.show($mdDialog.confirm({
                title: 'Looks like you are tyring to add a gift card',
                textContent: 'Gift cards can be redeemed from the gift cards page. Do you want to redeem a Gift Card?',
                ok: 'Redeem Gift Card',
                cancel: 'Cancel',
                theme: 'black'
            }))
                .then(function () {
                    $state.go('app.account.giftCards', {openRedeem: true, c: btoa($scope.couponCode)})
                })
                .catch(function () {

                })

        }


        function updateQuantity(productData, how, index) {
            $scope.updating = true;
            productData.updating = true;
            var quantity = 0;
            switch (how) {
                case "plus" :
                    if (productData.quantity !== 0)
                        quantity = productData.quantity + 1;
                    break;

                case "minus" :
                    if (productData.quantity !== 1)
                        quantity = productData.quantity - 1;
                    else
                        $scope.removeFromCart(productData);
                    break;
            }

            if (quantity) {
                //
                var promise = {};
                if (productData.product.productType === 0) {
                    promise = CartManager.updateCart(productData.product._id, productData.variation._id, quantity)
                } else {
                    promise = CartManager.updateCart(productData.product._id, productData.ucData._id, quantity)
                }
                promise
                    .then(function (cart) {
                        //
                        $scope.updating = false;
                        productData.updating = false;
                        $scope.cart = cart;
                    })
                    .catch(function (err) {
                        productData.updating = false;
                        $scope.updating = false;
                    });
            } else {
                $scope.updating = false;
            }
        }

        function removeFromCart(productData, index) {
            $scope.updating = true;
            productData.updating = true;

            var promise = {};
            if (productData.product.productType === 0) {
                promise = CartManager.removeFromCart(productData.product._id, productData.variation._id)
            } else {
                promise = CartManager.removeFromCart(productData.product._id, productData.ucData._id)
            }
            promise
                .then(function (cart) {
                    $analytics.eventTrack(
                        "Product Removed - Cart",
                        {product: productData.product.name, productType: productData.product.productType}
                    );
                    productData.updating = false;
                    $scope.updating = false;
                    $scope.cart = cart;
                })
                .catch(function (err) {
                    productData.updating = false;
                    $scope.updating = false;
                });
        }

        function goToCustomisationEditor(productData) {
            $state.go("app.customisationEditor", {slug: productData.product.slug, ucSlug: productData.ucData.slug})
        }

        $rootScope.$on("cartChanged", function ($event, cart) {
            console.log('Cart Changed', cart);
            if (cart && cart.discountAmount === 0 && cart.cashBackAmount) {
                cart.discountText = cart.cashBackText;
            }
            $scope.cart = cart;
            $scope.isUserLoggedIn = AuthManager.isUserLoggedIn;
            if (!$scope.isUserLoggedIn) {
                $scope.couponError = "Login/Register to be able to apply coupons";
            } else {
                if (!$scope.loadingGiftCards && !$scope.cards) {
                    $scope.fetchUsersGiftCards();
                }
                $scope.couponError = "";
            }

        });


        function getVariationValue(product) {
            //
            return Utils.getSelectedVariationFromCartProduct(product);
        }


        function getProperName(str) {
            return _.startCase(_.toLower(str));
        }

        $rootScope.$on("loggedIn", function ($event, data) {
            $state.reload();
        });

        if ($scope.isUserLoggedIn) {
            $scope.fetchUsersGiftCards();
        }

    }]);

/**
 * Created by kumardivyarajat on 10/11/16.
 */

angular.module("app.cart")
    .service("CartManager", ["$http", "$q", "Base", "Utils", "AuthManager", "$rootScope", "RestManager", "$window", "FullStory", function ($http, $q, Base, Utils, AuthManager, $rootScope, RestManager, $window,
                                      FullStory) {

        /**
         * @module CartService
         * @type {string}
         */

        this.cartUrl = Base.getBaseUrl() + "/cart";
        this._userCart = "";


        this._addToCart = function (pid, vid, ucData, quantity, ctx, resolve, reject) {
            var Cart = this;
            var data = {product: pid, quantity: quantity, ctx: ctx};
            if (pid && pid._id) {
                data.product = pid._id;
            }
            if (typeof ucData !== "undefined" || !ucData) {
                data.ucData = ucData;
            }
            if (typeof vid !== "undefined" || !vid) {
                if (vid._id) {
                    data.variation = vid._id;

                    if (vid.measurements) {
                        data.measurements = vid.measurements;
                    }

                } else {
                    data.variation = vid;
                }
            }


            //
            $http.post(Base.getBaseUrl() + "/cart",
                data
            ).then(function (response) {
                //
                if (response.data.code === 200) {
                    Cart._userCart = response.data.message.cart[0];
                    Cart.emitChanges();
                    resolve({cart: response.data.message.cart[0]});
                } else {
                    //
                    var err = new Error();
                    err.code = response.data.code;
                    err.message = response.data.message.error;
                    reject(err);
                }
            }).catch(function (err) {
                //
                reject(err);
            });
        };


        this.checkProductInCart = function (productId, variationId, custId) {
            if (this._userCart) {
                return _.find(this._userCart.products, function (o) {
                    return o.product && o.product._id === productId && o.variation._id === variationId && (custId ? (o.ucData._id === custId) : true);
                })
            } else {
                return false;
            }
        };


        this.emitChanges = function () {
            $rootScope.$emit("cartChanged", this._userCart);
        };

        this.clearLocalCart = function () {
            var Cart = this;
            return $q(function (resolve, reject) {
                var cart = {products: []};
                Cart._userCart = Cart.calculateCartAmount(cart);
                Cart.emitChanges();
                $window.localStorage.setItem('cart', JSON.stringify(Cart._userCart))
                resolve({cart: cart})
            })
        };

        this.removeFromLocalCart = function (product, variation) {
            var Cart = this;
            return $q(function (resolve, reject) {
                var cart = Cart._userCart;
                var productAndVariationIdx = _.findIndex(cart.products, function (p) {
                    return p.variation._id === variation && p.product._id === product;
                });

                if (productAndVariationIdx !== -1) {
                    cart.products.splice(productAndVariationIdx, 1);
                }
                Cart._userCart = Cart.calculateCartAmount(cart);
                Cart.emitChanges();
                $window.localStorage.setItem('cart', JSON.stringify(cart))
                resolve({cart: cart})
            });
        };

        this.addToLocalCart = function (product, variation, quantity, ucData, ctx) {
            var Cart = this;
            return $q(function (resolve, reject) {
                var cart = $window.localStorage.getItem('cart');
                try {
                    cart = JSON.parse(cart);
                } catch (e) {

                }

                if (!cart) {
                    cart = {
                        products: []
                    }
                }

                var productAndVariationIdx = _.findIndex(cart.products, function (p) {
                    return p.variation._id === variation && p.product._id === product;
                });

                if (productAndVariationIdx !== -1) {
                    cart.products[productAndVariationIdx].quantity = quantity;
                } else {
                    cart.products.push({
                        dateAdded: moment().toISOString(),
                        product: product,
                        variation: variation,
                        quantity: quantity,
                        ucData: ucData,
                        measurements: variation.measurements,
                        ctx: ctx
                    })
                }
                Cart._userCart = Cart.calculateCartAmount(cart);
                Cart.emitChanges();
                $window.localStorage.setItem('cart', JSON.stringify(cart))
                resolve({cart: cart})
            });
        };

        this.calculateCartAmount = function (cart) {
            var totalPrice = 0;
            var shippingCharges = 0;
            cart.amount = 0;
            cart.shippingCharges = 0;
            _.forEach(cart.products, function (productData) {
                if (productData.product.productType === 1) {
                    productData.price = productData.product.price;
                } else {
                    productData.price = (productData.variation.stockAndPrice.price.salePrice ? productData.variation.stockAndPrice.price.salePrice : productData.variation.stockAndPrice.price.mrp);
                }
                productData.totalPrice = productData.price * productData.quantity;
                totalPrice += productData.totalPrice;
            });
            cart.shippingCharges = shippingCharges;
            cart.amount = totalPrice + shippingCharges;
            return cart;
        };

        /**
         * @memberOf CartService
         * @param pid
         * @param vid
         * @param quantity
         * @param ucData
         * @param ctx
         * @return {*}
         */
        this.addToCart = function (pid, vid, quantity, ucData, ctx) {
            var Cart = this;
            if (AuthManager.isUserLoggedIn) {
                return $q(function (resolve, reject) {
                    Cart._addToCart(pid, vid, ucData, quantity, ctx, resolve, reject);
                });
            } else {
                return Cart.addToLocalCart(pid, vid, quantity, ucData, ctx);
            }
        };

        this.updateCart = function (pid, vid, quantity) {
            var Cart = this;
            FullStory.trackEvent('UpdateCart', {variationId : vid, productId : pid, quantity : quantity});
            return $q(function (resolve, reject) {
                if (AuthManager.isUserLoggedIn) {
                    $http.put(Base.getBaseUrl() + "/cart",
                        {product: pid, variation: vid, quantity: quantity}
                    ).then(function (response) {
                        //
                        if (response.data.code === 200) {
                            Cart._userCart = response.data.message.cart[0];
                            Cart.emitChanges();
                            resolve(response.data.message.cart[0]);
                        } else {
                            //
                            var err = new Error();
                            err.code = response.data.code;
                            err.message = response.data.message.error;
                            reject(err);
                        }
                    }).catch(function (err) {
                        //
                        reject(err);
                    });
                } else {
                    return Cart.addToLocalCart(pid, vid, quantity)
                }
            });
        };


        this.removeFromCart = function (pid, vid, isCustomisation) {
            var Cart = this;
            //
            FullStory.trackEvent('RemoveFromCart', {variationId : vid, productId : pid});
            var reqData = {};
            if (!AuthManager.isUserLoggedIn) {
                return Cart.removeFromLocalCart(pid, vid)
            } else {
                return $q(function (resolve, reject) {
                    $http.delete(Base.getBaseUrl() + "/cart", {
                        data: {product: pid, variation: vid},
                        headers: {"content-type": "application/json"}
                    }).then(function (response) {
                        //
                        if (response.data.code === 200) {
                            Cart._userCart = response.data.message.cart[0];
                            Cart.emitChanges();
                            resolve(response.data.message.cart[0]);
                        } else {
                            //
                            var err = new Error();
                            err.code = response.data.code;
                            err.message = response.data.message.error;
                            reject(err);
                        }
                    }).catch(function (err) {
                        //
                        reject(err);
                    });
                });
            }
        };

        this.clearCart = function () {
            var Cart = this;

            if (!AuthManager.isUserLoggedIn) {
                return Cart.clearLocalCart()
            } else {
                return $q(function (resolve, reject) {

                    RestManager.getResource("/cart/clear", 'cart')
                        .then(function (cart) {
                            Cart._userCart = cart[0];
                            Cart.emitChanges();
                            resolve(cart[0]);
                        }).catch(function (err) {

                        reject(err);
                    });
                })
            }
        };

        this.applyCoupon = function (couponCode) {
            var Cart = this;
            return $q(function (resolve, reject) {
                RestManager.putResource("/cart/applyCoupon", {coupon: couponCode}, "cart")
                    .then(function (cart) {
                        //
                        Cart._userCart = cart[0];
                        Cart.emitChanges();
                        resolve(cart[0]);
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            });

        };


        this.applyGiftCard = function (cardCode) {
            var Cart = this;
            return $q(function (resolve, reject) {
                RestManager.putResource("/cart/applyGiftCard", {card: cardCode}, "cart")
                    .then(function (cart) {
                        //
                        Cart._userCart = cart[0];
                        Cart.emitChanges();
                        resolve(cart[0]);
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            });
        };


        this.removeCoupon = function () {
            var Cart = this;
            return $q(function (resolve, reject) {
                RestManager.putResource("/cart/removeCoupon", {}, "cart")
                    .then(function (cart) {
                        Cart._userCart = cart[0];
                        Cart.emitChanges();
                        resolve(cart[0]);
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            });

        };

        this.removeGiftCard = function () {
            var Cart = this;
            return $q(function (resolve, reject) {
                RestManager.putResource("/cart/removeGiftCard", {}, "cart")
                    .then(function (cart) {
                        Cart._userCart = cart[0];
                        Cart.emitChanges();
                        resolve(cart[0]);
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            });

        };


        this.getUserCart = function (forceUpdate) {
            var that = this;
            //
            return $q(function (resolve, reject) {
                console.log('Is Logged In', AuthManager.isUserLoggedIn);
                if (AuthManager.isUserLoggedIn) {
                    if ((!that._userCart || forceUpdate)) {
                        $http.get(Base.getBaseUrl() + "/cart")
                            .then(function (response) {
                                //
                                if (response.data.code === 200) {
                                    that._userCart = response.data.message.cart[0];
                                    that.emitChanges();
                                    resolve(that._userCart);
                                }
                            })
                            .catch(function (err) {
                                //
                                reject(err);
                            })
                    } else {
                        resolve(that._userCart);
                    }
                } else {
                    var cart = JSON.parse($window.localStorage.getItem('cart'));
                    try {
                        cart = JSON.parse(cart);
                    } catch (e) {

                    }
                    that._userCart = cart;
                    if (that._userCart) {
                        that.emitChanges();
                    }
                    resolve(that._userCart);
                }
            });

        }
    }]);

/**
 * Created by kumardivyarajat on 04/11/16.
 */
angular.module("app.main")
    .service("Utils", ["$q", function ($q) {

        this.isCustomisableAdvancedProduct = function (product) {
            return product.productType === 1 &&
                (product.editorType === 'intermediate' ||
                    product.editorType === 'advanced')
        };

        this.dateAgo = function (date) {
            if (!date || !moment(date).isValid()) {
                return 'Never';
            } else {
                return moment(date).fromNow();
            }
        }

        this.scrollToTopOfThePage = function () {
            document.getElementById("body").scrollTop = 0;
        };

        this.performSearchBySlug = function (slug, entityArray) {
            return _.find(entityArray, function (o) {
                return o.slug == slug;
            })
        };

        this.addToSet = function (array, value) {
            var isPresent = false;
            if (Array.isArray(value)) {
                _.forEach(value, function (val) {
                    var a = _.find(array, function (v) {
                        return v == val;
                    });
                    if (!a) {
                        array.push(val);
                    }
                })
            } else {
                _.forEach(array, function (val) {
                    if (val == value) {
                        isPresent = true;
                    }
                });

                if (!isPresent) {
                    array.push(value);
                }
            }
        };


        this.getPaymentOption = function (option) {
            switch (option) {
                case 1 :
                    return "COD";

                case 2:
                    return "Online Payment/Net Banking (Instamojo)";

                case 3:
                    return "PayUMoney";

                case 4:
                    return "PayTm";

                case 5:
                    return "FreeCharge";

                case 6:
                    return "MobiKwik";
            }
        };


        this.getPrice = function (stockAndPrice, justNumber) {
            var price = "Free";
            if (stockAndPrice.price) {
                var salePrice = stockAndPrice.price.salePrice;

                if (salePrice) {
                    price = parseInt(salePrice);
                }
            }
            if (justNumber) {
                return price !== "Free" ? price : 0;
            } else {
                return price !== "Free" ? "+Rs. " + price : price;
            }
        };


        this.getIcon = function (name) {
            var backSpace = "assets/images/";
            switch (name) {
                case "Fabric" :
                    return backSpace + "colours-palette.svg";

                case "Sleevs" :
                    return backSpace + "sweater.svg";

                case "Sleeves" :
                    return backSpace + "sweater.svg";

                case "Length" :
                    return backSpace + "height.svg";

                case "Necks" :
                    return backSpace + "cocktail-dress.svg";

                case "Neck":
                    return backSpace + "cocktail-dress.svg";

                default :
                    return backSpace + "two-hole-button.svg";
            }
        };


        this.getSelectedVariationFromCartProduct = function (product) {
            //
            return _.find(product.variation.attributes[0].attribute.meta_values, function (val) {
                return val._id === product.variation.attributes[0].selectedValue[0];
            }).value;
        };
        this.getSizePriority = {
            "XXS": 0,
            "XS": 1,
            "S": 2,
            "M": 3,
            "L": 4,
            "XL": 5,
            "XXL": 6,
            "XXXL": 7

        };


        this.getProperName = function (str, length) {
            if (!length) length = 24;
            return _.startCase(_.toLower(_.truncate(str, {'length': length, 'separator': ' '})));
        };


        this.isImage = function (src) {
            var deferred = $q.defer();

            var image = new Image();
            image.onerror = function() {
                deferred.resolve(false);
            };
            image.onload = function() {
                deferred.resolve(true);
            };
            image.src = src;

            return deferred.promise;
        }
    }]);

/**
 * Created by kumardivyarajat$ on Sep, 2017
 */
(function () {
    'use strict';

    angular
        .module("app", ['ui.router', 'ngCookies', 'ngAnimate', 'ngMessages', 'angulartics',
            'angulartics.mixpanel', 'angulartics.google.analytics','angulartics.facebook.pixel', "app.main", "uiGmapgoogle-maps",
            "tandibar/ng-rollbar", "angular-loading-bar"])
})();

/**
 * Created by kumardivyarajat on 02/12/16.
 */
angular.module("app")
    .service("RestManager", ["$http", "$q", "Base", "$log", "ErrorHero", function ($http, $q, Base, $log, ErrorHero) {
        var _handleResponse = function (response, extras, resourceName, resolve, reject) {
            if (response.data.code == 200) {
                if (extras) {
                    if (extras.length > 0) {
                        var returnData = {};
                        returnData[resourceName] = response.data.message[resourceName];
                        _.forEach(extras, function (extra) {
                            returnData[extra] = response.data[extra];
                        });
                        resolve(returnData);
                    } else {
                        resolve(response.data.message[resourceName]);
                    }
                } else {
                    resolve(response.data.message[resourceName]);
                }
            } else {
                reject(ErrorHero(response));
            }
        };
        //
        // this.getResourcePromise = function (route) {
        //     return $q(function (resolve, reject) {
        //         return $http.get(Base.getBaseUrl() + route);
        //     })
        // };

        this._buildUrl = function (route, options) {
            if (!Array.isArray(options)) {
                if (!options) {
                    return Base.getBaseUrl() + route;
                } else if (options) {
                    var url = '';

                    switch (options.service) {
                        case 'socialProof' :
                            url = Base.getSocialProofUrl() + route;
                            break;

                        case 'reviews' :
                            url = Base.getReviewsUrl() + route;
                            break;

                        default:
                            url = Base.getBaseUrl() + route;
                            break;
                    }

                    if (options.query || options.cursor || options.select)
                        url += '?';

                    if (options.query) {
                        _.forOwn(options.query, function (val, key) {
                            url += key + '=' + val + '&'
                        })
                    }

                    if (options.cursor) {
                        _.forOwn(options.query, function (val, key) {
                            url += key + '=' + val + '&'
                        })
                    }

                    if (options.select) {
                        url += 'select=' + _.reduce(options.select, function (reducer, val) {
                            return reducer + val + ','
                        }, '')
                    }

                    return url;
                }


            } else {
                return Base.getBaseUrl() + route;
            }
        };


        this.getResource = function (route, resourceName, options) {
            var vm = this;
            return $q(function (resolve, reject) {
                $http.get(vm._buildUrl(route, options))
                    .then(function (response) {
                        if (Array.isArray(options) || !options) {
                            _handleResponse(response, options, resourceName, resolve, reject);
                        } else {
                            _handleResponse(response, options ? options.extras : null, resourceName, resolve, reject);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        };

        this.postResource = function (route, data, resourceName, options) {
            var vm = this;
            return $q(function (resolve, reject) {
                $http.post(vm._buildUrl(route, options), data)
                    .then(function (response) {
                        if (Array.isArray(options) || !options) {
                            _handleResponse(response, options, resourceName, resolve, reject);
                        } else {
                            _handleResponse(response, options ? options.extras : null, resourceName, resolve, reject);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };

        this.putResource = function (route, data, resourceName, extras) {
            return $q(function (resolve, reject) {
                $http.put(Base.getBaseUrl() + route, data)
                    .then(function (response) {
                        _handleResponse(response, extras, resourceName, resolve, reject);
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };

        this.patchResource = function (route, data, resourceName, options) {
            var vm = this;
            return $q(function (resolve, reject) {
                $http.patch(vm._buildUrl(route, options), data)
                    .then(function (response) {
                        if (Array.isArray(options)) {
                            _handleResponse(response, options, resourceName, resolve, reject);
                        } else {
                            _handleResponse(response, options ? options.extras : null, resourceName, resolve, reject);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        };

        this.deleteResource = function (route, resourceName, extras) {
            return $q(function (resolve, reject) {
                $http.delete(Base.getBaseUrl() + route)
                    .then(function (response) {
                        _handleResponse(response, extras, resourceName, resolve, reject);
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        }
    }]);

(function () {
    'use strict';


    Onboarding.$inject = ["$window"];
    angular.module('app.main')
        .service('Onboarding', Onboarding);

    function Onboarding($window) {
        this._gkey = 'onboarding';

        /**
         * @memberOf Onboarding
         * @param key
         */
        this.complete = function (key) {
            var onboarding = JSON.parse($window.localStorage.getItem(this._gkey) || '{}');
            onboarding[key] = true;
            $window.localStorage.setItem(this._gkey, JSON.stringify(onboarding));
        };

        /**
         * @memberOf Onboarding
         * @param key
         * @returns {boolean}
         */
        this.isComplete = function (key) {
            var onboarding = JSON.parse($window.localStorage.getItem(this._gkey) || '{}');
            return !!onboarding[key];
        }
    }

})(angular);

/**
 * Created by kumardivyarajat on 13/12/16.
 */
(function () {

    angular.module('app').factory('ImagePreloader', imagePreloader);

    imagePreloader.$inject = ['$q', '$timeout', 'Utils', 'Base'];

    function imagePreloader($q, $timeout, Utils, Base) {

        var _body = document.getElementsByTagName('body')[0];

        return {
            preloadImages: preloadImages
        };

        function renderImage(imgPath) {

            return $q(function (resolve) {


                Utils.isImage(imgPath)
                    .then(function (exists) {
                        //
                        if (exists) {
                            // Create an image element
                            var element = document.createElement('img');
                            var timeoutId;


                            // Assign properties to the element making it tiny and invisible to the viewer
                            element.src = imgPath;
                            element.height = "1";
                            element.width = "1";
                            element.style.opacity = 0;

                            // Begin a timeout.  If image has failed to load, resolve anyway and remove element
                            timeoutId = $timeout(function () {
                                _body.removeChild(element);
                                element.removeEventListener('load', processLoadEvent);
                                resolve();
                            }, 1750);

                            element.addEventListener('load', processLoadEvent);

                            // Wait for the image to load and then remove it
                            // Cancel the timeout event
                            function processLoadEvent() {
                                // //
                                _body.removeChild(element);
                                $timeout.cancel(timeoutId);
                                resolve(true);
                            }

                            // Add the image element to the DOM
                            _body.appendChild(element);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch(function (err) {

                    });
            });

        }

        /**
         * Take array of images and force them to be loaded/cached by the browser
         * @param {array} images
         */
        function preloadImages(images) {

            if (!images || images.length === 0) {
                return $q.when();
            }

            return $q.all(images.map(function (image) {
                return renderImage(image);
            }));

        }
    }

})();

/**
 * Created by kumardivyarajat on 02/11/16.
 */
angular.module("app.main")
    .factory('Header', ["Constants", "Role", function (Constants, Role) {
        var showHeaderImage = false;
        return {
            isHeaderImageEnabled: function () {
                return showHeaderImage;
            },
            setShowHeaderImage: function (boolVal) {
                showHeaderImage = boolVal
            }
        };
    }]);
(function () {
    'use strict';

    angular.module('app.main')
        .service('FullStory', fullStory);


    function fullStory() {

        /**
         * @memberOf FullStory
         * @param eventName
         * @param [eventProperties]
         * @method trackEvent
         */
        this.trackEvent = function (eventName, eventProperties) {
            try {
                if(ifFullStoryExists) {
                    window['FS'].event(eventName, eventProperties);
                }
            } catch (e) {
                console.log('Error in FS Track', e);
            }
        }

        function ifFullStoryExists() {
            return typeof FS !== 'undefined';
        }
    }

})(angular);

/**
 * Created by kumardivyarajat on 11/11/16.
 */
angular.module('app.main')
    .factory('$exceptionHandler', ['$log', function ($log) {
        return function myExceptionHandler(exception, cause) {
            // logErrorsToBackend(exception, cause);
            $log.warn(exception, cause);
            if (confData.env === 'prod') {
                mixpanel.track("Error", {"Trace": cause, "Exception": exception});
            }
        };
    }])
    .factory("ErrorHero", ["$log", function ($log) {
        return function myHero(response) {
            $log.warn(response);
            var err = new Error(getErrorDetails(response));
            err.message = getErrorDetails(response);
            err.code = response.data.code;
            if (confData.env === 'prod') {
                mixpanel.track("Error", {"Trace": err.message, "Cause": err.code, "Error": err, "Response": response});
            }
            return err;
        };


        function getErrorDetails(response) {
            switch (response.data.code) {
                case 410 :
                    return "Invalid OTP";

                case 423 :
                    return "Invalid Mobile Number/Password";

                case 435 :
                    return "User already registered";

                case 441 :
                    return "Invalid Coupon";

                default :
                    if (Array.isArray(response.data.message.error)) {
                        var string = "";
                        _.forEach(response.data.message.error, function (err) {
                            string += err.error + ", ";
                        });
                        return string;
                    } else {
                        return response.data.message.error;
                    }
            }
        }
    }]);

/**
 * Created by kumardivyarajat on 04/03/17.
 */
angular.module("app")
    .service("CookiesManager", ["$cookies", function ($cookies) {
        this.putCookie = function (key, value, expiry) {
            $cookies.putObject(key, value, {
                expires: expiry
            });
        };

        this.removeCookie = function (key) {
            $cookies.remove(key);
        };


        this.getCookie = function (key) {
            $cookies.get(key);
        };

        this.getCookieObject = function (key) {
            $cookies.getObject(key);
        };

    }]);
/**
 * Created by Nidhu on 11/11/16.
 */
angular.module("app.main")
    .service('AuthManager', ["$q", "$log", "$http", "Base", "$window", "$cookies", "$mdDialog", "ErrorHero", "$analytics", "RestManager", function ($q, $log, $http, Base, $window, $cookies, $mdDialog, ErrorHero, $analytics, RestManager) {
        this._currentUser = "";
        this.isUserLoggedIn = false;
        var deferred;

        this.getCurrentUser = function () {
            return this._currentUser;
        };

        this.getCurrentUserQ = function () {
            var self = this;
            return $q(function (resolve, reject) {
                resolve(self._currentUser);
            });
        };


        this.getCurrentUserAsync = function () {
            var that = this;
            if (!Base.getBaseUrl())
                Base.setBaseUrl("")
            return $q(function (resolve, reject) {
                var uid = $cookies.getObject('uid');
                var token = $cookies.getObject("tkn");
                var refreshToken = $cookies.getObject("rtkn");
                var guid = '';
                // if (!uid) {
                //     var guid = $cookies.getObject('guest_uid');
                //     token = $cookies.getObject("guest_tkn");
                //     refreshToken = $cookies.getObject("guest_rtkn");
                // }
                if (!that.isUserLoggedIn && (uid || guid)) {
                    that._setUpHeaders(token, refreshToken);
                    var id = uid ? uid : guid;
                    RestManager.getResource("/users/" + id, "users")
                        .then(function (users) {
                            that._currentUser = users[0];
                            that.isUserLoggedIn = !!uid;
                            // that._setUpHeaders(that._currentUser['x-access-token'], that._currentUser['x-refresh-token']);
                            resolve(that._currentUser);
                        })
                        .catch(function (err) {
                            if (err.status && (err.status === 401 || err.status === 413)) {
                                that.logout();
                                // that.setupTempUser(resolve, reject);
                            } else {
                                reject(err);
                            }
                        });
                } else if (!that.isUserLoggedIn) {
                    // that.setupTempUser(resolve, reject);
                } else {
                    resolve(that._currentUser);
                }
            });
        };

        this.setupTempUser = function (resolve, reject) {
            var that = this;

            RestManager.getResource("/users/setup", "users")
                .then(function (users) {

                    that.isUserLoggedIn = false;
                    that.setTempData(users[0]);
                    that._setUpHeaders(users[0]['x-access-token'], users[0]['x-refresh-token']);
                    resolve(that._currentUser);
                })
                .catch(function (err) {
                    reject(err);
                });
        };

        // this.setup = function () {
        //     var that = this;
        //     return $q(function (resolve, reject) {
        //         var user = $cookies.getObject('uid');
        //         RestManager.getResource("/users/" + user._id, "users")
        //             .then(function (user) {
        //                 if (user[0]) {
        //                     that._currentUser = user[0];
        //                     that.isUserLoggedIn = true;
        //                     that._setUpHeaders(that._currentUser['x-access-token'], that._currentUser['x-refresh-token']);
        //                 }
        //             })
        //             .catch(function (err) {
        //
        //             })
        //     })
        // };
        this.setCurrentUser = function (user, persistent) {
            //
            this._currentUser = user;
            //TODO Validate data for integrity
            this.isUserLoggedIn = !user.tempUser;

            if (!persistent) {
                var now = new Date();
                now.setDate(now.getDate() + 7);

                $cookies.putObject("uid", user._id, {
                    expires: now
                });

                $cookies.putObject("tkn", user["x-access-token"], {
                    expires: now
                });

                $cookies.putObject("rtkn", user["x-refresh-token"], {
                    expires: now
                })
            } else {
                $cookies.putObject("uid", user._id);
                $cookies.putObject("tkn", user["x-access-token"]);

                $cookies.putObject("rtkn", user["x-refresh-token"])
            }

            var a = {};
            angular.copy(user, a);
            delete a["x-access-token"];
            delete a["x-refresh-token"];
            $analytics.setAlias(a._id);
            $analytics.setUsername(a.email);
            $analytics.setUserProperties(a);
            this._setUpHeaders(user['x-access-token'], user['x-refresh-token']);
        };

        this.showLoginModal = function ($event, $scope, clickOnCloseOutside) {
            if (this.isUserLoggedIn) {
                return;
            }
            $analytics.eventTrack(
                "Auth Modal Opened"
            );
            $mdDialog.show({
                contentElement: '#loginDialog',
                parent: angular.element(document.body),
                fullscreen: false,
                targetEvent: $event,
                scope: $scope,        // use parent scope in template
                preserveScope: true,  // do not forget this if use parent scope
                clickOutsideToClose: clickOnCloseOutside,
                escapeToClose: true
            });
        };

        this.setTempData = function (user) {
            var expireDate = new Date();
            expireDate.setTime(2144232732000);
            $cookies.putObject("guest_uid", user._id, {'expires': expireDate});
            $cookies.putObject("guest_tkn", user["x-access-token"], {'expires': expireDate});
            $cookies.putObject("guest_rtkn", user["x-refresh-token"], {'expires': expireDate})
        };


        this.loginUser = function (username, password) {
            var that = this;
            return $q(function (resolve, reject) {
                $http.post(Base.getBaseUrl() + "/users/login", {mobile: username, password: password})
                    .then(function (response) {
                        //
                        if (response.data.code === 200) {
                            that.setCurrentUser(response.data.message.users[0]);
                            resolve(that._currentUser);
                            if (deferred) {
                                deferred.resolve(that._currentUser);
                            }
                        } else {
                            reject(ErrorHero(response));
                            if (deferred) {
                                deferred.reject(ErrorHero(response));
                            }
                        }
                    })
                    .catch(function (err) {
                        // $log.error(err);
                    })
            });
        };

        this._setUpHeaders = function (accessToken, refreshToken) {
            $http.defaults.headers.common['x-access-token'] = accessToken; // jshint ignore:line
            $http.defaults.headers.common['x-refresh-token'] = refreshToken; // js
        };

        this._clearHeaders = function () {
            $http.defaults.headers.common['x-access-token'] = undefined; // jshint ignore:line
            $http.defaults.headers.common['x-refresh-token'] = undefined; // js
        };

        this.logout = function (silent) {
            $cookies.remove('uid');
            $cookies.remove('tkn');
            $cookies.remove('rtkn');
            this._currentUser = {};
            this.isUserLoggedIn = false;
            $analytics.setAlias("");
            $analytics.setUsername("");
            $analytics.setUserProperties("");
            mixpanel.cookie.clear();
            this._clearHeaders();
            if (confData.env === 'prod' && typeof FS !== 'undefined') {
                FS.identify(false);
            }
            if(!silent) {
                $window.location.reload();
            }
        };

        this.requestOTP = function (mobile, email) {
            //
            var data = {mobile: mobile};
            if (email) {
                data.email = email;
            }
            return $q(function (resolve, reject) {
                $http.post(Base.getBaseUrl() + "/users/generateotp", data)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            resolve();
                        } else {
                            reject(ErrorHero(response));
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            });
        };

        this.verifyotp = function (mobile, otp) {
            //
            return $q(function (resolve, reject) {
                $http.post(Base.getBaseUrl() + "/users/verifyotp", {mobile: mobile, otp: otp})
                    .then(function (response) {
                        if (response.data.code === 200) {
                            resolve(true);
                        } else {
                            reject(ErrorHero(response));
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            });
        };

        this.forgotPassword = function (mobile) {
            return $q(function (resolve, reject) {
                RestManager.postResource("/users/forgotpassword", {mobile: mobile}, "users")
                    .then(function (users) {
                        resolve();
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };

        this.resetPassword = function (user) {
            return $q(function (resolve, reject) {
                RestManager.postResource("/users/resetpassword", user, "users")
                    .then(function (users) {
                        resolve();
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };

        this.signup = function (user) {
            var that = this;
            return $q(function (resolve, reject) {
                $http.post(Base.getBaseUrl() + "/users/signup", user)
                    .then(function (response) {

                        if (response.data.code === 200) {
                            that.setCurrentUser(response.data.message.users[0]);
                            resolve(that._currentUser);
                            if (deferred) {
                                deferred.resolve(that._currentUser);
                            }
                        } else {
                            reject(ErrorHero(response));
                            if (deferred)
                                deferred.reject(ErrorHero(response));
                        }
                    })
                    .catch(function (err) {
                        // $log.error(err);
                        deferred.reject(err);
                    })
            });
        };


        this.updateUser = function (data) {
            var self = this;
            return $q(function (resolve, reject) {
                RestManager.putResource("/users", data, "user")
                    .then(function (users) {
                        self._currentUser.mobile = users[0].mobile;
                        self._currentUser.email = users[0].email;
                        self._currentUser.virtualMobile = users[0].virtualMobile;
                        resolve(self._currentUser);
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };

        this._addToCookies = function () {

        };


        this._addToRootScope = function () {

        };


    }]);

/**
 * Created by kumardivyarajat on 06/05/17.
 */
angular.module("app.main")
    .directive('transparentHeader', ["$rootScope", "$mdMedia", function ($rootScope, $mdMedia) {
        return {
            restrict: 'C',
            link: function (scope, element, attrs) {
                if ($mdMedia("gt-sm")) {
                    var header = angular.element(document.querySelector('md-toolbar.toolbar.header'));
                    element.bind('scroll', handler);
                } else {
                    element.unbind('scroll', handler);
                }

                function handler() {
                    //do code here
                    var dimensions = element[0].scrollTop;
                    //
                    if($rootScope.transparentHeader) {
                        if (dimensions > $rootScope.varHeight) {
                            header.removeClass("gradient no-shadow");
                        } else {
                            header.addClass("gradient no-shadow");
                        }
                        scope.$apply();
                    }
                }
            }
        }
    }]);

/**
 * Created by kumardivyarajat on 05/12/16.
 */
angular.module("app.main")
    .directive('staticInclude', ["$http", "$templateCache", "$compile", function ($http, $templateCache, $compile) {
        return function (scope, element, attrs) {
            var templatePath = attrs.staticInclude;
            $http.get(templatePath, {cache: $templateCache}).then(function (response) {
                var contents = element.html(response.data).contents();
                $compile(contents)(scope);
            });
        };
    }]);
/**
 * Created by kumardivyarajat on 23/05/17.
 */
angular.module("app.main")
    .directive("spinWheel", ["$interval", "$cookies", function ($interval, $cookies) {
        return {
            restrict: "AEC",
            transclude: true,
            scope: {
                onComplete: "&"
            },
            link: function ($scope, element, attrs) {
                var rotated = false;
                $scope.tries = 0;
                $scope.coupons = [];
                var genRandom = function () {
                    var random = Math.floor(Math.random() * (($scope.tries + 1) * 2160)) + (($scope.tries + 1) * 1080);

                    return random;
                };

                var a = [
                    50,
                    40,
                    10,
                    20,
                    30
                ];

                $scope.spin = function () {
                    var div = document.getElementById('circle');

                    $scope.spinning = true;
                    // if ($scope.tries !== 0) {
                    //     $scope.reset(div);
                    // }
                    var deg = genRandom();
                    var con = $cookies.getObject("spinwheel");

                    if (con) {
                        if (!con.played) {
                            $cookies.putObject("spinwheel", {
                                cancelled: true,
                                viewed: true,
                                viewDate: con.viewDate,
                                played: true,
                                playDate: new Date()
                            }, {expires : new Date("06/10/2017")});
                        }
                    }
                    setTimeout(function () {
                        TweenLite.to("#circle", 8, {
                            rotation: deg,
                            transformOrigin: "center center",
                            ease: Elastic.easeOut.config(1, 0.3),
                            onComplete: onAnimationComplete
                        });
                    }, 0);

                    var onAnimationComplete = function () {
                        var x = Math.floor((deg % 360) / 72);
                        $scope.spinning = false;
                        $scope.status = a[x] + "% off coupon unlocked";
                        $scope.coupons.push({
                            chance: $scope.tries++,
                            coupon: a[x]
                        });

                        if ($scope.tries === 3) {
                            $scope.contestComplete = true;
                            setTimeout(function () {
                                var c = _.sortBy($scope.coupons, function (o) {
                                    return -o.coupon;
                                });
                                $scope.coupons = c.slice(0, 1);
                            }, 1000);
                            setTimeout(function () {
                                TweenLite.to("#cp" + $scope.coupons[0].chance + "-" + $scope.coupons[0].coupon,
                                    2, {
                                        scale: 2,
                                        y : -50,
                                        force3D: false,
                                        ease: Sine.easeInOut,
                                        onComplete: onFinalComputation
                                    });
                            }, 3000);
                        }
                        // $scope.tries++;
                    };


                    var onFinalComputation = function () {
                        $scope.onComplete({data: $scope.coupons[0].coupon});
                    }
                };


                $scope.reset = function (div) {
                    div.style.webkitTransform = 'none';
                    div.style.mozTransform = 'none';
                    div.style.msTransform = 'none';
                    div.style.oTransform = 'none';
                    div.style.transform = 'none';
                };
            },
            templateUrl: "app/modules/base/directives/templates/spinWheel.tpl.html"
        }
    }]);


/**
 * Created by kumardivyarajat on 07/03/17.
 */
angular.module("app.main")
    .directive('rdxZoom', function () {
        function link(scope, element, attrs) {
            var $ = angular.element;
            var original = $(element[0].querySelector('.original'));
            var originalImg = original.find('img');
            var zoomed = $(element[0].querySelector('.zoomed'));
            var zoomedImg = zoomed.find('img');

            var mark = $('<div></div>')
                .addClass('mark')
                .css('position', 'absolute')
                .css('height', scope.markHeight + 'px')
                .css('width', scope.markWidth + 'px');


            $(element).append(mark);

            element
                .on('mouseenter', function (evt) {
                    mark.removeClass('hide');

                    var offset = calculateOffset(evt);
                    moveMark(offset.X, offset.Y);
                })
                .on('mouseleave', function (evt) {
                    mark.addClass('hide');
                })
                .on('mousemove', function (evt) {
                    var offset = calculateOffset(evt);
                    moveMark(offset.X, offset.Y);
                });

            scope.$on('mark:moved', function (event, data) {
                updateZoomed.apply(this, data);
            });

            function moveMark(offsetX, offsetY) {
                var dx = scope.markWidth,
                    dy = scope.markHeight,
                    x = offsetX - dx / 2,
                    y = offsetY - dy / 2;

                mark
                    .css('left', x + 'px')
                    .css('top', y + 'px');

                scope.$broadcast('mark:moved', [
                    x, y, dx, dy, originalImg[0].height, originalImg[0].width
                ]);
            }

            function updateZoomed(originalX, originalY, originalDx, originalDy, originalHeight, originalWidth) {
                var zoomLvl = scope.zoomLvl;
                scope.$apply(function () {
                    zoomed
                        .css('height', zoomLvl * originalDy + 'px')
                        .css('width', zoomLvl * originalDx + 'px');
                    zoomedImg
                        .attr('src', scope.src)
                        .css('height', zoomLvl * originalHeight + 'px')
                        .css('width', zoomLvl * originalWidth + 'px')
                        .css('left', -zoomLvl * originalX + 'px')
                        .css('top', -zoomLvl * originalY + 'px');
                });
            }

            var rect;

            function calculateOffset(mouseEvent) {
                rect = rect || mouseEvent.target.getBoundingClientRect();
                var offsetX = mouseEvent.clientX - rect.left;
                var offsetY = mouseEvent.clientY - rect.top;

                return {
                    X: offsetX,
                    Y: offsetY
                }
            }

            attrs.$observe('ngSrc', function (data) {
                scope.src = attrs.ngSrc;
            }, true);


            attrs.$observe('zoomLvl', function (data) {
                scope.zoomLvl = data;
            }, true);
        }

        return {
            restrict: 'EA',
            scope: {
                markHeight: '@markHeight',
                markWidth: '@markWidth',
                src: '@src',
                zoomLvl: "@zoomLvl"
            },
            template: [
                '<div class="original">',
                '<md-img md-src="{{src}}"/>',
                '</div>',
                '<div class="zoomed">',
                '<img/>',
                '</div>'
            ].join(''),
            link: link
        };
    });

/**
 * Created by kumardivyarajat on 04/03/17.
 */
(function () {
    'use strict';
    angular.module("app.main").directive("copyToClipboard", copyClipboardDirective);
    function copyClipboardDirective() {
        var clip;

        function link(scope, element) {
            function clipboardSimulator() {
                var self = this,
                    textarea,
                    container;

                function createTextarea() {
                    if (!self.textarea) {
                        container = document.createElement('div');
                        container.id = 'simulate-clipboard-container';
                        container.setAttribute('style', ['position: fixed;', 'left: 0px;', 'top: 0px;', 'width: 0px;', 'height: 0px;', 'z-index: 100;', 'opacity: 0;', 'display: block;'].join(''));
                        document.body.appendChild(container);
                        textarea = document.createElement('textarea');
                        textarea.setAttribute('style', ['width: 1px;', 'height: 1px;', 'padding: 0px;'].join(''));
                        textarea.id = 'simulate-clipboard';
                        self.textarea = textarea;
                        container.appendChild(textarea);
                    }
                }

                createTextarea();
            }

            clipboardSimulator.prototype.copy = function () {
                this.textarea.innerHTML = '';
                this.textarea.appendChild(document.createTextNode(scope.textToCopy));
                this.textarea.focus();
                this.textarea.select();
                setTimeout(function () {
                    document.execCommand('copy');
                }, 20);
            };
            clip = new clipboardSimulator();
            element[0].addEventListener('click', function () {
                clip.copy();
            });
        }

        return {
            restrict: 'A',
            link: link,
            scope: {
                textToCopy: '='
            }
        };
    }
}());

(function () {
    'use strict';

    angular.module('app.main')
        .directive('onImageLoad', ['$parse', function ($parse) {
            return {
                restrict: 'A',
                link: function (scope, elem, attrs) {
                    var fn = $parse(attrs.onImageLoad);
                    elem.on('load', function (event) {
                        scope.$apply(function () {
                            fn(scope, {$event: event});
                        });
                    });
                }
            };
        }]);

})(angular);

/**
 * Created by kumardivyarajat on 14/12/16.
 */
angular.module("app.main")
    .directive("mdImageSlider", ["$interval", "$log", "$state", "$window", "$document", "$mdMedia", "$timeout", "$rootScope", "Base", function ($interval, $log, $state, $window, $document, $mdMedia, $timeout, $rootScope, Base) {
        return {
            restrict: "AEC",
            transclude: true,
            scope: {
                srcList: "=",
                autoPlay: "=",
                interval: "=",
                overlay: "=",
                controls: "=",
                fullLink: "=",
                isMobile : "=",
                aspectRatio : '=?'
            },
            link: function (scope, element, attrs) {
                scope.currentItem = 0;

                scope.isSmall = !$mdMedia("gt-sm");

                if(!scope.srcList.length || scope.srcList.length === 1) {
                    scope.hideIndicator = true;
                }
                var a, b;

                if(_.isString(scope.interval)) {
                    scope.interval = parseInt(scope.interval);
                    if(!scope.interval) {
                        scope.autoPlay = false;
                    }
                }

                if (scope.autoPlay) {
                    a = $interval(function () {
                        scope.currentItem = (scope.currentItem + 1) % scope.srcList.length;
                        // $log.info("Changed the slider image. Image at" + scope.currentItem + " is " + scope.srcList[scope.currentItem]);
                    }, scope.interval)
                }


                _.forEach(scope.srcList, function (o, i) {
                    if (scope.isSmall && o.position) {
                        o.alignClass = "layout-align-center-start";
                    } else if(o.position) {
                        o.alignClass = "layout-align-" + o.position.split(" ").join("-");
                    } else {
                        o.alignClass = "layout-align-center-center"
                    }
                });

                scope.getClass = function ($index) {
                    return scope.srcList[$index].alignClass;
                };

                scope.getButtonClass = function (index) {
                    return scope.srcList[index].buttonColor + " " + scope.srcList[index].buttonTextColor + "-text";
                };

                scope.performAction = function (event, index) {
                    if (scope.srcList[scope.currentItem].buttonSref) {
                        $state.go(scope.srcList[scope.currentItem].buttonSref);
                    }
                };

                scope.getUrl = function(url) {
                    if(url.indexOf('assets') !== -1) {
                        return url;
                    } else {
                        return Base.getMediaUrl() + url;
                    }
                }

                scope.next = function () {
                    scope.currentItem = (scope.currentItem + 1) % scope.srcList.length;
                    if (scope.autoPlay) {
                        $interval.cancel(a);
                        a = $interval(function () {
                            scope.currentItem = (scope.currentItem + 1) % scope.srcList.length;
                            // $log.info("Changed the slider image. Image at" + scope.currentItem);
                        }, scope.interval)
                    }
                };

                scope.previous = function () {
                    if (scope.currentItem === 0) {
                        scope.currentItem = scope.srcList.length - 1;
                    } else {
                        scope.currentItem = (scope.currentItem - 1) % scope.srcList.length;
                    }
                    if (scope.autoPlay) {
                        $interval.cancel(a);
                        a = $interval(function () {
                            scope.currentItem = (scope.currentItem + 1) % scope.srcList.length;
                            // $log.info("Changed the slider image. Image at" + scope.currentItem);
                        }, scope.interval)
                    }
                };

                var pendingSwipe = false;

                scope.onSwipeLeft = function () {
                    if (scope.isSmall && !pendingSwipe) {
                        scope.next();
                        pendingSwipe = true;
                        b = $timeout(function () {
                            pendingSwipe = false;
                        }, 100);
                    }
                };

                scope.onSwipeRight = function () {
                    if (scope.isSmall && !pendingSwipe) {
                        scope.previous();
                        pendingSwipe = true;
                        b = $timeout(function () {
                            pendingSwipe = false;
                        }, 100);
                    }
                };

                scope.change = function (newIndex) {
                    scope.currentItem = newIndex % scope.srcList.length;
                    if (scope.autoPlay) {
                        $interval.cancel(a);
                        a = $interval(function () {
                            scope.currentItem = (scope.currentItem + 1) % scope.srcList.length;
                            // $log.info("Changed the slider image. Image at" + scope.currentItem);
                        }, scope.interval)
                    }
                };

                scope.$on('$destroy', function () {
                    $interval.cancel(a);
                    $timeout.cancel(b);
                });

                scope.buildUrl = function () {
                    if (scope.srcList[scope.currentItem]) {
                        var src = scope.srcList[scope.currentItem];
                        return src.url;
                    } else {
                        return undefined;
                    }
                };


                if(!scope.aspectRatio) {
                    scope.aspectRatio = (1920 / 1080);
                }
                // Maintain aspect ratio
                scope.width = ($window.innerWidth <= 1440) ? $window.innerWidth : 1440;
                scope.height = Math.min(( scope.width - scope.width / 3), scope.width / scope.aspectRatio);

                scope.heightPx = scope.height + 'px';

                $rootScope.varHeight = scope.height;


                // FIxed height
                // scope.height = 400;
                // //

                // element.on("load", function () {
                //     //
                // });

                // image: "assets/images/summer-singlet-1200x750.jpg",
                //     position: "center start",
                //     button: true,
                //     heading: "New Arrivals",
                //     text: "Buy the latest fashion.",
                //     buttonText: "Shop Now",
                //     buttonColor: "white",
                //     buttonTextColor: "black",
                //     buttonIcon: "",
                //     buttonSref: "app.customisation"

            },
            templateUrl: "app/modules/base/directives/templates/mdSlider.tpl.html"
        }
    }]);

/**
 * Created by kumardivyarajat on 17/12/16.
 */
angular.module("app.main")
    .directive("mdPreload", ["ImagePreloader", "Base", "$interval", "$log", "$state", "$window", "$document", "$mdMedia", "$timeout", function (ImagePreloader, Base, $interval, $log, $state, $window, $document, $mdMedia, $timeout) {
        return {
            restrict: "AEC",
            scope: {
                mdSrc: "=",
                itemIndex: '=',
                key: "@",
                stagedKey : '@',
                aspectRatio : '=?',
                width : '=?',
                height : '=?',
                finalHeight : '=?'
            },
            link: function (scope, element, attrs) {
                if(!scope.stagedKey) {
                    scope.stagedKey = 'medium';
                }
                var a = scope.$watch('element', function () {
                    // a();
                    // //
                    var b = scope.$watch('mdSrc', function (mdSrc) {
                        // b();
                        if (mdSrc) {
                            // //
                            // //
                            // //


                            var observer = '', img = '';
                            var aspectRatio = scope.aspectRatio;

                            if(!aspectRatio && scope.width && scope.height) {
                                aspectRatio = parseFloat(scope.height / scope.width);
                            } else if(!aspectRatio) {
                                aspectRatio = parseFloat(205 / 150)
                            }

                            setTimeout(function () {
                                if(mdSrc &&
                                    mdSrc.urls &&
                                    mdSrc.urls.full &&
                                    mdSrc.urls.full.indexOf('gif') !== -1) {
                                    scope.key = 'full';
                                }
                                var css = {
                                    width: "100%",
                                    height: element.parent()[0].clientWidth * aspectRatio + "px"
                                };
                                try {
                                    css.background = mdSrc.swatch.css;
                                    css.opacity = 0.5;
                                } catch (e) {
                                    css.background = "rgb(53,62,84)";
                                }

                                if (typeof IntersectionObserver !== "undefined") {
                                    if (scope.itemIndex > 2) {
                                        scope.itemIndex = 2;
                                    }

                                    observer = new IntersectionObserver(loadImg, {
                                        rootMargin: '100px 0px 100px 0px',
                                        root: document.querySelector('#body')
                                    });
                                    img = angular.element(element)[0];
                                    observer.observe(img);
                                } else {
                                    changeSources()
                                }

                                element.css(css);


                            });


                            // changeSources()

                            function loadImg(changes) {
                                changes.forEach(function (change) {
                                    if (change.intersectionRatio > 0) {
                                        // change.target.src = 'boy.jpg'
                                        changeSources();
                                        observer.unobserve(img);
                                    }
                                })
                            }

                            function changeSources() {
                                var stagingImage = getBlurredImage(mdSrc.urls[scope.stagedKey]);
                                // //
                                ImagePreloader.preloadImages([prefixBaseUrl(mdSrc.urls[scope.stagedKey])])
                                    .then(function (done) {
                                        //
                                        if (done[0]) {
                                            element.css({
                                                width: "100%",
                                                height: scope.finalHeight || "auto",
                                                background: "",
                                                opacity: 1,
                                                animation: 'fadein 0.75s',
                                                '-moz-animation': 'fadein 0.75s', /* Firefox */
                                                '-webkit-animation': 'fadein 0.75s', /* Safari and Chrome */
                                                '-o-animation': 'fadein 0.75s'
                                            });
                                            element.attr({src: prefixBaseUrl(mdSrc.urls[scope.stagedKey])});
                                        }
                                        return ImagePreloader.preloadImages([prefixBaseUrl(mdSrc.urls[scope.key])]);
                                    })
                                    .then(function (done) {
                                        //
                                        if (done[0]) {
                                            element.css({
                                                width: "100%",
                                                height: scope.finalHeight || "auto",
                                                background: ""
                                            });
                                            element.attr({src: prefixBaseUrl(mdSrc.urls[scope.key])});
                                        }
                                        // return ImagePreloader.preloadImages([prefixBaseUrl(mdSrc.urls.large)]);
                                    })
                                    // .then(function (done) {
                                    //     //
                                    //     if (done[0]) {
                                    //         element.css({
                                    //             width: "100%",
                                    //             height: "auto",
                                    //             background: ""
                                    //         });
                                    //         element.attr({src: prefixBaseUrl(mdSrc.urls.large)});
                                    //     }
                                    // })
                                    .catch(function (err) {
                                        //
                                    });
                            }

                        }
                    })

                });

                function getBlurredImage(url) {
                    var a = url.split(".");
                    return a[0] + "-staged." + a[1];
                }

                function prefixBaseUrl(imageUrl) {
                    if (imageUrl && imageUrl.indexOf("http") === -1) {
                        scope.base = Base.getMediaUrl();
                        return scope.base + imageUrl;
                    } else if (imageUrl.indexOf("http") !== -1) {
                        return imageUrl;
                    } else {
                        return "/assets/images/placeholder.png";
                    }
                }

            }
        }
    }]);

/**
 * Created by kumardivyarajat on 24/08/17.
 */
(function () {
    "use strict";
    MdImageDirective.$inject = ["Base", "$sce"];
    angular.module("app.main")
        .directive("mdImg", MdImageDirective);


    function MdImageDirective(Base, $sce) {
        return {
            restrict: "E",
            scope: {
                src: "@mdSrc",
                hideLazyLoad : '='
            },
            replace: true,
            template: "<img ng-src='{{ srcUrl }}' />",
            compile: function (element, attr) {
                for (var i in attr) {
                    if (i.indexOf('$') === -1)
                        angular.element(element).attr(i, attr[i]);
                }
                return {
                    pre: function (scope, element, attr) {
                        var observer, img;
                        if (typeof IntersectionObserver !== "undefined" && !scope.hideLazyLoad) {
                            observer = new IntersectionObserver(loadImg);
                            img = angular.element(element)[0];
                            observer.observe(img);
                            scope.srcUrl = "/assets/images/placeholder.png";
                        } else {
                            changeSource()
                        }

                        function loadImg(changes) {
                            changes.forEach(function (change) {
                                if (change.intersectionRatio > 0) {
                                    // return link function
                                    changeSource()
                                    observer.unobserve(img);
                                }
                            })
                        }

                        function changeSource() {
                            if (scope.src && scope.src === 'default.png') {
                                scope.srcUrl = "/assets/images/woman.svg"
                            } else if (scope.src && (scope.src.indexOf("http") === -1)) {
                                scope.base = Base.getMediaUrl();
                                scope.srcUrl = scope.base + scope.src;
                            } else if (scope.src && (scope.src.indexOf("http") !== -1)) {
                                scope.srcUrl = scope.src;
                            } else if(!scope.hideLazyLoad) {
                                scope.srcUrl = "/assets/images/placeholder.png";
                            }
                        }

                    }
                };
            }
        }

    }

})();

/**
 * Created by kumardivyarajat on 15/11/16.
 */
angular.module("app.main")
    .directive("mdCarousel", ["$window", "$timeout", "$mdMedia", function ($window, $timeout, $mdMedia) {
        return {
            restrict: "AEC",
            transclude: true,
            scope: {
                theme: "@",
                showItems: "@",
                data: "=",
                itemHeight: "@",
                padding: "@",
                itemWidth: "@"
            },
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return element[0].clientWidth;
                }, function (value) {
                    scope.isMobile = $mdMedia('xs');
                    //
                    //

                    scope.$watch('data', function () {
                        if (scope.data.length > 0) {
                            if (value > 0 && scope.data) {
                                scope.fullWidth = element[0].clientWidth - 16;
                                scope.margin_left = 0;

                                //

                                if (!scope.padding) {
                                    scope.padding = 16;
                                } else {
                                    scope.padding = parseInt(scope.padding);
                                }

                                if (scope.showItems.indexOf(":") > -1) {
                                    //
                                    scope.showItems = 4;
                                    if (scope.isMobile) {
                                        scope.singleItemWidth = scope.itemWidth;
                                    } else {
                                        scope.singleItemWidth = scope.itemHeight;
                                    }
                                } else if (scope.itemWidth) {
                                    scope.singleItemWidth = scope.itemWidth;
                                } else {
                                    scope.totalPadding = (parseInt(scope.showItems) * (scope.padding * 2) );

                                    // if (scope.isMobile) {
                                    //     scope.singleItemWidth = scope.itemHeight;
                                    //     scope.showItems = 2;
                                    //     scope.itemHeight = ((scope.fullWidth - scope.totalPadding) / scope.showItems);
                                    // } else {
                                    if (scope.isMobile)
                                        scope.showItems = 1;

                                    scope.singleItemWidth = (scope.fullWidth - scope.totalPadding) / scope.showItems;
                                    // }
                                    // if (scope.showItems % 1 == 0) {
                                    //     scope.totalPadding = (parseInt(scope.showItems - 1) * (scope.padding * 2) );
                                    // } else {
                                    // }
                                    //

                                }

                                scope.style = {
                                    'min-height': scope.itemHeight + 'px',
                                    'position': 'relative',
                                    'overflow': 'hidden'
                                };

                                switch (scope.theme) {
                                    case "dark" :
                                        scope.style.background = 'rgba(1,1,1,0.81)';
                                        scope.style.color = 'white';
                                        break;

                                    default :
                                        scope.style.background = 'rgba(1,1,1,0.1)';
                                        scope.style.color = 'black';
                                        break;
                                }

                                //

                                scope.totalMarginLeft = (scope.data.length - scope.showItems ) * (parseInt(scope.singleItemWidth) + parseInt(scope.padding * 2));
                                //

                                scope.controlSlider = function (where) {
                                    switch (where) {
                                        case "previous" :
                                            scope.margin_left = scope.margin_left > 0 ? scope.margin_left - scope.fullWidth : scope.margin_left;
                                            break;

                                        case "next":
                                            scope.margin_left = scope.margin_left <= scope.totalMarginLeft ? scope.margin_left + scope.fullWidth : scope.margin_left;
                                            break;
                                    }
                                    //
                                };


                                //
                                //
                            }
                        }
                        scope.drawn = true;
                    });
                });
            },
            templateUrl: "app/modules/base/directives/templates/mdCarousel.tpl.html"
        }
    }]);

(function () {
    'use strict';

    angular
        .module('app.main')
        .directive('ldBuilder', ['$filter', '$sce', function ($filter, $sce) {
            return {
                restrict: 'EA',
                replace: true,
                link: function (scope, element) {
                    scope.$watch('ld', function (value) {
                        var val = $sce.trustAsHtml($filter('json')(value));
                        element[0].innerHTML = '<script type="application/ld+json">' + val + '</script>'
                    });
                }
            };
        }]);

})(angular);

(function () {
    'use strict';


    mdImageGallery.$inject = ["$interval", "Base", "$mdMedia", "$timeout"];
    angular.module("app.main")
        .directive("mdImageGallery", mdImageGallery);


    function mdImageGallery($interval, Base, $mdMedia, $timeout) {
        return {
            restrict: "AEC",
            transclude: true,
            replace: true,
            scope: {
                gallery: "=",
                selected: "=",
                imageSize: "=",
                onImageClick: "&",
                onMouseMove: "&",
                onMouseOut: "&",
                onSelectionChange: "&",
                selectedIndex: "=",
                onNext: "&"
            },
            link: function (scope, element, attrs) {
                scope.currentItem = 0;
                scope.selectedImage = scope.selected;
                scope.mediaUrl = Base.getMediaUrl();
                scope.startRendering = false;
                if (!scope.selectedIndex) {
                    scope.selectedIndex = 0;
                }
                scope.isSmall = !$mdMedia("gt-sm");
                scope.aspectRatio = 820 / 600;

                if (!scope.imageSize) {
                    scope.imageSize = 'large';
                }

                if(scope.onMouseMove) {
                    scope.showZoomCursor = true;
                }

                scope.moveLeft = moveLeft;
                scope.moveRight = moveRight;
                scope.move = move;
                scope.selectImage = selectImage;
                scope.transformSizes = transformSizes;

                scope.transformSizes();

                scope.$watch('imageSize', function (newVal, oldVal) {
                    if(newVal !== oldVal) {
                        scope.transformSizes();
                    }
                })

                $timeout(function () {
                    scope.containerWidth = element[0].clientWidth;
                    scope.width = Math.min(element[0].clientWidth, 600);
                    scope.totalWidth = scope.containerWidth * scope.images.length;
                    scope.moveX = 0;
                    scope.height = scope.width * scope.aspectRatio;
                    scope.startRendering = true;
                    if (scope.selectedIndex) {
                        scope.move();
                    }
                }, 0);


                function transformSizes() {
                    scope.images = scope.gallery.map(function (image) {
                        if (image &&
                            image.urls &&
                            image.urls.full &&
                            image.urls.full.indexOf('gif') !== -1) {
                            image.imageSize = 'full';
                        } else {
                            image.imageSize = scope.imageSize || 'large'
                        }
                        return image;
                    });
                }

                function moveRight(eventType, event) {
                    var prevIndex = scope.selectedIndex;
                    if (scope.selectedIndex !== (scope.images.length - 1)) {
                        scope.selectedIndex = scope.selectedIndex + 1;
                    } else {
                        scope.selectedIndex = 0
                    }
                    scope.move();
                    scope.onNext({
                        data: {
                            eventType: eventType,
                            eventAction: 'next',
                            previousIndex: prevIndex,
                            currentIndex: scope.selectedIndex
                        }
                    });
                    event.stopPropagation();
                    event.preventDefault();
                }

                function moveLeft(eventType, event) {

                    var prevIndex = scope.selectedIndex;
                    if (scope.selectedIndex !== 0) {
                        scope.selectedIndex = scope.selectedIndex - 1;
                    } else {
                        scope.selectedIndex = (scope.images.length - 1)
                    }
                    scope.move();
                    scope.onNext({
                        data: {
                            eventType: eventType,
                            eventAction: 'prev',
                            previousIndex: prevIndex,
                            currentIndex: scope.selectedIndex
                        }
                    });
                    event.stopPropagation();
                    event.preventDefault();
                }

                function move() {
                    scope.selectedImage = scope.images[scope.selectedIndex];
                    scope.moveX = -(scope.selectedIndex * scope.containerWidth);
                    scope.onSelectionChange({image: scope.selectedImage});
                }

                function selectImage($index, image) {
                    scope.selectedIndex = $index;
                    scope.selectedImage = image;
                    scope.moveX = -(scope.selectedIndex * scope.containerWidth);
                    scope.onSelectionChange({image: scope.selectedImage});
                }
            },
            templateUrl: "app/modules/base/directives/templates/mdImageGallery.tpl.html"
        }
    }

})(angular);

/**
 * Created by kumardivyarajat on 18/11/16.
 */
angular.module('app.main')
    .directive('elementWidth', function () {
        return {
            restrict: "AEC",
            link: function ($scope, element) {
                // do something with the element width here
                $scope.$watch('element', function () {
                    if (element.clientWidth > 0) {

                    }
                });
            }
        }
    });

(function () {
    'use strict';

    angular.module('app.main')
        // .directive('backSrc', function () {
        //     return function (scope, element, attrs) {
        //         var url = attrs.backSrc;
        //         element.css({
        //             'background-image': 'url(' + url + ')',
        //             'background-size': 'cover'
        //         });
        //     };
        // })
        .directive('backSrc', ['$parse', function ($parse) {
            return {
                restrict: 'A',
                link: function (scope, elem, attrs) {
                    var url = attrs.backSrc;
                    elem.css({
                        'background-image': 'url(' + url + ')',
                        'background-size': 'cover',
                        'background-position' : 'center',
                        'width' : '100%',
                        'height' : '200px'
                    });
                }
            };
        }]);

})(angular);

/**
 * Created by kumardivyarajat on 04/11/16.
 */
angular.module("app.main")
    .directive("aadiraCard", function () {
        return {
            restrict: "E",
            transclude: true,
            replace : true,
            link: function (scope, attrs, element) {
                //
            },
            templateUrl: "app/modules/base/directives/templates/aadiraCard.tpl.html"
        }
    });

/**
 * Created by kumardivyarajat on 15/11/16.
 */
angular.module("app.address", [])
    .controller("address.controller", ["$scope", "AddressManager", "$mdDialog", function ($scope, AddressManager, $mdDialog) {
        $scope.currentNavItem = 'page2';


        AddressManager.getAddresses()
            .then(function (addresses) {
                //
            })
            .catch(function (err) {
                //
            });

        $scope.cancel = function () {
            $mdDialog.hide();
        };

    }]);

/**
 * Created by kumardivyarajat on 15/11/16.
 */
angular.module("app.address")
    .service("AddressManager", ["$http", "$q", "$log", "Base", "AuthManager", "RestManager", function ($http, $q, $log, Base, AuthManager, RestManager) {
        this._addresses = [];


        this._fetchAllUserAddresses = function () {

        };

        this.addNewAddress = function (data) {
            var that = this;
            return $q(function (resolve, reject) {
                $http.post(Base.getBaseUrl() + "/address", data)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            // that._addresses.push(response.data.message.address[0]);
                            resolve(response.data.message.address[0])
                        } else {
                            reject(response.data.message.error);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };

        this.updateAddress = function (address) {
            var that = this;
            return $q(function (resolve, reject) {
                $http.put(Base.getBaseUrl() + "/address/" + address._id, address)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            // that._addresses.push(response.data.message.addresses[0]);
                            resolve(response.data.message.addresses[0])
                        } else {
                            reject(response.data.message.error);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };


        this.checkCodAvailability = function (pinCode) {
            return $q(function (resolve, reject) {
                $http.get(Base.getBaseUrl() + "/pinCodes/" + pinCode)
                    .then(function (response) {
                        if (response.data.code == 200) {
                            //
                            resolve(response.data.message.pinCodes[0]);
                        } else {
                            reject(response.data.message.error);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            });
        };

        this.queryPinCode = function (queryTerm) {
            return $q(function (resolve, reject) {
                $http.get(Base.getBaseUrl() + "/pinCodes/" + queryTerm)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            resolve(response.data.message.pinCodes[0]);
                        } else {
                            reject(response.data.message.error);
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    })
            })
        };


        this.getAddresses = function () {
            var that = this;
            return $q(function (resolve, reject) {
                if (that._addresses.length > 0) {

                } else {
                    $http.get(Base.getBaseUrl() + "/address")
                        .then(function (response) {
                            // $log.info(response);
                            if (response.data.code == 200) {
                                resolve(response.data.message.addresses);
                            } else {
                                reject(response.data.message.error)
                            }
                        })
                        .catch(function (err) {
                            reject(err);
                        })
                }
            });
        };


        this.deleteAddress = function (addressId) {
            return RestManager.deleteResource('/address/' + addressId, 'address')
        }
    }]);

(function () {
    'use strict';


    AddressAddCtrl.$inject = ["$scope", "address", "$mdDialog", "AddressManager"];
    angular.module('app.address')
        .controller('address.add.controller', AddressAddCtrl);

    function AddressAddCtrl($scope, address, $mdDialog, AddressManager) {
        if (address) {
            $scope.editingMode = true;
        }
        $scope.newAddress = address || {};

        $scope.populateCity = function () {
            if (!$scope.newAddress.pinCode || $scope.newAddress.pinCode.length !== 6) {
                return;
            }
            $scope.populatingCity = true;
            $scope.querySearch($scope.newAddress.pinCode)
                .then(function (data) {
                    $scope.populatingCity = false;
                    if (data) {
                        $scope.newAddress.city = data.city;
                        $scope.newAddress.state = data.state;
                    }
                    console.log(data)
                })
                .catch(function (err) {
                    $scope.populatingCity = false;
                    console.log(err)
                })
        };

        $scope.closeDialog = function (data) {
            $mdDialog.hide({data: data});
        };

        $scope.cancelDialog = function (err) {
            $mdDialog.cancel(err);
        };

        $scope.querySearch = function (query) {
            return AddressManager.queryPinCode(query);
        };

        $scope.saveAddress = function () {
            $scope.addressSaving = true;
            var promise = null;
            if ($scope.editingMode) {
                promise = AddressManager.updateAddress($scope.newAddress)
            } else {
                promise = AddressManager.addNewAddress($scope.newAddress)
            }
            promise
                .then(function (address) {
                    $scope.addressSaving = false;
                    $scope.closeDialog(address);
                })
                .catch(function (err) {
                    $scope.addressSaving = false;
                    $scope.cancelDialog(err)
                    // $log.error(err);
                })

        };
    }
})(angular);

(function () {
    'use strict';

    angular.module('app.account.giftCards', [])

})(angular);

(function () {
    'use strict';

    GiftCardController.$inject = ["$scope", "RestManager", "$state", "$rootScope", "$stateParams", "$mdDialog", "$mdToast", "$cookies", "AuthManager", "FullStory"];
    angular.module('app.account.giftCards')
        .controller('giftCards.controller', GiftCardController);

    function GiftCardController($scope, RestManager, $state, $rootScope,
                                $stateParams, $mdDialog, $mdToast, $cookies,
                                AuthManager, FullStory) {

        $scope.giftCards = [];
        $scope.loadingGiftCards = false;
        $scope.redeemingCard = false;
        $scope.generatingPin = false;
        $scope.pinGenerated = false;
        $scope.formError = '';
        $scope.newCard = {
            code: '',
            pin: ''
        };
        $scope.$parent.currentNavItem = "giftCards";
        $scope.$parent.currentActiveTitle = "My Gift Cards";

        $rootScope.pageMeta = {
            title: "Gift Cards | Redeem Aarida Gift Cards",
            description: "Check your gift cards, redeem gift cards"
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };


        $scope.fetchUsersGiftCards = fetchUsersGiftCards;
        $scope.redeemGiftCard = redeemGiftCard;
        $scope.openRedeemModal = openRedeemModal;
        $scope.generatePin = generatePin;
        $scope.close = close;
        $scope.init = init;
        $scope.applyFilter = applyFilter;
        $scope.submit = submit;
        $scope.resetForm = resetForm;
        $scope.removeError = removeError;
        $scope.showAlert = showAlert;
        $scope.showRedeemSuccessDialog = showRedeemSuccessDialog;

        function init() {
            if ($stateParams.code) {
                $scope.newCard.code = atob($stateParams.code || $stateParams.c);
            }
        }

        function removeError() {
            $scope.formError = ''
        }

        function resetForm() {
            $scope.giftCardForm.$setPristine();
            $scope.newCard = {
                code: '',
                pin: ''
            };

            $scope.redeemingCard = false;
            $scope.generatingPin = false;
            $scope.pinGenerated = false;
            $scope.formError = '';
        }

        function submit() {
            $scope.formError = '';
            if ($scope.pinGenerated) {
                $scope.redeemGiftCard()
            } else {
                $scope.generatePin();
            }
        }


        function applyFilter() {
            $scope.formError = '';
            var foo = $scope.newCard.code.split("-").join("");
            if (foo.length > 0) {
                foo = foo.match(new RegExp('.{1,4}', 'g')).join("-");
            }
            $scope.newCard.code = foo;
        }

        function close() {
            $mdDialog.cancel()
        }

        function openRedeemModal(ev, card) {
            if (card && card.code !== 'dummy') {
                ev.stopPropagation();
                ev.preventDefault();
                return;
            }
            $state.go('app.account.giftCards', {openRedeem: true}, {notify: false, reload: false})
            $mdDialog.show({
                templateUrl: 'app/modules/account/giftCards/redeem-gift-card.dialog.tpl.html',
                scope: $scope,
                fullscreen: true,
                targetEvent: ev,
                preserveScope: true,
                parent: angular.element(document.body),
                disableParentScroll: true,
                clickOutsideToClose: true,
                multiple: true
            })
                .then(function () {
                    $state.go('app.account.giftCards', {openRedeem: false}, {notify: false, reload: false})
                })
                .catch(function (error) {
                    // User clicked outside or hit escape
                    $state.go('app.account.giftCards', {openRedeem: false}, {notify: false, reload: false})
                });
        }

        function fetchUsersGiftCards() {
            $scope.loadingGiftCards = true;
            RestManager
                .getResource('/giftCards', 'cards')
                .then(function (cards) {
                    $scope.cards = cards.map(function (card) {
                        card.code = card.code.replace(/-/g, ' ');
                        return card;
                    });
                    if (cards.length) {
                        $scope.cards.push({code: 'dummy'});
                    }
                    $scope.loadingGiftCards = false;
                    if ($stateParams.openRedeem === 'true') {
                        $scope.openRedeemModal();
                        if ($cookies.getObject('code')) {
                            $scope.newCard.code = window.atob($cookies.getObject('code').code);
                        }
                    }

                })
                .catch(function (err) {
                    console.log(err);
                    $scope.loadingGiftCards = false;
                })
        }

        function generatePin() {
            // $scope.pinGenerated = true;
            $scope.generatingPin = true;

            RestManager.postResource('/giftCards/generatePin', {code: $scope.newCard.code}, 'cards')
                .then(function (result) {
                    $scope.generatingPin = false;
                    $scope.pinGenerated = !!result;
                    $scope.showAlert();
                })
                .catch(function (err) {
                    console.log('Error generating pin', err);
                    $scope.generatingPin = false;
                    $scope.formError = err.message;
                    $scope.redeemingCard = false;
                    var detailedMessage = '';
                    FullStory.trackEvent('GiftCardRedeemError', err);
                    switch (err.message) {
                        case 'Coupon does not exist':
                            detailedMessage = 'Looks like you are trying to redeem a Gift Card which does not exist. Please double check the Gift Card Code and try again.'
                            break;

                        case 'Card not active yet':
                            detailedMessage = 'The gift card you are trying to redeem has not been activated yet. You will receive an sms/email from the Aarida team as soon as your ' +
                                'card is activated with the instructions to redeem the card.';
                            break;

                        case 'Card has already been redeemed':
                            detailedMessage = 'This gift card has already been redeemed. You can shop for products on Aarida and during the checkout process, you can ' +
                                'apply the gift card to get discounts on your order.'
                            break;

                        case 'Card already expired':
                            detailedMessage = 'This gift card has already expired and can no longer be used. Please contact us at 08041521574 if you feel this is a mistake.';
                            break;

                        case 'Card is blocked':
                            detailedMessage = 'This gift card has been blocked due to security reasons.  Please contact us at 08041521574 if you feel this is a mistake.';
                            break;

                        case 'Invalid PIN':
                            detailedMessage = 'The 6 digit pin you are trying to enter is invalid. Please double check the OTP you have received or regenerate the pin using the Regenerate PIN button in the form below';
                            break;

                        case 'Unauthorized Request':
                            detailedMessage = 'Looks like this gift card does not belong to you. Please ensure that you are logged in with the same mobile number/email address mentioned in the activation message sent to you. ' +
                                'You will have to logout from this account first by clicking the logout button from the left side main menu.'
                            break;
                    }

                    if (detailedMessage) {
                        var alert = $mdDialog
                            .alert({
                                title: 'Oops! Error occurred.',
                                textContent: detailedMessage,
                                ok: 'Okay'
                            })
                            .multiple(true)
                            .theme('black');
                        $mdDialog.show(alert)
                    }
                })
        }

        function showRedeemSuccessDialog() {
            $mdDialog.show({
                contentElement: '#redeemSuccessDialog',
                scope: $scope,
                fullscreen: false,
                preserveScope: true,
                parent: angular.element(document.body),
                disableParentScroll: true,
                clickOutsideToClose: true,
                multiple: true
            })
        }

        function showAlert() {
            $scope.currentUser = AuthManager.getCurrentUser();
            var alert = $mdDialog.alert({
                title: 'Please check your phone',
                textContent: 'A 6 digit pin has been sent to your mobile number +91-' + $scope.currentUser.mobile + '. Please enter the code in the text box next.',
                ok: 'Okay'
            })
                .multiple(true)
                .theme('black');

            $mdDialog
                .show(alert)
                .finally(function () {
                    alert = undefined;
                    document.getElementById('card-pin').focus();
                });
        }

        function redeemGiftCard() {
            $scope.redeemingCard = true;
            RestManager
                .postResource('/giftCards/redeem', $scope.newCard, 'cards')
                .then(function (cards) {
                    var card = cards[0];
                    card.code = card.code.replace(/-/g, ' ');
                    $scope.cards.unshift(card);
                    $scope.redeemingCard = false;
                    $scope.newCard = {};
                    $cookies.remove('code');
                    $scope.generatingPin = false;
                    $scope.pinGenerated = false;
                    $scope.close();
                    $scope.showRedeemSuccessDialog();
                    FullStory.trackEvent('GiftCardRedeemSuccess', {code : card.code});
                })
                .catch(function (err) {
                    console.log('Error redeeming gift card', err);
                    $scope.formError = err.message;
                    FullStory.trackEvent('GiftCardRedeemError', err);
                    $scope.redeemingCard = false;
                })
        }

        if ($stateParams.openRedeem !== 'true') {
            $scope.close();
        }


        $scope.fetchUsersGiftCards();
        $scope.init();
    }

})(angular);

/**
 * Created by kumardivyarajat on 17/11/16.
 */
angular.module("app.account", ["app.account.orders", "app.account.home", "app.account.creations", "app.account.giftCards", "app.account.quotations"])
    .controller("account.controller", ["$scope", "$timeout", "$rootScope", "AddressManager", "$mdDialog", "$cookies", "AuthManager", "$state", "$stateParams", function ($scope, $timeout, $rootScope, AddressManager, $mdDialog, $cookies, AuthManager, $state, $stateParams) {
        $scope.currentNavItem = "";
        $scope.currentActiveTitle = "";
        console.log('Scope', $state.current, $stateParams);

        if ($cookies.getObject('tkn')) {
            $scope.loadingUser = true;
            AuthManager.getCurrentUserAsync()
                .then(function (currentUser) {
                    $scope.user = currentUser;
                    if (!AuthManager.isUserLoggedIn) {
                        // $scope.saveCurrentStateInCookies($state.current.name, $state.current.params);
                        $state.transitionTo("app.login", {returnTo: window.location.href}, {location: 'replace'});
                    }
                })
                .catch(function (err) {
                    if (!AuthManager.isUserLoggedIn) {
                        // $scope.saveCurrentStateInCookies($state.current.name, $state.current.params);
                        $state.transitionTo("app.login", {returnTo: window.location.href}, {location: 'replace'});
                    }
                })
        } else {
            // $scope.saveCurrentStateInCookies($state.current.name, $state.current.params);
            $state.transitionTo("app.login", {returnTo: window.location.href}, {location: 'replace'});
        }

        $scope.saveUserDetails = function () {
            AuthManager.updateUser($scope.user)
                .then(function (user) {
                    $scope.user = AuthManager.getCurrentUser();
                    $rootScope.$emit("updatedUser", user);
                    $mdDialog.hide();
                })
                .catch(function (err) {
                    $scope.error = err.message;

                })
        };



        $scope.showInfoDialog = function () {
            if ($scope.user.virtualMobile) {
                $scope.user.mobile = "";
            }

            $timeout(function () {
                $mdDialog.show({
                    clickOutsideToClose: false,
                    scope: $scope,
                    preserveScope: true,
                    contentElement: '#infoDialog',
                    fullscreen: false,
                    parent: angular.element(document.body)
                });
            }, 0);
        };

        $cookies.remove('h', $stateParams.h);

    }]);

/**
 * Created by kumardivyarajat on 19/11/16.
 */
angular.module("app.account.home", [])
    .controller("account.home.controller", ["$scope", "$rootScope", "$mdDialog", "$analytics", "AddressManager", "$log", function ($scope, $rootScope, $mdDialog, $analytics, AddressManager, $log) {
        $scope.$parent.currentActiveTitle = "My Account";
        $scope.$parent.currentNavItem = "home";

        $rootScope.pageMeta = {
            title: "My Account",
            description: "Buy customisazable products",
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };

        $scope.editingMode = '';

        $analytics.pageTrack('/account/home');
        $analytics.eventTrack('My Account', {page: "/account/home"});

        $scope.loadingAddresses = true;
        AddressManager.getAddresses()
            .then(function (addresses) {
                $scope.addressLoaded = true;
                $scope.addresses = addresses;
                _.forEach($scope.addresses, function (address) {
                    if (address.isDefault) {
                        $scope.defaultAddress = address._id;
                    }
                })
                $scope.loadingAddresses = false;
            })
            .catch(function (err) {
                $scope.addressLoaded = true;
                $scope.loadingAddresses = false;
                // $log.error(err);
            });

        $scope.changeDefault = function (address) {

            if (address._id !== $scope.defaultAddress) {
                //TODO make default
                var data = {};
                angular.copy(address, data);
                address.updating = true;
                data.isDefault = true;
                AddressManager.updateAddress(data)
                    .then(function (result) {
                        address.isDefault = true;
                        address.updating = false;
                        $scope.defaultAddress = address._id;
                    })
                    .catch(function (err) {
                        //
                        address.updating = false;
                    })
            }
        };

        $scope.capitalize = function (cannotUse) {
            return _.startCase(_.camelCase(cannotUse));
        };

        $scope.querySearch = function (query) {
            return AddressManager.queryCity(query);
        };

        $scope.resetSearch = function () {
            $scope.searchText = "";
            $scope.selectedItem = "";
        };


        $scope.showAddressDialog = function ($event, address, index) {
            $scope.newAddress = {};
            if (address) {
                angular.copy(address, $scope.newAddress);
                $scope.editingIndex = index;
                $scope.editingMode = true;
            } else {
                $scope.newAddress = null;
                $scope.editingIndex = '';
                $scope.editingMode = false;
            }
            $mdDialog.show({
                clickOutsideToClose: true,
                targetEvent: $event,
                locals: {
                    address: $scope.newAddress
                },
                controller: "address.add.controller",
                templateUrl: 'app/modules/address/partials/address.add.dialog.html',
                fullscreen: true,
                parent: angular.element(document.body)
            })
                .then(function (result) {
                    if (result.data) {
                        if ($scope.editingMode) {
                            $scope.addresses.splice($scope.editingIndex, 1, result.data)
                        } else {
                            $scope.addresses.push(result.data);
                        }
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
        };

        // $scope.saveAddress = function () {
        //     $scope.addressSaving = true;
        //     var promise;
        //     if ($scope.editingMode) {
        //         promise = AddressManager.updateAddress($scope.newAddress)
        //     } else {
        //         promise = AddressManager.addNewAddress($scope.newAddress)
        //     }
        //     promise
        //         .then(function (address) {
        //             $scope.addressSaving = false;
        //             console.log('edtigin mode')
        //             if ($scope.editingMode) {
        //                 $scope.addresses.splice($scope.editingIndex, 1, address)
        //             } else {
        //                 $scope.addresses.push(address);
        //             }
        //             $scope.resetDialog();
        //         })
        //         .catch(function (err) {
        //             $scope.addressSaving = false;
        //             // $log.error(err);
        //         })
        //
        // };

        // $scope.resetDialog = function () {
        //     $scope.newAddress = {};
        //     $scope.resetSearch();
        //     $scope.cancel();
        // };

        $scope.showConfirm = function (ev, addressId, index) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete this address?')
                .textContent('Please note that this action is irreversible.')
                .ariaLabel('Delete Address')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .theme('indigo')
                .ok('Yes')
                .cancel('Cancel');

            $mdDialog.show(confirm).then(function () {
                AddressManager.deleteAddress(addressId)
                    .then(function (deleted) {
                        console.log(deleted);
                        $scope.addresses.splice(index, 1);
                        $mdToast.show({
                            hideDelay: 3000,
                            position: 'bottom right',
                            content: "Address deleted successfully."
                        });
                    })
                    .catch(function (err) {
                        $mdToast.show({
                            hideDelay: 3000,
                            position: 'bottom right',
                            content: "There was an error in deleting this address :" + (err.code || 500)
                        });
                    })
            }, function () {
                console.log('Cancelled Action');
            });
        };


    }]);

(function () {
    'use strict';

    ProfileController.$inject = ["$scope", "AuthManager", "RestManager", "$mdDialog", "Base", "$mdToast", "$analytics", "$stateParams", "$rootScope", "$state", "Posts"];
    angular.module('app.profile')
        .controller('profile.controller', ProfileController);

    function ProfileController($scope, AuthManager, RestManager, $mdDialog, Base, $mdToast,
                               $analytics, $stateParams, $rootScope, $state, Posts) {
        $scope.mediaUrl = Base.getMediaUrl();
        $scope.selectedIndex = 0;
        $scope.init = init;
        $scope.fetchProfile = fetchProfile;
        $scope.fetchFeed = fetchFeed;
        $scope.fetchProducts = fetchProducts;
        $scope.openPost = openPost;
        $scope.fetchSimilarProfiles = fetchSimilarProfiles;
        $scope.followAction = followAction;
        $scope.onTabSelected = onTabSelected;
        $scope.scrollBy = Base.scrollBy;

        $scope.productsQuery = {
            page: 1,
            limit: 12,
            ux: null,
            sort: '-createdAt'
        };

        $rootScope.pageMeta = {
            title: "Fashion Expert Profile",
            description: "Loading Description ....",
            // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
        };

        function init() {
            if ($stateParams.postId) {
                $scope.openPost(null, {_id: $stateParams.postId})
            }
            $mdDialog.cancel();
            $scope.fetchProfile();
        }

        function fetchProfile() {

            $scope.fetchingProfile = true;
            if ($stateParams.userName) {
                RestManager.getResource('/users/profile/' + $stateParams.userName, 'users')
                    .then(function (users) {
                        if (users && users[0] && users[0]._id) {
                            $scope.user = users[0];
                            $scope.user.image = {
                                urls: {
                                    large: $scope.user.profileImageURL,
                                    medium: $scope.user.profileImageURL,
                                    'medium-staged': $scope.user.profileImageURL,
                                    'large-staged': $scope.user.profileImageURL,
                                }
                            };
                            $analytics.eventTrack(
                                "ProfilePage",
                                {
                                    userName: $scope.user.userName,
                                    uid: $scope.user._id,
                                    ref: $stateParams.ref
                                });
                            $rootScope.pageMeta = {
                                title: $scope.user.name + " (" + $scope.user.userName + ") | Aarida Fashion Profile",
                                description: "Follow " + $scope.user.userName + " on Aarida",
                                image: $scope.mediaUrl + $scope.user.profileImageURL,
                                // keywords: category.name + ", aarida, Shop Customised clothing, Buy " + category.name + " only on aarida.com."
                            };
                            $scope.fetchingProfile = false;
                            $scope.productsQuery.ux = $scope.user._id;
                            $scope.fetchFeed();
                            $scope.fetchProducts();
                            $scope.fetchSimilarProfiles($scope.user._id);
                        } else {
                            $scope.fetchingProfile = false;
                            $scope.fetchProfileError = 'The Profile you are looking for could not be found';
                        }
                    })
                    .catch(function (err) {
                        $scope.fetchingProfile = false;
                        $scope.fetchProfileError = err.message;

                    })
            } else {
                $scope.fetchingProfile = false;
                $scope.fetchProfileError = 'We have hit a snag. Please try again later.';
            }
        }

        function fetchFeed() {
            $scope.fetchingFeed = true;
            RestManager.getResource('/posts', 'posts', {
                query: {
                    user: $scope.user._id
                }
            })
                .then(function (posts) {
                    $scope.posts = posts;
                    $scope.fetchingFeed = false;
                })
                .catch(function (err) {
                    $scope.fetchingFeed = false;
                    $scope.feedFetchError = err.message;
                })
        }

        function openPost(event, post, index) {
            Posts
                .openPostDialog(event, {
                    postId: post._id,
                    index: index,
                    posts: $scope.posts,
                    backState: 'app.profile',
                    backParams: {userName: $stateParams.userName},
                    mode: 'dialog',
                })
                .catch(function (err) {
                    console.log("profile.controller.js", "err", err);
                })
        }

        function fetchProducts() {
            $scope.fetchingProducts = true;
            RestManager.getResource('/products/category/all', 'products', {query: $scope.productsQuery})
                .then(function (products) {
                    $scope.fetchingProducts = false;
                    $scope.products = products;
                })
                .catch(function (err) {
                    $scope.fetchingProducts = false;
                })
        }

        function fetchSimilarProfiles(userId) {
            RestManager.getResource('/users/popular?ctx=' + userId, 'users')
                .then(function (users) {
                    $scope.similarUsers = users;
                })

        }

        function followAction() {
            if (!AuthManager.isUserLoggedIn) {
                $scope.openLoginModal();
            } else {
                var promise;
                if ($scope.user.isFollowing) {
                    promise = RestManager.patchResource('/users/unfollow/' + $scope.user._id, null, 'completed');
                } else {
                    promise = RestManager.patchResource('/users/follow/' + $scope.user._id, null, 'completed');
                }
                $scope.saving = true;
                promise.then(function (result) {
                    $scope.saving = false;
                    if (result) {
                        $scope.user.isFollowing = !$scope.user.isFollowing;
                    }

                    if ($scope.user.isFollowing) {
                        // TODO Event for followed
                        $analytics.eventTrack(
                            "ProfileFollowed",
                            {
                                UserProfileName:$scope.user.name,
                                UserProfileId:$scope.user._id,
                            }
                        );
                        $mdToast.showSimple('You are now following ' + $scope.user.name);
                    } else {
                        // TODO Event for unfollowed
                        $analytics.eventTrack(
                            "ProfileUnFollowed",
                            {
                                UserProfileName:$scope.user.name,
                                UserProfileId:$scope.user._id,
                            }
                        );
                        $mdToast.showSimple('You have unfollowed ' + $scope.user.name);
                    }
                })
                    .catch(function (err) {
                        $scope.saving = false;
                        $mdToast.showSimple('Some error occurred : ' + err.message);
                    })
            }
        }

        function onTabSelected(tab) {
            console.log("profile.controller.js", "onTabSelected", tab);
        }

        $scope.$watch('selectedIndex', function (newVal) {
            console.log("profile.controller.js", "newVal", newVal);
        });

        $rootScope.$on("loggedIn", function ($event, data) {
            $state.reload();
        });

        $scope.init();
    }

})(angular);

(function () {
    'use strict';

    PostService.$inject = ["$mdDialog", "$state"];
    angular.module('app.profile')
        .service('Posts', PostService);

    function PostService($mdDialog, $state) {

        this.openPostDialog = openPostDialog;

        /**
         * @module Posts
         * @param event
         * @param options
         * @param options.postId
         * @param options.index
         * @param options.posts
         * @param options.backState
         * @param options.backParams
         */
        function openPostDialog(event, options) {
            return $mdDialog.show({
                templateUrl: 'app/modules/profile/post-viewer/post-viewer.tmpl.html',
                controller: 'post-viewer.controller',
                fullscreen: true,
                parent: angular.element(document.body),
                focusOnOpen : false,
                clickOutsideToClose: true,
                targetEvent: event,
                locals: {
                    postId: options.postId,
                    index: options.index,
                    posts: options.posts,
                    backState : options.backState,
                    backParams : options.backParams,
                    mode : options.mode || 'dialog',
                    scrollPosition : options.scrollPosition || 0,
                }
            })
        }


        function follow() {

        }
    }

})(angular);

/**
 * Created by kumardivyarajat on 31/10/16.
 */

(function () {
    "use strict";

    HomeController.$inject = ["$scope", "Base", "$state", "$analytics", "Utils", "$timeout", "CategoriesManager", "Header", "$rootScope", "RestManager", "$log", "Posts"];
    angular.module("app.home")
        .controller("homeController", HomeController);


    /** @ngInject **/
    function HomeController($scope, Base,$state, $analytics, Utils, $timeout, CategoriesManager,
                            Header, $rootScope, RestManager, $log, Posts) {
        Header.setShowHeaderImage(true);

        $analytics.eventTrack('Home', {page: "/"});

        $rootScope.$broadcast("transparentHeader", false);

        $rootScope.pageMeta = {
            title: "Home | Best Place To Buy And Customise Women’s Wear, Dresses Online India",
            description: "We are largest Customised Women Clothing Online women fashion online store India," +
                "offering widest collection of latest bespoke women’s clothing at discounted prices.",
            keywords: "Best place to customise women’s wear, Bespoke women’s wear India, Top site for " +
                "customising women’s dresses Bespoke women’s fashion , Bespoke fashion for women, Customised " +
                "fashion for women, Women Customised Clothing Online, Customised women’s wear India, Buy " +
                "Customised dresses online, Buy customised womens wear"
        };


        $scope.homeData = '';
        $scope.loadingData = true;
        $scope.blogPosts = [];
        $scope.fetchingBlogPosts = false;
        $scope.scrollTop = Utils.scrollToTopOfThePage;

        $scope.mediaUrl = Base.getMediaUrl();
        $scope.getLinkUrl = getLinkUrl;
        $scope.fetchBlogPosts = fetchBlogPosts;
        $scope.fetchHomeConfig = fetchHomeConfig;
        $scope.fetchFeed = fetchFeed;
        $scope.openPost = openPost;


        function getLinkUrl(product) {
            if (product.productType && product.editorType !== 'simple' && $scope.isSmall) {
                return $state.href('app.customisationEditor', {slug: product.slug, flags: 'none'});
            } else {
                return $state.href('app.product', {productSlug: product.slug, product: product});
            }
        }


        $scope.sliderList = [
            // {
            //     image: "assets/images/home/home12.jpg",
            //     position: "start center",
            //     button: false,
            //     heading: "",
            //     text: "",
            //     buttonText: "Start Customising",
            //     buttonColor: "white",
            //     buttonTextColor: "black",
            //     buttonIcon: "",
            //     buttonStyle: {'width': '200px', 'font-weight': 'bold'},
            //     buttonSref: "app.collection({'categoryName': 'eoss'})",
            //     state: "app.collection",
            //     params: {'categoryName': 'eoss'}
            // },
            {
                image: {
                    urls : {
                        full : "assets/images/home/home-new-1.jpg",
                        h_x_large : "assets/images/home/home-new-1.jpg",
                        h_mediumStaged : "assets/images/home/home-new-1.jpg"
                    }
                },
                position: "start center",
                button: false,
                heading: "",
                text: "",
                buttonText: "Start Customising",
                buttonColor: "white",
                buttonTextColor: "black",
                buttonIcon: "",
                buttonStyle: {'width': '200px', 'font-weight': 'bold'},
                buttonSref: "app.collection({'categoryName' : 'new_arrivals'})",
                state: "app.collection",
                params: {'categoryName': 'new_arrivals'}
            }
        ];


        $scope.homeData = [
            {
                type: 'slider',
                position: 1,
                objects: $scope.sliderList,
                options: {
                    autoPlay: true,
                    controls: false,
                    fullLink: true,
                    interval: 5000,
                    overlay: false
                }
            }
        ];

        $scope.loading = false;


        $scope.fetchProductForCollection = function (collection) {
            collection.fetchingProducts = true;
            RestManager.postResource("/products/collection/" + collection._id, {
                sort: collection.sortBy || '-createdAt',
                limit: 4,
                attributes: "",
                page: 1
            }, "products")
                .then(function (products) {
                    collection.fetchingProducts = false;
                    collection.products = products;
                })
                .catch(function (err) {
                    collection.fetchingProducts = false;
                });
        };

        $scope.fetchCollections = function () {
            $scope.loadingCollections = true;
            RestManager.getResource("/collections/home", "collections")
                .then(function (result) {
                    $scope.loadingCollections = false;
                    $scope.featuredCollections = result;
                    $scope.featuredCollections.unshift({
                        _id: 'new_arrivals',
                        name: 'New Arrivals'
                    })
                    $scope.featuredCollections.forEach(function (collection) {
                        return $scope.fetchProductForCollection(collection);
                    });
                    $scope.fetchBlogPosts();
                })
                .catch(function (err) {
                    $scope.loadingCollections = false;
                })
        };

        $scope.fetchCollections();
        // $scope.setUpImage();
        $scope.baseUrl = Base.getBase();


        $scope.errorReporter = function (err, context) {
            $log.debug(context, "Error", err);
        };

        $scope.getProperName = function (str) {
            return Utils.getProperName(str);
        };

        $scope.categories = [
            {
                name: "Gowns",
                image: "assets/images/gowns.png",
                sref: "app.category({categoryName : 'gowns'})",
                nested: [
                    {
                        name: "Bridal Wear",
                        sref: "app.category({categoryName : 'bridal'})"
                    }, {
                        name: "Fusion Wear",
                        sref: "app.category({categoryName : 'indo-western'})"
                    }, {
                        name: "Slit Tops",
                        sref: "app.category({categoryName : 'slit-tops'})"
                    }
                ]
            }, {
                name: "Tops",
                image: "assets/images/kurti.png",
                sref: "app.category({categoryName : 'tops'})",
                nested: [
                    {
                        name: "Crop Tops",
                        sref: "app.category({categoryName : 'crop-tops'})"
                    }, {
                        name: "Kurtis",
                        sref: "app.category({categoryName : 'kurti'})"
                    }, {
                        name: "Blouse",
                        sref: "app.category({categoryName : 'blouse'})"
                    }, {
                        name: "Jackets",
                        sref: "app.category({categoryName : 'jackets'})"
                    }
                ]
            }, {
                name: "Dresses",
                image: "assets/images/dresses.png",
                sref: "app.category({categoryName : 'dresses'})",
                nested: [
                    {
                        name: "Party Wear",
                        sref: "app.category({categoryName : 'party-wear'})"
                    }
                ]
            }
        ];

        function fetchBlogPosts() {
            var api = new GhostContentAPI({
                url: 'https://blog.aarida.com',
                key: '4691922c6bdc2a60d66ab96e15',
                version: 'v2'
            });

            // fetch 5 posts, including related tags and authors
            api
                .posts
                .browse({limit: 6})
                .then(function (posts) {
                    $scope.blogPosts = posts.filter(function (post) {
                        return post.title
                    });
                    $scope.fetchingBlogPosts = false;
                    console.log('Blog', $scope.blogPosts);
                })
                .catch(function (err) {
                    console.error(err);
                    $scope.fetchingBlogPosts = false;
                    $scope.blogPostError = true;
                });
        }


        function fetchHomeConfig() {
            $scope.loadingHomepage = true;
            RestManager.getResource('/settings/home', 'homeConfig')
                .then(function (configs) {
                    $scope.widgets = configs.map(function (config) {
                        if(config.sizes && config.sizes.length) {
                            var size = config.sizes[0];
                            config.aspectRatio = size.width / size.height;
                            config.width = size.width;
                            config.height = size.height;
                            config.objects = config.objects.map(function (object) {
                               if(object.image.urls.full.indexOf('gif') !== -1) {
                                   object.key = 'full';
                               } else {
                                   object.key = 'h_x_large';
                               }
                                return object;
                            });
                        }
                        return config;
                    });
                    $scope.loadingHomepage = false;
                })
                .catch(function (err) {
                    $scope.homePageError = err;
                })
        }

        function fetchFeed()  {
            RestManager.getResource('/posts', 'posts', {
                query : {
                    sort : '-viewCount',
                    limit : 12,
                    page : 1
                }
            })
                .then(function (posts) {
                    posts = posts.map(function (post) {
                        if(post.image.urls.medium.indexOf('gif') !== -1) {
                            post.key = 'full';
                        } else {
                            post.key = 'medium';
                        }
                        return post;
                    });
                    $scope.posts = posts;
                    $scope.fetchingFeed = false;
                })
                .catch(function (err) {
                    $scope.fetchingFeed = false;
                    $scope.feedFetchError = err.message;
                })
        }

        function openPost(event, post, index) {
            $scope.scrolledY = document.getElementById('body').scrollTop;
            Posts
                .openPostDialog(event, {
                    postId: post._id,
                    index: index,
                    posts: $scope.posts,
                    backState: 'app.home'
                })
                .then(function () {
                    Base.scrollToPosition($scope.scrolledY, 500)
                })
                .catch(function (err) {
                    console.log("profile.controller.js", "err", err);
                    Base.scrollToPosition($scope.scrolledY, 500)
                })
        }


        $scope.fetchFeed();
        $scope.scrollTop();
        $scope.fetchHomeConfig();


        // CategoriesManager.fetchAllCategories()
        //     .then(function (categories) {
        //         $scope.categories = categories;
        //         $scope.parentCategories = [];
        //         angular.forEach(categories, function (category) {
        //             if (!category.parent) {
        //                 $scope.parentCategories.push(category);
        //             }
        //         });
        //     })
        //     .catch(function (err) {
        //         //
        //     });

        // $scope.$on('$destroy', function () {
        //     $interval.cancel(a);
        // });


    }

})(angular);


(function () {
    'use strict';

    angular.module('app.feeds', [])

})(angular);

(function () {
    'use strict';

    FeedController.$inject = ["$scope", "RestManager", "Posts", "Base", "$state", "$rootScope", "$mdDialog"];
    angular.module('app.feeds')
        .controller('feed.controller', FeedController);

    /** @ngInject **/
    function FeedController($scope, RestManager, Posts, Base, $state, $rootScope, $mdDialog) {
        $scope.fetchingFeed = false;
        $scope.totalCount = 0;
        $scope.posts = [];
        $scope.query = {
            sort: '-viewCount',
            limit: 24,
            page: 1
        };


        $scope.fetchFeed = fetchFeed;
        $scope.openPost = openPost;
        $scope.setPageMeta = setPageMeta;
        $scope.clearObserver = clearObserver;
        $scope.initializeInfiniteLoader = initializeInfiniteLoader;
        $scope.loadNextPage = loadNextPage;
        $scope.init = init;

        function fetchFeed(concat) {
            $scope.fetchingFeed = true;
            RestManager.getResource('/posts', 'posts', {
                query: $scope.query,
                extras: ['total']
            })
                .then(function (result) {
                    $scope.totalCount = result.total;
                    result.posts = result.posts.map(function (post) {
                        if(post.image.urls.medium.indexOf('gif') !== -1) {
                            post.key = 'full';
                        } else {
                            post.key = 'medium';
                        }
                        return post;
                    });
                    if (concat) {
                        $scope.posts = $scope.posts.concat(result.posts);
                    } else {
                        $scope.posts = result.posts;
                    }
                    if ($scope.totalCount === $scope.posts.length) {
                        $scope.clearObserver();
                    }
                    $scope.fetchingFeed = false;
                })
                .catch(function (err) {
                    $scope.fetchingFeed = false;
                    $scope.feedFetchError = err.message;
                    console.log("feed.controller.js", "err", err);
                })
        }

        function openPost(event, post, index) {
            $scope.scrolledY = document.getElementById('body').scrollTop;
            Posts
                .openPostDialog(event, {
                    postId: post._id,
                    index: index,
                    posts: $scope.posts,
                    backState: 'app.feed'
                })
                .then(function () {
                    Base.scrollToPosition($scope.scrolledY, 500)
                })
                .catch(function (err) {
                    Base.scrollToPosition($scope.scrolledY, 500)
                    $state.go('app.feed', {}, {
                        notify: false,
                        reload: false
                    });
                    $scope.setPageMeta();
                })
        }

        function setPageMeta() {
            $rootScope.pageMeta = {
                title: "Discover Posts | Browse the posts from our community members, influencers",
                description: "We are largest Customised Women Clothing Online women fashion online store India," +
                    "offering widest collection of latest bespoke women’s clothing at discounted prices.",
                keywords: "Best place to customise women’s wear, Bespoke women’s wear India, Top site for " +
                    "customising women’s dresses Bespoke women’s fashion , Bespoke fashion for women, Customised " +
                    "fashion for women, Women Customised Clothing Online, Customised women’s wear India, Buy " +
                    "Customised dresses online, Buy customised womens wear"
            };
        }

        function loadNextPage(changes) {
            changes.forEach(function (change) {
                if (change.intersectionRatio > 0) {
                    if (!$scope.fetchingFeed) {
                        $scope.query.page += 1;
                        $scope.fetchFeed(true);
                    }
                }
            })
        }

        function initializeInfiniteLoader() {
            if (!$scope.inifinteLoadingElement) {
                $scope.inifinteLoadingElementObserver = new IntersectionObserver(loadNextPage, {
                    root: document.querySelector('#body'),
                    rootMargin: '200px 0px 200px 0px'
                });
                $scope.inifinteLoadingElement = document.querySelector('#infinite-load-trigger');
                if ($scope.inifinteLoadingElement) {
                    $scope.inifinteLoadingElementObserver.observe($scope.inifinteLoadingElement);
                    console.log("feed.controller.js", "initializeInfiniteLoader", $scope.inifinteLoadingElementObserver);
                }
            }
        }

        function clearObserver() {
            if ($scope.inifinteLoadingElementObserver && $scope.inifinteLoadingElement) {
                $scope.inifinteLoadingElementObserver.unobserve($scope.inifinteLoadingElement);
                $scope.inifinteLoadingElement = null;
            }
        }

        function init() {
            $mdDialog.cancel();
        }

        $scope.fetchFeed(false);
        $scope.setPageMeta();
        $scope.initializeInfiniteLoader();
        $scope.init();
    }

})(angular);

(function () {
    'use strict';
    MeasurementCtrl.$inject = ["$scope", "$mdDialog", "product", "ucData", "CartManager", "openEditView", "returnData", "$mdToast", "variations", "Utils", "sizeChart", "selectedVariation", "ctx", "customMeasurement"];
    angular.module('app.main')
        .controller('measurement.controller', MeasurementCtrl);

    /** @ngInject **/
    function MeasurementCtrl($scope, $mdDialog, product, ucData, CartManager, openEditView, returnData, $mdToast,
                             variations, Utils, sizeChart, selectedVariation, ctx, customMeasurement) {


        $scope.sizeChart = sizeChart;
        $scope.product = product;
        $scope.ucData = ucData;
        $scope.variations = variations;
        $scope.openEditView = openEditView;
        $scope.selectedVariation = selectedVariation;
        $scope.customMeasurement = customMeasurement;
        $scope.returnData = returnData;
        $scope.ctx = ctx;

        $scope.close = close;
        $scope.onAddToCart = onAddToCart;

        function onAddToCart(data) {
            if($scope.returnData) {
                $mdDialog.hide(data);
            } else {
                if(data && data.saved) {
                    $mdDialog.hide(data);
                } else if(data && !data.saved) {
                    $mdDialog.cancel(data);
                } else {
                    $mdDialog.cancel()
                }
            }

        }

        function close() {
            $mdDialog.cancel();
            console.log("close");
        }


    }

})(angular);

/**
 * Created by kumardivyarajat on 11/09/17.
 */
(function () {
    "use strict";

    BaseService.$inject = ["Constants", "Role"];
    angular
        .module("app.main")
        .factory('Base', BaseService);

    /** @ngInject */
    function BaseService(Constants, Role) {
        var title = 'aarida';
        var baseUrl = "/api/v1";
        var mediaUrl = "/";
        var productSocialProofUrl = "/";
        var reviewsUrl = "/";
        var role = Role.admin;
        var replaceDirectives = true;
        var env = Constants.ENVIRONMENT[0];
        var envID = 0;
        return {
            setConfData: function (confData) {
                baseUrl = confData.baseUrl;
                mediaUrl = confData.mediaUrl;
                productSocialProofUrl = confData.socialProofApi;
                env = confData.env;
                reviewsUrl = confData.reviewsUrl;
            },
            getTitle: function () {
                return title;
            },
            setTitle: function (newTitle) {
                title = newTitle
            },
            setBaseUrl: function (base) {
                baseUrl = base;
            },
            getBase: function () {
                return baseUrl;
            },
            getBaseUrl: function () {
                return baseUrl;
            },
            getMediaUrl: function () {
                return mediaUrl;
            },
            getReviewsUrl: function () {
                return reviewsUrl;
            },
            getSocialProofUrl: function () {
                return productSocialProofUrl;
            },
            setEnv: function (num) {
                env = Constants.ENVIRONMENT[num];
                envID = num;
            },
            getEnv: function () {
                return env;
            },
            getEnvId: function () {
                return envID;
            },
            setRole: function (text) {
                role = Role[text];
            },
            getRole: function () {
                return role;
            },
            setReplaceDirectives: function (change) {
                replaceDirectives = change;
            },
            getReplaceDirectives: function () {
                return replaceDirectives;
            },
            scrollBy: function (distance, duration) {
                var initialY = document.getElementById('body').scrollTop;
                var y = initialY + distance;
                var baseY = (initialY + y) * 0.5;
                var difference = initialY - baseY;
                var startTime = performance.now();

                function step() {
                    var normalizedTime = (performance.now() - startTime) / duration;
                    if (normalizedTime > 1) normalizedTime = 1;
                    document.getElementById('body').scrollTo(0, baseY + difference * Math.cos(normalizedTime * Math.PI));
                    if (normalizedTime < 1) window.requestAnimationFrame(step);
                }

                window.requestAnimationFrame(step);
            },
            scrollToPosition : function(elementY, duration) {
                var startingY = document.getElementById('body').scrollTop;
                var diff = elementY - startingY;
                var start;

                // Bootstrap our animation - it will get called right before next frame shall be rendered.
                window.requestAnimationFrame(function step(timestamp) {
                    if (!start) start = timestamp;
                    // Elapsed milliseconds since start of scrolling.
                    var time = timestamp - start;
                    // Get percent of completion in range [0, 1].
                    var percent = Math.min(time / duration, 1);

                    document.getElementById('body').scrollTo(0, startingY + diff * percent);

                    // Proceed with animation as long as we wanted it to.
                    if (time < duration) {
                        window.requestAnimationFrame(step);
                    }
                })
            }
        };
    }
})();

/**
 * Created by kumardivyarajat on 11/09/17.
 */
(function () {
    "use strict";

    MainController.$inject = ["$scope", "$rootScope", "Base", "$mdMedia", "$timeout", "$state", "RestManager", "$q", "$analytics", "$window", "Utils", "$stateParams", "$mdToast", "ErrorHero", "$mdMenu", "$interval", "$exceptionHandler", "WishListManager", "$cookies", "TagsManager", "FullStory", "$mdDialog", "Header", "$location", "CategoriesManager", "CartManager", "CookiesManager", "$mdSidenav", "$log", "AuthManager"];
    angular
        .module("app.main")
        .controller('mainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, Base, $mdMedia, $timeout, $state, RestManager, $q, $analytics, $window, Utils, $stateParams,
                            $mdToast, ErrorHero, $mdMenu, $interval, $exceptionHandler, WishListManager, $cookies, TagsManager, FullStory,
                            $mdDialog, Header, $location, CategoriesManager, CartManager, CookiesManager, $mdSidenav, $log, AuthManager) {

        var authLoading;
        $scope.authLoading = authLoading;
        $scope.parentCategories = [];
        $rootScope.$watch('pageMeta', function (newVal) {
            newVal.url = window.location.href;
            $scope.pageMeta = newVal;
            if ($scope.pageMeta.price) {
                $scope.$root.ld = {
                    "@context": "http://schema.org/",
                    "@type": "Product",
                    "productID": $scope.pageMeta.sku,
                    "sku": $scope.pageMeta.sku,
                    "name": $scope.pageMeta.title,
                    "description": $scope.pageMeta.description,
                    "url": $scope.pageMeta.url,
                    "image": $scope.pageMeta.image,
                    "brand": "Aarida",
                    "offers": [
                        {
                            "url": $scope.pageMeta.url,
                            "@type": "Offer",
                            "price": $scope.pageMeta.price,
                            "priceValidUntil": moment().add('35', 'days').format('YYYY-MM-DD'),
                            "priceCurrency": "INR",
                            "itemCondition": "https://schema.org/NewCondition",
                            "availability": $scope.pageMeta.outOfStock ? "https://schema.org/OutOfStock" : "https://schema.org/InStock"
                        }
                    ]
                }
            } else {
                $scope.$root.ld = {
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    "url": "https://www.aarida.com",
                    "potentialAction": {
                        "@type": "SearchAction",
                        "target": "https://www.aarida.com/search?q={search_term_string}",
                        "query-input": "required name=search_term_string"
                    }
                }
            }
            // $log.info("meta changed", newVal);
        });

        $scope.cashbackOfferEndDate = '2020-01-09T18:30:00.000Z';
        $scope.showCashbackOffer = moment().isBefore(moment($scope.cashbackOfferEndDate));

        $scope.hideFooter = false;

        $scope.baseUrl = Base.getBaseUrl();
        $scope.mediaUrl = Base.getMediaUrl();
        $analytics.setOptOut(Base.getEnv() !== 'prod');

        $rootScope.showRefreshLoader = false;

        $scope.hideBanner = false;
        $scope.pageCount = 0;
        $scope.deferredPrompt = null;
        $scope.cart = {products: []};
        $rootScope.navigated = false;

        $scope.showSearchToolbar = false;
        $scope.openCart = openCart;
        $scope.getProperName = Utils.getProperName;
        $scope.hideToolbar = false;

        $scope.updateQuantity = updateQuantity;
        $scope.removeFromCart = removeFromCart;

        $scope.querySearch = querySearch;
        $scope.getVariationValue = Utils.getSelectedVariationFromCartProduct;

        $scope.selectedItemChange = selectedItemChange;
        $scope.searchTextChange = searchTextChange;
        $scope.openProduct = openProduct;
        $scope.switchState = switchState;
        $scope.goToCustomisationEditor = goToCustomisationEditor;
        $scope.goBackInStack = goBackInStack;
        $scope.checkForUpdates = checkForUpdates;
        $scope.clearCart = clearCart;
        $scope.initAddToHomeScreen = initAddToHomeScreen;
        $scope.installHomeScreen = installHomeScreen;
        $scope.update = update;
        $scope.cancelUpdate = cancelUpdate;
        // ******************************
        // Internal methods
        // ******************************


        function initAddToHomeScreen() {

            window.addEventListener('beforeinstallprompt', function (evt) {
                evt.preventDefault();
                $scope.deferredPrompt = evt;
            })
        }

        function installHomeScreen() {
            if ($scope.deferredPrompt) {
                $scope.deferredPrompt.prompt();

                $scope.deferredPrompt.userChoice()
                    .then(function (choiceResult) {
                        if (choiceResult.outcome === 'accepted') {
                            console.log('User accepted the A2HS prompt');
                        } else {
                            console.log('User dismissed the A2HS prompt');
                        }
                        $scope.deferredPrompt = null;
                    })
            }
        }

        function checkForUpdates() {
            var promise = window['isUpdateAvailable'];
            if (promise) {
                promise
                    .then(function (isAvailable) {
                        if (isAvailable) {
                            $mdDialog.show({
                                contentElement: '#updateDialog',
                                scope: $scope,
                                preserveScope: true,
                                clickOutsideToClose: true,
                                escapeToClose: true,
                                openFrom: {
                                    top: 1500
                                },
                                closeTo: {
                                    left: 15000
                                }
                            })
                        }
                    });
            }
        }


        function update() {
            $analytics.eventTrack(
                "App Refreshed"
            );
            FullStory.trackEvent('App Refreshed');
            window.location.reload();
        }

        function cancelUpdate() {
            $analytics.eventTrack(
                "App Refresh Cancelled"
            );
            FullStory.trackEvent('App Refresh Cancelled');
            $mdDialog.cancel();
        }

        $scope.showPopupDialog = function () {
            var eoss = $window.localStorage.getItem('40off');
            if (!eoss || !JSON.parse(eoss).shown) {
                //     $mdDialog.show({
                //         templateUrl: 'offer.dialog.html',
                //         fullscreen: false,
                //         // openFrom : "#header",
                //         scope: $scope,        // use parent scope in template
                //         preserveScope: true,  // do not forget this if use parent scope
                //         clickOutsideToClose: true,
                //         escapeToClose: true
                //     })
                //         .then(function () {
                //
                //         })
                //         .catch(function (err) {
                //             $window.localStorage.setItem("eoss", JSON.stringify({shown: true}));
                //         });


                // $scope.showEoss = true;
            }
        };

        $scope.hideEoss = function () {
            $scope.showEoss = false;
            $window.localStorage.setItem("40off", JSON.stringify({shown: true}));
        };

        /**
         * Search for states... use $timeout to simulate
         * remote dataservice call.
         */
        function querySearch(query) {
            return TagsManager.searchQuery(query);
        }

        function searchTextChange(text) {
            // $log.info('Text changed to ' + text);
            // $scope.searchQuery = text;
            $rootScope.$emit("search", text);
        }

        function selectedItemChange(item) {
            if (item) {
                self.selectedItem = item.name;
            }
            // $log.info('Item changed to ' + JSON.stringify(item));
        }

        function openProduct(slug) {
            $scope.showSearchToolbar = false;
            $state.go("app.product", {productSlug: slug});
        }

        function updateQuantity(productData, how, index) {
            $scope.updating = true;
            productData.updating = true;
            var quantity = 0;
            switch (how) {
                case "plus" :
                    if (productData.quantity !== 0)
                        quantity = productData.quantity + 1;
                    break;

                case "minus" :
                    if (productData.quantity !== 1)
                        quantity = productData.quantity - 1;
                    else
                        $scope.removeFromCart(productData);
                    break;
            }

            if (quantity) {
                //
                var promise = {};
                if (productData.product.productType === 0 || !$scope.isUserLoggedIn) {
                    promise = CartManager.updateCart(productData.product._id, productData.variation._id, quantity)
                } else {
                    promise = CartManager.updateCart(productData.product._id, productData.ucData._id, quantity)
                }
                promise
                    .then(function (cart) {
                        //
                        productData.updating = false;
                        $scope.updating = false;
                        $scope.cart = cart;
                    })
                    .catch(function (err) {
                        productData.updating = false;
                        $scope.updating = false;

                    });
            } else {
                $scope.updating = false;
                // productData.updating = false;
            }
        }

        function removeFromCart(productData, index) {
            $scope.updating = true;
            productData.updating = true;

            console.log('ProductData', productData);

            var promise = {};
            if (productData.product.productType === 0 || !$scope.isUserLoggedIn) {
                promise = CartManager.removeFromCart(productData.product._id, productData.variation._id)
            } else {
                promise = CartManager.removeFromCart(productData.product._id, productData.ucData._id)
            }
            promise
                .then(function (cart) {
                    $analytics.eventTrack(
                        "Product Removed - Cart",
                        {product: productData.product.name, productType: productData.product.productType}
                    );
                    productData.updating = false;
                    $scope.updating = false;
                })
                .catch(function (err) {
                    productData.updating = false;
                    $scope.updating = false;
                });
        }

        function goToCustomisationEditor(productData) {
            $state.go("app.customisationEditor", {slug: productData.product.slug, ucSlug: productData.ucData.slug})
            $scope.closeSidebar('cart');
        }


        $log.info('aarida.com is hiring! Visit : https://www.aarida.com/careers 🚀');


        $scope.url = $location.absUrl();

        // CookiesManager.putCookie("shownOffer", false);

        $scope.showHeader = $location.path() === "/home";
        $scope.dynamicTheme = 'awesome';

        $scope.isSmall = !$mdMedia('gt-sm');
        // $scope.hideFooter = $scope.isSmall;

        $interval(function () {
            $scope.isSmall = !$mdMedia('gt-sm');
            // $scope.hideFooter = $scope.isSmall;
        }, 5000);


        $rootScope.$on("userSetup", function (data) {
            $scope.currentUser = AuthManager.getCurrentUser();
            if ($scope.currentUser) {
                $scope.isUserLoggedIn = AuthManager.isUserLoggedIn;
                $scope.fetchCart();
                $scope.fetchWishList();
            }
        });


        $scope.fecthingCategories = true;
        CategoriesManager.fetchFeatured()
            .then(function (categories) {
                $scope.fecthingCategories = false;
                categories = _.sortBy(_.map(categories, function (category) {
                    switch (category.name) {
                        case "Kids Wear" :
                            category.priority = 3;
                            break;

                        case "Tops":
                            category.priority = 1;
                            break;

                        case "Kurtis" :
                            category.priority = 0;
                            break;

                        case "Dresses" :
                            category.priority = 2;
                            break;

                        default:
                            category.priority = 5;
                            break;
                    }
                    return category;
                }), function (o) {
                    return o.priority;
                });

                // categories = _.reverse(categories);
                $scope.parentCategories = categories;

                // $timeout(function () {
                //
                //     if (!$scope.isUserLoggedIn) {
                //         var contest = JSON.parse($window.localStorage.getItem("30-off") || '{}');
                //         if (contest) {
                //             if (!contest.shown) {
                //                 $scope.showPopupDialog();
                //             }
                //         } else {
                //             $scope.showPopupDialog();
                //         }
                //     }
                //
                // }, 3000);
                // $scope.showPopupDialog();
            })
            .catch(function (err) {
                $scope.fecthingCategories = false;

            });

        $scope.open = function () {
            // Component lookup should always be available since we are not using `ng-if`
            //

            if ($mdSidenav('left').isOpen()) {
                $scope.closeSidebar()
                    .then(function () {
                        // $log.debug("close LEFT is done");
                        return $mdSidenav('left').open();
                    })
                    .then(function () {
                        // $log.debug("open LEFT is done");
                    });
            } else {
                $mdSidenav('left').open()
                    .then(function () {
                        // $log.debug("open LEFT is done");
                    });
            }
        };


        function openCart() {
            if ($mdSidenav('cart').isOpen()) {
                $scope.closeSidebar('cart')
                    .then(function () {
                        // $log.debug("close LEFT is done");
                        return $mdSidenav('cart').open();
                    })
                    .then(function () {
                        // $log.debug("open LEFT is done");
                    });
            } else {
                $mdSidenav('cart').open()
                    .then(function () {
                        // $log.debug("open LEFT is done");
                    });
            }
        };

        $scope.fetchWishList = function () {
            console.log('Fethcing w');
            WishListManager.getWishlistOutline()
                .then(function (wishlist) {
                    console.log('Wishlist', wishlist);
                    $scope.wishlist = wishlist;
                })
                .catch(function (err) {
                    console.log('Error fetching wishlist', err);
                })
        };


        $scope.fetchCart = function () {
            // if ($scope.isUserLoggedIn) {
            CartManager.getUserCart(true)
                .then(function (cart) {
                    // $log.info("Cart Loaded", cart);
                    $scope.cart = cart;
                })
                .catch(function (err) {
                    $exceptionHandler(err, err.cause);
                });
            // }
        };


        $scope.mergeCart = function () {
            if ($scope.cart && $scope.cart.products && $scope.cart.products.length) {
                console.log('MERGING CART', $scope.cart);
                var data = $scope.cart.products
                    .filter(function (productData) {
                        return productData.product && productData.product._id;
                    });
                data = data.map(function (productData) {
                    return {
                        product: productData.product._id,
                        variation: productData.variation._id,
                        quantity: productData.quantity,
                        measurements: productData.measurements,
                        ucData: productData.ucData ? productData.ucData : null
                    }
                });
                RestManager.postResource("/cart/merge", {p: data}, "cart")
                    .then(function (cart) {
                        $scope.cart = cart[0];
                        $window.localStorage.removeItem('wishlist');
                        $window.localStorage.removeItem('cart');
                        $rootScope.$broadcast('cartChanged', $scope.cart);
                    })
                    .catch(function (err) {
                        console.log('Error Merging Cart', err);
                    })
            } else {
                CartManager.getUserCart(true)
                    .then(function (cart) {
                        $scope.cart = cart;
                    })
                    .catch(function (err) {
                        console.log('Error Fetching Cart after login', err);
                    })
            }
        };

        $scope.mergeWishlist = function () {
            WishListManager.mergeWishlist()
                .then(function () {
                    $scope.fetchWishList();
                })
                .catch(function (err) {
                    console.log('Error Merging Wishlist', err);
                })
        };


        $scope.openLoginModal = function (ev) {
            // $scope.loginForm.$setPristine();
            $scope.showGetStartedForm();
            AuthManager.showLoginModal(ev, $scope, true);
            $scope.closeSidebar()
                .then(function () {
                    // $log.info("closed");
                })

        };

        $scope.removeBar = function (which) {
            switch (which) {
                case 'bottom' :
                    $scope.hideBanner = true;
                    break;
            }
        };

        $scope.checkState = function (slug, ctx) {
            if (!ctx) {
                ctx = 'app.category'
            }
            var a = $state.includes(ctx, {categoryName: slug});
            return a;
        };

        $scope.navigate = function (state, params) {
            $scope.closeSidebar()
                .then(function () {
                    $state.go(state, params);
                })
                .catch(function (err) {
                });
            // $timeout(function () {
            // }, 0);
        };

        $scope.closeSidebar = function (id) {
            return $mdSidenav(id || 'left').close();
        };

        function clearCart() {
            $scope.clearingCart = true;
            console.log('aa')
            CartManager.clearCart()
                .then(function (cart) {
                    $scope.cart = cart;
                    $scope.clearingCart = false;
                })
                .catch(function (err) {
                    $scope.clearingCart = false;
                    console.log('Error clearing cart', err);
                    $mdToast.showSimple('Error clearing cart : ' + err.message);
                })
        }


        // $scope.openMenu = function (event) {
        //     angular.element(document.querySelectorAll(".menu-trigger-button")).parent().find("section").addClass('hide');
        //     $timeout(function () {
        //         var targetButton = angular.element(event.target);
        //         targetButton.addClass("selected");
        //         var menuContainer = targetButton.parent().find("section");
        //         menuContainer.removeClass('hide');
        //     }, 0);
        // };

        $scope.openMenu = function ($mdOpenMenu, e) {
            if (AuthManager.isUserLoggedIn) {
                $scope.fetchingPoints = true;
                RestManager.getResource("/users/credits", "user")
                    .then(function (user) {
                        $scope.fetchingPoints = false;
                        $scope.currentUser.points = user[0].points;
                    })
                    .catch(function (err) {
                    })
            }
            try {
                $mdOpenMenu(e);
            } catch (err) {

            }
        };

        $scope.closeMenu = function (event, inside) {
            $timeout(function () {
                if (!inside)

                    $mdMenu.hide(event);
            }, 500);
            // var menuContainer = angular.element(event.target);
            // menuContainer.parent().find("section").addClass('hide');
            //
        };

        $scope.user = {};
        $scope.newUser = {};

        function unacceptable(pwd) {
            var unforgivable = [
                "password",
                "12345678",
                "8675309",
                "[a-z]{8,}",
                "qwerty",
                "asdfg",
                "qazwsx",
                "zxcvb",
                "letmein",
                "trustno1",
                "omnicloud",
                "monkey"
            ];
            var re = new RegExp(unforgivable.join("|"), "i");
            return (pwd.match(re) !== null);
        }


        // showForm === 0 LOGIN
        // showForm === 1 REGISTER
        // showForm === 2 VERIFY
        // showForm === 3 FORGOT PASSWORD

        $scope.showForm = 4;

        $scope.getTitle = function () {
            switch ($scope.showForm) {
                case 0:
                    return "Login";

                case 1 :
                    return "Register";

                case 2 :
                    return "Verify Otp";

                case 3 :
                    return "Forgot Password";
            }
        };

        $scope.showForgotPassword = function () {
            $scope.showForm = 3;
            $scope.formError = "";
        };

        $scope.backToLogin = function () {
            $scope.showForm = 0;
            $scope.formError = "";
        };

        $scope.showRegistrationForm = function () {
            $scope.showForm = 1;
            $scope.formError = "";
        };

        $scope.showVerifyOTPForm = function () {
            $scope.showForm = 2;
            if(!$scope.newUser) {
                $scope.newUser = {};
            }
            $scope.user = {};
            $scope.formError = "";
        };
        $scope.showPasswordForm = function () {
            $scope.showForm = 5;
            $scope.formError = "";
            $scope.reset($scope.passwordForm);
            $scope.passwordForm.password.$error = {};
            setTimeout(function () {
                var passwordInput = document.getElementById('loginPassword');
                if(passwordInput) {
                    passwordInput.focus();
                    passwordInput.setSelectionRange(0, passwordInput.value.length);
                }
            }, 0)
        };

        $scope.showGetStartedForm = function () {
            $scope.user = {};
            $scope.newUser = {};
            $scope.formError = "";
            $scope.showForm = 4;
        };

        $scope.reset = function (form) {
            // Each control (input, select, textarea, etc) gets added as a property of the form.
            // The form has other built-in properties as well. However it's easy to filter those out,
            // because the Angular team has chosen to prefix each one with a dollar sign.
            // So, we just avoid those properties that begin with a dollar sign.
             var controlNames = Object.keys(form).filter(function (key) {
                return key.indexOf('$') !== 0
            });

            // Set each control back to undefined. This is the only way to clear validation messages.
            // Calling `form.$setPristine()` won't do it (even though you wish it would).
            controlNames.forEach(function (name) {
                var control = form[name];
                control.$setViewValue(undefined);
            })

            form.$setPristine();
            form.$setUntouched();
        };

        $scope.showNewAccountForm = function () {
            $scope.user = {};
            $scope.formError = "";
            $scope.showForm = 6;
        };


        $scope.checkDetail = function (e) {
            $scope.checkingDetail = true;
            authLoading = true;
            $scope.authPromise = RestManager.postResource("/users/getAccountDetail", {mobile: $scope.user.mobile}, "data");
            $scope.authPromise
                .then(function (result) {
                    $scope.initi = true;
                    $scope.checkingDetail = false;
                    authLoading = false;
                    $scope.hasAccount = result[0].hasAccount;
                    $scope.onboardUser = result[0].onBoardUser;
                    if ($scope.hasAccount && $scope.onboardUser) {
                        $scope.forgotPassword();
                    } else if ($scope.hasAccount) {
                        $scope.showPasswordForm();
                    } else {
                        $scope.newUser.mobile = $scope.user.mobile;
                        // $scope.showVerifyOTPForm();
                        $scope.generateOTP();
                    }
                })
                .catch(function (err) {
                    authLoading = false;
                    $scope.checkingDetail = false;
                    $scope.formError = err.message;
                })
        };


        $scope.generateOTP = function ($event) {
            //
            try {
                $scope.authLoading = true;
                $scope.sendingOTP = true;
                $scope.authPromise = AuthManager.requestOTP($scope.newUser.mobile, $scope.newUser.email);
                $scope.authPromise
                    .then(function () {
                        $scope.sendingOTP = false;
                        $scope.authLoading = false;
                        $scope.showVerifyOTPForm();
                    })
                    .catch(function (err) {
                        $scope.sendingOTP = false;
                        $scope.authLoading = false;

                        $scope.formError = err.message;
                    })
            } catch (er) {

            }
        };

        $scope.verifyOTP = function () {
            try {
                $scope.authLoading = true;
                $scope.authPromise = AuthManager.verifyotp($scope.newUser.mobile, $scope.newUser.otp);
                $scope.authPromise
                    .then(function (result) {
                        $scope.authLoading = false;
                        $scope.showNewAccountForm();
                    })
                    .catch(function (err) {
                        $scope.sendingOTP = false;
                        $scope.authLoading = false;

                        $scope.formError = err.message;
                    })
            } catch (er) {

            }
        };

        $scope.forgotPassword = function () {

            $scope.formError = "";
            $scope.authPromise = AuthManager.forgotPassword($scope.user.mobile);

            $scope.authPromise.then(function () {
                $analytics.eventTrack(
                    "Forgot Password",
                    {"completed": "true"},
                    {"mobile": $scope.user.mobile}
                );
                if(!$scope.newUser) {
                    $scope.newUser = {};
                }
                $scope.newUser.mobile = $scope.user.mobile;
                $scope.newUser.password = "";
                $scope.showVerifyOTPForm();
                $scope.changingPassword = true;
                $scope.user.password = "";

            })
                .catch(function (err) {

                    if (err.code === 436) {
                        $analytics.eventTrack(
                            "Forgot Password",
                            {"completed": "false"},
                            {"reason": err.message},
                            {"mobile": $scope.newUser.mobile}
                        );
                        $scope.formError = err.message;
                    }
                })

        };

        $scope.signUp = function () {
            // if (!$scope.newUser.otp) {
            //     $mdToast.show({
            //         hideDelay: 3000,
            //         position: 'bottom right',
            //         content: "Please enter your otp"
            //     });
            // } else {
            $scope.authPromise = AuthManager.signup($scope.newUser);
            $scope.authPromise
                .then(function (user) {
                    $scope.isUserLoggedIn = true;
                    $scope.currentUser = user;
                    return CartManager.getUserCart()
                })
                .then(function (cart) {

                    $scope.fetchWishList();
                    $scope.cancel();
                    $analytics.eventTrack(
                        "Registration Success",
                        {
                            mobile: $scope.newUser.mobile,
                            email: $scope.newUser.email
                        }
                    );
                    $scope.newUser = {};
                    $scope.user = {};
                    // if ($scope.loginState) {
                    //     $scope.goToPreviousState();
                    // }
                    $rootScope.$broadcast("loggedIn", $scope.currentUser);
                })
                .catch(function (err) {
                    // $log.error(err);
                    $analytics.eventTrack(
                        "Invalid Registration",
                        {
                            err: err.message,
                            code: err.code,
                            mobile: $scope.newUser.mobile,
                            email: $scope.newUser.email,
                            otp: $scope.newUser.otp
                        }
                    );
                    FullStory.trackEvent('SignupError', {
                        err: err.message,
                        code: err.code,
                        mobile: $scope.user.mobile
                    });
                    $scope.formError = err.message;

                });
            // }
        };

        $scope.changePassword = function (e) {

            if (!$scope.newUser.otp || !$scope.newUser.mobile || !$scope.newUser.password || !$scope.newUser.confirmPassword ||
                $scope.newUser.confirmPassword !== $scope.newUser.password) {
                $mdToast.show({
                    hideDelay: 3000,
                    position: 'bottom right',
                    content: "Some details are either missing or wrong. Please re-check the form."
                });
            } else {
                $scope.authPromise = AuthManager.resetPassword($scope.newUser);
                $scope.authPromise
                    .then(function (user) {
                        $analytics.eventTrack("Password Change", {
                            // "mobile": $scope.newUser.mobile,
                            "completed": true
                        });
                        $mdToast.show({
                            hideDelay: 3000,
                            position: 'bottom right',
                            theme: "white-toast",
                            content: "Password changed successfully. Please login with your new credentials."
                        });
                        $scope.changingPassword = false;
                        $scope.user.mobile = $scope.newUser.mobile;
                        $scope.newUser = {};
                        $scope.showPasswordForm();
                    })
                    .catch(function (err) {
                        $scope.formError = err.message;
                        $analytics.eventTrack("Password Change", {
                            // "mobile": $scope.newUser.mobile,
                            "completed": false,
                            reason: err.message
                        });
                        $mdToast.show({
                            hideDelay: 3000,
                            position: 'bottom right',
                            content: err.message
                        });
                    })
            }

        };


        $scope.loginUser = function () {
            // $log.info("loggged in", $scope.user);
            $scope.authLoading = true;
            AuthManager.loginUser($scope.user.mobile, $scope.user.password)
                .then(function (user) {
                    $scope.isUserLoggedIn = true;
                    $scope.currentUser = user;
                    $scope.authLoading = false;
                    $scope.cancel();
                    $analytics.eventTrack(
                        "Login Success"
                        // {
                        //     mobile: $scope.user.mobile
                        // }
                    );
                    $scope.user = {};
                    // if ($scope.loginState) {
                    //     $scope.goToPreviousState();
                    // }
                    $rootScope.$broadcast("loggedIn", $scope.currentUser);
                })
                .catch(function (err) {
                    $analytics.eventTrack(
                        "Invalid Login",
                        {
                            err: err.message,
                            code: err.code,
                            // mobile: $scope.user.mobile
                        }
                    );
                    FullStory.trackEvent('LoginError', {
                        err: err.message,
                        code: err.code,
                        mobile: $scope.user.mobile
                    });
                    var message = err.message;
                    if(err.code === 423) {
                        message = 'Invalid Password';
                    }
                    $scope.formError = message;
                    var passwordInput = document.getElementById('loginPassword');
                    if(passwordInput) {
                        passwordInput.focus();
                        passwordInput.setSelectionRange(0, passwordInput.value.length);
                    }
                    $scope.authLoading = false;
                    $scope.errorText = message;

                })
        };

        // $scope.facebookLogin = function () {
        //     $scope.saveCurrentStateInCookies($state.current.name, $state.params);
        //
        //
        //     var form = document.createElement("form");
        //     form.method = "POST";
        //     form.action = "/api/v1/users/auth/facebook";
        //     document.body.appendChild(form);
        //     form.submit();
        //
        //     // RestManager.getResource("/users/auth/facebook", "")
        //     //     .then(function (res) {
        //     //
        //     //     })
        //     //     .catch(function (err) {
        //     //
        //     //     })
        // };

        $scope.googleLogin = function () {
            FullStory.trackEvent('GoogleLogin');
            if ($state.current.name !== 'app.login') {
                $scope.saveCurrentStateInCookies($state.current.name, $state.params);
                $cookies.putObject('returnTo', window.location.href);
            }
            var form = document.createElement("form");
            form.method = "GET";
            form.action = Base.getBaseUrl() + "/users/auth/google";
            document.body.appendChild(form);
            form.submit();
        };


        function switchState(showSearchToolbar, state) {
            $scope.showSearchToolbar = showSearchToolbar;
            $scope.searchInput = "";
            console.log('Search', showSearchToolbar, state);
            if (showSearchToolbar) {
                $scope.saveCurrentStateInCookies($state.current.name, $state.params);
                $state.go(state);
            } else {
                $scope.goBackInStack();
            }
        }

        function goBackInStack() {
            var options = {location: "replace"};
            var state = $cookies.getObject("mlnState");
            var params = $cookies.getObject("mlnParams");
            var returnTo = $cookies.getObject("returnTo");
            options = _.merge(options, params);
            $state.transitionTo(state || 'app.home', options || {});
            $cookies.remove('mlnState');
            $cookies.remove('mlnParams');
            $cookies.remove('returnTo');
        }


        $scope.saveCurrentStateInCookies = function (state, params) {
            if ($state.current.name !== 'app.callback') {
                $rootScope.backState = state;
                $rootScope.backParams = params;
                console.log('Saving state in cookies', state, params);
                $cookies.putObject("mlnState", state);
                $cookies.putObject("mlnParams", params);
            }
        };

        $scope.logout = function () {
            AuthManager.logout();

            // CartManager.clearCart();
            // $scope.cart = undefined;
            // $scope.wishlist = "";
            // //
            // $state.transitionTo("app.home");
            // $timeout(function () {
            //
            //     $scope.isUserLoggedIn = AuthManager.isUserLoggedIn;
            //     AuthManager.getCurrentUserAsync()
            //         .then(function (user) {
            //             $scope.currentUser = user;
            //             $scope.isUserLoggedIn = AuthManager.isUserLoggedIn;
            //             $scope.fetchCart();
            //             $scope.fetchWishList();
            //         })
            //         .catch(function (err) {
            //
            //         })
            // }, 1000);
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
            //
            return $mdSidenav('left').close()
        };

        $scope.menuIcon = 'menu';


        $scope.$on("$mdMenuOpen", function (event, element) {
            //
            if (element[0].children[0].id === "category-menu") {
                $scope.menuIcon = 'close';
            }
        });

        $scope.$on("$mdMenuClose", function (event, element) {
            //
            if (element[0].children[0].id === "category-menu") {
                $scope.menuIcon = 'menu';
            }
        });


        $scope.toggleForms = function () {
            $timeout(function () {
                $scope.showRegistrationForm = !$scope.showRegistrationForm;
                $scope.showOtpForm = false;
            }, 300);
        };

        $scope.goToPreviousState = function () {
            if ($scope.previous && $scope.previous.name) {
                console.log('Going in back stack', $scope.previous);
                $state.go($scope.previous.name, $scope.previous.params, {location: "replace"});
            } else {
                console.log('NavStack', 'No back stack found', $scope.previous);
                $state.go('app.home', {location: "replace"});
            }
        };


        $scope.setupLoginState = function () {
            $rootScope.pageMeta = {
                title: "Login",
                description: "Login/Register on aarida.com",
                keywords: "Login on aarida.com, Register on aarida.com"
            };

            $analytics.eventTrack(
                "Login",
                {page: "/login", previous: $scope.previous.name}
            );
        };

        // $scope.$emit('$mdMenuClose', $element, eventDetails);
        // ")

        $scope.handleHeader = function (data) {
            if (!$scope.isSmall) {
                $scope.transparentHeader = data;
                $rootScope.transparentHeader = data;
                var mainContent = angular.element(document.getElementById("body"));

                if ($scope.transparentHeader) {
                    mainContent.addClass("transparentHeader");
                } else {
                    mainContent.removeClass("transparentHeader");
                }
            }
        };


        $rootScope.$on("loggedIn", function ($event, data) {
            $scope.isUserLoggedIn = true;
            $cookies.remove('mob')
            $analytics.eventTrack(
                "Logged In/Registerd",
                {user: data.name}
            );
            //wrapped this within $apply
            $scope.currentUser = data;
            $analytics.setAlias(data._id);
            $analytics.setUsername(data.email);
            $analytics.setUserProperties(data);

            // if ($stateParams.returnTo) {
            //     window.location.replace($stateParams.returnTo);
            if ($rootScope.backState) {
                $scope.goBackInStack();
            } else if($stateParams.returnTo) {
                window.location.replace($stateParams.returnTo);
            }
            $rootScope.backState = "";
            $rootScope.backParams = "";
            $scope.mergeCart();
            $scope.mergeWishlist();
            if (confData.env === 'prod' && typeof FS !== 'undefined') {
                FS.identify(data._id, {
                    displayName: data.name,
                    email: data.email
                });
            }
            // $window.location.reload();
        });

        $rootScope.$on("showToolbar", function (e, d) {
            if (!$scope.showSearchToolbar) {
                $scope.showSearchToolbar = true;
            }
        });

        $rootScope.$on("updatedUser", function ($event, data) {
            $scope.currentUser = data;
        });


        $rootScope.$on("cartChanged", function ($event, cart) {
            $scope.cart = cart;
        });

        $rootScope.$on("wishlistChanged", function ($event, data) {
            $scope.wishlist = data;
        });

        $rootScope.$on("transparentHeader", function ($event, data) {

            $scope.handleHeader(data);
        });


        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
            // //
            $scope.loading = true;
        });

        $scope.navStack = [];

        $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
            $scope.loading = false;

            from.params = fromParams;
            // Assign {from} to {previous} in $state

            $scope.previous = from;

            $rootScope.$on('$stateChangeSuccess', function (ev, to, toParams, from, fromParams) {
                if (from.name) {
                    $rootScope.navigated = true;
                }
            });


            if (typeof hj !== 'undefined') {
                hj('stateChange', $location.url());
            }

            if ($state.current.name === "app.login") {
                if (AuthManager.isUserLoggedIn) {
                    $state.go("app.account.home");
                } else {
                    $scope.loginState = true;
                    $scope.setupLoginState();
                }
            } else {
                $scope.loginState = false;
            }

            if ($state.current.name !== "app.search") {
                $scope.searchInput = "";
                $scope.showSearchToolbar = false;
            }

            $scope.showBackButton = $state.current.name !== 'app.home';
            console.log('Show Back button', $scope.showBackButton);

            if (to.name === 'app.customisationEditor') {
                $scope.previous = from;
                // $scope.hideToolbar = true;
            } else {
                // $scope.hideToolbar = false;
            }

            if (to.name === 'app.login' && $cookies.getObject('mob')) {
                try {
                    $scope.user.mobile = window.atob($cookies.getObject('mob').mobile);
                    $scope.disableSocialLogin = true;
                } catch (e) {
                    console.error(e);
                }
            } else {
                // disabling google login to ensure that the people provide their contact details.
                $scope.disableSocialLogin = true;
            }
            console.log('to.name', to.name, toParams);

            if (to.name === 'app.account.singleOrder' || to.name === 'app.account.giftCards' || to.name === 'app.account.singleQuotation' && !$scope.isUserLoggedIn) {
                $scope.saveCurrentStateInCookies(to.name, toParams);
                if (toParams.h) {
                    try {
                        $cookies.putObject('mob', {mobile: toParams.h});
                    } catch (e) {
                        console.error(e)
                    }
                }
                if (to.name === 'app.account.giftCards' && toParams.c) {
                    try {
                        $cookies.putObject('code', {code: toParams.c});
                    } catch (e) {
                        console.error(e)
                    }
                }
            }
            //$scope.saveCurrentStateInCookies(from.name, fromParams);

            // if (!$scope.isUserLoggedIn) {
            // $scope.pageCount++;
            //
            // if ($scope.pageCount === 4) {
            //     $scope.showPopupDialog();
            // }
            // }

            $scope.transparentHeader = false;
            $scope.handleHeader(false);

        });

        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            //catch error

            $state.transitionTo("app.404client", {path: "error"});
            // Toast.errorToast("Some Error Occurred. Error report sent to admin.", 4000);
        });


        setTimeout(function () {
            $scope.showPopupDialog();
        }, 10000);


        $scope.fetchCart();
        $scope.fetchWishList();
        $scope.initAddToHomeScreen();
        $scope.checkForUpdates();
    }
})();

(function () {
    "use strict";

    angular.module("app.main")
        .constant('Constants', {
            ENVIRONMENT: {
                0: "DEVELOPMENT",
                1: "DEBUG",
                2: "PRODUCTION"
            }
        })
        .constant('Role', {
            admin: "ADMIN",
            shopManager: "SHOP MANAGER",
            csExecutive: "CS EXECUTIVE",
            customer: "CUSTOMER"
        });
})(angular);

/**
 * Created by kumardivyarajat on 11/09/17.
 */
(function () {
    "use strict";

    MainConfig.$inject = ["$mdThemingProvider", "$mdGestureProvider"];
    angular
        .module("app.main")
        .config(MainConfig);

    /** @ngInject */
    function MainConfig($mdThemingProvider, $mdGestureProvider) {
        $mdGestureProvider.skipClickHijack();

        $mdThemingProvider.definePalette('awesomePalette', {

            // Dark Navy Blue Palette
            // '50': '#bdc4d5',
            // '100': '#8e9ab8',
            // '200': '#6c7ba2',
            // '300': '#4d5a7a',
            // '400': '#414c67',
            // '500': '#7978de',
            // '600': '#293041',
            // '700': '#1d222e',
            // '800': '#11141c',
            // '900': '#060709',
            // 'A100': '#bdc4d5',
            // 'A200': '#8e9ab8',
            // 'A400': '#414c67',
            // 'A700': '#1d222e',

            // White Palette
            '50': '#FFFFFF',
            '100': '#FFFFFF',
            '200': '#FFFFFF',
            '300': '#FFFFFF',
            '400': '#FFFFFF',
            '500': '#FFFFFF',
            '600': '#FFFFFF',
            '700': '#FFFFFF',
            '800': '#FFFFFF',
            '900': '#FFFFFF',
            'A100': '#FFFFFF',
            'A200': '#FFFFFF',
            'A400': '#FFFFFF',
            'A700': '#FFFFFF',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                '500',
                '600',
                '700',
                '800',
                '900',
                'A100',
                'A200',
                'A400',
                'A700'
            ],
            'contrastLightColors': []


            //     '50': 'f9fcfe',
            //     '100': 'f1f6fb',
            //     '200': 'e7f1f9',
            //     '300': 'ddebf7',
            //     '400': 'd6e6f5',
            //     '500': 'cfe2f3',
            //     '600': 'cadff1',
            //     '700': 'c3daef',
            //     '800': 'bdd6ed',
            //     '900': 'b2cfea',
            //     'A100': 'ffffff',
            //     'A200': 'ffffff',
            //     'A400': 'ffffff',
            //     'A700': 'ffffff',
            //     'contrastDefaultColor': 'light',
            //     'contrastDarkColors': [
            //     '50',
            //     '100',
            //     '200',
            //     '300',
            //     '400',
            //     '500',
            //     '600',
            //     '700',
            //     '800',
            //     '900',
            //     'A100',
            //     'A200',
            //     'A400',
            //     'A700'
            // ],
            //     'contrastLightColors': []

        });

        $mdThemingProvider.definePalette('aadira-accent', {
            '50': 'fdf7e1',
            '100': 'faecb3',
            '200': 'f7df81',
            '300': 'f4d24f',
            '400': 'f1c829',
            '500': 'efbe03',
            '600': 'edb803',
            '700': 'ebaf02',
            '800': 'e8a702',
            '900': 'e49901',
            'A100': 'ffffff',
            'A200': 'fff1d8',
            'A400': 'ffdea5',
            'A700': 'ffd48b',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                '500',
                '600',
                '700',
                '800',
                '900',
                'A100',
                'A200',
                'A400',
                'A700'
            ],
            'contrastLightColors': []
        });
        $mdThemingProvider.definePalette('aadira-blue', {
            '50': 'e1f3fa',
            '100': 'b4e0f3',
            '200': '82cbeb',
            '300': '50b6e2',
            '400': '2ba7dc',
            '500': '0597d6',
            '600': '048fd1',
            '700': '0484cc',
            '800': '037ac6',
            '900': '0169bc',
            'A100': 'e5f2ff',
            'A200': 'b2d8ff',
            'A400': '7fbeff',
            'A700': '65b2ff',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': [
                '50',
                '100',
                '200',
                '300',
                '400',
                'A100',
                'A200',
                'A400',
                'A700'
            ],
            'contrastLightColors': [
                '500',
                '600',
                '700',
                '800',
                '900'
            ]
        });

        $mdThemingProvider.theme('indigo');
        $mdThemingProvider.theme('black');

        $mdThemingProvider.theme('awesome')
            .primaryPalette('awesomePalette', {
                'default': '500', // by default use shade 400 from the pink palette for primary intentions
                'hue-1': '100', // use shade 100 for the <code>md-hue-1</code> class
                'hue-2': '600', // use shade 600 for the <code>md-hue-2</code> class
                'hue-3': 'A100', // use shade A100 for the <code>md-hue-3</code> class,
            })
            .accentPalette('aadira-blue', {
                'default': '500',
                'hue-1': '100', // use shade9e630e 200 for default, and keep all other shades the same
                'hue-2': '900'
            })
            .warnPalette('red');

        $mdThemingProvider.setDefaultTheme('awesome');
        // $mdThemingProvider.enableBrowserColor({
        //     theme: 'boring', // Default is 'default'
        //     palette: 'blue', // Default is 'primary', any basic material palette and extended palettes are available
        // });

        $mdThemingProvider.alwaysWatchTheme(false);

    }
})();

/**
 * Created by kumardivyarajat on 09/09/17
 */
(function () {
    'use strict';

    runBlock.$inject = ["Base", "AuthManager", "$cookies", "$rootScope", "$anchorScroll", "$window", "$analytics"];
    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock(Base, AuthManager, $cookies, $rootScope, $anchorScroll, $window, $analytics) {
        Base.setConfData(confData);
        AuthManager.getCurrentUserAsync()
            .then(function (user) {
                if (user && !user.tempUser) {
                    var a = {};
                    if(confData.env === 'prod' && typeof FS !== 'undefined') {
                        FS.identify(user._id, {
                            displayName: user.name,
                            email: user.email
                        });
                    }
                    angular.copy(user, a);
                    delete a["x-access-token"];
                    delete a["x-refresh-token"];
                    delete a.profileImageURL;
                    $analytics.setAlias(a._id);
                    $analytics.setUsername(a.email);
                    $analytics.setUserProperties(a);
                }
                $rootScope.$emit("userSetup", user);
            })
            .catch(function (err) {
                console.log('Init err', err);
                if(err.code === 413) {
                    AuthManager.logout(true);
                }
            });
        $rootScope.pageMeta = {
            title: "Home",
            description: "",
            keywords: ""
        };


        var wrap = function (method) {
            var orig = $window.window.history[method];
            $window.window.history[method] = function () {
                var retval = orig.apply(this, Array.prototype.slice.call(arguments));
                document.getElementById("body").scrollTop = 0;
                $anchorScroll();
                return retval;
            };
        };
        wrap('pushState');
        wrap('back');
        wrap('replaceState');
    }
})();

/**
 * Created by kumardivyarajat on 09/09/17
 */
(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
    angular
        .module("app")
        .config(routeConfig);


    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {

        $stateProvider
            .state("app", {
                url: '',
                abstract: true,
                templateUrl: 'app/main/partials/base.html'
            })
            .state("app.home", {
                url: '/?ref',
                controller: "homeController",
                templateUrl: 'app/modules/home/home.tmpl.html'
            })
            .state("app.contest", {
                url: '/contest/spin-wheel?ref',
                controller: "contest.controller as conCtrl",
                templateUrl: 'app/modules/contests/partials/index.html'
            })
            .state("app.customisation", {
                url: '^/customisation',
                controller: "customisation.home.controller",
                templateUrl: 'app/modules/customisation/partials/home.html'
            })

            // .state("app.customisationProduct", {
            //     url: '^/customisation/product/:slug/:flags?',
            //     controller: "customisation.controller",
            //     templateUrl: 'app/modules/customisation/partials/single.html',
            //     resolve: {
            //         product: function ($stateParams, ProductsManager) {
            //             return ProductsManager.fetchSingleProduct($stateParams.slug);
            //         }
            //     }
            // })
            .state("app.customisationEditor", {
                url: '^/customisation/product/:slug/:ucSlug?/:flags?&RFX&RFID&RTYPE&layerData',
                controller: "customisation.controller",
                templateUrl: 'app/modules/customisation/partials/single.html',
                resolve: {
                    product: ["$stateParams", "ProductsManager", function ($stateParams, ProductsManager) {
                        console.log('$stateParams', $stateParams);
                        return ProductsManager.fetchSingleProduct($stateParams.slug);
                    }]
                },
                params: {
                    preview: null
                }
            })
            .state("app.cart", {
                url: '^/cart?fa&h',
                controller: "cartController",
                templateUrl: 'app/modules/cart/partials/cart.html'
            })
            .state("app.wishlist", {
                url: '^/wishlist',
                controller: "wishlist.controller",
                templateUrl: 'app/modules/wishlist/partials/wishlist.html'
            })
            .state("app.category", {
                url: '^/category/:categoryName?page&limit&sort&attributes&customisable',
                controller: "categoryController",
                templateUrl: 'app/modules/category/partials/category.html',
                params: {
                    collection: "false"
                }
            })
            .state("app.collection", {
                url: '^/collection/:categoryName?page&limit&sort&attributes',
                controller: "categoryController",
                templateUrl: 'app/modules/category/partials/category.html',
                params: {
                    collection: "true"
                }
            })
            .state("app.product", {
                /**
                 * RFX - User ID
                 * RFID - Post ID
                 * Rtype - 'post'
                 */
                url: "^/product/:productSlug?preview&RFX&RFID&RTYPE",
                controller: "productController",
                templateUrl: "app/modules/products/partials/product.html",
                params: {
                    product: null
                }
            })
            .state("app.search", {
                url: "^/search?q",
                controller: "app.main.search.Controller as ctrl",
                templateUrl: "app/modules/search/partials/index.html",
            })
            // .state("app.shipping", {
            //     url: '^/shipping',
            //     controller: "address.controller",
            //     templateUrl: 'app/modules/address/partials/shipping-information.html'
            // })
            .state("app.checkout", {
                url: '^/checkout?failed&orderNumber',
                controller: "checkout.controller",
                templateUrl: 'app/modules/checkout/partials/checkout.html',
                resolve: {
                    cart: ["CartManager", function (CartManager) {
                        return CartManager.getUserCart(true);
                    }]
                }
            })
            .state("app.profile", {
                url: '^/profile/:userName',
                controller: "profile.controller",
                templateUrl: 'app/modules/profile/profile.tmpl.html',
                params : {
                    scrollPosition : null
                }
            })
            .state("app.singlePost", {
                url: '^/post/:postId',
                controller: "post-viewer.controller",
                templateUrl: 'app/modules/profile/post-viewer/post-viewer.tmpl.html',
                resolve: {
                    postId: ["$stateParams", function ($stateParams) {
                        return $stateParams.postId;
                    }],
                    index : function () {
                        return null
                    },
                    posts : function () {
                        return null
                    },
                    backState : function () {
                        return null
                    },
                    backParams : function () {
                        return null
                    },
                    mode : function () {
                        return 'page'
                    }
                },
                params : {
                    scrollPosition : null
                }
            })
            .state("app.login", {
                url: '^/login?returnTo',
                templateUrl: 'app/modules/login/partials/login-page.html',
                params: {
                    returnTo: null,
                    reload: false
                }
            })
            .state("app.callback", {
                url: '^/callback/:platform?code',
                controller: "authCallbackCtrl",
                templateUrl: 'app/modules/login/partials/login-page.html',
                params: {
                    loading: true,
                    returnTo: null
                }
            })
            .state("app.account", {
                url: '^/account',
                abstract: true,
                controller: "account.controller",
                templateUrl: 'app/modules/account/partials/account-home.html'
            })
            .state("app.account.home", {
                url: '/home',
                controller: "account.home.controller",
                templateUrl: 'app/modules/account/partials/home.html'
            })
            .state("app.account.orders", {
                url: '/orders',
                controller: "orders.controller",
                templateUrl: 'app/modules/account/orders/partials/orders.html'
            })
            .state("app.account.giftCards", {
                url: '/gift-cards?openRedeem&h&c',
                controller: "giftCards.controller",
                templateUrl: 'app/modules/account/giftCards/giftCards.tmpl.html'
            })
            .state("app.account.singleOrder", {
                url: '/orders/:orderNum?askForReview&h',
                controller: "orders.details.controller",
                templateUrl: 'app/modules/account/orders/partials/details.html'
            })
            .state("app.account.quotations", {
                url: '/quotations',
                controller: "quotations.controller",
                templateUrl: 'app/modules/account/quotations/all/all.html'
            })
            .state("app.account.singleQuotation", {
                url: '/quotation/:slug?h',
                controller: "quotations.details.controller",
                templateUrl: 'app/modules/account/quotations/single/single.html'
            })
            .state("app.account.creations", {
                url: '/my-creations',
                controller: "creations.controller",
                templateUrl: 'app/modules/account/creations/partials/creations.html',
            })

            .state("app.account.thankyou", {
                url: '/orders/success/:orderNumber?payment_request_id&payment_id',
                controller: "thankyou.controller",
                templateUrl: 'app/modules/account/orders/partials/thank-you.html',
                resolve: {
                    order: ["OrdersManager", "$stateParams", function (OrdersManager, $stateParams) {
                        console.log("orderNumber", $stateParams.orderNumber);
                        return OrdersManager.fetchSingleOrder($stateParams.orderNumber);
                    }]
                }
            })
            .state("app.about_us", {
                url: '^/about-us',
                templateUrl: 'app/modules/static/partials/about-us.html',
                data: {
                    title: "About Us",
                    description: "About Aarida"
                }
            })
            .state("app.influencer_onboarding", {
                url: '^/influencer-onboarding',
                templateUrl: 'app/modules/static/influencer-onboarding/influencer-onboarding.tmpl.html',
                controller : 'influencer-onboarding',
                data: {
                    title: "Sign Up As Influencer",
                    description: "About Aarida"
                }
            })
            .state("app.promotions", {
                url: "/promotions",
                controller: "promotions.controller",
                templateUrl: 'app/modules/static/promotions/partials/promotion.tmpl.html',
            })
            .state("app.all_promotions", {
                url: "/all_promotions",
                controller: "allPromotions.controller",
                templateUrl: 'app/modules/static/promotions/partials/allPromotions.html',
            })

            // .state("app.privacy", {
            //     url: '^/privacy-policy',
            //     templateUrl: 'app/modules/static/partials/privacy-policy.html'
            // })
            // .state("app.shipping", {
            //     url: '^/shipping-and-returns',
            //     templateUrl: 'app/modules/static/partials/shipping-and-returns.html'
            // })
            .state("app.team", {
                url: '^/the-team',
                templateUrl: 'app/modules/static/partials/team.html'
            })
            .state("app.media", {
                url: '^/media',
                templateUrl: 'app/modules/static/partials/media.html'
            })
            .state("app.careers", {
                url: '^/careers',
                templateUrl: 'app/modules/static/partials/careers.html'
            })
            .state("app.how_it_works", {
                url: '^/process',
                templateUrl: 'app/modules/static/partials/how-it-works.html'
            })
            .state("app.contact_us", {
                url: '^/contact-us',
                templateUrl: 'app/modules/static/partials/contact_us.html'
            })
            // .state("app.terms", {
            //     url: '^/terms-and-conditions',
            //     templateUrl: 'app/modules/static/partials/terms.html'
            // })
            .state("app.faqs", {
                url: '^/faq',
                controller: 'faqCtrl',
                templateUrl: 'app/modules/static/partials/faqs.html'
            })
            .state("app.feed", {
                url: '^/feed',
                controller: 'feed.controller',
                templateUrl: 'app/modules/feed/feed.html'
            })
            .state("app.storeLocator", {
                url: '^/store-locator',
                controller: 'locatorCtrl',
                templateUrl: 'app/modules/static/partials/store-locator.html'
            })
            .state("app.static", {
                url: '^/:slug',
                templateUrl: 'app/modules/static/partials/index.html'
            })
            .state('app.404server', {
                templateUrl: 'app/main/partials/404.html'
            })
            .state('app.404client', {
                url: '*path',
                templateUrl: 'app/main/partials/404.html'
            });
        // .state("app.order");


        $urlRouterProvider.otherwise("/");
        $locationProvider.html5Mode(true);
    }


})();

/**
 * Created by kumardivyarajat on 09/09/17
 */
(function() {
    'use strict';

    angular
        .module('app');
})();

/**
 * Created by kumardivyarajat on 09/09/17
 */
(function () {
    'use strict';

    optionsConfig.$inject = ["$compileProvider", "$analyticsProvider", "$sceProvider", "$mdAriaProvider", "uiGmapGoogleMapApiProvider"];
    rollbarConfig.$inject = ["RollbarProvider"];
    angularSpinnerConfig.$inject = ["cfpLoadingBarProvider"];
    angular
        .module('app')
        .config(optionsConfig)
        .config(rollbarConfig)
        .config(angularSpinnerConfig);


    /** @ngInject */
    function optionsConfig($compileProvider, $analyticsProvider, $sceProvider, $mdAriaProvider, uiGmapGoogleMapApiProvider) {
        var debugInfo = true;
        var developerMode = true;

        if (confData.env === "prod") {
            debugInfo = false;
            developerMode = false;
        }
        $analyticsProvider.firstPageview(false);
        /* Records pages that don't use $state or $route */
        $analyticsProvider.withBase(false);
        // $analyticsProvider.virtualPageviews(false);
        /* Records full path */
        $analyticsProvider.trackExceptions(true);
        $sceProvider.enabled(false);
        $compileProvider.debugInfoEnabled(debugInfo);
        $analyticsProvider.developerMode(developerMode);
        $mdAriaProvider.disableWarnings();


        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyCqBtdUQ35_mCqdkAOk4XxmBwJOXYjL_ZE',
            v: '3.31' //defaults to latest 3.X anyhow
        });
    }

    /** @ngInject */
    function rollbarConfig(RollbarProvider) {

        if (confData.env === 'prod') {
            RollbarProvider.init({
                accessToken: "c9a2bd4cca60492799933bbb0ac466bf",
                captureUncaught: true,
                payload: {
                    environment: confData.env,
                    javascript: {
                        source_map_enabled: true, //this is now true by default
                        code_version: confData.version,
                        app_version: confData.version,
                        // Optionally have Rollbar guess which frames the error was thrown from
                        // when the browser does not provide line and column numbers.
                        guess_uncaught_frames: true
                    }
                }
            });
        }
    }

    function angularSpinnerConfig(cfpLoadingBarProvider) {
        cfpLoadingBarProvider.includeSpinner = false;
        cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
    }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/custom-measurement-dialog/measurements-dialog.html","<md-dialog flex-xs=\"80\" flex-sm=\"65\" flex-md=\"50\" flex-gt-lg=\"40\" layout=\"column\" class=\"openCustomMeasurementsDialog\" flex-gt-md=\"40\"><md-toolbar layout=\"row\" md-whiteframe=\"1\" class=\"md-toolbar-tools\" layout-align=\"center center\" ng-cloak=\"\"><span>Select Size</span> <span flex=\"\"></span><md-button ng-click=\"close();\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></md-toolbar><md-dialog-content><custom-measurement size-chart=\"sizeChart\" product=\"product\" uc-data=\"ucData\" return-data=\"returnData\" ctx=\"ctx\" variations=\"variations\" open-edit-view=\"openEditView\" on-added=\"onAddToCart(data)\" selected-variation=\"selectedVariation\" custom-measurement-data=\"customMeasurement\"></custom-measurement></md-dialog-content></md-dialog>");
$templateCache.put("app/main/partials/404.html","<div layout=\"\" layout-align=\"center start\" layout-padding=\"\" style=\"min-height: calc(100vh - 64px ); background-image: url(\'assets/images/not_found.svg\'); background-position: center center; background-size: 70%; background-repeat: no-repeat;\"><section layout=\"column\" layout-align=\"start center\" layout-padding=\"\" style=\"margin-bottom: 64px;\"><span ng-class=\"{\'md-display-2 \' : !isSmall, \'md-headline\' : isSmall}\" class=\"bold-text center-text\" style=\"letter-spacing: 3px; text-shadow: red 3px 1px;\">SEEMS LIKE YOU ARE LOST</span><md-button class=\"md-raised md-accent\" style=\"min-width: 200px;\" ui-sref=\"app.home({ref : \'404\'})\">Go Home</md-button></section></div>");
$templateCache.put("app/main/partials/base.html","<div layout=\"column\" layout-fill=\"\" ng-cloak=\"\"><md-toolbar class=\"toolbar header\" id=\"header\" md-whiteframe=\"1\" ng-style=\"{\'height\' : isSmall ? \'56px\' : \'64px\'}\" style=\"z-index: 5;\" ng-cloak=\"\" layout=\"column\"><div layout=\"column\" class=\"md-toolbar-tools\" flex=\"\" style=\"padding: 0;\"><section layout=\"\" layout-align=\"center center\" ng-style=\"{\'height\' : isSmall ? \'56px\' : \'64px\'}\" style=\"width: 100%;\"><md-button style=\"min-width: 60px; margin: 0;\" ng-click=\"open();\" ng-if=\"isSmall && !showSearchToolbar\" md-ink-ripple=\"\" hide-gt-sm=\"\" aria-label=\"open sidebar\" class=\"hamburger-icon\"><md-icon>menu</md-icon></md-button><back-button ng-if=\"isSmall && showSearchToolbar\"></back-button><div flex-gt-sm=\"15\" ng-if=\"!isSmall || (isSmall && !showSearchToolbar)\" flex=\"\" layout=\"\" layout-align-gt-sm=\"center center\" layout-align=\"start center\" class=\"pointer\" style=\"min-width: 79.8px;\" ng-style=\"{\'max-height\' : isSmall ? \'56px\' : \'64px\'}\"><img src=\"assets/images/aarida-optimized.png\" ui-sref=\"app.home\" ng-style=\"{\'height\' : \'50px\'}\"></div><div flex=\"\" ng-if=\"!isSmall && !showSearchToolbar && !parentCategories.length\"></div><div class=\"menu\" flex=\"\" layout=\"\" layout-align=\"center center\" ng-if=\"!isSmall && !showSearchToolbar && parentCategories.length\"><md-button role=\"button\" md-ink-ripple=\"false\" class=\"aarida-menu-btn\" ui-sref-active=\"active\" ui-sref=\"app.home\"><span class=\"nav-dot\"></span> <span class=\"md-caption title\">Home</span></md-button><md-button role=\"button\" md-ink-ripple=\"false\" ng-repeat=\"category in parentCategories\" ng-class=\"{active: checkState(category.slug)}\" class=\"menu-trigger-button aarida-menu-btn\" ui-sref=\"app.category({categoryName : category.slug, page : 1, limit : 24, sort : name, attributes : \'\'})\"><span class=\"md-caption title\">{{category.name}}</span> <span class=\"nav-dot\"></span></md-button><md-button role=\"button\" md-ink-ripple=\"false\" ng-class=\"{active: checkState(\'customisable_products\', \'app.collection\')}\" class=\"md-accent aarida-menu-btn\" ui-sref=\"app.collection({categoryName : \'customisable_products\'})\"><span class=\"nav-dot\"></span> <span class=\"md-caption title\">Design Your Own</span> <span class=\"badge\">NEW</span></md-button></div><div flex=\"\" layout=\"\" layout-align=\"center center\" ng-if=\"showSearchToolbar\" class=\"search-box-container\"><md-input-container md-no-float=\"\" flex=\"\" class=\"md-primary md-block no-error-spacer search-box\" md-theme=\"black\"><input ng-model=\"$parent.searchInput\" ng-model-options=\"{\'debounce\' : 50}\" ng-focus=\"\'true\'\" ng-change=\"searchTextChange($parent.searchInput);\" placeholder=\"Search for products here ...\"></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-if=\"!showSearchToolbar\" ng-click=\"switchState(true,\'app.search\');\"><md-icon>search</md-icon></md-button><md-button md-ink-ripple=\"\" class=\"md-icon-button\" ng-if=\"!showSearchToolbar\" aria-label=\"Wishlist\" ui-sref=\"app.wishlist\"><span ng-if=\"wishlist.products.length > 0\" md-colors=\"{\'background\' : \'awesome-accent-100-1\'}\" class=\"cart-info\">{{ wishlist.products.length }}</span><md-icon>favorite</md-icon><md-tooltip md-direction=\"bottom\">View Wishlist {{wishlist.products.length ? \'( \' + wishlist.products.length + \' products )\' : \'\' }}</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Cart\" ng-if=\"!showSearchToolbar\" ng-click=\"openCart()\"><span md-colors=\"{\'background\' : \'awesome-accent-100-1\'}\" ng-if=\"cart.products.length > 0\" class=\"cart-info\">{{ cart.products.length }}</span><md-icon>shopping_cart</md-icon><md-tooltip md-direction=\"bottom\">View Cart {{cart.products.length ? \'( \' + cart.products.length + \' products )\' : \'\' }}</md-tooltip></md-button><md-button class=\"md-accent md-raised\" hide-sm=\"\" hide-xs=\"\" ng-if=\"!isUserLoggedIn\" ng-click=\"openLoginModal($event);\" aria-label=\"User\"><md-icon>person</md-icon><span>Login/Register</span></md-button><md-menu md-offset=\"0 0\" hide-xs=\"\" hide-sm=\"\" ng-if=\"isUserLoggedIn\"><md-button style=\"border: 1px solid\" class=\"md-accent\" ng-click=\"openMenu($mdOpenMenu,$event);\" aria-label=\"User\"><div layout=\"row\" class=\"profile-menu small\" layout-align=\"center center\"><md-img md-src=\"{{currentUser.profileImageURL}}\"></md-img><div flex=\"\" layout=\"column\" layout-align=\"center center\" style=\"padding-left: 4px\"><span class=\"md-body-1\">{{ currentUser.name }}</span></div><md-icon>keyboard_arrow_down</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item ng-if=\"isUserLoggedIn\"><div layout=\"row\" class=\"profile-menu\" layout-align=\"center center\"><md-img md-src=\"{{currentUser.profileImageURL}}\"></md-img><div flex=\"\" layout=\"column\" layout-align=\"center center\" style=\"padding-left: 4px\"><span class=\"md-body-2\">{{ currentUser.name }}</span> <span class=\"md-caption\">{{ currentUser.email }}</span></div></div></md-menu-item><md-menu-item ng-if=\"isUserLoggedIn\"><div layout=\"row\" class=\"profile-menu\" md-colors=\"{\'color\' : \'accent-500-1\'}\" layout-align=\"start center\"><md-icon style=\"margin: 0\" md-colors=\"{\'color\' : \'accent-500-1\'}\">account_balance_wallet</md-icon><span>Wallet :</span><div layout=\"row\" class=\"profile-menu\" layout-align=\"center center\" ng-if=\"!fetchingPoints\"><img src=\"assets/images/rupee-indian.svg\" style=\"border: none; border-radius: 0; width: 12px; height: auto;\"> <span class=\"md-subhead\">{{ currentUser.points }}</span></div><md-progress-circular class=\"md-accent\" style=\"margin-left: 20px\" md-diameter=\"20\" ng-if=\"fetchingPoints\"></md-progress-circular></div></md-menu-item><md-menu-item ng-if=\"isUserLoggedIn\"><md-button ui-sref=\"app.account.home\">My Account</md-button></md-menu-item><md-menu-item ng-if=\"isUserLoggedIn\"><md-button ui-sref=\"app.account.giftCards\">My Gift Cards</md-button></md-menu-item><md-menu-item ng-if=\"isUserLoggedIn\"><md-button ui-sref=\"app.account.orders\">My Orders</md-button></md-menu-item><md-menu-item ng-if=\"isUserLoggedIn\"><md-button ng-click=\"logout();\">Logout</md-button></md-menu-item><md-menu-item ng-if=\"!isUserLoggedIn\"><md-button ng-click=\"openLoginModal($event);\">Login/Signup</md-button></md-menu-item></md-menu-content></md-menu></div></section></div><div class=\"refresh-loader\" layout=\"\" layout-align=\"center center\" ng-show=\"showRefreshLoader\"><section class=\"refresh-container\" md-whiteframe=\"6\"><md-progress-circular class=\"md-accent\" md-diameter=\"24\"></md-progress-circular></section></div></md-toolbar><md-sidenav class=\"md-sidenav-left\" md-disable-scroll-target=\"body\" md-component-id=\"left\" md-whiteframe=\"4\"><div ng-include=\"\'app/main/partials/mobile-menu.html\'\"></div></md-sidenav><md-sidenav class=\"md-sidenav-right\" md-disable-scroll-target=\"body\" md-component-id=\"cart\" md-whiteframe=\"4\"><div ng-include=\"\'app/modules/cart/partials/cart-sidenav.html\'\"></div></md-sidenav><md-content class=\"body transparentHeader\" layout=\"column\" id=\"body\" ng-class=\"{\'transform-none\' : isSmall}\" layout-align=\"start center\" ng-style=\"{\'margin-top\': transparentHeader ? \'-64px\' : \'0\'}\"><div ng-style=\"{\'width\' : !isSmall ? \'1440px\' : \'100%\', \'margin-bottom\' : hideFooter ? \'64px\' : \'0px\' }\" ui-view=\"\" ng-show=\"!loading\" class=\"main-section\"></div><div style=\"min-height: 80vh;\" ng-show=\"loading\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/aadira-logo.svg\" style=\"width: 200px;\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular></div><div static-include=\"app/main/partials/footer.html\" ng-if=\"!hideFooter\" style=\"width: 100%;\"></div></md-content></div><div class=\"eoss-poster pointer\" ng-class=\"{\'shown\' : showEoss}\"><md-button class=\"md-icon-button\" ng-click=\"hideEoss()\"><md-icon>close</md-icon></md-button><a ng-click=\"openLoginModal()\"><img src=\"assets/images/offers/40%25-off_small.jpg\" ng-click=\"hideEoss()\"></a></div><div ng-include=\"\'app/modules/login/partials/login-modal.html\'\"></div><div ng-include=\"\'app/modules/base/dialogs/update-dialog.html\'\"></div><script type=\"text/ng-template\" id=\"contest.dialog.html\"><md-dialog flex-xl=\"40\" flex-lg=\"60\" flex-md=\"60\" flex-sm=\"70\" flex-xs=\"90\"> <md-dialog-content class=\"relative\"> <md-button class=\"md-icon-button\" style=\"position: absolute; right: 8px; top: 8px;\" ng-click=\"cancel()\"> <md-icon class=\"white-text\">close</md-icon> </md-button> <img md-whiteframe=\"8\" src=\"assets/images/home/contest-artwork@2x.png\" alt=\"contest\"/> <div layout=\"column\" class=\"md-padding\" layout-align=\"start center\"> <h2 style=\"margin: 8px; padding: 0;\">Contest Alert !</h2> <h4 style=\"margin: 8px; padding: 0;\" class=\"md-subhead center-text\">Get a chance to win upto 50% off on all products.</h4> <span class=\"md-padding md-body-2 center-text\">Spin the wheel of fortune and avail discounts upto 50% off right away.</span> <md-button ng-click=\"cancel();\" ui-sref=\"app.contest({ref : \'homepage\'})\" class=\"md-raised md-accent\" style=\"border-radius: 32px; width: 150px;\"> <span>Try Now</span> </md-button> </div> </md-dialog-content> </md-dialog></script>");
$templateCache.put("app/main/partials/footer.html","<div layout=\"column\" style=\"z-index: 1;\" id=\"footer\"><section class=\"branding\" layout-gt-sm=\"row\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\" ng-style=\"{\'min-height\': isSmall ? \'450px\' : \'200px\'}\"><div flex=\"\" layout=\"column\" layout-align=\"center center\" class=\"section\"><img src=\"assets/images/home/003-security.svg\" style=\"width: 48px; height: 48px; margin-bottom:8px;\"> <span class=\"grey-text md-padding\" ng-class=\"{\'md-caption\' : !isSmall}\">100% Secure Payments</span> <span class=\"black-text md-subhead bold-text center-text\">All major credit cards and debit card accepted</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\" class=\"section\"><img src=\"assets/images/home/002-delivery-truck.svg\" style=\"width: 48px; height: 48px; margin-bottom:8px;\"> <span class=\"grey-text md-padding\" ng-class=\"{\'md-caption\' : !isSmall}\">Hassle-Free Delivery</span> <span class=\"black-text md-subhead bold-text center-text\">Blazing fast delivery and returns</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\" class=\"section\"><img src=\"assets/images/home/001-headphones.svg\" style=\"width: 48px; height: 48px; margin-bottom:8px;\"> <span class=\"grey-text md-padding\" ng-class=\"{\'md-caption\' : !isSmall}\">Customer Care Number</span> <span class=\"black-text md-subhead bold-text center-text\">080 4152 1574 (10.00 am to 10.00 pm)</span></div></section><section class=\"links\" layout-gt-sm=\"row\" layout=\"column\" layout-fill=\"\" layout-align=\"start start\" layout-padding=\"\" md-colors=\"{background: \'accent-50-0.1\'}\" style=\"padding-top: 40px;\" ng-style=\"{\'min-height\': isSmall ? \'450px\' : \'200px\'}\"><div flex-gt-sm=\"\" flex=\"50\" layout-fill=\"\" layout=\"column\" layout-align=\"start center\" flex-order-gt-sm=\"1\" flex-order=\"2\"><span class=\"md-subhead pointer\">{{\"Company\" | uppercase}}</span> <a class=\"md-link md-body-1 pointer\" ui-sref=\"app.about_us\">About Us</a> <a class=\"md-link md-body-1 pointer\" ui-sref=\"app.team\">Team</a> <a class=\"md-link md-body-1 pointer\" ui-sref=\"app.storeLocator\">Store Locator</a> <a class=\"md-link md-body-1 pointer\" ui-sref=\"app.static({slug : \'shipping-and-returns\'})\">Shipping & Returns</a></div><div flex-gt-sm=\"\" flex=\"50\" layout-fill=\"\" layout=\"column\" layout-align=\"start center\" flex-order-gt-sm=\"1\" flex-order=\"2\"><span class=\"md-subhead pointer\">{{\"Help\" | uppercase}}</span> <a class=\"md-link md-body-1 pointer\" ui-sref=\"app.careers\">Careers</a> <a class=\"md-link md-body-1 pointer\" ui-sref=\"app.faqs\">FAQs</a> <a class=\"md-link md-body-1 pointer\" ui-sref=\"app.contact_us\">Contact Us</a> <a class=\"md-link md-body-1 pointer\" ui-sref=\"app.influencer_onboarding\">Influencer</a></div><div flex-gt-sm=\"\" flex=\"50\" layout-fill=\"\" layout=\"column\" layout-align=\"center center\" flex-order-gt-sm=\"1\" flex-order=\"1\"><span class=\"md-subhead pointer\">{{\"Payment\" | uppercase}}</span><div layout=\"row\" flex=\"\"><img src=\"assets/images/mastercard.svg\" class=\"margin-2p\" style=\"margin:4px; width: 40px; height: 40px;\"> <img src=\"assets/images/visa.svg\" class=\"margin-2p\" style=\"margin:4px; width: 40px; height: 40px;\"> <img src=\"assets/images/credit-card.svg\" class=\"margin-2p\" style=\"margin:4px; width: 40px; height: 40px;\"></div></div><div flex-gt-sm=\"\" flex=\"50\" layout=\"column\" layout-fill=\"\" layout-align=\"center center\" flex-order-gt-sm=\"1\" flex-order=\"1\"><span class=\"md-subhead pointer\">{{\"Social\" | uppercase}}</span><div layout=\"\"><md-button target=\"_blank\" ng-href=\"https://www.facebook.com/AaridaIndia/\" class=\"md-icon-button\"><md-icon md-svg-src=\"assets/images/facebook.svg\"></md-icon><md-tooltip>Facebook</md-tooltip></md-button><md-button target=\"_blank\" ng-href=\"https://www.instagram.com/aaridafashion/\" class=\"md-icon-button\"><md-icon md-svg-src=\"assets/images/instagram.svg\"></md-icon><md-tooltip>Instagram</md-tooltip></md-button><md-button target=\"_blank\" ng-href=\"https://twitter.com/AaridaIndia\" class=\"md-icon-button\"><md-icon md-svg-src=\"assets/images/twitter.svg\"></md-icon><md-tooltip>Twitter</md-tooltip></md-button></div></div></section><section class=\"accreditation\" style=\"min-height: 44px;\" layout=\"row\" layout-fill=\"\" layout-padding=\"\" layout-align=\"center center\"><div><p class=\"md-caption\">Made with <span class=\"red-text\">♥</span>in India</p></div><div flex=\"\"></div><div layout-gt-sm=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-padding=\"\" class=\"footer-lbinks\"><a class=\"md-link md-caption\" ui-sref=\"app.static({slug : \'terms-and-conditions\'})\">Terms and Conditions</a> <a class=\"md-link md-caption\" ui-sref=\"app.static({slug : \'privacy-policy\'})\">Privacy Policy</a> <a class=\"md-link md-caption\" ui-sref=\"app.static({slug : \'shipping-and-returns\'})\">Shipping and Returns</a></div><span class=\"hidden\">Icon made by Freepik from www.flaticon.com</span></section></div>");
$templateCache.put("app/main/partials/mobile-menu.html","<div layout=\"column\" id=\"mobile-menu\"><header flex=\"\" layout-fill=\"\" layout=\"column\" layout-align=\"end end\" style=\"background: url(\'assets/images/bg/pattern.png\') center; background-size: cover; height: 180px; min-height: 180px; max-height: 180px;\"><span flex=\"\"></span><section layout=\"row\" style=\"width: 100%; background: rgba(1,1,1,0.5); padding: 8px;\"><md-menu-bar ng-if=\"isUserLoggedIn\" layout=\"\"><md-menu><md-button class=\"md-no-focus\" ng-click=\"$mdOpenMenu($event)\" layout=\"row\" layout-align=\"center center\" style=\"min-height: 56px; width: 240px;\"><md-img class=\"avatar\" md-src=\"{{currentUser.profileImageURL}}\"></md-img><div layout=\"column\" flex=\"\" layout-align=\"center start\" style=\"margin-left: 16px\"><span class=\"md-caption white-text capitalize\" style=\"line-height: 24px\">{{ currentUser.name }}</span> <span class=\"md-caption white-text\" style=\"line-height: 24px\" ng-if=\"!currentUser.virtualMobile && currentUser.mobile\">{{ currentUser.mobile }}</span> <span class=\"md-caption white-text\" style=\"line-height: 24px\" ng-if=\"currentUser.virtualMobile && currentUser.email\">{{ currentUser.email }}</span></div><md-icon class=\"white-text\">keyboard_arrow_down</md-icon></md-button><md-menu-content width=\"4\"><md-menu-item ng-if=\"isUserLoggedIn\" style=\"height: 56px; line-height: 56px;\"><div layout=\"row\" class=\"profile-menu\" layout-align=\"center center\"><md-icon style=\"margin: 0\">account_balance_wallet</md-icon><span>Wallet :</span><div layout=\"row\" class=\"profile-menu\" layout-align=\"center center\" ng-if=\"!fetchingPoints\"><img src=\"assets/images/rupee-indian.svg\" style=\"border: none; border-radius: 0; width: 12px; height: auto;\"> <span class=\"md-subhead\">{{ currentUser.points }}</span></div><md-progress-circular class=\"md-accent\" style=\"margin-left: 20px\" md-diameter=\"20\" ng-if=\"fetchingPoints\"></md-progress-circular></div></md-menu-item><md-menu-item ng-if=\"isUserLoggedIn\" style=\"height: 44px; line-height: 44px;\"><md-button ng-click=\"navigate(\'app.account.home\')\">My Account</md-button></md-menu-item><md-menu-item ng-if=\"isUserLoggedIn\" style=\"height: 44px; line-height: 44px;\"><md-button ng-click=\"navigate(\'app.account.giftCards\')\">My Gift Cards</md-button></md-menu-item><md-menu-item ng-if=\"isUserLoggedIn\" style=\"height: 44px; line-height: 44px;\"><md-button ng-click=\"navigate(\'app.account.orders\')\">My Orders</md-button></md-menu-item><md-menu-item ng-if=\"isUserLoggedIn\" style=\"height: 44px; line-height: 44px;\"><md-button ng-click=\"logout();\">Logout</md-button></md-menu-item><md-menu-item ng-if=\"!isUserLoggedIn\"><md-button ng-click=\"openLoginModal($event);\">Login/Signup</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-button flex-offset=\"30\" class=\"md-raised md-accent\" ng-click=\"openLoginModal();\" ng-if=\"!isUserLoggedIn\">Login/SignUp</md-button></section></header><md-content layout=\"column\" layout-fill=\"\" layout-align=\"start start\" style=\"min-height: calc(100vh - 180px)\"><md-list flex=\"\" layout=\"column\" layout-fill=\"\" layout-align=\"start start\"><md-list-item layout-fill=\"\" layout-align=\"start start\" ng-click=\"navigate(\'app.home\', {});\" style=\"height: 56px;\"><div flex=\"\" layout=\"row\"><span class=\"\" flex=\"\" style=\"margin-left: 10px\">Home</span></div></md-list-item><md-divider style=\"width: 100%; height: 1px;max-height: 1px;\" flex=\"\"></md-divider><md-list-item layout-fill=\"\" class=\"badged-button\" ng-click=\"navigate(\'app.collection\', {categoryName : \'customisable_products\'});\" layout-align=\"start start\" style=\"height: 56px;\"><div flex=\"\" layout=\"row\"><span flex=\"\" style=\"margin-left: 10px\">Design Your Own</span> <span class=\"badge\">NEW</span></div></md-list-item><md-divider style=\"width: 100%; height: 1px;max-height: 1px;\" flex=\"\"></md-divider><md-list-item ng-repeat-start=\"category in parentCategories\" layout-fill=\"\" layout-align=\"start start\" ng-click=\"navigate(\'app.category\', {categoryName : category.slug, page : 1, limit : 24, attributes : \'\'});\" style=\"height: 56px;\"><div flex=\"\" layout=\"row\"><span class=\"\" flex=\"\" style=\"margin-left: 10px\">{{ category.name }}</span></div></md-list-item><md-divider style=\"width: 100%; height: 1px;max-height: 1px;\" flex=\"\" ng-repeat-end=\"\"></md-divider></md-list><div class=\"add-to-home-screen-section\" layout=\"row\" layout-align=\"start center\"><div class=\"install-icon\"><md-icon>add_to_home_screen</md-icon></div><section layout=\"column\" class=\"content\"><span class=\"montserrat bold-text md-body-1\">Install Webapp</span> <span class=\"md-caption\">Under 0.2 mb in size. App like experience. Offline support.</span><md-button class=\"md-primary install-btn\" ng-click=\"installHomeScreen()\"><div layout=\"\" layout-align=\"center center\"><span>Install</span></div></md-button></section></div></md-content><div></div></div>");
$templateCache.put("app/main/partials/sizeChart.html","<div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"sizeChartDialog\"><md-dialog layout=\"column\" class=\"sizeChartDialog\"><md-toolbar layout=\"row\" md-whiteframe=\"1\" class=\"md-toolbar-tools\" layout-align=\"center center\" ng-cloak=\"\"><span>Size Chart</span> <span flex=\"\"></span><md-button ng-click=\"cancel();\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></md-toolbar><div ng-cloak=\"\" flex=\"\" layout=\"row\" class=\"content md-padding\"><table md-table=\"\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\" md-numeric=\"\" ng-repeat=\"size in product.sizeChart.values.values.charts\"><span class=\"md-caption\">{{size.key}}</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"value in product.sizeChart.values.values.charts[0].values\" ng-init=\"key = value.key; parent = $index\"><td md-cell=\"\"><span class=\"md-caption\">{{value.key}}</span></td><td md-cell=\"\" ng-repeat=\"size in product.sizeChart.values.values.charts\"><span>{{findValue(size, $index, parent, key);}}</span></td></tr></tbody></table></div></md-dialog></div></div>");
$templateCache.put("app/main/partials/toast-template.html","<md-toast><span class=\"md-toast-text\" flex=\"\">Welcome Back {{currentUser.name}}</span></md-toast>");
$templateCache.put("app/modules/feed/feed.html","<div class=\"feed-page\"><h1 class=\"md-headline bold-text title center-text\">Aarida Feed</h1><p class=\"md-subhead subtitle center-text\">Explore the top posts by our community members</p><div class=\"aarida-feed\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div layout=\"column\" layout-align=\"center center\"><md-grid-list class=\"full-width\" md-cols=\"2\" md-cols-gt-md=\"12\" md-cols-md=\"8\" md-gutter=\"4px\" md-gutter-gt-md=\"4px\" md-gutter-md=\"4px\" md-row-height=\"3:4\" md-row-height-gt-md=\"3:4\"><md-grid-tile class=\"single-post pointer\" md-colspan-gt-sm=\"2\" md-ink-ripple=\"#efefef\" md-rowspan-gt-sm=\"2\" ng-click=\"openPost($event, post, $index)\" ng-repeat=\"post in posts\" ng-style=\"{\'backgroundImage\' : \'url(\' + mediaUrl + post.image.urls[post.key] + \')\'}\"><md-grid-tile-footer class=\"post-user\" layout=\"\" layout-align=\"start center\"><profile-image image-url=\"{{post.user.profileImageURL}}\" ng-click=\"$event.stopPropagation()\" small=\"true\" user-name=\"{{post.user.userName}}\"></profile-image><a class=\"montserrat md-body-1 profile-name\" ng-class=\"{\'md-caption\' : isSmall, \'md-body-1\' : !isSmall}\" ng-click=\"$event.stopPropagation()\" ui-sref=\"app.profile({userName : post.user.userName})\">{{post.user.name}}</a></md-grid-tile-footer></md-grid-tile></md-grid-list><div id=\"infinite-load-trigger\" layout=\"\" layout-align=\"center center\"></div><div layout=\"\" layout-align=\"center start\" layout-margin=\"\" layout-padding=\"\" ng-if=\"fetchingFeed\"><md-progress-circular class=\"md-accent\" md-diameter=\"36\" md-mode=\"query\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/modules/home/home.tmpl.html","<section id=\"home\"><div layout=\"column\" class=\"relative\"><div ng-repeat=\"widget in widgets\" ng-if=\"!loadingHomepage\"><md-image-slider ng-if=\"widget.type === \'slider\'\" ng-class=\"widget.classes\" aspect-ratio=\"widget.aspectRatio\" auto-play=\"widget.options.autoPlay\" controls=\"widget.options.controls\" flex=\"100\" full-link=\"widget.options.fullLink\" interval=\"widget.options.interval\" overlay=\"widget.options.overlay\" src-list=\"widget.objects\"></md-image-slider><section ng-if=\"widget.type === \'column-banner\'\" layout=\"\" layout-wrap=\"\"><a ng-class=\"widget.classes\" ng-repeat=\"object in widget.objects\" ng-href=\"{{object.url}}\"><img md-preload=\"\" width=\"widget.width\" height=\"widget.height\" md-src=\"object.image\" item-index=\"$index\" final-height=\"\'100%\'\" key=\"{{object.key}}\" staged-key=\"h_mediumStaged\"></a></section></div><div class=\"widgets-loader\" ng-if=\"loadingHomepage\" layout=\"column\" layout-align=\"center center\"><h3 class=\"center-text md-title\">Introducing <span class=\"allura md-display-1\">Aarida</span></h3><h5 class=\"center-text\" style=\"line-height: 1.5em\">India\'s premier<br>Customisable Clothing Store</h5><md-progress-circular md-diameter=\"24\" class=\"md-accent\"></md-progress-circular><p class=\"md-subhead\">Loading your experience ...</p></div><customisation-notification hide-notification-section=\"true\"></customisation-notification><section layout=\"column\" class=\"relative\" flex-order=\"1\" ng-if=\"featuredCollections && collection.products.length > 0\" ng-repeat=\"collection in featuredCollections | orderBy : \'-createdAt\'\"><md-card md-whiteframe=\"-1\" style=\"margin: 0; padding: 0;\"><md-toolbar><div layout-xs=\"column\" layout-sm=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"center center\" layout-align=\"center center\" class=\"md-padding md-toolbar-tools\"><span ng-class=\"{\'odd\' : $odd}\" class=\"md-title montserrat center-text bold-text\">{{collection.name | uppercase}}</span></div></md-toolbar><md-divider></md-divider><md-card-content><div class=\"catalog md-padding\" ng-if=\"!collection.fetchingProducts && collection.products.length > 0\" ng-class=\"{\'md-margin\' : !isSmall}\" layout=\"\" layout-wrap=\"\" layout-align=\"space-around stretch\"><a ng-href=\"{{getLinkUrl(product)}}\" id=\"{{\'product-card-\' + $index}}\" ng-repeat=\"product in collection.products | limitTo : 4\" layout=\"\" flex-lg=\"17\" flex-gt-md=\"20\" flex-gt-xs=\"20\" flex=\"50\"><md-card ng-style=\"{\'border\' : isSmall ? \'0.5px solid rgba(211, 211, 211, 0.38)\' : \'none\'}\" style=\"position: relative\" flex=\"\" ng-class=\"{\'no-margin no-box-shadow\' : isSmall}\"><img item-index=\"$index\" md-preload=\"\" md-src=\"product.gallery[0]\" key=\"medium\"><div style=\"position: absolute; right: 0px; top: 0px; width: 100%;\" layout=\"\" ng-init=\"product.inWishlist = checkIfProductIsInWishlist(product._id);\"><span class=\"md-caption\" ng-if=\"checkIfNew(product.createdAt)\" style=\"margin: 8px; font-weight: bold; padding: 4px 8px; color: white; background: #a5382a;\">NEW</span> <span flex=\"\"></span></div><md-divider></md-divider><md-card-footer-text layout=\"column\" layout-padding=\"\"><span class=\"montserrat\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-tiny\' : isSmall}\">{{getProperName(product.name);}}</span> <span class=\"green-text bold-text\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\" style=\"font-weight: 600;\">Rs. {{product.price}}</span></md-card-footer-text></md-card></a><div layout=\"column\" layout-align=\"center center\" flex-lg=\"17\" flex-gt-md=\"10\" flex-gt-xs=\"10\" flex=\"50\"><md-button class=\"md-fab\" ui-sref=\"app.collection({categoryName : collection.slug})\"><md-icon>open_in_new</md-icon></md-button><span class=\"md-caption grey-text\">View all</span></div></div></md-card-content></md-card></section><div flex-order=\"2\" flex-order-gt-sm=\"1\"><customisation-process></customisation-process></div><div flex-order=\"2\" flex-order-gt-sm=\"1\" class=\"aarida-feed\"><div layout=\"column\" layout-align=\"center center\"><h2 class=\"md-headline bold-text title\">Aarida Feed</h2><p class=\"md-subhead subtitle\">Explore the top posts by our community members</p><md-grid-list class=\"full-width\" md-cols-gt-md=\"12\" md-cols=\"2\" md-cols-md=\"8\" md-row-height-gt-md=\"3:4\" md-row-height=\"3:4\" md-gutter-gt-md=\"4px\" md-gutter-md=\"4px\" md-gutter=\"4px\"><md-grid-tile class=\"single-post pointer\" md-ink-ripple=\"#efefef\" ng-repeat=\"post in posts\" ng-click=\"openPost($event, post, $index)\" ng-style=\"{\'backgroundImage\' : \'url(\' + mediaUrl + post.image.urls[post.key] + \')\'}\" md-colspan-gt-sm=\"2\" md-rowspan-gt-sm=\"2\"><md-grid-tile-footer class=\"post-user\" layout=\"\" layout-align=\"start center\"><profile-image small=\"true\" user-name=\"{{post.user.userName}}\" ng-click=\"$event.stopPropagation()\" image-url=\"{{post.user.profileImageURL}}\"></profile-image><a ui-sref=\"app.profile({userName : post.user.userName})\" class=\"montserrat md-body-1 profile-name\" ng-click=\"$event.stopPropagation()\" ng-class=\"{\'md-caption\' : isSmall, \'md-body-1\' : !isSmall}\">{{post.user.name}}</a></md-grid-tile-footer></md-grid-tile></md-grid-list><div layout=\"\" layout-align=\"center center\" layout-margin=\"\"><md-button class=\"md-raised md-accent\" ui-sref=\"app.feed\">Discover more posts</md-button></div></div></div><section class=\"blog-posts-section\" layout=\"column\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div layout=\"\" layout-align=\"center center\"><h2 class=\"md-headline bold-text\">From Our Blog</h2></div><div ng-if=\"!fetchingBlogPosts && !blogPostError\" layout=\"\" layout-xs=\"column\" layout-wrap=\"\" class=\"list-container\"><section ng-repeat=\"post in blogPosts\" class=\"single-blog-post\" flex=\"33\" flex-xs=\"100\"><div back-src=\"{{post.feature_image}}\"></div><p class=\"published-date grey-text md-caption\">{{post.published_at | date: \'mediumDate\'}}</p><h3 class=\"blog-title\">{{post.title}}</h3><a class=\"next-link\" target=\"_blank\" ng-href=\"{{post.url}}\">Read More<md-icon>arrow_right_alt</md-icon></a></section></div><div layout=\"\" layout-align=\"center center\" ng-if=\"fetchingBlogPosts\"><md-progress-circular class=\"md-accent\" md-diameter=\"36\"></md-progress-circular></div><div ng-if=\"blogPostError\" layout=\"column\" layout-align=\"center center\"><p>Error Fetching Blog Posts</p><md-button class=\"md-accent\"><md-icon>refresh</md-icon>Retry</md-button></div></section><section flex-order=\"2\" flex-order-gt-sm=\"1\" layout=\"column\" layout-align=\"center center\" class=\"md-padding\"><instagram-section on-error=\"errorReporter(err, context);\"></instagram-section></section></div></section>");
$templateCache.put("app/modules/profile/profile.tmpl.html","<div class=\"profile-page\"><section ng-if=\"!fetchingProfile && !fetchProfileError\"><section class=\"profile-header\" layout=\"\" layout-align=\"center center\"><div class=\"profile-cover\"></div><div layout=\"\" class=\"profile-card\"><div layout=\"\" layout-align=\"end center\"><profile-image large=\"true\" image-url=\"{{user.profileImageURL}}\"></profile-image></div><div flex=\"\" layout=\"column\" layout-align=\"center start\" flex-offset=\"10\"><h3 class=\"user-name\">{{user.name}}</h3><p class=\"name\">@{{user.userName}}</p><md-button class=\"small follow-button md-accent\" ng-class=\"{\'md-raised\' : user.isFollowing, \'outline\' : !user.isFollowing}\" ng-click=\"followAction()\"><md-icon>{{user.isFollowing ? \'check_circle\' : \'add\'}}</md-icon>{{user.isFollowing ? \'Following\' : \'Follow\'}}</md-button></div></div></section><div layout=\"\" layout-align=\"center center\" ng-if=\"user.bio\" class=\"user-bio-container\"><p class=\"user-bio\">{{user.bio}}</p></div><div layout=\"\" layout-align=\"center center\" class=\"user-actions\"><md-button ng-if=\"user.instagramProfile\" class=\"md-accent md-icon-button medium\" target=\"_blank\" ng-href=\"{{user.instagramProfile}}\"><md-icon md-svg-src=\"assets/images/instagram.svg\"></md-icon><md-tooltip>View Instagram Profile</md-tooltip></md-button><md-button ng-if=\"user.facebookProfile\" class=\"md-accent md-icon-button medium\" target=\"_blank\" ng-href=\"{{user.facebookProfile}}\"><md-icon md-svg-src=\"assets/images/facebook.svg\"></md-icon><md-tooltip>View Facebook Profile</md-tooltip></md-button><md-button ng-if=\"user.youtubeProfile\" class=\"md-accent md-icon-button medium\" target=\"_blank\" ng-href=\"{{user.youtubeProfile}}\"><md-icon md-svg-src=\"assets/images/youtube.svg\"></md-icon><md-tooltip>View Youtube Profile</md-tooltip></md-button><md-button ng-if=\"user.website\" class=\"md-accent md-icon-button medium\" target=\"_blank\" ng-href=\"{{user.website}}\"><md-icon>language</md-icon><md-tooltip>View Website</md-tooltip></md-button></div><md-divider></md-divider><md-content class=\"profile-content\" md-theme=\"black\"><md-tabs md-selected=\"selectedIndex\" md-center-tabs=\"\" md-dynamic-height=\"\" md-stretch-tabs=\"{{isSmall ? \'always\' : \'auto\'}}\" md-border-bottom=\"\"><md-tab md-on-select=\"onTabSelected(tab)\" md-on-deselect=\"announceDeselected(tab)\"><md-tab-label>Feed</md-tab-label><md-tab-body><div layout=\"\" layout-wrap=\"\"><section class=\"single-post\" ng-repeat=\"post in posts\" ng-if=\"posts.length && !fetchingFeed\" flex=\"20\" flex-xs=\"33\" flex-sm=\"33\" flex-md=\"20\"><md-card class=\"post-card relative pointer\" md-ink-ripple=\"#efefef\" ng-click=\"openPost($event, post, $index)\"><img md-preload=\"\" md-src=\"post.image\" key=\"{{isSmall ? \'thumbnail\' : \'medium\'}}\" class=\"md-card-image post-image\"></md-card></section><div layout=\"column\" layout-align=\"center center\" class=\"no-posts\" ng-if=\"!posts.length && !fetchingFeed\"><img src=\"assets/images/profile/no-posts.svg\"><p>No Posts Yet</p><md-button md-theme=\"black\" class=\"md-raised md-accent round medium padding-horizontal\" ui-sref=\"app.category({categoryName : \'all\'})\">Check Other Feeds</md-button></div><div layout=\"column\" layout-align=\"center center\" class=\"loading-posts\" ng-if=\"fetchingFeed\"><md-progress-circular md-theme=\"black\" class=\"md-accent\"></md-progress-circular><p>Fetching User Feed...</p></div><div class=\"suggested-profile-section\"><h4 class=\"montserrat center-text\">Suggested Profiles for you</h4><md-content md-scroll-x=\"\" class=\"suggested-profiles-list\"><section layout=\"\"><div class=\"suggested-profile\" ng-repeat=\"profile in similarUsers\" layout=\"column\" layout-align=\"start center\"><profile-image user-name=\"{{profile.userName}}\" image-url=\"{{profile.profileImageURL}}\"></profile-image><span class=\"md-caption profile-name md-truncate\">{{profile.name}}</span><md-button class=\"outline small\" ng-click=\"scrollBy(-1000, 500)\" ui-sref=\"app.profile({userName : profile.userName})\">Visit Profile</md-button></div></section></md-content></div></div></md-tab-body></md-tab><md-tab md-on-select=\"onTabSelected(tab)\" md-on-deselect=\"announceDeselected(tab)\"><md-tab-label>Products</md-tab-label><md-tab-body><div layout=\"\" layout-wrap=\"\" ng-if=\"products.length\"><a md-ink-ripple=\"\" target=\"_blank\" class=\"product-card\" ui-sref=\"app.product({productSlug: product.slug, product: product})\" ng-repeat=\"product in products\" flex-xs=\"50\" flex-sm=\"33\" flex-md=\"33\" flex-lg=\"25\"><md-card class=\"influencer-image no-margin no-box-shadow relative\"><img md-preload=\"\" md-src=\"product.featured_image\" key=\"large\" class=\"md-card-image\"><p class=\"md-caption md-truncate center-text\">{{product.name}}</p><span class=\"md-body-1 center-text\">₹ {{product.price}}</span></md-card></a></div><div layout=\"column\" layout-align=\"center center\" class=\"no-products\" ng-if=\"!products.length\"><img src=\"assets/images/profile/no-products.svg\"><p>No Promoted Products Found</p><md-button md-theme=\"black\" class=\"md-raised md-accent round medium padding-horizontal\" ui-sref=\"app.category({categoryName : \'all\'})\">Shop All Products</md-button></div></md-tab-body></md-tab></md-tabs></md-content></section><div ng-if=\"!fetchingProfile && fetchProfileError\" layout-fill=\"\" flex=\"\" style=\"min-height: 40vh;\" layout=\"column\" layout-align=\"center center\" layout-margin=\"\"><img src=\"assets/images/error.svg\" style=\"width: 200px\"><h4 class=\"center-text grey-text\">{{fetchProfileError}}</h4></div><div ng-if=\"fetchingProfile\" class=\"full-page\" layout-fill=\"\" layout=\"\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\"></md-progress-circular></div></div>");
$templateCache.put("app/modules/account/giftCards/giftCards.tmpl.html","<div layout=\"column\" flex-gt-sm=\"80\" flex-offset-gt-sm=\"10\" class=\"gift-card-page\"><h1 class=\"center-text\">Gift Cards</h1><h4 class=\"center-text no-margin no-padding\" ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\">Check all your gift cards | Redeem a gift Card</h4><div layout=\"\" layout-align=\"end center\" class=\"md-padding\" ng-if=\"cards.length\"><md-button class=\"md-accent md-padding aarida-stroked-button\" ng-click=\"openRedeemModal($event)\"><md-icon>add</md-icon><span>Redeem Gift Card</span></md-button></div><div layout=\"\" layout-wrap=\"\" ng-if=\"cards.length\" class=\"gift-cards-container\" layout-align=\"stretch center\"><section flex-gt-md=\"33\" flex-sm=\"50\" flex-xs=\"100\" ng-repeat=\"card in cards\"><md-card class=\"gift-card\" ng-class=\"{\'pointer dummy-card\' : card.code === \'dummy\'}\" ng-click=\"openRedeemModal($event, card)\"><div class=\"bg-energy\" ng-show=\"card.code !== \'dummy\'\"></div><md-card-content ng-if=\"card.code !== \'dummy\'\"><div layout=\"\" layout-align=\"space-between center\"><span class=\"md-caption white-text\">Valid Till : {{card.expiryDate | date: \'mediumDate\'}}</span> <img src=\"assets/images/aarida-logo-white.png\" class=\"logo\" alt=\"logo\"></div><div layout=\"column\" layout-align=\"center start\"><p class=\"bold-text card-number\">{{card.code}}</p><span class=\"md-subhead white-text\">₹ <span class=\"gift-card-balance\">{{card.balance}}</span></span></div></md-card-content><md-card-content ng-if=\"card.code === \'dummy\'\" layout=\"column\" layout-align=\"center center\"><div class=\"add-icon\"><md-icon>add</md-icon></div><span class=\"redeem-text\">Redeem Gift Card</span></md-card-content></md-card></section></div><section flex=\"\" ng-if=\"!cards.length\" layout=\"column\" layout-align=\"center center\" class=\"empty-state\"><img src=\"assets/images/gift-cards/gift-card.svg\" alt=\"gift card image\"><p class=\"md-padding center-text\" ng-class=\"{\'md-caption\' : isSmall}\">No gift cards associated with your account yet</p><md-button class=\"md-accent md-padding aarida-stroked-button\" ng-click=\"openRedeemModal($event)\"><md-icon>add</md-icon><span>Redeem Gift Card</span></md-button></section></div><div static-include=\"app/modules/account/giftCards/redeem-success-dialog.html\"></div>");
$templateCache.put("app/modules/account/giftCards/redeem-gift-card.dialog.tpl.html","<div class=\"md-dialog-container\" id=\"addressDialog\"><md-dialog flex=\"50\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\"><h2 class=\"bold-text\" style=\"padding-top: 0;\">Redeem Gift Card</h2><span flex=\"\"></span><md-button class=\"md-icon-button md-accent\" ng-click=\"close()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><form name=\"giftCardForm\" ng-cloak=\"\"><md-dialog-content class=\"gift-card-form\"><div class=\"md-dialog-content\"><div layout=\"column\" layout-align=\"stretch center\"><div class=\"gift-card-illustration\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><img src=\"assets/images/gift-cards/gift-card-outline.svg\" alt=\"gift-card-outline\"><div layout=\"column\" layout-align=\"center start\" class=\"md-padding info\"><h3 ng-class=\"{\'center-text\' : isSmall}\" class=\"title-text\">How to find Gift Card Code?</h3><span class=\"arrow\"></span><p class=\"info-text\">Look for the 16 digit code in the front of your Gift Card and enter the code below. The gift card code looks something like <span class=\"bold-text\">A1A1-I9I9-B2B2-C3C3</span>.</p></div></div><div layout=\"column\" layout-align=\"center center\" class=\"input-container\"><md-input-container class=\"md-block md-primary input-box\" md-theme=\"black\"><label>Enter Gift Card Code</label> <input ng-change=\"applyFilter()\" ng-disabled=\"generatingPin || redeemingCard || pinGenerated\" required=\"\" ng-model=\"newCard.code\" autocomplete=\"code\" md-maxlength=\"19\" md-minlength=\"19\"></md-input-container><md-input-container class=\"md-block md-primary\" md-theme=\"black\" ng-if=\"pinGenerated\"><label>Enter 6 digit PIN</label> <input ng-change=\"removeError()\" id=\"card-pin\" type=\"number\" required=\"\" ng-disabled=\"generatingPin || redeemingCard\" ng-model=\"newCard.pin\" autocomplete=\"code\" ng-maxlength=\"6\" ng-minlength=\"6\" md-maxlength=\"6\" md-minlength=\"6\"></md-input-container><p class=\"red-text center-text md-caption\">{{formError}}</p></div><div ng-if=\"pinGenerated\" layout=\"column\" layout-align=\"center center\"><a class=\"md-link pointer\" ng-click=\"resetForm()\">Change gift card code</a><p class=\"md-caption\" ng-class=\"{\'center-text\' : isSmall}\">6 digit pin sent to your mobile number +91-{{currentUser.mobile}}</p><span>Didn\'t receive the pin?</span><md-button ng-click=\"generatePin()\" ng-disabled=\"generatingPin\">Regenerate PIN</md-button></div></div></div></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"end center\" md-colors=\"{\'background\' : \'accent-50-0.2\'}\"><md-button class=\"md-raised md-accent\" ng-click=\"submit();\" ng-disabled=\"generatingPin || redeemingCard || giftCardForm.$invalid\"><div layout=\"\" layout-align=\"center center\"><div layout=\"\" layout-align=\"space-between center\" ng-if=\"!generatingPin && !redeemingCard\"><span>{{pinGenerated ? \'Redeem Gift Card\' : \'Next\'}}</span><md-icon>keyboard_arrow_right</md-icon></div><md-progress-circular class=\"md-accent\" md-diameter=\"20\" ng-if=\"generatingPin || redeemingCard\"></md-progress-circular></div></md-button></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/modules/account/giftCards/redeem-success-dialog.html","<div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"redeemSuccessDialog\"><md-dialog flex-gt-md=\"50\" flex=\"75\" layout=\"column\" class=\"redeemSuccessDialog\"><md-button class=\"md-icon-button dialog-static-close-button\" ng-click=\"close()\"><md-icon>close</md-icon></md-button><div class=\"header-section\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/gift-cards/gift-card-redeemed.svg\" alt=\"Gift Card Redemption Success\"> <span class=\"success-text md-headline bold-text md-padding center-text\">Gift Card Redeemed Successfully</span><div layout=\"\" layout-xs=\"column\" layout-align=\"space-between center\"><md-button class=\"md-primary large-button aarida-rounded-btn md-raised\" style=\"min-width: 200px;\" ui-sref=\"app.category({categoryName: \'all\'})\">Start Shopping</md-button><md-button class=\"md-primary large-button aarida-rounded-btn md-raised\" style=\"min-width: 200px;\" ui-sref=\"app.cart()\"><span>Go to Cart</span><md-icon>arrow_right_alt</md-icon></md-button></div></div><section layout=\"column\" layout-align=\"center center\" class=\"usage-container\"><p class=\"center-text md-subhead bold-text description-text\">Gift Cards can be used to place an order during the checkout process</p><div layout=\"\" layout-align=\"center center\"><img class=\"usage-tutorial center-text\" src=\"assets/images/gift-cards/redeem.gif\" alt=\"redeem gif\"></div></section></md-dialog></div></div>");
$templateCache.put("app/modules/account/partials/account-home.html","<div ng-include=\"\'app/modules/account/partials/account-nav.html\'\"></div><div ui-view=\"\"></div>");
$templateCache.put("app/modules/account/partials/account-nav.html","<div layout=\"column\" layout-align=\"center center\" md-whiteframe=\"1\" class=\"white-background\"><div layout=\"row\" flex=\"\" layout-align=\"center center\" class=\"md-padding md-margin\"><md-img md-src=\"{{ user.profileImageURL}}\" class=\"md-avatar\" style=\"width: 90px; height: auto; border-radius: 8px; padding: 2px;\"></md-img><div layout=\"column\" flex=\"\" layout-align=\"center start\" layout-padding=\"\"><span ng-class=\"{\'md-title\' : !isSmall, \'md-subhead\' :isSmall }\">{{ user.name }}</span> <span ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' :isSmall }\">{{ user.email }}</span> <span ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' :isSmall }\" ng-if=\"!user.virtualMobile && user.mobile\">{{ user.virtualMobile ? \"Update Now\" : user.mobile }}</span> <span ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' :isSmall }\" ng-click=\"showInfoDialog()\" md-colors=\"{\'color\' : \'accent-500-1\'}\" class=\"pointer\" ng-if=\"user.virtualMobile || !user.mobile\">Update Mobile Number</span></div></div><md-content md-scroll-x=\"\"><md-nav-bar class=\"md-primary\" md-selected-nav-item=\"currentNavItem\" md-stretch-tabs=\"always\" nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-sref=\"app.account.home\" name=\"home\">Addresses</md-nav-item><md-nav-item md-nav-sref=\"app.account.giftCards\" name=\"giftCards\">Gift Cards</md-nav-item><md-nav-item md-nav-sref=\"app.account.quotations\" name=\"quotations\">Quotations</md-nav-item><md-nav-item md-nav-sref=\"app.account.orders\" name=\"orders\">Orders</md-nav-item></md-nav-bar></md-content></div><div style=\"visibility: hidden\" ng-if=\"user\"><div class=\"md-dialog-container\" id=\"infoDialog\"><md-dialog><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\"><md-button class=\"md-icon-button\" ui-sref=\"app.cart\"><md-icon>arrow_back</md-icon></md-button><h2 flex=\"\" style=\"padding-top: 0; text-align: center\">Enter Mobile Number</h2></div></md-toolbar><md-divider></md-divider><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\" layout-padding=\"\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"no-margin red-text\">info</md-icon><span class=\"center-text md-caption red-text\">Please enter your mobile number to continue</span></div><form name=\"$parent.infoForm\" ng-cloak=\"\"><div layout-gt-sm=\"column\"><div layout=\"\"><span class=\"md-caption grey-text\" style=\"margin-top: 30px;\">+91 -</span><md-input-container class=\"md-block md-primary\" md-theme=\"black\" flex-gt-sm=\"\"><label>Mobile Number</label> <input type=\"tel\" ng-pattern=\"/^[56789][0-9]{9}$/\" name=\"mobile\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\" ng-model=\"user.mobile\"><div ng-messages=\"$parent.infoForm.mobile.$error\" ng-if=\"$parent.infoForm.mobile.$touched && $parent.infoForm.mobile.$error\"><div ng-message-exp=\"[\'required\', \'pattern\', \'minlength\', \'maxlength\']\"><div ng-message=\"pattern\">Please provide a 10 digit Indian mobile number without 0 or +91</div></div></div></md-input-container></div></div><div layout=\"\" layout-align=\"center center\"><span ng-if=\"error\" class=\"center-text red-text md-caption\">{{error}}</span></div><div layout=\"\"><md-button class=\"md-raised md-accent\" style=\"width: 100%\" ng-click=\"saveUserDetails();\" ng-disabled=\"userSaving || $parent.infoForm.$invalid\">Update Details</md-button></div></form></div></md-dialog-content></md-dialog></div></div>");
$templateCache.put("app/modules/account/partials/home.html","<div layout=\"column\" flex-gt-sm=\"80\" flex-offset-gt-sm=\"10\"><h1 class=\"center-text\">Manage Addresses</h1><section flex=\"\" layout=\"column\" ng-if=\"!loadingAddresses\"><md-radio-group flex=\"\" layout=\"\" layout-wrap=\"\" layout-align=\"stretch center\" class=\"md-accent\" ng-model=\"defaultAddress\" ng-if=\"addressLoaded && addresses.length > 0\"><div ng-repeat=\"address in addresses\" flex-sm=\"50\" flex-xs=\"100\" flex-md=\"50\" flex-lg=\"33\" flex-xl=\"25\"><md-card class=\"address-item relative\" ng-class=\"{\'selected\' : defaultAddress == address._id, \'md-whiteframe-3dp\' : defaultAddress == address._id}\"><md-card-header layout=\"\" layout-align=\"space-between center\" style=\"padding: 8px\"><md-card-header-text><span class=\"md-body-2 bold-text\">{{ capitalize(address.name) }}</span> <span class=\"md-caption\">{{capitalize(address.mobile);}}</span></md-card-header-text><span class=\"md-caption address-type\">{{address.addressType ? capitalize(address.addressType) : \'Other\' }}</span></md-card-header><md-divider></md-divider><div flex=\"\" style=\"padding: 12px 8px;\"><span class=\"md-caption\">{{ address.streetAddress }}</span> <span class=\"md-caption\">{{ address.landmark ? address.landmark : \"\" }}</span><br><span class=\"md-caption\">{{ capitalize(address.city) }}, {{ capitalize(address.state) }} -</span> <span class=\"md-caption\">{{ capitalize(address.pinCode) }}</span></div><md-divider></md-divider><md-card-actions layout=\"\" layout-align=\"space-between center\"><md-radio-button ng-value=\"address._id\" ng-click=\"changeDefault(address);\" style=\"margin-bottom: 0; outline: none;\">Default</md-radio-button><div><md-button title=\"Edit Address\" aria-label=\"edit address\" ng-click=\"showAddressDialog($event, address, $index)\" class=\"md-icon-button\"><md-icon>edit</md-icon></md-button><md-button title=\"Delete Address\" aria-label=\"delete address\" class=\"md-icon-button\" ng-click=\"showConfirm($event, address._id, $index)\"><md-icon>delete</md-icon></md-button></div></md-card-actions><div class=\"opaque-loader\" layout=\"\" layout-align=\"center center\" ng-show=\"address.updating\"><md-progress-circular class=\"md-accent\"></md-progress-circular></div></md-card></div></md-radio-group><md-progress-circular md-mode=\"indeterminate\" ng-if=\"!addressLoaded\"></md-progress-circular><div layout=\"column\" layout-align=\"center center\" style=\"min-height: 40vh;\" ng-if=\"addresses.length == 0 && addressLoaded\"><img src=\"assets/images/error.svg\" style=\"width: 75px;\"> <span class=\"md-margin md-caption grey-text\">No Address Yet</span></div></section><section class=\"md-padding md-margin\" ng-if=\"loadingAddresses\" layout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\"></md-progress-circular></section></div><div style=\"visibility: hidden\" ng-if=\"user\"><div class=\"md-dialog-container\" id=\"addressDialog\"><md-dialog><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\"><h2 style=\"padding-top: 0;\">Add New Address</h2><span flex=\"\"></span><md-button class=\"md-icon-button md-accent\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><form name=\"$parent.addressForm\" ng-cloak=\"\"><md-dialog-content><div class=\"md-dialog-content\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block md-accent\" flex-gt-sm=\"\"><label>Name</label> <input required=\"\" ng-model=\"newAddress.name\"></md-input-container><md-input-container class=\"md-block md-accent\" flex-gt-sm=\"\"><label>Mobile Number</label> <input type=\"tel\" ng-pattern=\"/^[56789][0-9]{9}$/\" name=\"mobile\" ng-minlength=\"10\" ng-maxlength=\"10\" required=\"\" ng-model=\"newAddress.mobile\"><div ng-messages=\"$parent.mobile.city.$error\" ng-if=\"$parent.mobile.city.$touched && $parent.mobile.city.$error\"><div ng-message-exp=\"[\'required\', \'pattern\', \'minlength\', \'maxlength\']\"><div ng-message=\"pattern\">Please provide a 10 digit Indian mobile number without 0 or +91</div></div></div></md-input-container></div><md-input-container class=\"md-block md-accent\"><label>Address</label> <textarea required=\"\" md-maxlength=\"100\" ng-model=\"newAddress.streetAddress\"></textarea></md-input-container><md-input-container class=\"md-block md-accent\"><input md-maxlength=\"32\" ng-model=\"newAddress.landmark\" placeholder=\"Landmark\"></md-input-container><div layout-gt-sm=\"row\"><md-autocomplete flex=\"\" required=\"\" class=\"md-accent\" md-input-name=\"city\" md-input-minlength=\"2\" md-input-maxlength=\"18\" md-no-cache=\"noCache\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in querySearch(searchText)\" md-selected-item-change=\"selectedItemChange(item)\" md-item-text=\"item.city\" md-require-match=\"\" md-floating-label=\"City\"><md-item-template><span class=\"black-text\" md-highlight-text=\"searchText\" md-highlight-flags=\"^i\">{{item.city }}</span></md-item-template><md-not-found>No cities matching \"{{searchText}}\" were found.</md-not-found><div ng-messages=\"$parent.addressFrom.city.$error\" ng-if=\"$parent.city.$touched && $parent.city.$invalid && $parent.addressFrom.city.$error\"><div ng-message=\"required\">Please enter your city.</div><div ng-message=\"md-require-match\">Please select an existing city.</div></div></md-autocomplete><md-input-container class=\"md-block md-accent\" flex-gt-sm=\"\"><label>State</label> <input name=\"state\" md-maxlength=\"20\" ng-model=\"newAddress.state\" required=\"\"><div ng-if=\"$parent.state.$touched && $parent.state.$error\" ng-messages=\"$parent.state.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\" class=\"my-message\">You must add a state.</div></div></md-input-container><md-input-container class=\"md-block md-accent\" flex-gt-sm=\"\"><label>Pin Code</label> <input name=\"postalCode\" ng-model=\"newAddress.pinCode\" placeholder=\"123456\" required=\"\" ng-pattern=\"/^[0-9]{6}$/\" md-maxlength=\"6\"><div ng-if=\"$parent.postalCode.$touched && $parent.addressFrom.postalCode.$error\" ng-messages=\"$parent.addressFrom.postalCode.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\" class=\"my-message\">You must supply a postal code.</div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"50\"><md-checkbox class=\"md-accent\" ng-model=\"newAddress.isDefault\" aria-label=\"Default Address\"><span>Default Address</span></md-checkbox></div><md-input-container class=\"md-block md-accent\" flex-gt-sm=\"\"><label>Address Label</label> <input name=\"tag\" ng-model=\"newAddress.addressType\" placeholder=\"Home, Office, etc.\" md-maxlength=\"10\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"end center\" md-colors=\"{\'background\' : \'accent-50-0.2\'}\"><md-button class=\"md-raised md-accent\" ng-click=\"saveAddress();\" ng-disabled=\"addressSaving || $parent.addressForm.$invalid\">Save Address</md-button></md-dialog-actions></form></md-dialog></div></div>");
$templateCache.put("app/modules/address/partials/address.add.dialog.html","<div class=\"md-dialog-container\" id=\"addressDialog\"><md-dialog><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\"><h2 style=\"padding-top: 0;\">{{editingMode ? \'Edit\' : \'Add New\'}} Address</h2><span flex=\"\"></span><md-button class=\"md-icon-button md-accent\" ng-click=\"cancelDialog()\"><md-icon aria-label=\"Close dialog\">close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><form name=\"$parent.addressForm\" ng-cloak=\"\"><md-dialog-content><div class=\"md-dialog-content\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block md-primary\" md-theme=\"black\" flex-gt-sm=\"\"><label>Name</label> <input required=\"\" ng-model=\"newAddress.name\" autocomplete=\"name\"></md-input-container><md-input-container class=\"md-block md-primary\" md-theme=\"black\" flex-gt-sm=\"\"><label>Mobile Number</label> <input type=\"tel\" ng-pattern=\"/^[56789][0-9]{9}$/\" name=\"mobile\" md-maxlength=\"10\" md-minlength=\"10\" autocomplete=\"mobile\" required=\"\" ng-model=\"newAddress.mobile\"><div ng-messages=\"$parent.mobile.city.$error\" ng-if=\"$parent.mobile.city.$touched && $parent.mobile.city.$error\"><div ng-message-exp=\"[\'required\', \'pattern\', \'minlength\', \'maxlength\']\"><div ng-message=\"pattern\">Please provide a 10 digit Indian mobile number without 0 or +91</div></div></div></md-input-container></div><md-input-container class=\"md-block md-primary\" md-theme=\"black\"><label>Address</label> <textarea required=\"\" md-maxlength=\"100\" autocomplete=\"address\" ng-model=\"newAddress.streetAddress\"></textarea></md-input-container><md-input-container class=\"md-block md-primary\" md-theme=\"black\"><input md-maxlength=\"32\" ng-model=\"newAddress.landmark\" autocomplete=\"landmark\" placeholder=\"Landmark\"></md-input-container><div layout-gt-sm=\"row\" class=\"md-block md-primary\" md-theme=\"black\"><md-input-container class=\"md-block md-primary\" md-theme=\"black\" flex-gt-sm=\"\"><label>Pin Code</label> <input name=\"postalCode\" ng-model=\"newAddress.pinCode\" placeholder=\"123456\" required=\"\" ng-pattern=\"/^[0-9]{6}$/\" md-maxlength=\"6\" ng-blur=\"populateCity()\"><div ng-if=\"$parent.postalCode.$touched && $parent.addressFrom.postalCode.$error\" ng-messages=\"$parent.addressFrom.postalCode.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\" class=\"my-message\">You must supply a postal code.</div></div></md-input-container><md-input-container><label>City</label> <input name=\"city\" ng-model=\"newAddress.city\" placeholder=\"Delhi\" required=\"\" minlength=\"2\" ng-disabled=\"populatingCity\"><div ng-messages=\"$parent.addressFrom.city.$error\" ng-if=\"$parent.city.$touched && $parent.city.$invalid && $parent.addressFrom.city.$error\"><div ng-message=\"required\">Please enter your city.</div></div></md-input-container><md-input-container class=\"md-block md-primary\" md-theme=\"black\" flex-gt-sm=\"\"><label>State</label> <input name=\"state\" md-maxlength=\"20\" ng-model=\"newAddress.state\" required=\"\"><div ng-if=\"$parent.state.$touched && $parent.state.$error\" ng-messages=\"$parent.state.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\" class=\"my-message\">You must add a state.</div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"50\"><md-checkbox class=\"md-accent\" ng-model=\"newAddress.isDefault\" aria-label=\"Default Address\"><span>Default Address</span></md-checkbox></div><md-input-container class=\"md-block md-primary\" md-theme=\"black\" flex-gt-sm=\"\"><label>Address Label</label> <input name=\"tag\" ng-model=\"newAddress.addressType\" placeholder=\"Home, Office, etc.\" md-maxlength=\"10\"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"\" layout-align=\"end center\" md-colors=\"{\'background\' : \'accent-50-0.2\'}\"><md-button class=\"md-raised md-accent\" ng-click=\"saveAddress();\" ng-disabled=\"addressSaving || $parent.addressForm.$invalid\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!addressSaving\">{{editingMode ? \'Update\' : \'Add New\'}} Address</span><md-progress-circular class=\"md-accent\" md-diameter=\"20\" ng-if=\"addressSaving\"></md-progress-circular></div></md-button></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/modules/address/partials/shipping-information.html","<div layout=\"column\" layout-align=\"center center\"><md-subheader layout=\"column\" layout-align=\"center center\"><span class=\"md-headline\">Shipping Details</span></md-subheader><md-nav-bar md-theme=\"default\" md-selected-nav-item=\"currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-sref=\"app.cart\" name=\"page1\">Cart</md-nav-item><md-nav-item md-nav-sref=\"app.shipping\" name=\"page2\">Shipping Details</md-nav-item><md-nav-item md-nav-sref=\"app.checkout\" name=\"page3\">Payment</md-nav-item></md-nav-bar></div><md-content layout=\"\" layout-fill=\"\" class=\"body body-background\"><md-card flex=\"\" style=\"margin: 16px;\"><md-card-content flex=\"\"><md-grid-list md-row-height=\"1:1\" md-rows=\"3\"><md-grid-tile></md-grid-tile></md-grid-list></md-card-content></md-card></md-content>");
$templateCache.put("app/modules/base/dialogs/update-dialog.html","<div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"updateDialog\"><md-dialog class=\"update-dialog\" flex-xs=\"90\" flex-sm=\"60\" flex-md=\"40\" flex-lg=\"35\" flex-xl=\"25\"><md-dialog-content class=\"update-dialog-content\"><md-button class=\"close-button md-icon-button\" ng-click=\"cancelUpdate()\"><md-icon class=\"black-text\">close</md-icon></md-button><div layout=\"\" layout-align=\"center center\"><img src=\"assets/images/app-update.svg\"></div><div layout=\"column\" layout-align=\"center center\"><h3 class=\"center-text title md-title\">New App Update Available</h3><p class=\"update-text md-body-1\">There is an update available for your app experience. <span class=\"allura md-title\">Aarida</span> is updated regularly to <span class=\"bold-text\">enhance your experience</span>, <span class=\"bold-text\">fix bugs</span> and <span class=\"bold-text\">patch security vulnerabilities</span>. Please refresh the page to get the update automatically.<br><br><span class=\"md-subhead center-text\">Estimated Update Time : <span class=\"bold-text\">10 seconds</span></span></p></div><div layout=\"column\" layout-align=\"space-between center\"><md-button class=\"update-now-button\" ng-click=\"update()\">Update Now</md-button><md-button class=\"md-warn\" ng-click=\"cancelUpdate()\">Update Later</md-button></div></md-dialog-content></md-dialog></div></div>");
$templateCache.put("app/modules/cart/partials/cart-nav.html","");
$templateCache.put("app/modules/cart/partials/cart-sidenav.html","<div layout=\"column\" flex=\"\" class=\"cart-sidenav\"><div layout=\"\" layout-align=\"space-between center\" flex=\"\" class=\"md-padding md-whiteframe-2dp cart-sidenav-header\"><section layout=\"column\"><span class=\"cart-title md-headline\">Shopping Cart</span> <span ng-hide=\"!cart.products.length\" class=\"cart-subtitle md-caption grey-text\" style=\"margin-top: 4px\">{{cart.products.length}} {{cart.products.length === 1 ? \'PRODUCT\' : \'PRODUCTS\'}}</span></section><md-button class=\"md-icon-button\" ng-click=\"closeSidebar(\'cart\')\"><md-icon>close</md-icon></md-button></div><md-content md-scroll-y=\"\" class=\"cart-sidenav-main-content\"><md-list ng-if=\"cart.products.length\"><md-list-item ng-repeat-start=\"productData in cart.products\" class=\"md-padding relative\"><img style=\"width: 50px; margin-top: 10px;\" ng-src=\"{{mediaUrl + productData.product.featured_image.urls.thumbnail}}\" alt=\"{{productData.product.name}}\"><div class=\"md-list-item-text\" flex=\"\" layout=\"column\" style=\"margin-left: 4px\"><span class=\"md-body-1 bold-text\">{{getProperName(productData.product.name, 40)}}</span><div layout=\"\" layout-align=\"space-between center\" style=\"padding: 4px 0;\"><span class=\"md-caption\" ng-if=\"productData.variation && productData.variation.attributes.length > 0\">Size - {{getVariationValue(productData);}}</span><md-card ng-show=\"productData.product.productType === 1\" class=\"green white-text ng-scope _md md-awesome-theme\" style=\"border-radius: 32px; padding: 2px 8px\"><div layout=\"\" layout-align=\"center center\" class=\"layout-align-center-center layout-row\"><span class=\"bold-text md-tiny\">CUSTOMISABLE</span></div></md-card></div><section layout=\"\" layout-align=\"space-between center\"><div layout=\"\" layout-align=\"start center\"><md-button class=\"md-icon-button md-accent\" ng-click=\"updateQuantity(productData,\'minus\',$index);\"><md-icon>remove</md-icon></md-button><span style=\"border: 1px solid #fff; padding: 2px 8px; font-size: 12px\" class=\"md-title\" md-colors=\"{\'borderColor\' : \'awesome-accent-500-1\'}\">{{ productData.quantity }}</span><md-button class=\"md-icon-button md-accent\" ng-click=\"updateQuantity(productData,\'plus\',$index);\"><md-icon>add</md-icon></md-button></div><span class=\"md-primary md-body-2 bold-text\">Rs. {{productData.totalPrice }}</span></section><div ng-show=\"productData.product.productType === 1 && currentUser.role === \'admin\'\" flex=\"\" layout=\"\"><md-button class=\"md-accent\" style=\"border: 1px solid; width: 100%\" ng-click=\"goToCustomisationEditor(productData);\">Edit</md-button></div></div><div class=\"cart-loader\" ng-if=\"productData.updating\" layout=\"column\" layout-align=\"center center\"><section class=\"display-backdrop\"></section><md-progress-circular class=\"md-accent\" md-diameter=\"24\"></md-progress-circular></div></md-list-item><md-divider style=\"margin: 8px 0\" ng-repeat-end=\"\"></md-divider></md-list><section class=\"white upsell-offer\" layout=\"column\" layout-align=\"start center\" md-whiteframe=\"1\" ng-if=\"cart.products.length && showCashbackOffer\" style=\"width: 100%; border: 1px solid lightgrey; border-radius: 4px; margin: 0 !important;\"><div layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><span class=\"md-body-1 offer-title center-text\">Here is an exclusive offer for you.</span> <span class=\"md-subhead montserrat center-text\" style=\"font-weight: bold;\">Get Flat 100% Cashback</span> <span class=\"md-tiny\">New Users Only | Valid on First Transaction</span> <span class=\"md-caption\">Use Coupon Code</span><div layout=\"\" layout-align=\"center center\"><span class=\"md-title pink-text\" style=\"padding: 4px; border: 2px dashed lightgrey;\">FXMD43FRS</span><md-button class=\"md-raised md-primary\" copy-to-clipboard=\"\" ng-click=\"!isUserLoggedIn ? openLoginModal($event) : copied = true;\" ng-disabled=\"copied\" ng-init=\"ttc = \'FXMD43FRS\'\" style=\"margin: 0\" text-to-copy=\"ttc\"><span>{{ copied ? \"Copied\" : \"Copy\"}}</span></md-button></div></div><div class=\"white-text\" layout=\"\" layout-align=\"center center\" style=\"width: 100%; border-bottom-right-radius : 4px; border-bottom-left-radius: 4px; padding: 4px; background: #ffcfea !important\"><countdown-timer end-date=\"{{cashbackOfferEndDate}}\"></countdown-timer></div></section><div flex=\"\" layout=\"column\" layout-align=\"center center\" ng-if=\"!cart.products.length\"><img src=\"assets/images/cart/empty-cart.svg\" style=\"width: 150px; margin-top: 100px\"><p>Nothing in cart yet</p></div><div class=\"review-btn\" flex=\"\" layout=\"\" layout-align=\"space-between center\" ng-if=\"cart.products.length\"><md-button ng-click=\"clearCart()\" class=\"md-warn\">Clear Cart</md-button><md-button class=\"md-accent md-raised flex\" ng-click=\"closeSidebar(\'cart\');\" ui-sref=\"app.cart\"><span>Next</span><md-icon>keyboard_arrow_right</md-icon></md-button></div></md-content></div>");
$templateCache.put("app/modules/cart/partials/cart.html","<div class=\"cart-page\"><div ng-include=\"\'app/modules/cart/partials/cart-nav.html\'\"></div><div class=\"md-padding\" layout=\"\" layout-align=\"space-between center\"><h3 class=\"md-headline montserrat bold-text shopping--cart--title\">Shopping Cart</h3><h5 class=\"md-title shopping--cart--title\">{{$parent.cart.products ? $parent.cart.products.length: \'No\'}} items</h5></div><md-divider></md-divider><section layout=\"\"><div flex=\"\" layout=\"row\" layout-align=\"center center\" layout-margin=\"\" ng-if=\"($parent.cart.products.length === 0 || !$parent.cart.products) && !loadingCart\"><div layout=\"column\" layout-align=\"center center\" style=\"padding: 3%;\"><h3 class=\"md-display-1\">Nothing in cart yet</h3><section class=\"cart-nothing-found\" layout=\"row\"><md-icon md-svg-icon=\"assets/images/cart/bobbin.svg\"></md-icon><md-icon md-svg-icon=\"assets/images/cart/cutter.svg\"></md-icon><md-icon md-svg-icon=\"assets/images/cart/cutter-1.svg\"></md-icon><md-icon md-svg-icon=\"assets/images/cart/dummy.svg\"></md-icon><md-icon md-svg-icon=\"assets/images/cart/hanger.svg\"></md-icon><md-icon md-svg-icon=\"assets/images/cart/needle.svg\"></md-icon></section><span class=\"md-title\">We have kept everything ready for you.</span> <span class=\"md-subhead md-padding\">What are you waiting for ?</span><md-button class=\"md-accent large-button md-raised\" style=\"min-width: 200px;\" ui-sref=\"app.category({categoryName: \'all\'})\">Shop Now</md-button></div></div><div flex=\"\" layout=\"column\" layout-align-gt-sm=\"center start\" layout-gt-sm=\"row\" class=\"cart-details-section\" ng-class=\"{\'layout-margin\' : !isSmall}\" ng-if=\"$parent.cart.products.length > 0 && !loadingCart\"><div class=\"md-padding\" flex-gt-sm=\"70\"><section class=\"cart-item relative\" layout=\"\" layout-wrap=\"\" ng-repeat=\"productData in cart.products\"><div class=\"cart-item-image-container\" flex=\"40\" flex-gt-sm=\"10\" layout-align=\"center center\"><md-img alt=\"{{productData.product.name}}\" class=\"cart-image\" md-src=\"{{ productData.product.featured_image.urls.thumbnail }}\"></md-img><div class=\"customisable-badge\" layout=\"\" layout-align=\"center center\" ng-if=\"productData.product.productType === 1\"><span>CUSTOMISABLE</span></div></div><div class=\"cart-item-info\" flex=\"60\" flex-gt-sm=\"35\" layout=\"column\"><a class=\"md-link bold-text\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\" ui-sref=\"app.product({productSlug : productData.product.slug})\">{{ getProperName(productData.product.name) }}</a> <span class=\"variation-value grey-text\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\" ng-if=\"productData.variation && productData.variation.attributes.length > 0\">Size - {{getVariationValue(productData);}}</span> <span class=\"grey-text\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\">Rs. {{ productData.price }}</span> <a class=\"md-link pointer md-warn\" ng-click=\"removeFromCart(productData,$index);\"><span>Remove</span><md-tooltip md-direction=\"bottom\">Remove Product from Cart</md-tooltip></a></div><div flex=\"40\" flex-gt-sm=\"20\" layout=\"\" layout-align=\"end center\" layout-padding=\"\" class=\"cart-item-actions\"><md-button class=\"md-icon-button md-accent cart-action\" ng-click=\"updateQuantity(productData,\'minus\',$index);\"><md-icon>remove</md-icon></md-button><span class=\"md-title cart-action-quantity\" ng-class=\"{\'md-title\' : !isSmall, \'md-body-1\' : isSmall}\">{{ productData.quantity }}</span><md-button class=\"md-icon-button md-accent cart-action\" ng-click=\"updateQuantity(productData,\'plus\',$index);\"><md-icon>add</md-icon></md-button></div><div flex=\"30\" flex-gt-sm=\"15\" layout=\"column\" layout-align=\"center center\" style=\"margin: auto;\"><span flex=\"\"></span><div layout=\"column\" layout-align=\"center center\"><span ng-if=\"productData.isEligible\" flex=\"\" ng-class=\"{\'md-title\' : !isSmall, \'md-subhead\' : isSmall}\" class=\"md-tiny red-text\"><strike>Rs. {{ productData.subTotal }}</strike></span> <span flex=\"\" ng-class=\"{\'md-title\' : !isSmall, \'md-subhead\' : isSmall}\" class=\"md-primary bold-text\">Rs. {{productData.totalPrice }}</span> <span class=\"md-caption green-text bold-text\" ng-if=\"productData.isEligible\">OFFER</span></div><span flex=\"\"></span></div><div flex=\"30\" flex-gt-sm=\"20\" layout=\"\" style=\"margin: auto;\"><md-button class=\"md-accent aarida-stroked-button\" ng-click=\"goToCustomisationEditor(productData);\" ng-if=\"productData.product.productType == 1 && currentUser.role === \'admin\'\"><md-icon>edit</md-icon><span>Edit</span><md-tooltip md-direction=\"bottom\">Edit Product</md-tooltip></md-button></div><div class=\"cart-loader\" ng-if=\"productData.updating\" layout=\"column\" layout-align=\"center center\"><section class=\"display-backdrop\"></section><md-progress-circular class=\"md-accent\" md-diameter=\"32\"></md-progress-circular></div></section></div><div class=\"md-padding cart-info-section\" flex=\"\" layout=\"column\" layout-margin=\"\"><h3 class=\"md-title\">Cart Summary</h3><md-card class=\"gift-card dummy-card\" ng-if=\"!loadingGiftCards && cards && cards.length\"><md-card-content layout=\"column\" layout-align=\"center center\"><div class=\"add-icon\" layout=\"\" layout-align=\"center center\"><md-icon>verified_user</md-icon><span class=\"md-title white-text montserrat card-title\">Gift Cards</span></div><span class=\"redeem-text center-text md-body-1\">You have {{cards.length}} gift {{cards.length === 1 ? \'card\' : \'cards\'}} in your account. Apply it next in the checkout process.</span><md-button ui-sref=\"app.checkout\" class=\"md-accent\">Proceed to checkout<md-icon>arrow_right_alt</md-icon></md-button></md-card-content></md-card><section class=\"white upsell-offer layout-align-start-center md-whiteframe-1dp\" layout=\"column\" md-whiteframe=\"1\" ng-if=\"showCashbackOffer\" style=\"width: 100%; border: 1px solid lightgrey; border-radius: 4px; margin: 0 !important;\"><div class=\"layout-align-center-center\" layout=\"column\" layout-padding=\"true\"><span class=\"md-title offer-title\">Here is an exclusive offer for you.</span> <span class=\"md-headline montserrat\" style=\"font-weight: bold;\">Get Flat 100% Cashback</span> <span class=\"md-tiny\">New Users Only | Valid on First Transaction</span> <span class=\"md-caption\">Use Coupon Code</span><div class=\"layout-align-center-center\" layout=\"\"><span class=\"md-title pink-text coupon-code\" style=\"padding: 4px; border: 2px dashed lightgrey;\">FXMD43FRS</span><md-button class=\"md-raised md-primary\" copy-to-clipboard=\"\" ng-click=\"copied = true; !isUserLoggedIn ? openLoginModal($event) : applyDefaultCoupon(\'FXMD43FRS\')\" ng-disabled=\"copied\" style=\"margin: 0\" text-to-copy=\"ttc\"><span>{{ copied ? \"Applied\" : \"Apply Coupon\"}}</span></md-button></div></div><div class=\"white-text layout-align-center-center\" style=\"width: 100%; border-bottom-right-radius : 4px; border-bottom-left-radius: 4px; padding: 4px; background: #ffcfea !important\"><countdown-timer end-date=\"{{cashbackOfferEndDate}}\"></countdown-timer></div></section><div flex-sm=\"50\"><form class=\"coupon-box\" layout=\"\" name=\"coupon1\" ng-class=\"{\'small\' : isSmall, \'large\' : !isSmall}\" ng-disabled=\"checkingStatus\" ng-if=\"!cart.coupon._id\" ng-submit=\"applyCoupon()\"><div flex=\"\" layout=\"column\" layout-padding=\"\"><div flex=\"30\" layout=\"column\" layout-align=\"center center\"><span class=\"white-text md-subhead center-text\" flex=\"\">Have a coupon code?</span></div><span class=\"red-text center-text\" ng-if=\"couponError\" style=\"font-weight: 600\">{{ couponError }}</span><div layout=\"row\" layout-align=\"center center\"><md-input-container flex=\"\" md-no-float=\"\" md-theme=\"black\"><input class=\"white md-no-label\" ng-change=\"clearError();\" ng-disabled=\"!isUserLoggedIn\" ng-model=\"$parent.$parent.couponCode\" ng-required=\"\" placeholder=\"Enter Coupon Code\" type=\"text\"></md-input-container><md-progress-circular class=\"md-primary md-hue-1\" flex=\"20\" md-diameter=\"20\" ng-if=\"$parent.checkingStatus\"></md-progress-circular></div><md-button class=\"md-raised\" ng-disabled=\"couponCode.length <= 4 || !isUserLoggedIn\" style=\"margin: 0; padding: 0;\" type=\"submit\">Redeem</md-button></div></form><form class=\"coupon-box\" layout=\"\" md-whiteframe=\"6\" name=\"coupon2\" ng-class=\"{\'small\' : isSmall, \'large\' : !isSmall}\" ng-if=\"cart.coupon._id\"><div flex=\"\" layout=\"column\" layout-padding=\"\"><span class=\"center-text md-headline white-text\">{{ cart.discountText}}</span> <span class=\"center-text white-text md-caption\" ng-if=\"cart.cashBackText && cart.discountAmount\">{{cart.cashBackText}}</span> <span class=\"center-text md-caption cart-error-text\" ng-if=\"cart.errorText\">{{cart.errorText}}</span> <span class=\"center-text white-text\">Coupon Applied</span><div class=\"md-chips\" layout=\"\" layout-align=\"center center\"><md-chip class=\"white md-chip pointer\" layout=\"\" layout-align=\"center center\" style=\"border-radius : 20px; height: 40px; line-height: 40px;\"><span class=\"md-body-1 black-text\">{{ cart.coupon.couponCode }}</span> <span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"removeCoupon();\"><md-icon>close</md-icon></md-button></md-chip></div></div></form></div><div flex-sm=\"50\" layout=\"column\" layout-margin=\"\"><div ng-class=\"{\'white\' : isSmall}\"><table><tbody><tr><th class=\"md-subhead\">Sub Total</th><td>Rs. {{ (cart.subtotal ? cart.subtotal : (cart.amount - cart.shippingCharges)) }}</td></tr><tr ng-if=\"cart.subtotal\"><th class=\"md-subhead\">Discount</th><td><span class=\"green-text\">- Rs. {{ cart.discountAmount }}</span></td></tr><tr><th class=\"md-subhead\">Delivery Charges</th><td><span class=\"green-text\">{{cart.shippingCharges ? \'Rs.\' + cart.shippingCharges : \'Free\'}}</span></td></tr><tr><th class=\"montserrat md-subhead\">Total</th><td><span style=\"font-weight: bold\">Rs. {{ cart.amount }}</span></td></tr></tbody></table></div><md-button class=\"md-accent md-raised\" ng-if=\"isUserLoggedIn\" style=\"font-weight: bold\" ui-sref=\"app.checkout\"><span>Proceed to checkout</span><md-icon>arrow_right_alt</md-icon></md-button><section layout=\"column\" layout-align=\"center center\" ng-if=\"!isUserLoggedIn\"><span class=\"md-caption\">Login/Register to checkout order. It is needed to provide you features like Order Tracking, SMS and email notifications and much more.</span><md-button class=\"md-accent md-raised\" ng-click=\"openLoginModal($event)\"><span class=\"bold-text\">Proceed To Checkout</span><md-icon>arrow_right_alt</md-icon></md-button></section><span flex=\"\"></span></div></div></div><div class=\"cart-loader full-page\" ng-if=\"loadingCart\" layout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><span class=\"md-padding\">Loading Cart ...</span></div></section><div class=\"proceed-to-checkout-button-container md-whiteframe-6dp\" layout=\"\" ng-if=\"isSmall && $parent.cart.products.length > 0\"><div flex=\"\" layout=\"\" layout-align=\"center center\"><span class=\"bold-text md-body-1\" ng-if=\"cart.amount\">Rs. {{ cart.amount }}</span></div><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-accent md-raised md-padding\" ng-if=\"isUserLoggedIn\" ui-sref=\"app.checkout\"><span class=\"bold-text\">Proceed to checkout</span><md-icon>arrow_right_alt</md-icon></md-button><md-button class=\"md-raised md-accent md-padding\" ng-if=\"!isUserLoggedIn\" ng-click=\"openLoginModal($event)\"><span class=\"bold-text\">Proceed to Checkout</span><md-icon>arrow_right_alt</md-icon></md-button></div></div></div>");
$templateCache.put("app/modules/category/partials/bottom-sheet-filters.html","<div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"filtersDialog\"><md-dialog layout=\"column\" class=\"filters-modal\" style=\"padding: 0 0 0px 0;\"><md-toolbar layout=\"row\" md-whiteframe=\"1\" class=\"md-toolbar-tools\" layout-align=\"center center\" ng-cloak=\"\"><span>Filters</span> <span flex=\"\"></span><md-button ng-click=\"close();\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></md-toolbar><div ng-cloak=\"\" flex=\"\" layout=\"row\" class=\"content\"><section layout=\"column\" md-whiteframe=\"2\" class=\"filters-list\" flex=\"40\" md-colors=\"{\'background\' : \'awesome-primary-50-0.5\'}\"><md-button class=\"md-raised\" md-whiteframe=\"-1\" ng-click=\"select($index)\" style=\"border-radius: 0; margin: 0;\" ng-class=\"{\'white\' : filterIndex !== $index, \'md-accent\' : filterIndex === $index}\" ng-repeat=\"attribute in filteringAttributes\">{{attribute.meta_key}}</md-button><span flex=\"\"></span></section><div class=\"md-padding\" flex=\"\" style=\"overflow: scroll;\"><md-list ng-if=\"attribute.meta_key == \'Color\'\"><md-list-item layout=\"\" layout-align=\"start center\" ng-repeat-start=\"meta_value in attribute.values\"><div layout=\"\" layout-align=\"end center\"><div style=\"width: 32px; height: 32px; margin-right: 5px; border-radius: 50%;\" ng-style=\"{\'background\' : \'{{ :: meta_value.value}}\'}\"></div><span class=\"md-caption\">{{meta_value.value}}</span></div><md-checkbox class=\"md-secondary\" ng-model=\"attribute.shown[$index]\" aria-label=\"{{meta_value}}\" ng-click=\"filter(meta_value, $index, attribute, true);\"></md-checkbox></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list><md-list ng-if=\"attribute.meta_key != \'Color\'\"><md-list-item layout=\"\" layout-align=\"start center\" ng-repeat-start=\"meta_value in attribute.values\"><p class=\"md-caption\">{{meta_value.value}}</p><md-checkbox ng-model=\"attribute.shown[$index]\" class=\"md-secondary\" aria-label=\"meta_value.value\" ng-click=\"filter(meta_value, $index, attribute, true);\"></md-checkbox></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></div></div><div layout=\"\" class=\"actions\"><md-button style=\"margin: 0; width: 50%;\" ng-click=\"clearFilters();\" class=\"md-raised md-warn md-padding\" md-ink-ripple=\"\"><md-icon>flash_on</md-icon><span>Clear Filters</span></md-button><md-button style=\"margin: 0; width: 50%;\" ng-click=\"apply();\" class=\"md-raised md-primary md-padding\" md-ink-ripple=\"\"><md-icon>timeline</md-icon><span>Apply</span></md-button></div></md-dialog></div></div>");
$templateCache.put("app/modules/category/partials/bottom-sheet-sort.html","<script type=\"text/ng-template\" id=\"sort-bottom-sheet\"><md-bottom-sheet class=\"md-list md-has-header\"> <div ng-cloak> <h4>Sort Options</h4> </div> <md-radio-group ng-model=\"query.sort\" ng-change=\"applySorting()\"> <md-list ng-cloak> <md-list-item ng-repeat=\"option in sortOptions\" ng-click=\"applyValue(option)\"> <p class=\"md-list-item-text\"> <md-icon>{{option.icon}}</md-icon> <span class=\"md-inline-list-icon-label\">{{option.text}}</span> </p> <md-radio-button class=\"md-secondary\" ng-value=\"option.value\"></md-radio-button> </md-list-item> </md-list> </md-radio-group> </md-bottom-sheet></script>");
$templateCache.put("app/modules/category/partials/category-home.html","<");
$templateCache.put("app/modules/category/partials/category.html","<div layout=\"column\" layout-wrap=\"\" layout-align=\"center center\" class=\"category-page-header\"><div flex=\"\" layout=\"column\" layout-wrap=\"\" layout-align=\"center center\" class=\"background\"><h1 class=\"bold-text category-title\" ng-class=\"{\'md-display-1\' : !isSmall, \'md-headline\' : isSmall}\">{{ category.name}}</h1><p ng-if=\"category.description\" ng-bind-html=\"category.description\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\" class=\"center-text category-description hide\"></p></div></div><section ng-style=\"{\'margin\' : isSmall ? \'-32px 0 0 0\' : \'-32px 48px 0 48px\'}\" class=\"category-page-content\"><md-subheader ng-style=\"{\'margin\' : isSmall ? \'0 8px\' : \'none\'}\" class=\"md-no-sticky subheader\" md-whiteframe=\"1\" layout=\"column\" style=\"padding: 0; z-index: 1; position: relative; background: white;\"><section layout=\"row\" layout-align=\"center center\" flex=\"\"><span ng-class=\"{\'md-margin\' : !isSmall}\" class=\"md-caption black-text\">Showing {{ products.length}} of {{ totalCount }} products</span> <span flex=\"\"></span><div flex-gt-sm=\"20\" flex=\"50\" layout=\"\" layout-align=\"center center\" ng-class=\"{\'md-margin\' : !isSmall}\" class=\"sortByContainer\"><p>Sort By : &nbsp</p><md-select class=\"md-no-underline\" aria-label=\"sort\" ng-model=\"query.sort\" ng-change=\"applySorting()\" style=\"margin: 0;\" flex=\"\" md-theme=\"black\"><md-option ng-value=\"option.value\" ng-repeat=\"option in sortOptions\"><md-icon>{{option.icon}}</md-icon>{{option.text}}</md-option></md-select></div></section></md-subheader><div layout=\"row\" layout-align=\"center start\" style=\"margin-top: 48px; z-index: 1;\"><md-card flex=\"20\" id=\"filter-container\" layout=\"column\" ng-if=\"!isSmall\"><div layout=\"\" layout-wrap=\"\" layout-align=\"center center\" class=\"md-padding md-margin\" ng-if=\"hasFilters\"><md-button ng-click=\"clearFilters();\" class=\"md-accent md-padding aarida-rounded-btn aarida-stroked-button\" md-ink-ripple=\"\"><md-icon>flash_on</md-icon><span>Clear Filters</span><md-icon>close</md-icon></md-button></div><div layout=\"\" layout-align=\"start center\" class=\"md-padding\"><md-checkbox ng-model=\"query.customisable\" ng-change=\"applySorting()\"><span class=\"md-caption\">Hide Customisable Products</span></md-checkbox></div><md-divider></md-divider><div ng-repeat-start=\"attribute in filteringAttributes\" layout=\"column\" class=\"md-margin\" layout-padding=\"\"><span class=\"md-subhead grey-text\">{{ attribute.meta_key }}</span><div md-whiteframe=\"-1\"><md-virtual-repeat-container id=\"vertical-container\" md-auto-shrink=\"\" style=\"height: 350px;\"><div md-virtual-repeat=\"meta_value in attribute.values\" class=\"repeated-item\"><md-checkbox ng-model=\"attribute.shown[$index]\" aria-label=\"meta_value.value\" ng-click=\"filter(meta_value, $index, filteringAttributes[$parent.$index]);\"><div layout=\"\" ng-if=\"attribute.meta_key === \'Color\'\"><span md-whiteframe=\"3\" ng-style=\"{\'background\' : \'{{ :: meta_value.value}}\'}\" style=\"width: 24px; height: 24px; border-radius: 24px; margin-right: 8px; background: grey;\"></span> <span class=\"md-caption\" style=\"line-height: 24px\">{{meta_value.value}}</span></div><span ng-if=\"attribute.meta_key !== \'Color\'\">{{meta_value.value}}</span></md-checkbox></div></md-virtual-repeat-container></div></div><md-divider ng-repeat-end=\"\"></md-divider></md-card><div flex-gt-sm=\"80\" flex=\"100\" layout=\"column\" class=\"relative\"><div ng-if=\"!aloading && products.length === 0\" flex=\"\" style=\"min-height: 40vh;\" layout=\"column\" layout-align=\"center center\" layout-margin=\"\"><img src=\"assets/images/error.svg\" style=\"width: 200px\"><h4 class=\"center-text grey-text\">Seems quite lonely here<br>No products found</h4></div><div id=\"products-catalog\" class=\"catalog\" ng-if=\"products.length > 0\" ng-class=\"{\'md-margin\' : !isSmall}\" layout=\"\" layout-wrap=\"\"><section class=\"product-card\" ng-repeat=\"product in products\" ng-class=\"getProductCardClass(product)\"><customisable-product-card id=\"{{\'product-card-\' + $index}}\" on-main-button-click=\"saveState($index, product)\" product=\"product\" ng-if=\"showCustomisableCard(product)\"></customisable-product-card><a ng-href=\"{{getLinkUrl(product)}}\" ng-if=\"!showCustomisableCard(product)\" ng-click=\"saveState($index, product)\" id=\"{{\'product-card-\' + $index}}\" layout=\"\" class=\"relative\"><div style=\"position: absolute; right: 8px; top: 8px; z-index: 1; width: 100%;\" layout=\"\" ng-init=\"product.inWishlist = checkIfProductIsInWishlist(product._id);\"><span flex=\"\"></span><div layout=\"\" layout-align=\"center center\" style=\"width: 44px; height: 44px;\"><md-button class=\"md-icon-button wishlist-button\" md-ink-ripple=\"\" ng-if=\"!product.serverConn\" ng-disabled=\"product.outOfStock\" ng-click=\"perfomWishListAction(product, $event);\"><md-icon ng-class=\"{\'grey-text\' : product.outOfStock, \'pink-text\' : !product.outOfStock}\">{{ product.inWishlist ? \'favorite\' : \'favorite_outline\' }}</md-icon><md-tooltip md-direction=\"bottom\" ng-if=\"!isSmall\">{{ (product.inWishlist ? \"Remove from\" : \"Add to\") + \" wishlist\"}}</md-tooltip></md-button><md-progress-circular class=\"md-accent\" md-diameter=\"20\" ng-if=\"product.serverConn\"></md-progress-circular></div></div><md-card ng-class=\"{\'out-of-stock\' : product.outOfStock, \'no-shadow\' : isSmall}\" class=\"relative product-card\" md-ink-ripple=\"\" flex=\"\"><section class=\"relative\"><hand-embroidery-badge ng-if=\"product.hasEmbroidery\"></hand-embroidery-badge><img md-preload=\"\" md-src=\"product.featured_image\" item-index=\"$index\" key=\"large\"><div class=\"customisable-badge\" layout=\"\" layout-align=\"center center\" ng-if=\"product.productType === 1\"><span>CUSTOMISABLE</span></div><div ng-if=\"product.isNew\" layout=\"\" layout-align=\"center center\" class=\"new-badge\"><div layout=\"\" layout-align=\"center center\"><span class=\"bold-text\">NEW</span></div></div></section><md-card-footer-text layout=\"column\" ng-if=\"!product.placeholder\"><span class=\"md-truncate md-caption product-name center-text\">{{getProperName(product.name);}}</span><div layout=\"\" layout-align=\"center center\" class=\"price\"><strike ng-if=\"product.isOnSale\" class=\"bold-text warn sale-price\" ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' : isSmall}\">₹{{product.mrp}}</strike><span class=\"bold-text\" ng-class=\"{\'md-title\' : !isSmall, \'md-subhead\' : isSmall}\">₹{{product.price}}</span> <span class=\"discount bold-text\" ng-if=\"product.isOnSale\" ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' : isSmall}\">( {{product.discountPercentText}} off )</span></div><div layout=\"\" layout-align=\"center center\"><md-card ng-if=\"product.outOfStock\" class=\"red white-text\" style=\"padding: 4px 8px; border-radius: 32px;\"><div layout=\"\" layout-align=\"center center\"><span class=\"bold-text md-tiny\">OUT OF STOCK</span></div></md-card><md-card ng-if=\"!product.published && product.comingSoon\" class=\"white-text\" style=\"background: #614385; padding: 4px 8px; border-radius: 32px\"><div layout=\"\" layout-align=\"center center\"><span class=\"bold-text md-tiny\">COMING SOON</span></div></md-card></div></md-card-footer-text><md-card-footer-text ng-if=\"product.placeholder\" class=\"product-placeholder\"><div class=\"product-name-placeholder\"></div><div class=\"product-price-placeholder\"></div></md-card-footer-text></md-card></a></section></div><div id=\"infinite-load-trigger\" layout=\"\" layout-align=\"center center\" ng-show=\"totalCount > products.length\"></div><div ng-if=\"totalCount === products.length\" layout=\"column\" layout-align=\"center center\" class=\"all-products-loaded\"><img src=\"assets/images/category/loaded_all.svg\"><h4>Loaded All Products</h4></div><div class=\"products-loader\" layout=\"\" layout-align=\"center start\" layout-margin=\"\" layout-padding=\"\" ng-if=\"aloading\"><md-progress-circular md-diameter=\"36\" class=\"md-accent\" md-mode=\"query\"></md-progress-circular></div></div></div><div class=\"bottom-toolbar\" layout=\"\" ng-if=\"isSmall\" md-whiteframe=\"12\"><md-button id=\"sort-action\" class=\"md-accent flex montserrat\" ng-click=\"showSortBottomSheet()\"><md-icon>sort</md-icon><span>Sort</span></md-button><md-button id=\"filter-action\" class=\"md-accent flex montserrat\" ng-click=\"openFilters($event);\" ng-disabled=\"!filteringAttributes.length\"><span class=\"applied-filter\" ng-if=\"hasFilters\"></span><md-icon>filter_list</md-icon><span>Filter</span></md-button></div></section><div static-include=\"app/modules/category/partials/bottom-sheet-filters.html\" ng-if=\"isSmall\"></div><div static-include=\"app/modules/category/partials/bottom-sheet-sort.html\" ng-if=\"isSmall\"></div>");
$templateCache.put("app/modules/checkout/partials/checkout.html","<div ng-include=\"\'app/modules/cart/partials/cart-nav.html\'\"></div><style>\n    .right-border {\n        border-right: 1px solid rgba(1, 1, 1, 0.25);\n    }\n\n    .ticket {\n        font-family: Arial;\n        font-size: 12px;\n        font-weight: bold;\n        position: relative !important;\n        background: #8dc63f;\n        float: left;\n        padding: 7px 3px;\n        margin: 0 5px 5px 0;\n    }\n\n    .ticket:after {\n        content: \"\";\n        position: absolute !important;\n        z-index: 100;\n        top: 0;\n        left: 0;\n        border-right: #fff 7px solid;\n        border-bottom: #fff 7px solid;\n        -moz-border-radius: 0 0 20px 0;\n        -webkit-border-radius: 0 0 20px 0;\n        border-radius: 0 0 20px 0;\n    }\n\n    .ticket:before {\n        content: \"\";\n        position: absolute !important;\n        z-index: 100;\n        top: 0;\n        right: 0;\n        border-left: #fff 7px solid;\n        border-bottom: #fff 7px solid;\n        -moz-border-radius: 0 0 0 20px;\n        -webkit-border-radius: 0 0 0 20px;\n        border-radius: 0 0 0 20px;\n    }\n\n    .ticket a:after {\n        content: \"\";\n        position: absolute !important;\n        z-index: 100;\n        bottom: 0;\n        left: 0;\n        border-right: #fff 7px solid;\n        border-top: #fff 7px solid;\n        -moz-border-radius: 0 20px 0 0;\n        -webkit-border-radius: 0 20px 0 0;\n        border-radius: 0 20px 0 0;\n    }\n\n    .ticket a:before {\n        content: \"\";\n        position: absolute !important;\n        z-index: 1000;\n        bottom: 0;\n        right: 0;\n        border-left: #fff 7px solid;\n        border-top: #fff 7px solid;\n        -moz-border-radius: 20px 0 0 0;\n        -webkit-border-radius: 20px 0 0 0;\n        border-radius: 20px 0 0 0;\n    }\n\n    .ticket a {\n        outline: 1px rgba(255, 255, 255, 0.4) dashed;\n        border: 1px rgba(0, 0, 0, 0.3) dashed;\n        padding: 4px 10px 4px 20px;\n        text-decoration: none;\n        color: rgba(255, 255, 255, 0.5);\n        white-space: nowrap;\n    }\n\n    .ticket a:hover {\n        color: rgba(0, 0, 0, 0.5);\n    }\n\n</style><section class=\"checkout-page languid\"><div layout=\"\" layout-align=\"center center\"><h3 class=\"md-display-1 montserrat bold-text center-text\">Secure Checkout</h3></div><div layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex=\"\" ng-show=\"!loadingUser\"><div flex-gt-sm=\"40\" flex-xs=\"100\" flex-sm=\"100\"><md-card-content layout=\"column\" ng-if=\"user && cartLoaded && !cart.hideAddressForm\" ng-class=\"{\'no-margin no-padding\' : isSmall}\"><div layout=\"row\" layout-align=\"center center\" class=\"md-padding\"><span class=\"center-text montserrat bold-text\" ng-class=\"{\'md-headline\' : !isSmall, \'md-subhead\' : isSmall}\">Shipping Address</span> <span flex=\"\"></span><md-button class=\"md-accent aarida-stroked-button\" ng-click=\"showAddressDialog($event, $scope);\" ng-if=\"addresses.length > 0\"><md-icon class=\"bold-text\">add</md-icon><span class=\"bold-text\">Add New Address</span></md-button></div><md-divider></md-divider><div flex=\"\" layout=\"column\" flex-order-gt-sm=\"1\" flex-order=\"1\"><div flex=\"\" ng-if=\"!addresses.length\" layout=\"column\" layout-align=\"center center\" style=\"position: relative;\" class=\"empty-state\"><img src=\"assets/images/no-orders.svg\"><p class=\"md-caption md-warn montserrat\">No Address Found</p><md-button class=\"md-accent aarida-stroked-button\" ng-click=\"showAddressDialog($event, $scope);\"><md-icon>add</md-icon><span>Add New Address</span></md-button></div></div><md-radio-group ng-model=\"selectedAddress\" ng-if=\"addresses.length\" class=\"md-padding\"><md-list class=\"md-3-line\"><md-list-item ng-repeat=\"address in addresses\" class=\"white\" style=\"border-radius: 5px; margin: 8px; border: 1px solid #efefef\"><div class=\"md-list-item-text md-padding address-single-item\" layout=\"column\"><span class=\"md-caption bold-text address-header\"><span ng-if=\"address.addressType\">{{capitalize(address.addressType)}} -</span> <span>{{ capitalize(address.name) }}</span></span> <span class=\"md-caption address-address\">{{ address.streetAddress }}, {{ address.landmark ? address.landmark+ \", \" : \"\" }} {{ capitalize(address.city) }}, {{ capitalize(address.state) }}- {{ address.pinCode }}</span> <span class=\"md-caption bold-text address-number\">{{ capitalize(address.mobile); }}</span></div><md-radio-button class=\"md-secondary\" aria-label=\"{{address.name}}\" ng-value=\"address\" ng-click=\"selectAddress(address, $index);\"></md-radio-button></md-list-item></md-list></md-radio-group></md-card-content><md-card-content ng-if=\"cart.hideAddressForm\" layout=\"column\" layout-align=\"center center\" class=\"warehouse-dispatch\"><img src=\"/assets/images/cart/empty-cart.svg\" alt=\"Dispatch to warehouse\"><p class=\"center-text\">The order will be delivered to you by a representative of the organisation sponsoring this campaign.</p></md-card-content><md-card-content layout=\"\" ng-if=\"user && !cartLoaded\" layout-fill=\"\"><div flex=\"\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></md-card-content></div><md-card flex=\"\" class=\"relative aarida-shadow checkout-card\" ng-class=\"{\'isSmall\' : isSmall}\"><md-card-content ng-if=\"user && cartLoaded\" layout=\"column\" layout-wrap=\"\"><md-progress-circular md-mode=\"indeterminate\" ng-show=\"!cartLoaded\"></md-progress-circular><span class=\"md-headline center-text md-padding montserrat bold-text\">Order Summary</span><div class=\"gift-card-container\" ng-if=\"cards.length\"><md-list><md-subheader><h3 class=\"center-text\">Apply a Gift Card here</h3>You have {{cards.length}} Gift {{cards.length === 1 ? \'Card\' : \'Cards\'}} in your account. Select one to use.</md-subheader><md-list-item ng-repeat-start=\"card in cards\"><div class=\"md-list-item-text\"><p class=\"bold-text md-body-1\">{{card.code}}</p><p class=\"md-caption\">Balance: <span class=\"bold-text\">₹{{card.balance}}</span> | Expiry: {{card.expiryDate | date : \'mediumDate\'}}</p></div><md-button class=\"md-secondary md-accent aarida-stroked-button\" ng-if=\"cart.giftCard !== card._id\" ng-click=\"applyGiftCard(card)\">Apply</md-button><md-button class=\"md-secondary md-warn\" ng-if=\"cart.giftCard === card._id\" ng-click=\"removeGiftCard(card)\">Remove</md-button></md-list-item><md-divider ng-repeat-end=\"\"></md-divider></md-list></div><md-divider></md-divider><table><tr><th>Total Products</th><td>{{ cart.products.length }}</td></tr><tr><th>Total Price</th><td>Rs. {{ cart.amount - cart.shippingCharges}}</td></tr><tr><th>Shipping Fee</th><td>{{ !cart.shippingCharges ? \"Free\" : \"Rs. \" + cart.shippingCharges}}</td></tr><tr><th>Sub Total</th><td>Rs. {{ cart.amount }}</td></tr><tr ng-if=\"userCredits > 0\"><th class=\"green-text\">Aarida Cash Used</th><td class=\"green-text\">- Rs. {{ creditDiscount}}</td></tr><tr ng-if=\"cart.giftCardAmount\"><th class=\"green-text\">Gift Card Discounts</th><td class=\"green-text\">- Rs. {{ cart.giftCardAmount}}</td></tr><tr><th>Grand Total</th><td>Rs. {{ totalAmount }}</td></tr></table><div class=\"cashback-info\" layout=\"row\" layout-align=\"start center\" ng-if=\"cart.cashBackAmount\"><section><md-icon>info</md-icon></section><section flex-offset=\"5\" layout=\"column\" layout-align=\"center start\"><p class=\"md-caption\">You will get a CashBack of <b>Rs {{cart.cashBackAmount}}</b> as Aarida Cash 15 days after the order has been delivered.</p><a class=\"md-link md-body-1 pointer md-tiny\" ui-sref=\"app.static({slug : \'terms-and-conditions\'})\">View Terms and Conditions</a></section></div><span class=\"md-headline center-text\" style=\"padding: 5px; margin-top: 20px; margin-bottom: 10px;\">Select Payment Method</span><div ng-show=\"(!cart.hideAddressForm && servicable) || cart.hideAddressForm\" ng-if=\"(!cart.hideAddressForm && selectedAddress) || (cart.hideAddressForm)\"><md-radio-group ng-model=\"order.paymentMode\"><md-radio-button ng-init=\"cod = 1;\" value=\"{{ cod }}\" class=\"md-accent\" ng-disabled=\"!codAvaiable || valueLimitCOD\"><div layout=\"column\"><div layout=\"\"><span>Cash On Delivery {{codAvaiable ? \'\' : \'(DISABLED)\'}}</span></div><span ng-if=\"!codAvaiable && !codReason\" class=\"red-text md-caption\">Cod is not available for this address.</span> <span style=\"margin-top: 8px\" ng-if=\"!codAvaiable && codReason\" class=\"red-text md-caption\">{{codReason}}</span> <span ng-if=\"valueLimitCOD\" class=\"red-text md-caption\">Cod is not available on orders above Rs 15000</span></div></md-radio-button><md-radio-button ng-disabled=\"disableOnlinePayments || instamojoDisabled\" ng-init=\"instamojo = 3; instamojoDisabled = false;\" value=\"{{instamojo}}\"><div layout=\"row\"><span>Debit Card/ Net Banking</span><span class=\"md-caption\" style=\"margin-left: 10px;\" ng-if=\"disableOnlinePayments || instamojoDisabled\">Disabled</span></div></md-radio-button><div layout=\"row\"><span class=\"md-caption grey-text\">Wallets</span></div><div class=\"md-margin md-padding\"><md-radio-button aria-label=\"paytm\" ng-disabled=\"paytmDisabled || disableOnlinePayments\" ng-init=\"paytm = 4; paytmDisabled = false;\" value=\"{{paytm}}\"><div layout=\"row\" layout-align=\"center center\"><md-icon md-svg-src=\"{{(paytmDisabled || disableOnlinePayments) ? \'assets/images/paytm_logo_disabled.svg\':\'assets/images/paytm_logo.svg\'}}\" style=\"width: 50px; height: 36px;\"></md-icon><span class=\"md-caption\" style=\"margin-left: 10px;\" ng-if=\"paytmDisabled\">Coming Soon</span></div></md-radio-button><md-radio-button aria-label=\"freecharge\" ng-init=\"frDisbaled = true; freecharge = 5;\" ng-disabled=\"frDisbaled || disableOnlinePayments\" value=\"{{freecharge}}\"><div layout=\"row\" layout-align=\"center center\"><md-icon md-svg-src=\"{{(frDisbaled || disableOnlinePayments) ? \'assets/images/freecharge_logo_disabled.svg\':\'assets/images/freecharge_logo.svg\'}}\" style=\"width: 100px; height: 36px;\"></md-icon><span class=\"md-caption\" style=\"margin-left: 10px;\" ng-if=\"frDisbaled\">Coming Soon</span></div></md-radio-button><md-radio-button aria-label=\"mobikwik\" ng-init=\"mbDisbaled = false; mobikwik = 6 ;\" ng-disabled=\"mbDisbaled || disableOnlinePayments\" ng-value=\"mobikwik\"><div layout=\"row\" layout-align=\"center center\"><md-icon md-svg-src=\"{{(mbDisbaled || disableOnlinePayments) ? \'assets/images/mobikwik_logo_disabled.svg\':\'assets/images/mobikwik_logo.svg\'}}\" style=\"width: 75px; height: 36px;\"></md-icon><span class=\"md-caption\" style=\"margin-left: 10px;\" ng-if=\"mbDisbaled\">Coming Soon</span></div></md-radio-button></div></md-radio-group></div><div ng-if=\"!selectedAddress && !cart.hideAddressForm\"><p class=\"center-text md-title red-text\">Select a shipping address first</p></div><div ng-show=\"selectedAddress && !servicable\"><p class=\"center-text red-text\">We do not deliver to this address anymore.</p></div><section layout=\"\" layout-align=\"start start\"><md-button class=\"md-raised md-accent\" style=\"width: 100%\" ng-disabled=\"((!cart.hideAddressForm && !order.address) || !order.paymentMode || placingOrder )\" ng-click=\"createNewOrder();\"><div layout=\"\" layout-align=\"center center\"><md-progress-circular ng-if=\"placingOrder\" md-diameter=\"20\"></md-progress-circular><span ng-if=\"!placingOrder\">Place Order</span></div></md-button></section></md-card-content><div class=\"opaque-loader\" ng-if=\"applyingGiftCard\" layout=\"\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-diameter=\"24\"></md-progress-circular></div></md-card></div><div class=\"loader-container\" layout=\"column\" layout-margin=\"\" layout-padding=\"\" layout-align=\"start center\" ng-show=\"loadingUser\"><md-progress-circular class=\"md-accent\"></md-progress-circular><p>Securely Loading Checkout Details...</p></div></section><div style=\"visibility: hidden\" ng-if=\"user\"><div class=\"md-dialog-container\" id=\"infoDialog\"><md-dialog><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\"><md-button class=\"md-icon-button\" ui-sref=\"app.cart\"><md-icon>arrow_back</md-icon></md-button><h2 flex=\"\" style=\"padding-top: 0; text-align: center\">Enter Missing Details</h2></div></md-toolbar><md-divider></md-divider><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\" layout-padding=\"\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"no-margin red-text\">info</md-icon><span class=\"center-text md-caption red-text\" ng-if=\"disableEmailForm && !disableMobileForm\">Please enter your mobile number to continue</span> <span class=\"center-text md-caption red-text\" ng-if=\"!disableEmailForm && disableMobileForm\">Please enter your email address to continue</span> <span class=\"center-text md-caption red-text\" ng-if=\"!disableEmailForm && !disableMobileForm\">Please enter your details to continue</span></div><form name=\"$parent.infoForm\" ng-cloak=\"\"><div layout-gt-sm=\"column\"><div layout=\"\"><span class=\"md-caption grey-text\" style=\"margin-top: 30px;\">+91 -</span><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-theme=\"black\"><label>Mobile Number</label> <input type=\"tel\" ng-pattern=\"/^[56789][0-9]{9}$/\" name=\"mobile\" ng-minlength=\"10\" ng-maxlength=\"10\" ng-disabled=\"disableMobileForm\" required=\"\" ng-model=\"user.mobile\"><div ng-messages=\"$parent.infoForm.mobile.$error\" ng-if=\"$parent.infoForm.mobile.$touched && $parent.infoForm.mobile.$error\"><div ng-message-exp=\"[\'required\', \'pattern\', \'minlength\', \'maxlength\']\"><div ng-message=\"pattern\">Please provide a 10 digit Indian mobile number without 0 or +91</div></div></div></md-input-container></div><md-input-container class=\"md-block\" flex-gt-sm=\"\" md-theme=\"black\"><label>Email Address</label> <input type=\"email\" name=\"email\" ng-disabled=\"disableEmailForm\" required=\"\" ng-model=\"user.email\"><div ng-messages=\"$parent.infoForm.email.$error\" ng-if=\"$parent.infoForm.email.$touched && $parent.infoForm.email.$error\"><div ng-message-exp=\"[\'required\']\"><div ng-message=\"pattern\">Please provide a valid email address</div></div></div></md-input-container></div><div layout=\"\" layout-align=\"center center\"><span ng-if=\"error\" class=\"center-text red-text md-caption\">{{error}}</span></div><div layout=\"\"><md-button class=\"md-raised md-accent\" style=\"width: 100%\" ng-click=\"saveUserDetails();\" ng-disabled=\"userSaving || $parent.infoForm.$invalid\">Update Details</md-button></div></form></div></md-dialog-content></md-dialog></div></div>");
$templateCache.put("app/modules/contests/partials/index.html","<div layout=\"column\"><section class=\"contest-artwork\" style=\"position: relative;\"><div class=\"background\"></div><div style=\"position: absolute; left: 0; top: 0; bottom: 0; right: 0; z-index: 3; width: 100%;\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><p class=\"montserrat md-display-1 white-text\">Thank You</p><img src=\"assets/images/success.svg\" style=\"width: 100px;\"><p class=\"md-subhead white-text bold-text center-text\">We thank you for the overwhelming response.<br>The spinwheel contest is now finished.<br>But you can continue shopping though.</p><md-button class=\"md-raised md-accent\" style=\"height: 44px; width: 250px; line-height: 44px; border-radius:32px;\" ui-sref=\"app.category({\'categoryName\' : \'all\'})\">Shop Now</md-button></div></div></section></div><script type=\"text/ng-template\" id=\"contestTC.tmpl.html\"><md-dialog flex-xl=\"40\" flex-lg=\"40\" flex-md=\"60\" flex-sm=\"70\" flex-xs=\"90\"> <md-dialog-content class=\"montserrat\"> <div class=\"relative\"> <div style=\"position: absolute; top: 0; left: 0; right: 0; bottom: 0;\" layout=\"column\" layout-align=\"center center\"> <h2 class=\"center-text white-text\">Spinwheel Contest</h2> <h4 class=\"center-text white-text\">by aarida</h4> </div> <img md-whiteframe=\"5\" src=\"assets/images/spinwheel-contest/full-artwork.svg\" alt=\"contest\"/> <md-button class=\"md-icon-button\" style=\"position: absolute; right: 4px; top: 4px;\" ng-click=\"cancel()\"> <md-icon class=\"white-text\">close</md-icon> </md-button> </div> <div layout=\"column\" layout-align=\"start center\" class=\"md-padding\"> <span class=\"md-title bold-text\">Rules</span> <ol style=\"font-size: 12px;\"> <li ng-repeat=\"rule in rules\" class=\"md-1-line\"> <!--<span>{{$index + 1}}.</span>--> <p class=\"md-caption\">{{rule}}</p> </li> </ol> </div> </md-dialog-content> <md-dialog-actions> <md-button style=\"width: 150px; border-radius: 32px; \" ng-click=\"cancel();\" class=\"md-accent md-raised\"> Continue </md-button> </md-dialog-actions> </md-dialog></script>");
$templateCache.put("app/modules/customisation/partials/home.html","<div><img src=\"assets/images/customisation/1.webp\"> <img src=\"assets/images/customisation/2.webp\"> <img src=\"assets/images/customisation/3.webp\"> <img src=\"assets/images/customisation/4.webp\"><div class=\"relative\"><img src=\"assets/images/customisation/5.webp\"><div style=\"position: absolute; width: 100%; height: 100%; top: 0;\" layout=\"\"><a flex=\"\" href=\"/collection/customisable_products\"></a> <a flex=\"\" href=\"/category/all?sort=-createdAt&attributes=%7B%7D&customisable=true&y=0\"></a></div></div></div>");
$templateCache.put("app/modules/customisation/partials/single.html","<div class=\"customisation-editor\" device-detector=\"\" layout=\"column\" layout-fill=\"\"><md-toolbar layout=\"row\" layout-align=\"start center\" md-whiteframe=\"-1\" ng-if=\"!isSmall\"><div layout=\"row\" flex=\"\" flex-offset=\"10\" layout-align=\"start center\" ng-include=\"\'app/modules/customisation/partials/sub-partials/data.html\'\"></div></md-toolbar><section flex=\"\" layout=\"column\" ng-if=\"everythingLoaded && !isSmall\" ng-include=\"\'app/modules/customisation/partials/sub-partials/desktop-editor.html\'\"></section><section flex=\"\" layout=\"column\" ng-if=\"isSmall && everythingLoaded && loadEditor\" ng-include=\"\'app/modules/customisation/partials/sub-partials/mobile-editor.html\'\"></section><div style=\"min-height: 80vh;\" layout=\"column\" layout-align=\"center center\" layout-margin=\"\" ng-if=\"!everythingLoaded\"><md-progress-circular class=\"md-accent\"></md-progress-circular><md-icon class=\"md-accent\" md-svg-src=\"assets/images/aadira-logo.svg\" style=\"width: 100px; height: auto;\"></md-icon><span class=\"md-caption\">Loading the editor ...</span></div><div style=\"visibility: hidden\" ng-if=\"product.variations.length > 1\"><div class=\"md-dialog-container\" id=\"variationsDialog\"><md-dialog flex-xs=\"80\" flex-sm=\"70\" flex-md=\"40\" flex-lg=\"30\" flex-xl=\"30\"><md-dialog-content layout=\"column\" layout-padding=\"\"><h4 class=\"center-text\">Select Variation</h4><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-fab md-mini\" ng-repeat=\"variation in product.variations\" ng-class=\"{\'md-accent md-hue-6\' : selectedVariation == variation._id, \'md-accent md-hue-1\' : selectedVariation != variation._id}\" ng-click=\"selectVariation(variation);\"><span>{{ getVariationValue(variation); }}</span></md-button></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel();\" md-autofocus=\"\" class=\"md-raised md-warn\">Cancel</md-button><span flex=\"\"></span><md-button ng-click=\"addToCart($event)\" class=\"md-raised md-accent md-hue-1 large-btn\">Add to Cart</md-button></md-dialog-actions></md-dialog></div></div></div><div static-include=\"app/main/partials/sizeChart.html\"></div>");
$templateCache.put("app/modules/home/components/actions.html","<div flex-order=\"2\" flex-order-gt-sm=\"1\" layout=\"column\" layout-align=\"start center\" layout-padding=\"\" style=\"padding: 0; position: relative; z-index: 4;\"><span class=\"md-headline center-text md-margin montserrat\" style=\"font-weight: bold; padding: 8px 0 0 0; border-bottom: 2px solid #c43400\">FROM DESIGN TO DELIVERY. IN QUICK STEPS!</span> <span flex=\"10\"></span><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"space-around\" class=\"md-padding md-margin\"><md-card flex=\"\" layout=\"column\" layout-align=\"center center\" ng-style=\"{\'margin-bottom\' : isSmall ? \'30px\' : \'0px\'}\" style=\"z-index: -1; position: relative;\" ng-repeat=\"data in $ctrl.howCustomisationWorks track by data.id\"><md-card-content layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><div layout=\"column\" layout-align=\"center center\"><span class=\"md-caption grey-text\">{{ ::data.subText }}</span> <span class=\"md-title\" style=\"font-weight: 700\">{{ ::data.headText }}</span></div><div ng-mouseenter=\"highlight(data);\" style=\"width: 75px; position: relative;\"><img ng-src=\"{{ data.hover ? data.image : (data.image_init ? data.image_init : data.image )}}\" style=\"width: 75px; height: auto;\"></div><span flex=\"\" class=\"center-text md-caption\" style=\"margin: 10px 10% 0 10%\">{{ :: data.text }}</span></md-card-content></md-card></div><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" style=\"width: 200px; line-height: 44px;\" ui-sref=\"app.category({\'categoryName\' : \'all\'})\"><md-icon>open_in_new</md-icon><span>Get Started</span></md-button></div></div>");
$templateCache.put("app/modules/login/partials/forgotpassword.html","<form layout=\"column\" layout-align=\"start center\" name=\"$parent.$parent.forgotPasswordForm\" ng-disabled=\"authPromise.$$state.pending\" style=\"margin-top: 50px;\"><md-input-container style=\"margin: 3px 0\"><label>Mobile Number</label> <input type=\"tel\" name=\"mobile\" ng-model=\"newUser.mobile\" required=\"\" md-maxlength=\"10\" ng-minlength=\"10\" ng-pattern=\"/^[56789][0-9]{9}$/\" placeholder=\"10 digit mobile number\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.forgotPasswordForm.mobile.$error\" ng-show=\"$parent.$parent.forgotPasswordForm.mobile.$dirty\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid 10 digit mobile number</div></div></md-input-container><p class=\"md-caption red-text center-text\">{{ formError }}</p><div layout=\"\"><md-button class=\"md-warn md-raised\" ng-disabled=\"authPromise.$$state.pending\" ng-click=\"backToLogin();\"><md-icon>close</md-icon><span>Back to login</span></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"forgotPasswordForm.$invalid\" ng-click=\"forgotPassword($event);\"><span>Next</span><md-icon>arrow_forward</md-icon></md-button></div></form>");
$templateCache.put("app/modules/login/partials/getStarted.html","<form layout=\"column\" layout-align=\"start center\" name=\"$parent.$parent.getStartedForm\" ng-disabled=\"authLoading\"><div layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><span class=\"md-title\">Let\'s get started</span> <span class=\"md-body-1\">Enter your mobile number to continue</span></div><md-input-container class=\"md-no-float md-primary\" md-theme=\"black\"><md-icon class=\"md-accent\">phone</md-icon><input type=\"tel\" name=\"mobile\" ng-model=\"user.mobile\" required=\"\" maxlength=\"10\" minlength=\"10\" md-maxlength=\"10\" ng-pattern=\"/^[56789][0-9]{9}$/\" placeholder=\"Mobile Number\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.getStartedForm.mobile.$error\" ng-show=\"$parent.$parent.getStartedForm.mobile.$dirty\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid 10 digit mobile number</div></div></md-input-container><md-progress-circular md-mode=\"44\" ng-if=\"checkingDetail\" class=\"md-accent\"></md-progress-circular><md-button class=\"md-accent md-raised\" style=\"width: 200px;\" ng-if=\"!checkingDetail\" ng-disabled=\"$parent.$parent.getStartedForm.$invalid\" type=\"submit\" ng-click=\"checkDetail();\"><span class=\"bold-text\">Continue</span></md-button><div layout=\"\" class=\"md-margin\" style=\"width: 100%;\" ng-if=\"!disableSocialLogin\"><section layout=\"column\" flex=\"\" layout-align=\"center stretch\"><md-divider class=\"md-accent\"></md-divider></section><span class=\"center-text\" style=\"border: 1px solid; border-radius: 50%; padding: 8px;\">OR</span><section layout=\"column\" flex=\"\" layout-align=\"center stretch\"><md-divider class=\"md-accent\"></md-divider></section></div><div layout=\"\" layout-align=\"center center\" ng-if=\"!disableSocialLogin\"><md-button class=\"md-primary md-raised\" ng-click=\"googleLogin();\"><md-icon md-svg-src=\"assets/images/search.svg\"></md-icon><span style=\"margin-left: 10px\">Login With Google</span></md-button></div><div ng-if=\"disableSocialLogin\" style=\"height: 100px\"></div></form>");
$templateCache.put("app/modules/login/partials/login-modal.html","<div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"loginDialog\"><md-dialog flex-xs=\"90\" flex-sm=\"70\" flex-md=\"40\" flex-lg=\"30\" flex-xl=\"20\" md-whiteframe=\"1\"><md-dialog-content layout=\"row\" style=\"min-height : 400px;\"><div flex=\"\" layout=\"column\" class=\"auth\" style=\"position: relative;\"><div style=\"position: relative; height: 64px;\" layout=\"\" layout-align=\"end center\"><md-button md-ink-ripple=\"\" class=\"md-icon-button md-accent\" ng-click=\"cancel()\"><md-icon>close</md-icon></md-button></div><div layout=\"\" layout-align=\"center center\"><img src=\"assets/images/aarida-optimized.png\" style=\"height: 75px; width: auto;\"></div><div layout=\"column\" class=\"md-padding\" style=\"height: 100%;\"><div ng-show=\"showForm === 2\" static-include=\"app/modules/login/partials/verifyotp.html\"></div><div ng-show=\"showForm === 3\" static-include=\"app/modules/login/partials/forgotpassword.html\"></div><div ng-show=\"showForm === 4\" static-include=\"app/modules/login/partials/getStarted.html\"></div><div ng-show=\"showForm === 5\" static-include=\"app/modules/login/partials/password.html\"></div><div ng-show=\"showForm === 6\" static-include=\"app/modules/login/partials/newAccount.html\"></div></div></div></md-dialog-content></md-dialog></div></div>");
$templateCache.put("app/modules/login/partials/login-page.html","<div layout=\"\" layout-padding=\"\" layout-align=\"center center\" style=\"min-height: 80vh; background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%);\"><div md-whiteframe=\"16\" layout=\"column\" class=\"auth white md-margin login\" style=\"overflow: hidden;position: relative; width: 360px;\"><div layout=\"\" layout-align=\"center center\"><img src=\"assets/images/aarida-optimized.png\" style=\"height: 75px; width: auto;\"></div><div layout=\"column\" class=\"md-padding\" style=\"height: 100%;\"><div ng-show=\"showForm === 2\" static-include=\"app/modules/login/partials/verifyotp.html\"></div><div ng-show=\"showForm === 3\" static-include=\"app/modules/login/partials/forgotpassword.html\"></div><div ng-show=\"showForm === 4\" static-include=\"app/modules/login/partials/getStarted.html\"></div><div ng-show=\"showForm === 5\" static-include=\"app/modules/login/partials/password.html\"></div><div ng-show=\"showForm === 6\" static-include=\"app/modules/login/partials/newAccount.html\"></div></div></div></div>");
$templateCache.put("app/modules/login/partials/login.html","<form layout=\"column\" layout-align=\"start center\" name=\"$parent.$parent.loginForm\" ng-disabled=\"authLoading\"><span class=\"md-caption center-text\">Login using Social Accounts</span><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-raised bold-text\" style=\"color: #db4437;\" ng-click=\"googleLogin();\"><md-icon md-svg-src=\"assets/images/search.svg\"></md-icon>Google</md-button></div><div layout=\"\" layout-align=\"center center\"><span class=\"md-caption grey-text\" style=\"padding: 4px; text-align: center;\">OR</span></div><md-input-container style=\"margin: 20px 0\"><label>Mobile Number</label> <input type=\"tel\" name=\"mobile\" ng-model=\"user.mobile\" required=\"\" maxlength=\"10\" minlength=\"10\" ng-pattern=\"/^[56789][0-9]{9}$/\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.loginForm.mobile.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid 10 digit mobile number</div></div></md-input-container><md-input-container style=\"margin: 3px 0\"><label>Password</label> <input name=\"password\" ng-model=\"user.password\" minlength=\"6\" required=\"\" type=\"password\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.loginForm.password.$error\"><div ng-message-exp=\"[\'required\', \'minlength\']\">Please enter a valid password</div></div></md-input-container><div flex=\"15\" layout=\"\" layout-align=\"center center\" class=\"md-padding\" ng-if=\"errorText\"><span class=\"red-text md-caption center-text\" ng-if=\"errorText\">{{ errorText }}</span></div><md-checkbox flex=\"\" ng-model=\"user.rememberMe\" aria-label=\"Remember Me\">Remember Me</md-checkbox><div layout=\"column\"><md-button class=\"md-primary md-raised\" type=\"submit\" ng-disabled=\"$parent.$parent.loginForm.$invalid || authLoading\" ng-click=\"loginUser($event);\"><span ng-hide=\"authLoading\">LOGIN</span><md-progress-circular style=\"margin: auto;\" md-diameter=\"24\" ng-if=\"authLoading\"></md-progress-circular></md-button><div layout=\"\" layout-align=\"end center\" style=\"width: 100%;\" class=\"md-padding\"><a class=\"md-caption pointer\" style=\"text-align: end\" flex=\"50\" ng-click=\"showForgotPassword();\">Forgot Password ?</a></div><span class=\"md-caption center-text\" style=\"margin-top: 20px;\">Don\'t have an account?</span><md-button class=\"md-primary\" ng-disabled=\"authLoading\" ng-click=\"showRegistrationForm()\" style=\"border: 1px solid currentColor\">Create New Account</md-button></div></form>");
$templateCache.put("app/modules/login/partials/newAccount.html","<div layout=\"column\"><form layout=\"column\" layout-align=\"start center\" name=\"$parent.$parent.newAccountForm\" ng-disabled=\"authPromise.$$state.pending\"><div layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><span class=\"md-caption\">Create a new Account</span><div layout=\"\" layout-align=\"center center\"><span class=\"md-subhead bold-text\">+91-{{newUser.mobile}}</span><div layout=\"\" layout-align=\"center center\" style=\"margin-left: 8px;\"><svg class=\"checkmark\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 52 52\"><circle class=\"checkmark__circle\" cx=\"26\" cy=\"26\" r=\"25\" fill=\"none\"></circle><path class=\"checkmark__check\" fill=\"none\" d=\"M14.1 27.2l7.1 7.2 16.7-16.8\"></path></svg></div></div></div><md-input-container class=\"md-accent\" style=\"margin: 3px 0;\"><label>Name</label><md-icon class=\"md-accent\">person_outline</md-icon><input type=\"text\" name=\"name\" ng-model=\"newUser.name\" required=\"\" md-maxlength=\"20\" ng-pattern=\"/^[a-zA-z\\s]*$/\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.newAccountForm.name.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid name</div></div></md-input-container><md-input-container class=\"md-accent\" style=\"margin: 3px 0\"><md-icon class=\"md-accent\">email</md-icon><label>Email ID</label> <input type=\"email\" name=\"email\" ng-model=\"newUser.email\" required=\"\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.newAccountForm.email.$error\"><div ng-message-exp=\"[\'required\', \'pattern\']\">Please enter a valid email ID</div></div></md-input-container><md-input-container class=\"md-accent\" style=\"margin: 3px 0\"><md-icon class=\"md-accent\">lock_outline</md-icon><label>Password</label> <input name=\"password\" ng-model=\"newUser.password\" minlength=\"6\" required=\"\" type=\"password\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.newAccountForm.password.$error\"><div ng-message-exp=\"[\'required\', \'minlength\']\">Please enter a valid password</div></div></md-input-container><span class=\"red-text md-caption center-text\" ng-if=\"formError\">{{ formError }}</span><div layout=\"column\"><md-button class=\"md-accent md-raised\" type=\"submit\" ng-disabled=\"$parent.$parent.newAccountForm.$invalid || authLoading\" ng-click=\"signUp($event);\"><span ng-hide=\"authLoading\">Register</span><md-progress-circular style=\"margin: auto;\" md-diameter=\"24\" ng-if=\"authLoading\"></md-progress-circular></md-button><span class=\"md-caption center-text\">Incorrect details or want to try social login?</span><md-button ng-click=\"showGetStartedForm()\">Go Back</md-button></div></form></div>");
$templateCache.put("app/modules/login/partials/password.html","<form layout=\"column\" layout-align=\"start center\" name=\"$parent.$parent.passwordForm\" ng-disabled=\"authPromise.$$state.pending\"><div layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><span class=\"md-body-1\">Login to your account</span><div layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><a href=\"#\" class=\"md-accent md-link\" ng-click=\"showGetStartedForm();\" layout=\"\" layout-align=\"center center\"><md-icon class=\"md-accent\">keyboard_backspace</md-icon><span class=\"md-caption\">Incorrect mobile number? Change here.</span></a> <span class=\"md-subhead bold-text\">+91-{{user.mobile}}</span></div></div><md-input-container class=\"md-primary\" md-theme=\"black\" style=\"margin: 3px 0\"><label>Password</label><md-icon class=\"md-accent\">lock_outline</md-icon><input name=\"password\" ng-model=\"user.password\" minlength=\"6\" required=\"\" type=\"password\" id=\"loginPassword\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.passwordForm.password.$error\"><div ng-message-exp=\"[\'required\', \'minlength\']\">Please enter a valid password</div></div></md-input-container><div layout=\"\" layout-align=\"end center\" style=\"width: 80%;\" class=\"md-padding\"><a class=\"pointer md-caption\" ng-click=\"forgotPassword()\">Forgot Password ?</a></div><span class=\"center-text red-text md-caption\">{{formError}}</span><md-progress-circular md-mode=\"44\" ng-if=\"authLoading\" class=\"md-accent\"></md-progress-circular><md-button class=\"md-accent md-raised\" style=\"width: 200px;\" ng-if=\"!authLoading\" type=\"submit\" ng-disabled=\"$parent.$parent.passwordForm.$invalid\" ng-click=\"loginUser();\"><span class=\"bold-text\">Login</span></md-button><div layout=\"\" class=\"md-margin\" style=\"width: 100%;\" ng-if=\"!disableSocialLogin\"><section layout=\"column\" flex=\"\" layout-align=\"center stretch\"><md-divider class=\"md-accent\"></md-divider></section><span class=\"center-text\" style=\"border: 1px solid; border-radius: 50%; padding: 8px;\">OR</span><section layout=\"column\" flex=\"\" layout-align=\"center stretch\"><md-divider class=\"md-accent\"></md-divider></section></div><div layout=\"\" layout-align=\"center center\" ng-if=\"!disableSocialLogin\"><md-button class=\"md-primary md-raised\" ng-click=\"googleLogin();\"><md-icon md-svg-src=\"assets/images/search.svg\"></md-icon><span style=\"margin-left: 10px\">Login With Google</span></md-button></div></form>");
$templateCache.put("app/modules/login/partials/register.html","<div layout=\"column\"><span class=\"md-caption center-text\">Register using Social Accounts</span><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-raised bold-text\" style=\"color: #db4437;\" ng-click=\"googleLogin();\"><md-icon md-svg-src=\"assets/images/search.svg\"></md-icon>Google</md-button></div><div layout=\"\" layout-align=\"center center\"><span class=\"md-caption grey-text\" style=\"padding: 4px; text-align: center;\">OR</span></div><form layout=\"column\" layout-align=\"start center\" name=\"$parent.$parent.registerForm\" ng-disabled=\"authPromise.$$state.pending\"><md-input-container style=\"margin: 10px 0;\"><label>Name</label> <input type=\"text\" name=\"name\" ng-model=\"newUser.name\" required=\"\" md-maxlength=\"20\" ng-pattern=\"/^[a-zA-z\\s]*$/\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.registerForm.name.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid name</div></div></md-input-container><md-input-container style=\"margin: 3px 0\"><label>Email ID</label> <input type=\"email\" name=\"email\" ng-model=\"newUser.email\" required=\"\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.registerForm.email.$error\"><div ng-message-exp=\"[\'required\', \'pattern\']\">Please enter a valid email ID</div></div></md-input-container><md-input-container style=\"margin: 3px 0\"><label>Mobile Number</label> <input type=\"tel\" name=\"mobile\" ng-model=\"newUser.mobile\" required=\"\" md-maxlength=\"10\" ng-minlength=\"10\" ng-pattern=\"/^[56789][0-9]{9}$/\" placeholder=\"10 digit mobile number\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.registerForm.mobile.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid 10 digit mobile number</div></div></md-input-container><md-input-container style=\"margin: 3px 0\"><label>Password</label> <input name=\"password\" ng-model=\"newUser.password\" minlength=\"6\" required=\"\" type=\"password\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.registerForm.password.$error\"><div ng-message-exp=\"[\'required\', \'minlength\']\">Please enter a valid password</div></div></md-input-container><div flex=\"15\" layout=\"\" layout-align=\"center center\" class=\"md-padding\" ng-if=\"formError\"><span class=\"red-text md-caption center-text\" ng-if=\"formError\">{{ formError }}</span></div><div layout=\"column\"><md-button class=\"md-primary md-raised\" type=\"submit\" ng-disabled=\"$parent.$parent.registerForm.$invalid || authLoading\" ng-click=\"generateOTP($event);\"><span ng-hide=\"authLoading\">Register</span><md-progress-circular style=\"margin: auto;\" md-diameter=\"24\" ng-if=\"authLoading\"></md-progress-circular></md-button><span class=\"md-caption center-text\" style=\"margin-top: 20px;\">Already Have An Account?</span><md-button class=\"md-primary\" ng-disabled=\"authLoading\" ng-click=\"backToLogin()\" style=\"border: 1px solid currentColor\">LOGIN INSTEAD</md-button></div></form></div>");
$templateCache.put("app/modules/login/partials/verifyotp.html","<form layout=\"column\" layout-align=\"start center\" name=\"$parent.$parent.otpForm\" ng-disabled=\"authLoading\"><div layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><span class=\"md-caption\">Enter the OTP sent to</span> <span class=\"md-title bold-text\">+91-{{newUser.mobile}}</span> <a href=\"#\" class=\"md-accent md-link\" ng-click=\"showGetStartedForm();\" layout=\"\" layout-align=\"center center\"><md-icon class=\"md-accent\">keyboard_backspace</md-icon><span class=\"md-caption\">Incorrect mobile number? Change here.</span></a></div><md-input-container class=\"md-primary\" md-theme=\"black\" style=\"margin: 10px 0\"><label>OTP</label><md-icon class=\"md-accent\">lock_open</md-icon><input type=\"text\" name=\"otp\" ng-model=\"newUser.otp\" required=\"\" md-maxlength=\"6\" maxlength=\"6\" minlength=\"6\" ng-pattern=\"/^[0-9]{6}$/\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.otpForm.otp.$error\" ng-show=\"otpForm.otp.$dirty\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid 6 digit OTP</div></div></md-input-container><div layout=\"column\" class=\"md-accent\" ng-if=\"changingPassword && newUser.otp.length === 6\"><md-input-container class=\"md-primary\" md-theme=\"black\" style=\"margin: 3px 0\"><label>New Password</label> <input name=\"password\" ng-model=\"newUser.password\" minlength=\"6\" required=\"\" type=\"password\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.otpForm.password.$error\" ng-show=\"otpForm.password.$dirty\"><div ng-message=\"required\">Please enter a valid password</div><div ng-message=\"minlength\">Password should be at least 6 characters long</div></div></md-input-container><md-input-container class=\"md-primary\" md-theme=\"black\" style=\"margin: 3px 0\"><label>Confirm New password</label> <input ng-pattern=\"\\b{{newUser.password}}\\b\" name=\"confirmPassword\" ng-model=\"newUser.confirmPassword\" minlength=\"6\" required=\"\" type=\"password\"><div class=\"valMessage\" ng-messages=\"$parent.$parent.otpForm.confirmPassword.$error\" ng-show=\"otpForm.confirmPassword.$dirty\"><div class=\"md-tiny\" ng-message-exp=\"[\'required\', \'minlength\']\">Please enter a valid password</div><div class=\"md-tiny\" ng-show=\"$parent.$parent.otpForm.confirmPassword.$error.pattern\">Passwords do not match</div></div></md-input-container></div><p class=\"md-caption red-text center-text\">{{ formError }}</p><div layout=\"\"><md-button class=\"md-accent md-raised\" aria-label=\"otp submit button\" type=\"submit\" ng-disabled=\"$parent.$parent.otpForm.$invalid || authPromise.$$state.pending\" ng-click=\"changingPassword ? changePassword($event) : verifyOTP($event) ;\"><section layout=\"\" layout-align=\"center center\"><span ng-if=\"!authPromise.$$state.pending\">{{changingPassword ? \"Change Password\" : \"Verify OTP\"}}</span><md-progress-circular md-diameter=\"24\" ng-if=\"authPromise.$$state.pending\"></md-progress-circular></section></md-button></div></form>");
$templateCache.put("app/modules/products/partials/product.html","<div class=\"product-page\"><section ng-if=\"loadingProduct\" layout=\"\" layout-align=\"center center\" class=\"md-padding loader\"><md-progress-circular class=\"md-accent\"></md-progress-circular></section><section ng-if=\"!loadingProduct && productLoadError\" class=\"no-product-found md-padding\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/no-orders.svg\"><p class=\"md-body-1 center-text\">{{productLoadError}}</p><md-button md-theme=\"black\" class=\"md-raised md-accent aarida-rounded-btn\" ui-sref=\"app.home\">Go to Home</md-button></section><section ng-if=\"!loadingProduct && !productLoadError\"><div layout=\"column\" flex=\"\" class=\"product-container\"><section flex=\"\" class=\"no-margin\"><md-card-content style=\"position: relative; padding: 0;\" layout=\"column\"><div layout-gt-sm=\"row\" layout=\"column\" style=\"position: relative; padding: 0;\" layout-wrap=\"\"><section flex-gt-sm=\"40\" flex=\'100\"\' layout-align=\"center center\" layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-fill=\"\" style=\"position: sticky; position: -webkit-sticky; top : 0;\"><md-image-gallery gallery=\"product.gallery\" image-size=\"imageSize\" selected-index=\"selectedIndex\" on-mouse-move=\"showZoomTool(event)\" on-mouse-out=\"hideZoomTool(event)\" on-image-click=\"openFullScreenZoomer(event)\" on-selection-change=\"changeSelectedImage(image)\" selected=\"product.featured_image\"></md-image-gallery><md-button class=\"md-fab md-mini zoom-button md-primary\" ng-click=\"openFullScreenZoomer($event)\"><md-icon>zoom_out_map</md-icon></md-button><md-button class=\"md-fab md-mini md-primary mobile-favourite-btn\" ng-if=\"isSmall\" ng-disabled=\"product.outOfStock\" style=\"z-index: 4\" ng-click=\"perfomWishListAction($event);\"><md-icon ng-class=\"{\'grey-text\' : product.outOfStock, \'pink-text\' : !product.outOfStock}\">{{product.inWishlist ? \'favorite\' : \'favorite_outline\'}}</md-icon></md-button><section ng-if=\"hasViewCount\" class=\"social-proof md-whiteframe-2dp\"><p class=\"md-body-1 bold-text\">{{views}} people viewed this product recently</p></section></section><md-card flex-gt-sm=\"60\" flex=\'100\"\' ng-class=\"{\'no-margin no-shadow\': !isSmall}\" layout=\"column\" ng-style=\"{\'margin-top\' : isSmall ? \'-10px\' : \'0px\'}\" style=\"padding: 0 3% 0 3%; position: relative;\"><div md-whiteframe=\"1\" ng-if=\"showPopup && !isSmall\" style=\"position: absolute; top: 5%; left: 0%; width: 450px; height: 450px;z-index: 21; overflow: hidden; background-color: white\"><img ng-src=\"{{mediaUrl + selectedImage.urls.full}}\" alt=\"{{product.name}}\" ng-style=\"{\'transform\' : \'translate3d(\' + zoomX + \'px,\' + zoomY + \'px, 0\'}\" style=\"width: 1200px; height: 1640px; max-width: inherit;\"></div><product-overview total-price=\"totalPrice\" product-loaded=\"productLoaded\" product=\"product\"></product-overview><div layout=\"\" ng-if=\"showPromoteButton\" layout-align-xs=\"center center\" layout-align-sm=\"center center\" layout-align-gt-sm=\"start center\"><md-button class=\"outline small round\" ng-class=\"{\'md-warn\' : promoted}\" ng-click=\"promoteProduct()\">{{promoted ? \'Stop Promoting This Product\' : \'Promote this product\'}}</md-button></div><shipping-box product=\"product\"></shipping-box><div ng-if=\"product.published && !product.outOfStock && productLoaded\"><section ng-if=\"product.productType === 1 && (product.editorType ? product.editorType !== \'simple\' : true)\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-fab md-mini md-primary\" ng-disabled=\"product.outOfStock\" ng-click=\"perfomWishListAction($event);\"><md-icon ng-class=\"{\'grey-text\' : product.outOfStock, \'pink-text\' : !product.outOfStock}\">{{product.inWishlist ? \'favorite\' : \'favorite_outline\'}}</md-icon></md-button><div layout=\"column\" layout-margin=\"\" style=\"width: 75%;\" ng-if=\"product.productType === 1\"><md-button class=\"customise-now-button\" ng-disabled=\"product.outOfStock\" ui-sref=\"app.customisationEditor({slug : product.slug, flags : \'none\', RFX : ctx.refUser, RFID : ctx.refId, RTYPE : ctx.refType})\"><md-icon>edit</md-icon><span>Customise Now</span></md-button></div></div></section><div ng-if=\"product.productType === 1 && product.editorType === \'simple\'\"><div layout=\"\" layout-align=\"center center\"><p class=\"center-text customisation--title\">Customise this product to match your style</p></div><section ng-repeat-start=\"data in product.customisation.data\" class=\"customisation-layers\" id=\"layer-{{$index}}\" ng-class=\"{\'error\' : data.error}\"><h2 class=\"md-title center-text montserrat bold-text section-title\">Step {{$index + 1}} : Select {{ data.name }}</h2><p ng-if=\"data.error\" class=\"center-text red-text flicker\">{{data.error}}</p><section layout=\"\" layout-wrap=\"\" ng-init=\"dataIndex = $index\"><div ng-repeat=\"option in data.options\" flex=\"25\" layout=\"column\" layout-align=\"center center\" md-ink-ripple=\"{{!option.outOfStock ? \'#efefef\' : false}}\" flex-xs=\"50\" flex-sm=\"25\" class=\"md-padding uc-options relative\" ng-class=\"{\'selected\' : data.default._id === option._id, \'out-of-stock\' : option.outOfStock, \'pointer\' : !option.outOfStock}\" ng-click=\"!option.outOfStock ? saveSelection(data, option, dataIndex) : null\"><img class=\"option-image\" ng-src=\"{{mediaUrl +option.image.urls.c_medium}}\" alt=\"{{option.image.urls.c_medium}}\"><span class=\"md-truncate md-caption option-name\">{{ option.name }}</span><p class=\"md-truncate md-caption option-price\"><span ng-if=\"!option.outOfStock\">{{ option.stockAndPrice.price.salePrice ? \'+ ₹\' + option.stockAndPrice.price.salePrice : \'Free\' }}</span> <span ng-if=\"option.outOfStock\" class=\"red-text\">Out Of Stock</span></p></div></section></section><md-divider ng-repeat-end=\"\"></md-divider></div><div ng-if=\"product.productType === 0 || (product.productType === 1 && product.editorType === \'simple\')\"><h3 class=\"md-title center-text montserrat bold-text section-title\">{{getSizeLabel()}}</h3><custom-measurement size-chart=\"product.sizeChart\" product=\"product\" uc-data=\"product.productType === 1 ? ucData : null\" on-added=\"onAddToCart(data)\" variations=\"product.variations\" ctx=\"ctx\" validate=\"true\" before-add-to-cart-validation=\"beforeAddToCartValidator(data)\" open-edit-view=\"openEditView\" selected-variation=\"null\"></custom-measurement></div></div><div class=\"md-padding\" ng-if=\"!productLoaded\" layout=\"\" layout-align=\"center center\"><md-progress-circular md-diameter=\"20\" class=\"md-accent\"></md-progress-circular></div></md-card></div><product-details product=\"product\"></product-details></md-card-content></section><customisation-process hide-get-started=\"true\"></customisation-process><aarida-testimonials></aarida-testimonials><section ng-if=\"loadingUpsells\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\" layout-margin=\"\"><md-progress-circular class=\"md-accent\"></md-progress-circular><h4 class=\"center-text\">Loading similar products ...</h4></section><section ng-if=\"!loadingUpsells\"><div layout=\"row\" class=\"md-padding\"><span flex=\"\" class=\"bordered-header\"></span><h3 class=\"center-text md-title md-padding montserrat\">SIMILAR PRODUCTS</h3><span flex=\"\" class=\"bordered-header\"></span></div><div layout=\"row\" layout-wrap=\"\" layout-align=\"center stretch\"><md-card ng-click=\"gotoDetailsPage(product.slug, product)\" class=\"pointer\" md-ink-ripple=\"\" id=\"{{\'product-card-\' + $index}}\" ng-style=\"{\'border\' : isSmall ? \'0.5px solid rgba(211, 211, 211, 0.38)\' : \'none\'}\" style=\"position: relative\" ng-class=\"{\'no-margin no-box-shadow\' : isSmall}\" ng-repeat=\"product in recommendedProducts\" flex-gt-sm=\"20\" flex=\"50\"><section class=\"relative\"><img md-preload=\"\" md-src=\"product.gallery[0]\" item-index=\"$index\" key=\"medium\"><div class=\"customisable-badge\" layout=\"\" layout-align=\"center center\" ng-if=\"product.productType === 1\"><span>CUSTOMISABLE</span></div></section><md-card-footer-text layout=\"column\" class=\"md-padding\"><span class=\"md-truncate grey-text product-name center-text\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\">{{getProperName(product.name)}}</span><div layout=\"\" layout-align=\"center center\" class=\"price\"><s ng-if=\"product.isOnSale\" class=\"bold-text warn sale-price\" ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' : isSmall}\">₹{{product.mrp}}</s> <span class=\"bold-text\" ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\">₹{{product.price}}</span> <span class=\"discount bold-text\" ng-if=\"product.isOnSale\" ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' : isSmall}\">( {{calculatePrice(product.mrp,product.price)}}% off )</span></div></md-card-footer-text></md-card></div></section></div></section><div ng-class=\"{\'shown\' : isSmall && productLoaded}\" class=\"white bottom-toolbar product-page-bottom-toolbar\" layout=\"\" md-whiteframe=\"2\"><section class=\"product-price-info flex\" layout=\"\" layout-align=\"center center\"><s class=\"md-caption product-discounted-price\" ng-if=\"product.isOnSale\">₹{{product.mrp}}</s> <span class=\"md-body-1 bold-text product-sale-price\">₹{{ totalPrice }}</span> <span class=\"product-discount-value md-tiny bold-text\" ng-if=\"product.isOnSale\">({{product.discountPercentText}} off)</span></section><md-button class=\"flex customise-now-button md-raised small\" ng-disabled=\"product.outOfStock\" ng-if=\"product.productType === 1 && (product.editorType ? product.editorType !== \'simple\' : true)\" ui-sref=\"app.customisationEditor({slug : product.slug, flags : \'none\'})\"><span>Customise Now</span></md-button><md-button class=\"md-accent md-raised flex md-hue-1\" ng-if=\"!addedToCart && !(product.productType === 1 && (product.editorType ? product.editorType !== \'simple\' : true))\" ng-click=\"openCustomMeasurements($event);\" ng-disabled=\"product.outOfStock\"><md-icon>shopping_cart</md-icon><span>Add to Cart</span></md-button><md-button class=\"md-accent md-raised flex\" ng-if=\"addedToCart && !(product.productType === 1 && (product.editorType ? product.editorType !== \'simple\' : true))\" ui-sref=\"app.cart\"><md-icon>shopping_cart</md-icon><span>Browse Cart</span></md-button></div><div style=\"visibility: hidden\" ng-if=\"productLoaded && product.variations.length > 1\"><div class=\"md-dialog-container\" id=\"variationsDialog\"><md-dialog flex-xs=\"80\" flex-sm=\"70\" flex-md=\"40\" flex-lg=\"30\" flex-xl=\"30\"><md-dialog-content layout=\"column\" layout-padding=\"\"><h4 class=\"center-text\">Select Variation</h4><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-fab md-mini\" ng-repeat=\"variation in product.variations\" ng-class=\"{\'md-accent md-hue-6\' : selectedVariation == variation._id, \'md-accent md-hue-1\' : selectedVariation != variation._id}\" ng-click=\"selectVariation(variation);\"><span>{{ getVariationValue(variation); }}</span></md-button></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"cancel();\" md-autofocus=\"\" class=\"md-raised md-warn\">Cancel</md-button><span flex=\"\"></span><md-button ng-click=\"addToCart($event)\" class=\"md-raised md-primary md-hue-1\">Add to Cart</md-button></md-dialog-actions></md-dialog></div></div></div><div style=\"visibility: hidden\" ng-if=\"productLoaded\"><div class=\"md-dialog-container\" id=\"imageBoxDialog\"><md-dialog flex=\"100\" style=\"height: 100vh; position: relative;\"><md-dialog-content><section layout=\"column\"><div flex=\"\" layout=\"\" layout-align=\"center center\" style=\"position: relative;\" ng-style=\"{\'minHeight\' : zoomedIn ? \'200vh\' : \'inherit\'}\" ng-click=\"toggleZoomer()\"><img ng-src=\"{{ mediaUrl + modalImage.urls.full }}\" alt=\"{{modalImage.urls.full}}\" id=\"showcaseImage\" on-image-load=\"hideProgress()\"></div></section></md-dialog-content><div style=\"position: absolute; top: 0; width: 100%; height: 64px;\"><section class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"cancel();\"><md-icon>keyboard_arrow_left</md-icon>Back</md-button><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></section></div><div layout=\"row\" class=\"md-padding\" flex=\"\" layout-align=\"center center\" layout-padding=\"\" style=\"background: rgba(1,1,1,0.1); position: absolute; bottom: 0; width: 100%;\"><section ng-repeat=\"image in product.gallery\" class=\"image-thumbnail relative\" style=\"width: 100px; height: auto; position: relative;\"><md-img md-src=\"{{ image.urls.thumbnail }}\" ng-click=\"selectModalImage(image);\" md-ink-ripple=\"\" md-colors=\"{\'borderColor\' : modalImage === image ? \'awesome-accent-500-1\' : \'awesome-accent-50-0.1\'}\" style=\"outline: none; cursor: pointer; position: relative; width: 100%; height: auto; border: 2px solid;\"></md-img><div class=\"zoom-progress-loader\" ng-if=\"image.zoomProgressLoader\" layout=\"\" layout-align=\"center center\"><md-progress-circular md-diameter=\"20\"></md-progress-circular></div></section></div></md-dialog></div></div><div static-include=\"app/main/partials/sizeChart.html\"></div><md-fab-toolbar md-open=\"false\" class=\"md-accent md-fab-bottom-right\" md-direction=\"left\" ng-if=\"currentUser.role === \'admin\'\"><md-fab-trigger class=\"align-with-text\"><md-button aria-label=\"menu\" class=\"md-fab md-accent\"><md-icon>menu</md-icon></md-button></md-fab-trigger><md-toolbar><md-fab-actions class=\"md-toolbar-tools\"><md-button ng-click=\"editProduct()\" aria-label=\"edit product\" class=\"md-primary\"><md-icon>edit</md-icon><span>Edit Product</span></md-button></md-fab-actions></md-toolbar></md-fab-toolbar>");
$templateCache.put("app/modules/products/partials/productCard.html","<md-card ng-style=\"{\'border\' : isSmall ? \'0.5px solid rgba(211, 211, 211, 0.38)\' : \'none\'}\" style=\"position: relative\" flex=\"\" ng-class=\"{\'no-margin no-box-shadow\' : isSmall}\"><img md-preload=\"\" md-src=\"product.gallery[0]\" key=\"large\"><div style=\"position: absolute; right: 0px; top: 0px; width: 100%;\" layout=\"\" ng-init=\"product.inWishlist = checkIfProductIsInWishlist(product._id);\"><span flex=\"\"></span><div layout=\"\" layout-align=\"center center\" style=\"width: 44px; height: 44px;\"><md-button class=\"md-icon-button\" md-ink-ripple=\"\" ng-if=\"!product.serverConn\" ng-disabled=\"product.outOfStock\" ng-click=\"perfomWishListAction(product, $event);\"><md-icon ng-class=\"{\'grey-text\' : product.outOfStock, \'pink-text\' : !product.outOfStock}\">{{ product.inWishlist ? \'favorite\' : \'favorite_outline\' }}</md-icon><md-tooltip md-direction=\"bottom\">{{ (product.inWishlist ? \"Remove from\" : \"Add to\") + \" wishlist\"}}</md-tooltip></md-button><md-progress-circular class=\"md-accent\" md-diameter=\"20\" ng-if=\"product.serverConn\"></md-progress-circular></div></div><md-divider></md-divider><md-card-footer-text layout=\"column\"><span class=\"montserrat md-truncate\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-tiny\' : isSmall}\">{{getProperName(product.name);}}</span><div layout=\"\" layout-align=\"center center\"><strike ng-if=\"product.isOnSale\" class=\"bold-text red-text\" ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' : isSmall}\" style=\"font-weight: 600; padding: 8px 0; margin-right: 8px;\">Rs. {{product.mrp}}</strike><span class=\"bold-text\" ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\" style=\"font-weight: 600; padding: 8px 0;\">Rs. {{product.price}}</span></div><div layout=\"\" layout-align=\"center center\"><md-card ng-if=\"checkIfNew(product.createdAt)\" layout=\"\" layout-align=\"center center\" class=\"white-text\" style=\"padding: 4px 8px; border-radius: 32px; background: #a5382a;\"><div layout=\"\" layout-align=\"center center\"><span class=\"md-tiny bold-text\">NEW</span></div></md-card><md-card ng-if=\"product.productType === 1\" class=\"green white-text\" style=\"padding: 4px 8px; border-radius: 32px;\"><div layout=\"\" layout-align=\"center center\"><span class=\"bold-text md-tiny\">CUSTOMISABLE</span></div></md-card><md-card ng-if=\"product.outOfStock\" class=\"red white-text\" style=\"padding: 4px 8px; border-radius: 32px;\"><div layout=\"\" layout-align=\"center center\"><span class=\"bold-text md-tiny\">OUT OF STOCK</span></div></md-card><md-card ng-if=\"!product.published && product.comingSoon\" class=\"white-text\" style=\"background: #614385; padding: 4px 8px; border-radius: 32px\"><div layout=\"\" layout-align=\"center center\"><span class=\"bold-text md-tiny\">COMING SOON</span></div></md-card></div></md-card-footer-text></md-card>");
$templateCache.put("app/modules/profile/post-viewer/post-viewer.tmpl.html","<md-dialog class=\"post-viewer\" ng-class=\"[mode, isSmall ? \'mobile\' : \'desktop\']\" flex=\"{{mode === \'page\' ? 100 : 80}}\" md-theme=\"awesome\"><md-toolbar class=\"transparent post-viewer-toolbar\"><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon class=\"black-text\">arrow_back</md-icon></md-button></div></md-toolbar><div class=\"post-image carousel\" layout-xs=\"column\" layout-sm=\"column\" layout-md=\"column\" layout-gt-md=\"row\" ng-if=\"posts.length\" layout-align-gt-md=\"center start\"><md-image-gallery gallery=\"gallery\" flex-gt-md=\"60\" class=\"image-gallery\" image-size=\"\'large\'\" selected-index=\"$parent.selectedIndex\" on-next=\"onPostChange(data)\"></md-image-gallery><div layout=\"\" class=\"products-list\" flex-gt-md=\"40\"><md-card class=\"products-card\"><md-card-header class=\"hide-xs hide-sm\"><md-card-avatar><profile-image user-name=\"{{posts[selectedIndex].user.userName}}\" small=\"true\" image-url=\"{{posts[selectedIndex].user.profileImageURL}}\"></profile-image></md-card-avatar><md-card-header-text><span class=\"md-title montserrat pointer\" ui-sref=\"app.profile({userName : posts[0].user.userName})\">{{posts[selectedIndex].user.name}}</span> <span class=\"md-subhead pointer\" ui-sref=\"app.profile({userName : posts[0].user.userName})\">@{{posts[selectedIndex].user.userName}}</span></md-card-header-text></md-card-header><md-divider class=\"hide-xs hide-sm\"></md-divider><div layout=\"\" layout-align=\"center center\"><p class=\"product-card-title montserrat\">Products</p></div><section layout=\"\" layout-align=\"space-between center\" layout-wrap=\"\"><div ng-repeat=\"product in posts[selectedIndex].products\" flex=\"50\" class=\"product-card-container\"><a md-ink-ripple=\"\" role=\"button\" target=\"_blank\" ng-click=\"triggerAnalytics(posts[selectedIndex], product)\" ui-sref=\"app.product({productSlug: product.slug, product: product, RFX: posts[selectedIndex].user._id, RFID : posts[selectedIndex]._id, RTYPE : \'post\' })\" class=\"single-product relative\"><md-img md-src=\"{{product.featured_image.urls.medium}}\" class=\"product-card-image\"></md-img><p class=\"md-caption md-truncate center-text product-name\">{{product.name}}</p><p class=\"md-caption center-text product-price\">₹ {{product.price}}</p></a></div></section></md-card></div></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"!posts.length\" class=\"post-loader\"><md-progress-circular class=\"md-accent\"></md-progress-circular><p>Loading Post ...</p></div></md-dialog>");
$templateCache.put("app/modules/profile/profile-image/profile-image.tmpl.html","<div ng-if=\"!userName\" class=\"profile-image\" ng-class=\"class\" ng-style=\"{\'backgroundImage\' : \'url(\' + mediaUrl+ imageUrl + \')\'}\"></div><div ng-if=\"userName\" class=\"profile-image pointer\" ng-class=\"class\" ui-sref=\"app.profile({userName : userName})\" ng-style=\"{\'backgroundImage\' : \'url(\' + mediaUrl+ imageUrl + \')\'}\"></div>");
$templateCache.put("app/modules/search/partials/index.html","<div class=\"search-results\" style=\"min-height: calc(100vh - 64px);\" layout=\"column\"><section flex=\"\" ng-if=\"ctrl.products.length === 0\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><span>Start typing to see search results appear here</span> <img src=\"assets/images/search-i.svg\" style=\"max-width: 300px; opacity: 0.5\"></section><section layout=\"column\" ng-if=\"ctrl.products.length > 0\"><div layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align-gt-sm=\"space-between center\" layout-padding=\"\"><span class=\"center-text\" ng-class=\"{\'md-title\': !isSmall}\">Showing {{ctrl.products.length}} results for query \"{{ctrl.query}}\"</span> <img src=\"assets/images/algolia.svg\"></div><div class=\"catalog\" ng-class=\"{\'md-margin\' : !isSmall}\" layout=\"\" layout-wrap=\"\" layout-align=\"center stretch\"><a ng-href=\"{{ctrl.getLinkUrl(product)}}\" ng-repeat=\"product in ctrl.products\" target=\"_blank\" layout=\"\" flex-lg=\"25\" flex-gt-md=\"25\" flex-gt-xs=\"30\" flex=\"50\"><md-card ng-style=\"{\'border\' : isSmall ? \'0.5px solid rgba(211, 211, 211, 0.38)\' : \'none\'}\" style=\"position: relative\" flex=\"\" id=\"{{\'product-card-\' + $index}}\" ng-class=\"{\'no-margin no-box-shadow\' : isSmall}\"><img item-index=\"$index\" md-preload=\"\" md-src=\"product.featured_image\" key=\"large\"><div style=\"position: absolute; right: 0px; top: 0px; width: 100%;\" layout=\"\" ng-init=\"product.inWishlist = checkIfProductIsInWishlist(product._id);\"><span flex=\"\"></span><div layout=\"\" layout-align=\"center center\" style=\"width: 44px; height: 44px;\"><md-button class=\"md-icon-button\" md-ink-ripple=\"\" ng-if=\"!product.serverConn\" ng-disabled=\"product.outOfStock\" ng-click=\"perfomWishListAction(product, $event);\"><md-icon ng-class=\"{\'grey-text\' : product.outOfStock, \'pink-text\' : !product.outOfStock}\">{{ product.inWishlist ? \'favorite\' : \'favorite_outline\' }}</md-icon><md-tooltip md-direction=\"bottom\">{{ (product.inWishlist ? \"Remove from\" : \"Add to\") + \" wishlist\"}}</md-tooltip></md-button><md-progress-circular class=\"md-accent\" md-diameter=\"20\" ng-if=\"product.serverConn\"></md-progress-circular></div></div><md-divider></md-divider><md-card-footer-text layout=\"column\"><span class=\"montserrat md-truncate center-text product-name grey-text\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\">{{ctrl.getProperName(product.name);}}</span><div layout=\"\" layout-align=\"center center\"><strike ng-if=\"product.isOnSale\" class=\"bold-text red-text\" ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' : isSmall}\" style=\"font-weight: 600; padding: 8px 0; margin-right: 8px;\">Rs. {{product.mrp}}</strike><span class=\"bold-text\" ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\" style=\"font-weight: 600; padding: 8px 0;\">Rs. {{product.price}}</span></div><div layout=\"\" layout-align=\"center center\"><md-card ng-if=\"checkIfNew(product.createdAt)\" layout=\"\" layout-align=\"center center\" class=\"white-text\" style=\"padding: 4px 8px; border-radius: 32px; background: #a5382a;\"><div layout=\"\" layout-align=\"center center\"><span class=\"md-tiny bold-text\">NEW</span></div></md-card><md-card ng-if=\"product.productType === 1\" class=\"green white-text\" style=\"padding: 4px 8px; border-radius: 32px;\"><div layout=\"\" layout-align=\"center center\"><span class=\"bold-text md-tiny\">CUSTOMISABLE</span></div></md-card><md-card ng-if=\"product.outOfStock\" class=\"red white-text\" style=\"padding: 4px 8px; border-radius: 32px;\"><div layout=\"\" layout-align=\"center center\"><span class=\"bold-text md-tiny\">OUT OF STOCK</span></div></md-card><md-card ng-if=\"!product.published && product.comingSoon\" class=\"white-text\" style=\"background: #614385; padding: 4px 8px; border-radius: 32px\"><div layout=\"\" layout-align=\"center center\"><span class=\"bold-text md-tiny\">COMING SOON</span></div></md-card></div></md-card-footer-text></md-card></a></div></section></div>");
$templateCache.put("app/modules/static/influencer-onboarding/influencer-onboarding.tmpl.html","<div class=\"influencer-onboarding\"><section layout=\"column\" layout-align=\"center center\" class=\"md-padding md-margin\"><h1>Influencer Application</h1><p class=\"subtitle center-text\">Sign up as an influencer and be the part of Aarida\'s next gen band wagon</p></section><form name=\"applicationForm\" ng-if=\"!applied\" class=\"form\" layout=\"column\" layout-align=\"start center\"><div class=\"form-group\"><md-input-container class=\"md-accent md-block\" md-no-float=\"\"><label>Name</label> <input ng-model=\"user.name\" required=\"\" type=\"text\" name=\"name\"><div class=\"valMessage\" ng-messages=\"applicationForm.name.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid name</div></div></md-input-container></div><div class=\"form-group\" layout=\"\" layout-wrap=\"\"><md-input-container class=\"md-accent md-block\" md-no-float=\"\" flex=\"\"><label>Email</label> <input required=\"\" ng-model=\"user.email\" type=\"email\" name=\"email\"><div class=\"valMessage\" ng-messages=\"applicationForm.email.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid email</div></div></md-input-container></div><div class=\"form-group\" layout=\"\" layout-wrap=\"\"><md-input-container class=\"md-accent md-block\" md-no-float=\"\" flex-sm=\"100\" flex-gt-sm=\"50\"><label>Mobile</label> <input required=\"\" ng-model=\"user.mobile\" type=\"tel\" name=\"mobile\"><div class=\"valMessage\" ng-messages=\"applicationForm.mobile.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid mobile</div></div></md-input-container><md-input-container class=\"md-accent md-block\" md-no-float=\"\" flex-sm=\"100\" flex-gt-sm=\"50\"><label>Age</label> <input required=\"\" min=\"13\" ng-model=\"user.age\" type=\"number\" name=\"age\"><div class=\"valMessage\" ng-messages=\"applicationForm.age.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid age</div></div></md-input-container></div><div class=\"form-group\" layout=\"\" layout-wrap=\"\"><md-input-container class=\"md-accent md-block\" md-no-float=\"\" flex=\"100\"><label>Instagram Profile</label> <input required=\"\" ng-model=\"user.instagramProfile\" type=\"url\" name=\"instaProfile\"><div class=\"valMessage\" ng-messages=\"applicationForm.instaProfile.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid instaProfile</div></div></md-input-container></div><div class=\"form-group\" layout=\"\" layout-wrap=\"\"><md-input-container class=\"md-accent md-block\" md-no-float=\"\" flex=\"100\"><label>Facebook Profile</label> <input required=\"\" ng-model=\"user.facebookProfile\" type=\"url\" name=\"fbProfile\"><div class=\"valMessage\" ng-messages=\"applicationForm.fbProfile.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid fbProfile</div></div></md-input-container></div><div class=\"form-group\"><md-input-container class=\"md-accent md-block\" md-no-float=\"\"><label>Pin Code</label> <input required=\"\" ng-change=\"queryPinCode(user.pinCode)\" ng-model=\"user.pinCode\" type=\"number\" name=\"pinCode\"><div class=\"valMessage\" ng-messages=\"applicationForm.pinCode.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid pinCode</div></div></md-input-container></div><div class=\"form-group\"><md-input-container class=\"md-accent md-block\" md-no-float=\"\"><label>City</label> <input required=\"\" ng-model=\"user.city\" type=\"text\" name=\"city\"><div class=\"valMessage\" ng-messages=\"applicationForm.city.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid city</div></div></md-input-container></div><div class=\"form-group\"><md-input-container class=\"md-accent md-block\" md-no-float=\"\"><label>State</label> <input required=\"\" ng-model=\"user.state\" type=\"text\" name=\"state\"><div class=\"valMessage\" ng-messages=\"applicationForm.state.$error\"><div ng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Please enter a valid city</div></div></md-input-container></div><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-accent aarida-stroked-button apply-button\" ng-click=\"saveApplication()\" ng-disabled=\"!applicationForm.$valid || applying\"><div layout=\"\" layout-align=\"center center\"><span ng-if=\"!applying\">Apply Now</span><md-progress-circular md-diameter=\"20\" ng-if=\"applying\"></md-progress-circular></div></md-button></div></form><md-card-content ng-if=\"applied\" style=\"max-width: 400px;\"><div layout=\"\" layout-margin=\"\" layout-align=\"center center\"><svg class=\"checkmark\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 52 52\"><circle class=\"checkmark__circle\" cx=\"26\" cy=\"26\" r=\"25\" fill=\"none\"></circle><path class=\"checkmark__check\" fill=\"none\" d=\"M14.1 27.2l7.1 7.2 16.7-16.8\"></path></svg></div><div layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><h3 class=\"md-title bold-text montserrat\">Application Sent</h3><span class=\"md-body-1 text-center\">We have received your request and will get back to your email address {{user.email}} in the next few days. We appreciate your patience.</span></div></md-card-content></div>");
$templateCache.put("app/modules/static/partials/about-us.html","<section layout=\"column\"><div class=\"about-us-bg\" style=\"min-height: 300px\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"start center\"><h1 class=\"montserrat md-display-1 bold-text white-text center-text\">About Us</h1><p class=\"center-text md-title white-text montserrat\">A message from our Co-founders</p></div></div><section layout=\"\" layout-align=\"center center\" class=\"white\" layout-padding=\"\" style=\"min-height: 300px; margin-top: 50px\" ng-class=\"{\'md-padding\' : !isSmall}\"><span class=\"md-body-1 center-text\" flex-gt-sm=\"50\" flex=\"90\" style=\"text-align: justify;\">\"Welcome to Aarida, India’s solitary personal style and fashion friendly online store. Come and celebrate the vogue that you hold by shopping with us for the finest clothing <b>exclusively made for you</b>. We firmly believe Shopping to be our birth-right, and not a luxury. We hold pride in delivering the biggest style trends at the most affordable prices to your doorstep, pan-India. Our commitment is to provide <b>Customised Clothing</b> put together using the best quality fabrics and churning out trendy fashion clothing with a class-leading customer service experience to our patrons.<br><br>We really hope you enjoy the customised products as much as we enjoy offering them to you! We hold our confidence in transfiguring the industry of customised products and are affirmed in offering you with new and innovative products to re-define your personal style. Aarida is operated by Redux X-Press Pvt. Ltd, incorporated in Jharkhand with the corporate office in Bengaluru, Karnataka. If you have any questions or thoughts over how could we improve, please don’t hesitate to contact us.\"</span></section><div layout=\"\" layout-align=\"center center\" layout-padding=\"\" md-colors=\"{\'background\' : \'awesome-primary-50-0.5\'}\"><h1 class=\"md-display-1 montserrat bold-text\">Founding Members</h1></div><section layout=\"column\" layout-gt-sm=\"row\" class=\"white\" layout-padding=\"\" layout-align=\"space-around center\"><div layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><img src=\"assets/images/team/aditya.jpg\" class=\"avatar\"> <span class=\"montserrat bold-text\">Kumar Aditya</span> <span class=\"montserrat md-caption grey-text\">Co-Founder</span><md-divider style=\"width: 60px;border-width: 3px;\" md-colors=\"{\'borderTopColor\' : \'awesome-accent-500-1\'}\"></md-divider><div layout=\"\" layout-align=\"center center\"><md-button aria-label=\"facebook\" class=\"md-icon-button\" ng-href=\"https://www.facebook.com/adyrajat\" target=\"_blank\"><md-icon md-svg-src=\"assets/images/facebook.svg\"></md-icon></md-button><md-button aria-label=\"instagram\" class=\"md-icon-button\" ng-href=\"https://www.instagram.com/ady_rajat\" target=\"_blank\"><md-icon md-svg-src=\"assets/images/instagram.svg\"></md-icon></md-button></div></div><div layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><img src=\"assets/images/team/megha.jpg\" class=\"avatar\"> <span class=\"montserrat bold-text\">Megha Nayak</span> <span class=\"montserrat md-caption grey-text\">Lead Fashion-Designer</span><md-divider style=\"width: 60px;border-width: 3px;\" md-colors=\"{\'borderTopColor\' : \'awesome-accent-500-1\'}\"></md-divider><div layout=\"\" layout-align=\"center center\"><md-button aria-label=\"facebook\" class=\"md-icon-button\" ng-href=\"https://www.facebook.com/megha.nayak.39982\" target=\"_blank\"><md-icon md-svg-src=\"assets/images/facebook.svg\"></md-icon></md-button><md-button aria-label=\"instagram\" class=\"md-icon-button\" ng-href=\"https://www.instagram.com/megha.nayak\" target=\"_blank\"><md-icon md-svg-src=\"assets/images/instagram.svg\"></md-icon></md-button><md-button aria-label=\"linkedin\" class=\"md-icon-button\" ng-href=\"https://www.linkedin.com/in/megha-nayak-9a1b95122\" target=\"_blank\"><md-icon md-svg-src=\"assets/images/linkedin.svg\"></md-icon></md-button></div></div></section></section>");
$templateCache.put("app/modules/static/partials/careers.html","<div layout=\"column\" ng-controller=\"careersCtrl\"><div style=\"min-height: 500px; z-index: 0; position: relative;\" layout=\"column\" layout-align=\"center center\"><section style=\"z-index: -2; position: absolute; top: 0; left: 0; bottom: 0; right: 0;\" class=\"careers-bg\"></section><div layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><span class=\"montserrat md-display-3 bold-text white-text center-text\">Work With Us</span> <span class=\"white-text bold-text center-text\">We are a Bangalore based startup & We are looking forward to having the best minds working for our company.</span></div></div><div layout=\"\" layout-align=\"center center\" md-colors=\"{\'background\' : \'awesome-primary-50-0.3\'}\"><span class=\"md-headline center-text md-padding md-margin\">What we have to offer?</span></div><section layout=\"\" layout-padding=\"\" layout-wrap=\"\" layout-align=\"center center\" class=\"white\" style=\"padding: 40px 0;\"><div flex=\"100\" flex-gt-sm=\"45\" layout=\"\" layout-align=\"center center\" class=\"md-margin md-padding\"><div layout=\"\" layout-align=\"end center\" flex=\"30\"><img src=\"assets/images/careers/trophy.svg\" style=\"width: 50px;\"></div><section layout=\"column\" layout-padding=\"\" flex=\"\"><span class=\"bold-text md-subhead montserrat\">Conducive Environment</span></section></div><div flex=\"100\" flex-gt-sm=\"45\" layout=\"\" layout-align=\"center center\" class=\"md-margin md-padding\"><div layout=\"\" layout-align=\"end center\" flex=\"30\"><img src=\"assets/images/careers/shared-folder.svg\" style=\"width: 50px;\"></div><section layout=\"column\" layout-padding=\"\" flex=\"\"><span class=\"bold-text md-subhead montserrat\">Shared Success</span></section></div><div flex=\"100\" flex-gt-sm=\"45\" layout=\"\" layout-align=\"center center\" class=\"md-margin md-padding\"><div layout=\"\" layout-align=\"end center\" flex=\"30\"><img src=\"assets/images/careers/online-learning.svg\" style=\"width: 50px;\"></div><section layout=\"column\" layout-padding=\"\" flex=\"\"><span class=\"bold-text md-subhead montserrat\">Culture of Learning</span></section></div><div flex=\"100\" flex-gt-sm=\"45\" layout=\"\" layout-align=\"center center\" class=\"md-margin md-padding\"><div layout=\"\" layout-align=\"end center\" flex=\"30\"><img src=\"assets/images/careers/computing.svg\" style=\"width: 50px;\"></div><section layout=\"column\" layout-padding=\"\" flex=\"\"><span class=\"bold-text md-subhead montserrat\">Best Gadgets</span></section></div></section><div style=\"min-height: 250px; position: relative;\" layout=\"column\" layout-align=\"center center\"><span style=\"position: absolute; top: 0; left: 0; bottom: 0; right: 0; z-index: 0\" class=\"careers-mid-bg\"></span> <span style=\"z-index: 1\" class=\"md-display-1 white-text bold-text\">Open Positions</span></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"jobs.length === 0\" style=\"min-height: 400px;\" layout-padding=\"\"><img src=\"assets/images/error.svg\" style=\"width: 150px;\"> <span class=\"grey-text\">No Open Positions Right Now</span></div><div layout=\"\" ng-if=\"jobs.length > 0\" layout-align=\"center start\" ng-class=\"{\'md-padding\' : !isSmall}\"><md-card flex-gt-sm=\"60\" flex=\"100\"><md-tabs md-center-tabs=\"\" md-selected=\"selectedIndex\" md-border-bottom=\"\" md-swipe-content=\"\" class=\"md-accent\"><md-tab ng-repeat=\"tab in tabs\" md-on-select=\"onTabSelected(tab)\"><md-tab-label>{{tab}}</md-tab-label><md-tab-body><md-list><md-list-item class=\"md-padding md-margin\" ng-repeat-start=\"job in jobsInTabs\"><div layout=\"column\"><div layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\" style=\"padding-bottom: 4px;\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall }\"><span class=\"montserrat bold-text\">{{job.title}}</span> <span class=\"montserrat bold-text\" style=\"margin-left: 4px;\">({{job.experience}} )</span></div><div layout=\"column\"><span class=\"md-caption grey-text\">Skills : <span class=\"bold-text\">{{ job.skills}}</span></span> <span class=\"md-caption grey-text\">Location : <span class=\"bold-text\">{{ job.city}}</span></span></div></div><md-button class=\"md-secondary md-raised md-accent\" ng-click=\"doSecondaryAction(job,$event)\" aria-label=\"apply\"><span ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' : isSmall }\" class=\"bold-text montserrat\">View Details</span></md-button></md-list-item><md-divider ng-repeat-end=\"\" ng-if=\"!$last\"></md-divider></md-list></md-tab-body></md-tab></md-tabs></md-card></div><md-card><md-card-content layout=\"\" layout-align=\"center center\"><span class=\"center-text\">Write to us at support@aadira.com if think you have a cool resume.</span></md-card-content></md-card><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"careersDialog\"><md-dialog flex=\"100\" flex-md=\"70\" flex-lg=\"60\" flex-xl=\"40\" aria-label=\"careersDialog\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"\"><h5 style=\"padding-top: 0;\">Details For {{selectedJob.title}}</h5><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon md-svg-src=\"assets/images/close.svg\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content md-colors=\"{\'background\' : \'awesome-primary-50-0.25\'}\"><section layout=\"\"><md-card flex=\"\"><section layout=\"\" layout-align=\"center center\" style=\"padding: 4px;\"><span class=\"grey-text md-caption\">Experience</span></section><md-divider></md-divider><md-card-content><section layout=\"\" layout-align=\"center center\"><span class=\"md-caption center-text bold-text\">{{selectedJob.experience}}</span></section></md-card-content></md-card><md-card flex=\"\"><section layout=\"\" layout-align=\"center center\" style=\"padding: 4px;\"><span class=\"grey-text md-caption\">CTC/year</span></section><md-divider></md-divider><md-card-content><section layout=\"\" layout-align=\"center center\"><span class=\"md-caption center-text bold-text\">{{selectedJob.salary}}</span></section></md-card-content></md-card><md-card flex=\"\"><section layout=\"\" layout-align=\"center center\" style=\"padding: 4px;\"><span class=\"grey-text md-caption\">City</span></section><md-divider></md-divider><md-card-content><section layout=\"\" layout-align=\"center center\"><span class=\"md-caption center-text bold-text\">{{selectedJob.city}}</span></section></md-card-content></md-card></section><section layout=\"\"><md-card flex=\"\"><section layout=\"\" layout-align=\"center center\" style=\"padding: 4px;\"><span class=\"grey-text md-caption\">Skills</span></section><md-divider></md-divider><md-card-content><section layout=\"\" layout-align=\"center center\"><span class=\"md-caption center-text bold-text\">{{selectedJob.skills}}</span></section></md-card-content></md-card><md-card flex=\"\"><section layout=\"\" layout-align=\"center center\" style=\"padding: 4px;\"><span class=\"grey-text md-caption\">Languages</span></section><md-divider></md-divider><md-card-content><section layout=\"\" layout-align=\"center center\"><span class=\"md-caption center-text bold-text\">{{selectedJob.languages}}</span></section></md-card-content></md-card></section><div layout=\"column\" class=\"md-padding\"><section layout=\"column\" flex=\"\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><span class=\"md-accent md-title\">Responsibilities</span></div><ul><li ng-repeat=\"skill in selectedJob.responsibilities\"><span class=\"md-body-2\" style=\"margin-left: 4px;\">{{skill}}</span></li></ul></section><section layout=\"column\" flex=\"\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><span class=\"md-accent md-title\">Skill Set</span></div><ul><li ng-repeat=\"skill in selectedJob.skillSet\"><span class=\"md-body-2\" style=\"margin-left: 4px;\">{{skill}}</span></li></ul></section></div></md-dialog-content><md-dialog-actions md-colors=\"{\'background\' : \'awesome-accent-50-0.75\'}\"><section flex=\"\" layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-warn\" ng-click=\"cancel();\">Cancel</md-button><md-button class=\"md-accent md-raised\" target=\"_blank\" ng-href=\"{{selectedJob.url}}\">Apply Now</md-button></section></md-dialog-actions></md-dialog></div></div><script type=\"text/ng-template\" id=\"careersApplyDialog.html\"><md-dialog flex-md=\"50\" flex-lg=\"40\" flex-xl=\"30\" aria-label=\"careersApplyDialog\"> <md-toolbar> <div class=\"md-toolbar-tools\" layout> <h5 style=\"padding-top: 0;\">Apply For {{selectedJob.title}}</h5> <span flex></span> <md-button class=\"md-icon-button\" ng-click=\"cancel()\"> <md-icon md-svg-src=\"assets/images/close.svg\" aria-label=\"Close dialog\"></md-icon> </md-button> </div> </md-toolbar> <md-dialog-content class=\"md-padding\"> <form name=\"applyForm\"> <section layout layout-wrap> <md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\"> <label>Name</label> <input type=\"text\" name=\"name\" required ng-pattern=\"/^[a-zA-z\\s]*$/\" ng-model=\"apply.name\"/> </md-input-container> <md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\"> <label>Email</label> <input type=\"email\" name=\"email\" ng-pattern=\'/^(([^<>()[\\]\\\\.,;:\\s@\\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\\"]+)*)|(\\\".+\\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\' required ng-model=\"apply.email\"/> </md-input-container> <md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"33\"> <label>Mobile Number</label> <input type=\"tel\" name=\"mobile\" required ng-model=\"apply.mobile\" minlength=\"10\" ng-maxlength=\"10\" maxlength=\"10\" ng-pattern=\"/^[56789][0-9]{9}$/\"/> </md-input-container> <md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"33\"> <label>Experience</label> <md-select ng-model=\"apply.experience\" required> <md-option ng-repeat=\"time in times\" ng-value=\"time\"> {{time === 1 ? time + \" year\" : time + \" years\"}} </md-option> </md-select> </md-input-container> <md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"33\"> <label>Notice Period (In Days)</label> <input type=\"number\" name=\"noticePeriod\" required ng-model=\"apply.noticePeriod\"/> </md-input-container> <choose-file layout=\"row\" ng-model=\"apply.file\" flex=\"70\" flex-offset=\"15\"> <input id=\"fileInput\" type=\"file\" class=\"ng-hide\"> <md-input-container flex class=\"md-block\" required> <label>Upload your resume</label> <input type=\"text\" required ng-model=\"apply.file.name\" disabled> <!--<div class=\"hint\">Upload your CV</div>--> </md-input-container> <div> <md-button id=\"uploadButton\" class=\"md-fab md-mini\" aria-label=\"file\"> <md-icon class=\"material-icons\">attach_file</md-icon> </md-button> </div> </choose-file> </section> </form> </md-dialog-content> <md-dialog-actions md-colors=\"{\'background\' : \'awesome-primary-50-0.75\'}\"> <section flex layout layout-align=\"space-between center\"> <md-button class=\"md-warn\" ng-click=\"doSecondaryAction(selectedJob, $ev);\"> Back to Details </md-button> <md-button class=\"md-primary\" ng-disabled=\"applyForm.$invalid\" ng-click=\"applyForJob();\"> Apply Now </md-button> </section> </md-dialog-actions> </md-dialog></script></div>");
$templateCache.put("app/modules/static/partials/contact_us.html","<div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" class=\"aarida-background\" ng-controller=\"contactCtrl\" layout-padding=\"\"><section flex=\"100\" flex-gt-sm=\"40\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><span class=\"center-text md-display-1 md-margin\">Contact Us</span> <span class=\"center-text md-subhead\">Let\'s talk it out</span><div layout=\"column\" layout-align=\"start center\" layout-margin=\"\"><a href=\"tel:080-4152 1574\" class=\"click-link green-text\">080-4152 1574</a> <a href=\"mailto:support@aadira.com\" class=\"click-link green-text\">support@aarida.com</a></div></section><section flex=\"100\" flex-gt-sm=\"60\" layout=\"column\"><form layout=\"row\" layout-align=\"center center\" class=\"relative\" name=\"contactForm\"><md-card><h3 class=\"center-text montserrat md-title\">Say Hello !</h3><md-divider></md-divider><md-card-content layout=\"column\" ng-if=\"!messageSent\"><div layout=\"\" layout-padding=\"\"><md-input-container flex=\"\" class=\"md-block md-accent\"><label>Name</label> <input type=\"text\" required=\"\" ng-model=\"message.name\"></md-input-container><md-input-container flex=\"\" class=\"md-block md-accent\"><label>Email</label> <input type=\"email\" required=\"\" ng-model=\"message.email\"></md-input-container></div><div layout=\"\" layout-padding=\"\"><md-input-container flex=\"\" class=\"md-block md-accent\"><label>Subject</label> <textarea name=\"bio\" ng-model=\"message.subject\" required=\"\" md-maxlength=\"100\"></textarea></md-input-container></div><div layout=\"\" layout-padding=\"\"><md-input-container flex=\"\" class=\"md-block md-accent\"><label>Message</label> <textarea name=\"bio\" ng-model=\"message.message\" required=\"\" md-maxlength=\"300\"></textarea></md-input-container></div><div layout=\"\" layout-align=\"center center\"><span class=\"md-caption red-text\">{{error}}</span></div><section layout=\"\" layout-align=\"center center\" class=\"md-padding\"><div vc-recaptcha=\"\" ng-model=\"message.captchaResponse\" ng-required=\"\" key=\"\'6LezjR8TAAAAAGNK4RMki4WPCVg3dV1qtd8eZ711\'\"></div></section><md-button class=\"md-raised md-accent\" ng-disabled=\"sendingMsg || contactForm.$invalid\" type=\"submit\" value=\"Submit\" ng-click=\"send();\"><div layout=\"\" layout-align=\"center center\"><span class=\"bold-text\" ng-if=\"!sendingMsg\">SEND Message</span><md-progress-circular ng-if=\"sendingMsg\" md-diameter=\"24\" class=\"md-accent\"></md-progress-circular></div></md-button></md-card-content><md-card-content ng-if=\"messageSent\" style=\"max-width: 400px;\"><div layout=\"\" layout-margin=\"\" layout-align=\"center center\"><svg class=\"checkmark\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 52 52\"><circle class=\"checkmark__circle\" cx=\"26\" cy=\"26\" r=\"25\" fill=\"none\"></circle><path class=\"checkmark__check\" fill=\"none\" d=\"M14.1 27.2l7.1 7.2 16.7-16.8\"></path></svg></div><div layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><span class=\"md-title bold-text montserrat\">Message Sent</span> <span class=\"md-body-1\">We have received your request and will get back to your email address {{message.email}} in the next 24-48 hours. We appreciate your patience.</span></div></md-card-content></md-card></form></section></div>");
$templateCache.put("app/modules/static/partials/faqs.html","<div><section layout=\"column\" layout-align=\"start center\" layout-padding=\"\" class=\"aarida-background\" style=\"min-height: 200px; padding-bottom: 100px\"><h1 class=\"center-text uppercase md-display-1\">Frequently Asked Questions</h1><span class=\"center-text md-subhead\">Cannot find what your are looking for, feel free to <a class=\"md-link bold-text pointer\" ui-sref=\"app.contact_us\">contact us</a></span></section><md-card style=\"margin-top: -48px;\"><md-card-content><div ng-repeat=\"faq in faqs\" class=\"accordion-container\"><button class=\"accordion\">{{faq.question | uppercase}}</button><div class=\"panel\"><p>{{faq.answer}}</p></div></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/static/partials/how-it-works.html","dshdfgg");
$templateCache.put("app/modules/static/partials/index.html","<div ng-controller=\"staticController\" class=\"static-page\"><section class=\"header\" layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><h1 class=\"center-text uppercase md-display-1\">{{data.title}}</h1><span class=\"center-text md-subhead\" ng-if=\"data.subhead\">{{data.subhead}}</span></section><md-card style=\"margin-top: -48px;\"><div class=\"aarida-editor\" id=\"aarida-dyn\"></div></md-card></div>");
$templateCache.put("app/modules/static/partials/media.html","fdghdfh");
$templateCache.put("app/modules/static/partials/privacy-policy.html","<div style=\"min-height: 100vh;\"><md-card ng-class=\"{\'static-card\' : !isSmall}\"><md-card-content layout=\"column\" layout-align=\"start center\" ng-class=\"{\'layout-padding layout-margin\': !isSmall}\"><h2>Privacy Policy</h2><span>We are aarida.com, a service provided by Redux X-Press Pvt. Ltd.</span><div layout-gt-sm=\"row\" layout=\"column\" style=\"text-align: justify;\"><div layout=\"column\" flex=\"\" layout-padding=\"\" layout-margin=\"\"><span>At the time of sign up, we collect and store your E-mail address, password, username provided by you in our database. You are entirely responsible for maintaining your confidentiality of your account and passwords as well as you are fully responsible for all activities in your account. “aarida” is not liable for any damages or losses arises from your failure to comply with the above maintained.</span><ol><li><span class=\"md-title\">Information’s about you that we collect</span><ul><li><h5>User account details</h5>At aarida we collect and store the delivery/shipping address (name, complete address, town, city, district, state, country & postal code) and your phone number at the time you place an order with us. We only share this information with our logistic partners.</li><li><h5>Payment information</h5>We don’t store any credit card/debit card, net banking information. At the time of payment, the user is redirected to a third party website where you fill out the details. aarida has no control over the information provided by you to the third party website and does not take any responsibility for the misuse of any credit card information provided on the third-party website.</li><li><h5>IP Address</h5>Each time a user visit the website, we automatically collect your IP address and the web page from where you came. In order to administer and optimise the Site for the user and to diagnose problems with our website, we use user’s IP address to help identify them and to gather broad demographic information about them.</li></ul><p>We at aarida assure you to protect your information on our website. We will not distribute any such information to the third party.</p><p>We shall therefore only use your name and any other information which relates to you in the manner set out in this Privacy Policy. We will only collect your information if it helps us in making your experience on the website better. “aarida” implements standard measures to protect against any unauthorised access to and unlawful interception of any Personal Information. However, no website can fully eliminate all security risks.</p><p>This website uses these so-called social plugins (“plugins”) of the social networks Instagram, Pinterest, Twitter, Facebook & Google+ which are operated by their respective entities. Kindly read their Privacy Policies for further information on how they protect your personal data. If you do not want any of these parties to collect any personal information about your visit to aarida, Please log out of them before visiting our website.</p></li><li><span class=\"md-title\">Cookies</span><p><ul><li>Cookies are tiny text files which help us identify your computer to our server as a unique user when you visit certain pages on our website and stored by your Internet browser on your computer’s hard-drive.</li><li>Cookies can be used to recognise the user’s Internet Protocol address, saving you time while you are on, or want to enter our website. We only use cookies for user’s convenience in using the Site and not for obtaining or using any other information about you.</li><li>Please accept our assurance that our use of any cookies does not contain any personal or private details and are free from viruses.</li></ul></p></li></ol></div><div layout=\"column\" flex=\"\" layout-padding=\"\" layout-margin=\"\"><ol start=\"3\"><li><span class=\"md-title\">General exceptions</span><p>If we are required to monitor, disclose, intercept and/or store your personal information:<ul><li>by law;</li><li>to secure our systems;</li><li>to conduct our business;</li><li>to enforce our own rights,</li></ul></p><p>we will do so in the manner as prescribed by law. Such type of interception, disclosure, monitoring and storage may take place without your knowledge. In these cases, we will not be liable to you or any other third party for any damages howsoever arising from such interception, storage, monitoring and disclosure. Additionally, we may monitor all or any of your personal information to the extent that this may be required to determine any compliance and/or to identify any instances of non-compliance. This monitoring may include(without limitation) the filtering of any incoming and outgoing electronic data messages to identify, limit and/or prevent the transmission of viruses, spam and/or defamatory, unlawful, obscene or otherwise undesirable materials or contents. We may under certain circumstances procure an element of the services from a third-party service provider. To the extent that it might be necessary and solely for the purposes of providing the service to the user, the user agrees that we may disclose to such third party any of their personal information that may be necessary for the procurement of services from the third party.</p><p></p></li><li><span class=\"md-title\">Changes in policy</span><p>The user unconditionally agrees that using this website signifies their assent to aarida’s Privacy Policy. If you do not agree with these Privacy policies, please refrain from using our website. Any dispute over privacy is subject to this policy and all our terms of Use, including limitations on damages as well. “aarida” reserves the right to change the terms of use and this privacy policy at any time. Any changes, in the policy, will be posted and you will be expected to know about it. We do not bear any responsibility for updating our users on the same. Unless stated otherwise, our current privacy policy applies to all the information that we have about you and your account.</p></li><li><span class=\"md-title\">Laws</span><p>We may be required by law to disclose the user’s Personal Information to any proper law enforcement agencies; even if the user requested that we don’t share any of their information. This information may be necessary to identify any contact or bring legal action against anyone who had committed any offence as per stated laws and regulations.</p><p>This terms shall be governed by and constructed in accordance with the laws of the Republic of India without reference to any conflict of laws, principles and any kind of disputes arising in relation hereto shall be subjected to the exclusive jurisdiction of our registered address only.</p></li></ol></div></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/static/partials/shipping-and-returns.html","<div style=\"min-height: 70vh\"><md-card ng-class=\"{\'static-card\' : !isSmall}\"><md-card-content layout=\"column\" layout-align=\"start center\" layout-padding=\"\" layout-margin=\"\"><div layout=\"column\" layout-gt-sm=\"row\" style=\"text-align: justify\" layout-padding=\"\" layout-margin=\"\"><div flex=\"\"><h3>SHIPPING POLICY</h3><div layout=\"column\"><div><p>The user can trust that their order will be processed and delivered quickly. For few out of stock items, the user can back order the same item*. But the shipping time will be mentioned in the particular product description section. We are shipping though out pan India. But the mode of shipping entirely depends on us. As the order placed, we will estimate the approximate delivery date based on the availability of the product and shipping destination.</p><ul><li class=\"md-caption\">*Only applicable for few products and will be mentioned on the product page.</li><li class=\"md-caption\">It takes 2-3 business days to ship the items which are in stock.</li></ul></div><p>We fully commit to delivering user’s orders within the specified time period. In a case, of delays in delivery due to any unforeseeable and unavoidable reasons, aarida shall not be held responsible. aarida will not be responsible for any delivery at wrong address(es) if the address, specified at the time of ordering is incorrect.</p><p>We ship through our logistic partners. Our shipping or delivery policy also contains their individual terms and conditions and other policies. We are not accountable for any changes made by them in their terms and conditions. The estimated delivery time for any user’s order will vary based on the nature of the product and the destination for shipping.</p><p>If the user wishes to change the address, then they need to intimate us till the order is in the processing stage. They need to intimate us through call or mail provided in our contact details. Otherwise, we would process the order with the previous address.</p><div><h4>Shipping charges</h4><p>The shipping charges will be determined by the weight of the item ordered and the delivery address. We would provide you with free shipping if the order value exceeds Rs 500.</p></div></div></div><div flex=\"\"><h3>RETURN, REFUND AND CANCELLATION POLICY</h3><div style=\"margin-top: 35px;\"><h4>Return</h4><p>We understand and appreciate your concerns about online shopping and hence we have a return policy where we can exchange the size of the product if it does not fit you. Or the product received by you is defective or damaged.</p><h4>Note</h4><ul><li>You can exchange the item from 3 days after the date of delivery.</li><li>Tag and Label should be intact properly.</li></ul><h4>Cancellation Policy</h4><p>Orders can be cancelled, if it’s in the processing stage. On cancellation of the order, we will refund the entire order amount to the customer. The user may request a cancellation by contacting us at support@aadira.com or call us on our Toll-Free number- 1800-2700-385.</p><h4>Refund</h4><ul><li>In the case of returned product, the entire amount will be credited back into your account with us.</li><li>In the case of cancellation, the entire order amount will be refunded to customer’s bank account.</li></ul><span>For further information, please contact us at 1800-2700-385</span></div></div></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/static/partials/store-locator.html","<div><section layout=\"\" layout-align=\"center center\"><h1 class=\"md-display-1\">Store Locator</h1></section><section layout=\"column\"><div flex=\"\" layout-gt-sm=\"row\" layout=\"column\"><section flex-gt-sm=\"33\" flex-xs=\"100\" flex-sm=\"100\" ng-repeat=\"city in cities\" class=\"md-padding\"><md-list><div class=\"md-no-sticky\"><h2 style=\"padding-left: 16px\">{{city.cityName}}</h2></div><md-list-item class=\"md-3-line store-item\" ng-repeat-start=\"store in city.stores\" ng-class=\"{\'active md-whiteframe-2dp\' : selected === store}\" ng-click=\"selectAddress(store)\"><div class=\"md-list-item-text\" layout=\"column\"><h3 style=\"font-weight: 600\">{{ store.name }}</h3><h4>{{ store.address1 }}</h4><h4>{{ store.address2 }}</h4><p class=\"bold-text\">Contact Number : {{ store.contactNumber }}</p></div></md-list-item><div style=\"padding: 2px 0\" ng-repeat-end=\"\"></div></md-list></section></div><section flex=\"\" ng-if=\"showMap\"><ui-gmap-google-map center=\"map.center\" zoom=\"map.zoom\" options=\"map.options\"><ui-gmap-marker coords=\"marker.coords\" idkey=\"marker.id\" options=\"marker.options\"><ui-gmap-window><div>{{marker.window.title}}</div><div>{{marker.window.address}}</div></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map></section></section></div>");
$templateCache.put("app/modules/static/partials/team.html","<div layout=\"column\"><div class=\"team-bg\" style=\"min-height: 100vh; background-position-y: center;\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><span class=\"montserrat md-display-3 bold-text white-text center-text\">Our Team</span> <span class=\"white-text bold-text center-text\">The people who make it all come together.</span></div></div></div>");
$templateCache.put("app/modules/static/partials/terms.html","<div ng-class=\"{\'md-margin\' : !isSmall}\" style=\"min-height: 100vh;\" layout=\"\" layout-align=\"center start\"><md-card ng-class=\"{\'static-card\' : !isSmall}\"><md-card-content ng-class=\"{\'md-margin\' : !isSmall}\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><h2>Terms and Conditions</h2><span>Please read the following carefully as they contain the legalities a user needs to agree to before using any of our services.</span> <span>www.aarida.com is an internet based E-commerce website in sole discretion of Redux X-Press Pvt. Ltd.</span><div layout=\"column\" layout-gt-sm=\"row\" layout-padding=\"\" layout-margin=\"\" style=\"text-align: justify\"><div flex=\"\"><span><h4>Non-Transferable</h4><span>Any password or right given to the user to obtain documents, information or any other access to the website is not transferable or assignable.</span><h4>Passwords and account security</h4><span>The user is solely responsible for maintaining the confidentiality of password associated with the account they use to access the offerings from www.aarida.com. We will take all due care to ensure the confidentiality of their credentials. They agree and acknowledge that in the very unlikely event of any of their credentials becoming known to any third-party, they will notify the concerned official at www.aarida.com immediately.</span><h3>PRICES AND SHIPPING FEES</h3><span><ul><li><span>The prices that are listed at the time of your order on the productpage are exclusive of all taxes, and the final price, inclusive of applicable taxes, is shown on the shopping cart page.</span></li><li><span style=\"margin-left: 5px;\">For return of products, contact our customer support via support@aadira.com or via our contact form provided.</span></li></ul></span><h4>Discount Codes</h4><span>Promotional discount codes may vary from time to time and apply with respect to any specific purchases made though our website. The conditions of use, relating to discount codes will be specified at the time of issue.</span><h4>Link to other websites</h4><span>www.aarida.com may provide links to websites that are maintained by third parties. We are not responsible or liable for any of the information available on these websites.</span><h4>PAYMENT OPTIONS</h4><span>We have partnered with few of the best payment gateways prevailing in India; PayUMoney and Instamojo for carrying out the online transactions at aarida. All credit cards and debit cards payments are processed through secure and trusted channels managed by leading banks. We offer following payment modes:-<ul><li>Credit/Debit card</li><li>Net banking</li><li>COD - Cash on Delivery (For selected pin codes)</li></ul>The maximum price applicable for COD is Rs 1000</span><h4>Credit card payment</h4><span>aarida agrees not to store any credit card information in our database without permission. We will not be held responsible for any such issues arising out of the payment gateways dysfunction.</span><h4>Privacy policy</h4><span>The user hereby fully consents, expresses and agrees that he/she has read and fully understands the entire privacy policy of our website www.aarida.com. Our privacy policy, as it might be changed from time to time, is hereby expressly made part of this agreement.</span><h4>Shipping and Delivery of Order</h4><span>The user can trust that their order will be processed and delivered quickly. For few out of stock items, the user can reorder*. But the shipping time will be mentioned in the particular product description section. We ship pan India. But the mode of shipping entirely depends on us. Once the order is placed, we will estimate the approximate delivery date based on the availability of the product and shipping destination. *Only applicable for few products and will be mentioned on the product page. It takes 2-3 business days to ship the items which are in stock. We fully commit to delivering orders within the specified time period. In case of delays in delivery due to any unavoidable circumstances, aarida shall not be held responsible. We ship through our logistic partners. Our shipping or delivery policy also contains their individual terms and conditions and other policies. We are not accountable for any changes made by them in their terms and conditions. The estimated delivery time for any order will vary based on the nature of the product and the destination for shipping. If the user wishes to change the address, they need to intimate us while the order is still in the processing stage. They can call or mail provided in our contact details.</span><h4>Shipping charges</h4><span>The shipping charges will be determined by the weight of the item ordered and the delivery address. We would provide you with free shipping if the order value exceeds Rs500.</span><h3>RETURN, REFUND AND CANCELLATION POLICY</h3><span>Returns - We understand and appreciate your concerns about online shopping and hence we have a return policy where we can exchange the size of the product if it does not fit you. Or the product received by you is defective or damaged. Note<ul><li>You can exchange the item up to 3 days after the date of delivery.</li><li>Tag and Label should be intact.</li></ul></span><h4>Cancellation Policy</h4><span>Orders can be cancelled, if it&#39;s in the processing stage. On cancellation of the order, we will refund the entire order amount to the customer. The user may request a cancellation by contacting us at support@aadira.com or call us on our Toll-Free number- 1800-2700-385.</span><h5>Refund</h5><span>In the case of returned product, the entire amount will be credited back into your account. In the case of cancellation, the entire order amount will be refunded. For further information, please contact us.</span><h3>WHAT WE DO ABOUT MISPRICINGS</h3><span>Despite all our best efforts, a small number of the many hundreds of items in our catalogue might be mispriced. However, we verify prices as part of our dispatch procedures.<ul><li>If a product\'s correct price is lower than our stated price, we then charge the lower amount and send you the item.</li><li>If an item\'s correct price is higher than our originally stated price, we will cancel your order and notify you of that cancellation.</li></ul></span><h4>Modification of terms and conditions</h4><span>&quot;aarida&quot; reserves the sole rights to modify or amend these terms of service for any other reason. Such modification or amendments will be effective immediately upon giving the user notice by following means, including but not only limited to, posting on our website or email. The user expressly consents to use any information available on the website at their own risk. The user is advised to hereby make proper enquiries while using the information provided on the website.</span></span></div><div flex=\"\"><h4>Law</h4><span>This Agreement will be governed by and entirely construed in accordance with the judiciary laws of the Republic of India without giving effect to any of the principles or conflicts of law. All kinds of legal proceedings shall be subject to the jurisdiction of our registered address only (Jharkhand, India) and shall be governed by and construed in accordance with the laws of India and users agree to resolve any and all disputes under the Arbitration and Conciliation Act 1996. Venue for any such arbitration shall be at the registered address at Jharkhand, India.</span><h4>Indemnity/Compensation</h4><span>The user agrees to indemnify/compensate aarida and its affiliates, including its directors, employees, content providers, service providers, partners, suppliers against any losses, claims or demand including any legal fees, resulting from any type of violation of these Terms and Conditions of Service, or any wrongful activity related to user’s account by user or any other person using user’s account.</span><h4>Exclusion of warranties</h4><span><ul><li>The user understands and agrees that they use any of the offerings is at their own risk and that the offering is provided as it is and as available.</li><li>In particular, aarida does not represent or warrant to you that: (a) your use of any of the offerings will meet your requirements, (b) your use of all the offerings will be always uninterrupted, timely, secure or free from the errors, including specifically from server downtime, (c) any kind of information obtained by you as a result of your use of the offerings will be accurate or reliable, and.</li><li>Any of the materials downloaded or otherwise obtained through the use of the offerings is done at your own discretion and risk and aarida will not be responsible for any such damage to your computer system or any loss of data or other any devices that results from the download of any such materials.</li><li>No advice or information, whether it is oral or written, obtained by you from aarida or through or from any of the offerings shall create any warranty which is not expressly stated in the terms.</li><li>aarida further expressly disclaims all the warranties and conditions of any kind, whether implied or expressed, including, but not only limited to all the implied warranties and conditions of the merchantability and fitness for any particular purpose and all noninfringement.</li></ul></span><h4>Disclaimer</h4><span>It is entirely the user&#39;s responsibility to log-in earlier if they want to avail any of the better products or styles because aarida.com sales are &quot;first come, first served&quot; basis. No information regarding any presence of the products, in our stock, will be guaranteed whereas we will alert you only when a product is sold out (on our website). The terms and conditions for any such Contest shall be separately available on our website. In the event of any such conflict between these T&amp;C and the terms and conditions relate to any of the contest, such terms and conditions shall prevail. Information about the prices, products, services and merchants are for informational purposes only. The product images are only for representation. We cannot guarantee that information is 100% correct. aarida will not be liable for any such omissions, errors or delays or any kind of damages, injuries and losses arising from its display or use. We, as a merchant shall be under no such liability whatsoever in respect of any losses or damages or injuries that arises directly or indirectly out of the decline of authorization for any type of transaction, on account of the cardholder having exceeded the preset limit value mutually agreed by us with our acquiring banks from time to time. aarida.com also disclaims any responsibility for any kind of accuracy, availability of information , or contents found on websites that link to or from aarida.com websites. You acknowledge that any other companies or some advertisers, employ automated search results or otherwise link you to websites containing any information that may be deemed offensive or inappropriate in any way. aarida.com is not liable for any copyright compliance, accuracy, decency of material, or legality or content contained on any third-party websites. aarida prohibits its user from creating derivative works, publishing, displaying, distributing, modifying , transmitting, copying, selling, licensing or using any of content available on or through aarida.com for any type of commercial or public purposes.</span><h4>Intellectual Property Rights</h4><span>Everything on aarida’s website, including graphics, text , software, patents, designs, any and all rights, service marks, trade names, trademarks , utility models, trade secrets and inventions, databases, source code, text, content, goodwill, graphics, icons, meta tags, and hyperlinks, logos, icons and images, is the valuable intellectual property of aarida a Division of Redux X-press Pvt. Ltd. its subsidiary, associates and affiliates. You acknowledge and agree that you shall not distribute, reproduce or use any contents from the website of aarida.com without obtaining authorization from aarida.com or the thirty party owner of such Intellectual Property Right.</span><h4>Limitation of liability</h4><span>Neither aarida nor any of its affiliates, employees, agents or consultants shall in any events be liable for any indirect, incidental or consequential damages or damages arising out of any breach of warranty even if aarida or any of its affiliates, employees, agents or consultants have been advised of the possibility of any such kind of damages. Such limitation of liability shall apply whether the damages arise from use or misuse of or reliance on aarida information, from inability to use aarida information, or from any interruption, suspension, or termination of access to the contents or site (including any such damages incurred by any of the third parties). This limitation shall also apply to the costs of procurement of any substitute content, loss of goodwill, loss of good faith, loss of profits, or loss of data. Any such limitation shall further be applicable with respect to the performance or non-performance of aarida or any information that appears on, or is linked to or related in any way to, the site provided thereunder. Any such limitation shall apply notwithstanding any failure of essential purposes of any limited remedy and to the fullest extent permitted by the law.</span></div></div><h3>Reporting violations/grievance</h3><p>Report abuse to <span>support@aadira.com.</span></p></md-card-content></md-card></div>");
$templateCache.put("app/modules/wishlist/partials/wishlist.html","<section class=\"wislist-page\"><div layout=\"\" layout-align=\"center center\" class=\"wishlist-bg\"><h1 class=\"white-text wishlist-title\">My Wishlist</h1></div><div class=\"wishlist-section\"><md-card layout=\"\" layout-align=\"start center\" class=\"md-padding md-margin\"><span class=\"md-title\"><md-icon style=\"margin-right: 10px;\">favorite</md-icon>Wishlist</span> <span flex=\"\"></span> <span ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\">{{ wishlist.products.length }} products</span></md-card><div class=\"catalog\" ng-if=\"wishlist.products.length > 0\" layout=\"\" layout-align=\"center stretch\" layout-wrap=\"\"><section flex-lg=\"20\" flex-gt-md=\"30\" flex-gt-xs=\"30\" flex=\"50\" ng-repeat=\"product in wishlist.products\"><md-card ui-sref=\"app.product({productSlug: product.slug})\" id=\"{{\'product-card-\' + $index}}\" md-whiteframe=\"1\" ng-class=\"{\'out-of-stock\' : product.outOfStock}\" class=\"pointer wishlist-item product-item\" style=\"position: relative\"><div layout=\"\" layout-align=\"center center\" class=\"remove-from-wishlist-button-container\"><md-button class=\"md-icon-button\" ng-click=\"removeFromWishlist(product, $event)\"><md-icon>close</md-icon></md-button></div><img md-preload=\"\" item-index=\"$index\" md-src=\"product.featured_image\" key=\"large\"><md-divider></md-divider><md-card-footer-text layout=\"column\" class=\"md-padding\"><span class=\"grey-text\" ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\">{{getProperName(product.name);}}</span> <span class=\"bold-text\" ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\">Rs. {{product.price}}</span><md-button class=\"md-accent\"><span>Move to Cart</span></md-button></md-card-footer-text></md-card></section></div><div ng-if=\"wishlist.products.length == 0\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\" style=\"min-height: 60vh;\"><img src=\"assets/images/vacations.svg\" style=\"width: 300px;\"> <span class=\"cookie md-title\">Unlike this list, your\'s is completely empty.</span> <span class=\"cookie md-title\">Go on. Fill it up.</span></div></div><span style=\"height: 32px;\"></span></section>");
$templateCache.put("app/modules/account/creations/partials/creations.html","<div layout=\"column\" flex=\"\" ng-if=\"ucLoaded\"><section ng-show=\"ucData.length > 0 && ucLoaded\" ng-if=\"ucLoaded\" layout=\"row\" layout-align=\"center\" layout-wrap=\"\"><md-card ng-repeat=\"data in ucData\" md-ink-ripple=\"\" class=\"pointer\" ui-sref=\"app.customisationEditor({slug : data.product.slug, ucSlug : data.slug})\"><customisable-product customisation=\"data.customisation\" size=\"small\"></customisable-product><md-card-footer-text layout-padding=\"\"><span class=\"md-caption\">{{ data.name }}</span></md-card-footer-text></md-card></section><section ng-show=\"ucData.length == 0\" layout=\"\" layout-align=\"center-center\" layout-margin=\"\"><md-card flex=\"40\" layout-margin=\"\"><md-card-content layout=\"column\" layout-align=\"center center\"><md-img md-src=\"assets/images/dress.svg\" style=\"width: 100px;\"><span class=\"md-title\" style=\"margin-top: 50px;\">No Creations Yet</span><md-button class=\"md-primary\" ui-sref=\"app.customisation\">Create Now</md-button></md-img></md-card-content></md-card></section></div><div ng-if=\"!ucLoaded\" layout=\"\" flex=\"\"><section layout=\"column\" layout-align=\"center center\" layout-fill=\"\" style=\"min-height: 50vh;\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><span class=\"md-accent md-title montserrat\">Loading your creations...</span></section></div>");
$templateCache.put("app/modules/account/orders/partials/cancellation-dialog.html","<md-dialog aria-label=\"cancel order dialog\" flex=\"30\" flex-xs=\"90\" flex-sm=\"60\" flex-md=\"40\" flex-lg=\"30\" flex-xl=\"20\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h5>{{title}} Order</h5><md-button class=\"md-icon-button\" ng-click=\"close();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><p class=\"md-caption grey-text center-text\">Select a reason for {{textDesc}}</p><form name=\"$parent.cancelForm\"><md-radio-group required=\"\" ng-model=\"cancelReason\"><md-list><md-list-item ng-repeat-start=\"reason in reasons\"><md-radio-button aria-label=\"{{reason}}\" value=\"{{reason}}\"><span class=\"md-caption montserrat\">{{reason}}</span></md-radio-button></md-list-item><md-divider ng-repeat-end=\"\"></md-divider></md-list></md-radio-group><md-input-container class=\"md-block\" md-theme=\"black\" ng-if=\"cancelReason === \'Others\'\"><label>Reason for {{textDesc}}</label> <textarea ng-model=\"$parent.otherReason\" required=\"\" rows=\"5\" placeholder=\"Tell us why you feel like {{textDesc}} this order\"></textarea></md-input-container></form></md-dialog-content><md-divider></md-divider><md-dialog-actions><md-button class=\"md-accent\" ng-click=\"cancelTheOrder();\" ng-disabled=\"$parent.cancelForm.$invalid\"><md-icon>delete</md-icon><span class=\"bold-text\">{{title}} Order</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/account/orders/partials/details.html","<div layout=\"column\" ng-if=\"!ordersLoaded\" layout-align=\"center center\" flex=\"\" style=\"min-height: 60vh;\"><md-progress-circular class=\"md-accent\"></md-progress-circular><span class=\"md-caption grey-text md-margin\">Fetching details for {{orderNumber}}</span></div><div layout=\"column\" ng-if=\"ordersLoaded && unauthorized\" layout-align=\"center center\" style=\"min-height: 60vh;\"><img src=\"assets/images/error.svg\" style=\"width: 150px;\"><p class=\"md-caption grey-text md-margin\">Unauthorized Request</p></div><div layout=\"column\" ng-if=\"ordersLoaded && !unauthorized\" class=\"md-margin\"><div layout=\"\" layout-align=\"start center\"><md-button class=\"md-accent\" ui-sref=\"app.account.orders\"><md-icon>keyboard_arrow_left</md-icon><span>Back to Orders</span></md-button></div><md-card md-colors=\"{\'background\' : \'awesome-accent-500-1\'}\"><md-card-content layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align=\"center center\"><span style=\"font-weight: bold\" class=\"white-text\" ng-class=\"{\'md-title\' : !isSmall, \'md-subhead\' : isSmall}\">{{order.orderNumber}}</span> <span flex=\"\"></span><md-button class=\"md-raised md-primary\" ng-if=\"order.status === \'shipped\'\" ng-href=\"{{\'https://tracklite.in/track/\' + order.awbCode}}\" target=\"_blank\"><span class=\"bold-text\">Track Order</span></md-button><md-button class=\"md-raised md-hue-2 md-accent\" ng-click=\"showCancellationDialog($event);\" ng-if=\"order.status ==\'delivered\' && order.returnable\"><md-icon>location_on</md-icon><span class=\"bold-text\">Return Order</span></md-button><md-button class=\"md-raised md-hue-2 md-primary\" ng-click=\"showCancellationDialog($event);\" ng-if=\"order.status == \'placed\' || order.status == \'incomplete\' || order.status==\'approved\'\"><md-icon>cancel</md-icon><span class=\"md-caption montserrat\">Cancel Order</span></md-button></md-card-content></md-card><md-card class=\"red\"><md-card-content ng-if=\"order.status ===\'cancelled\'\" layout=\"\" layout-xs=\"column\" layout-sm=\"column\" layout-align-gt-sm=\"start center\" layout-align=\"center start\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">info</md-icon></div><span class=\"white-text\" ng-class=\"{\'md-caption\' : isSmall}\" style=\"margin-left: 4px;\"><span class=\"bold-text\">Order Cancelled on :</span>{{getCompletionDate(\"cancelled\") | date : \"medium\"}}</span> <span class=\"white-text\" ng-class=\"{\'md-caption\' : isSmall}\" style=\"margin-left: 50px;\"><span class=\"bold-text\">Reason :</span>{{order.cancellationReason}}</span></md-card-content></md-card><md-card style=\"background: #c67d09\"><md-card-content ng-if=\"order.status ===\'return requested\'\" layout=\"\" layout-xs=\"column\" layout-sm=\"column\" layout-align-gt-sm=\"start center\" layout-align=\"center start\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">info</md-icon></div><span class=\"white-text\" ng-class=\"{\'md-caption\' : isSmall}\" style=\"margin-left: 4px;\"><span class=\"bold-text\">Return Requested on :</span>{{getCompletionDate(\"return requested\") | date : \"medium\"}}</span> <span class=\"white-text\" ng-class=\"{\'md-caption\' : isSmall}\" style=\"margin-left: 50px;\"><span class=\"bold-text\">Reason :</span>{{order.cancellationReason}}</span></md-card-content></md-card><md-card class=\"md-padding\" ng-if=\"order.status !== \'cancelled\'\"><md-card-content layout=\"column\"><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" ng-value=\"orderStatusValue\"></md-progress-linear><div layout=\"\" class=\"relative\"><div ng-show=\"placedSuccess && showPlacedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : 0 +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"approvedSuccess && showApprovedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (30 - 1) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"packedSuccess && showPackedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (50 - 1) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"shippedSuccess && showShippedSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (70 - 1) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div><div ng-show=\"deliveredSuccess && showDeliveredSuccess\" style=\"position: absolute; top: -15px; width: 24px;\" ng-style=\"{\'left\' : (100 - 1) +\'%\'}\"><img src=\"assets/images/success.svg\" style=\"width: 24px;\"></div></div><div layout=\"\" style=\"margin-top: 30px; position: relative;\"><div layout=\"column\" flex=\"\" layout-align=\"center start\"><img src=\"assets/images/places.svg\" style=\"width: 24px; margin-left: 10px; margin-bottom: 8px;\"> <span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : order.status === \'cancelled\'|| order.status ===\'returned\'}\">Placed</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/approve.svg\" style=\"width: 24px; margin-left: 10px; margin-bottom: 8px;\"> <span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : order.status === \'cancelled\'|| order.status ===\'returned\'}\">Approved</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/export.svg\" style=\"width: 24px; margin-left: 10px; margin-bottom: 8px;\"> <span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : order.status === \'cancelled\'|| order.status ===\'returned\'}\">Packed</span></div><div flex=\"\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/route.svg\" style=\"width: 24px; margin-left: 10px; margin-bottom: 8px;\"> <span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : order.status === \'cancelled\'|| order.status ===\'returned\'}\">Shipped</span></div><div flex=\"\" layout=\"column\" layout-align=\"center end\"><img src=\"assets/images/truck-delivering.svg\" style=\"width: 24px; margin-right: 12px; margin-bottom: 8px;\"> <span ng-class=\"{\'md-caption\' : isSmall,\'grey-text\' : order.status === \'cancelled\'|| order.status ===\'returned\'}\">Delivered</span></div></div></md-card-content></md-card><div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\"><md-card flex=\"\" layout=\"row\" layout-align=\"center center\"><img src=\"assets/images/calendar.svg\" style=\"width: 36px;\"><md-card-content layout=\"column\" layout-align=\"center center\"><span class=\"md-title grey-text\">Order Date</span> <span class=\"md-caption\">{{ order.createdAt | date : \"medium\" }}</span></md-card-content></md-card><md-card flex=\"\" layout=\"row\" layout-align=\"center center\"><img src=\"assets/images/3d-creative-process.svg\" style=\"width: 36px;\"><md-card-content layout=\"column\" layout-align=\"center center\"><span class=\"md-title grey-text\">Order Status</span> <span class=\"md-caption\">{{ order.status | uppercase }}</span></md-card-content></md-card><md-card flex=\"\" layout=\"row\" layout-align=\"center center\"><img src=\"assets/images/rupee_orders_details.svg\" style=\"width: 36px;\"><md-card-content layout=\"column\" layout-align=\"center center\"><span class=\"md-title grey-text\">Total Amount</span> <span class=\"md-caption\">Rs. {{ order.amount}}</span></md-card-content></md-card><md-card flex=\"\" layout=\"row\" layout-align=\"center center\"><img src=\"assets/images/payment_mode.svg\" style=\"width: 36px;\"><md-card-content layout=\"column\" layout-align=\"center center\"><span class=\"md-title grey-text\">Payment Mode</span> <span class=\"md-caption\">{{ paymentOption(order.paymentMode) }}</span></md-card-content></md-card></div><section layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align-gt-sm=\"stretch stretch\"><div flex-gt-sm=\"70\" flex=\"100\" layout=\"column\"><md-card><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><span class=\"center-text grey-text bold-text\">Products</span></div><md-divider></md-divider><md-list flex=\"\"><md-list-item class=\"md-3-line\" ng-repeat-start=\"lineItem in order.lineItems\" ng-style=\"{\'margin\' : !isSmall ? \'12px 8px 0 8px\' : \'0\'}\"><md-img alt=\"{{lineItem.product.name}}\" class=\"md-avatar\" md-src=\"{{ lineItem.image.urls.thumbnail }}\" style=\"height: auto; margin: 5px; width: 75px; border-radius : 0;\"></md-img><div class=\"md-list-item-text\" flex-offset=\"5\" layout=\"column\" style=\"margin-left: 12px\"><span ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\">{{ properProductName(lineItem.name) }}</span> <span ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\">Quantity : {{ lineItem.quantity }}</span> <span class=\"md-body-1\" ng-class=\"{\'md-tiny\' : isSmall}\">Size : {{ lineItem.selectedVariationText}}</span> <span class=\"bold-text\" ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\">Rs. {{ lineItem.totalPrice }}</span></div></md-list-item><md-list-item><div class=\"md-secondary\" layout=\"column\" layout-align=\"center center\" ng-class=\"{\'md-padding\' : !isSmall}\"><div layout=\"\" layout-align=\"center center\" layout-xs=\"20\" ng-if=\"!lineItem.reviews.isReviewDone && order.status === \'delivered\'\"><md-button class=\"md-accent\" ng-click=\"openReviewDialog($event, lineItem, $index)\"><md-icon class=\"review-star\">star</md-icon><span class=\"md-caption bold-text\" flex=\"\">Rate and Review Product</span></md-button></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"lineItem.reviews.isReviewDone && lineItem.reviews.reviewPoints\" style=\"width: 100%\"><section layout=\"\" layout-align=\"end center\"><div ng-repeat=\"star in range(lineItem.reviews.reviewPoints)\"><md-icon class=\"review-star\">star</md-icon></div></section><i class=\"md-caption\">Already Reviewed</i><md-tooltip>You gave {{lineItem.reviews.reviewPoints}} stars to this product</md-tooltip></div><div layout=\"\" layout-align=\"center center\" ng-if=\"lineItem.isReviewDone && !lineItem.reviews.isReviewDone && !lineItem.reviews.reviewPoints\" style=\"width: 100%\"><span class=\"md-tiny green-text\">Product Reviewed</span></div></div></md-list-item><md-divider ng-if=\"!$last\" ng-repeat-end=\"\"></md-divider></md-list></md-card></div><div layout=\"column\" flex=\"\"><md-card><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><span class=\"center-text grey-text bold-text\">Invoice</span></div><md-divider></md-divider><md-card-content><table><tbody><tr class=\"md-caption\"><td class=\"bold-text\">Products</td><td class=\"center-text\">Rs. {{totalOrderValue}}</td></tr><tr class=\"md-caption\" ng-if=\"order.orderData.coupon\"><td class=\"bold-text\">Discount(Coupon) ({{order.orderData.coupon.couponCode}})</td><td class=\"center-text green-text\">- Rs. {{order.orderData.discountAmount}}</td></tr><tr class=\"md-caption\" ng-if=\"order.orderData.giftCard\"><td class=\"bold-text\">Discount(Giftcard) {{order.couponCode}}</td><td class=\"center-text green-text\">- Rs. {{order.giftCardAmount}}</td></tr><tr class=\"md-caption\" ng-if=\"order.orderData.shippingCharges\"><td class=\"bold-text\">Shipping Charges</td><td class=\"center-text red-text\">+ Rs. {{order.orderData.shippingCharges}}</td></tr><tr class=\"md-caption\" ng-if=\"order.orderData.shippingCharges\"><td class=\"bold-text\">Total</td><td class=\"center-text\">Rs. {{order.orderData.amount}}</td></tr><tr class=\"md-caption\" ng-if=\"order.orderData.creditDiscount\"><td class=\"bold-text\">aarida Cash Used</td><td class=\"center-text green-text\">- Rs. {{order.orderData.creditDiscount}}</td></tr><tr class=\"md-body-1 bold-text\"><td>Grand Total</td><td class=\"center-text\">Rs. {{order.amount}}</td></tr></tbody></table></md-card-content><md-divider></md-divider></md-card><md-card><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><span class=\"center-text grey-text bold-text\">Address</span></div><md-divider></md-divider><md-card-content ng-if=\"!order.flags || !order.flags.hideAddress\"><div layout=\"column\"><span class=\"md-title bold-text\">{{capitalize(order.cachedAddress.name)}}</span> <span class=\"md-body-1\">{{order.cachedAddress.streetAddress}},</span> <span class=\"md-body-1\" ng-if=\"order.cachedAddress.landmark\">{{order.cachedAddress.landmark}},</span> <span class=\"md-body-1\">{{capitalize(order.cachedAddress.city)}},{{\" \" + capitalize(order.cachedAddress.state + \" \")}}<span class=\"bold-text\">{{ \" - \" +capitalize(order.cachedAddress.pinCode)}}</span></span></div></md-card-content><md-card-content ng-if=\"order.flags && order.flags.hideAddress\" layout=\"column\" layout-align=\"center center\" class=\"warehouse-dispatch small\"><img src=\"/assets/images/cart/empty-cart.svg\" alt=\"Dispatch to warehouse\"><p class=\"center-text\">The order will be delivered to you by a representative of the organisation sponsoring this campaign.</p></md-card-content><md-divider></md-divider><div layout=\"\" layout-align=\"start center\" class=\"md-padding\" ng-if=\"!order.flags || !order.flags.hideAddress\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"green-text\">call</md-icon></div><span style=\"margin-left: 5px;\">{{order.cachedAddress.mobile}}</span></div></md-card></div></section></div><md-fab-toolbar md-open=\"false\" class=\"md-accent md-fab-bottom-right\" md-direction=\"left\" ng-if=\"currentUser.role === \'admin\'\"><md-fab-trigger class=\"align-with-text\"><md-button aria-label=\"menu\" class=\"md-fab md-accent\"><md-icon>menu</md-icon></md-button></md-fab-trigger><md-toolbar><md-fab-actions class=\"md-toolbar-tools\"><md-button ng-click=\"viewOrderInDashboard()\" aria-label=\"edit product\" class=\"md-primary\"><md-icon>edit</md-icon><span>View Order in Dashboard</span></md-button></md-fab-actions></md-toolbar></md-fab-toolbar>");
$templateCache.put("app/modules/account/orders/partials/orders.html","<div flex-gt-sm=\"80\" layout=\"column\" flex-offset-gt-sm=\"10\" ng-if=\"ordersLoaded && orders.length > 0\"><h1 class=\"center-text\">Order List</h1><md-list><md-list-item ng-repeat=\"order in orders\" md-whiteframe=\"1\" style=\"padding: 0;\" class=\"white-background margin-2p\"><div flex=\"\" layout=\"column\"><div layout-align=\"space-between center\" layout=\"row\" class=\"md-padding\"><span class=\"bold-text\" ng-class=\"{\'md-body-1\' : isSmall,\'md-title\' : !isSmall }\">{{order.orderNumber}}</span> <span ng-class=\"{\'md-caption\' : isSmall}\">Order Status - {{ order.status | uppercase }}</span></div><div layout=\"row\" layout-padding=\"\"><span ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\">{{ order.createdAt | date : \"mediumDate\" }}</span> <span flex=\"\"></span><section layout=\"\" layout-align=\"center center\" md-colors=\"{\'background\' : \'accent-100-1\'}\" style=\"padding: 8px 24px; border-radius: 32px;\"><span class=\"md-subhead\">Total :</span> <span ng-if=\"order.orderData.discountAmount\" class=\"red-text\" ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\" style=\"text-decoration: line-through; margin: 0 4px;\">Rs. {{ order.orderData.subtotal }}</span> <span class=\"bold-text md-subhead\">Rs. {{ order.amount }}</span></section></div><md-list flex=\"\"><md-list-item class=\"md-3-line\" ng-repeat-start=\"productData in order.orderData.products\" ng-if=\"$index < 3\" layout=\"\" layout-align=\"stretch center\" layout-padding=\"\" style=\"border: 1px dashed rgba(1,1,1,0.1); margin: 2%;\"><md-img md-src=\"{{ productData.product.featured_image.urls.thumbnail }}\" alt=\"{{productData.product.name}}\" style=\"width: 50px; height: auto; border-radius: 50%; margin: 5px;\"></md-img><div layout=\"column\" flex=\"\"><span ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\" class=\"montserrat\">{{ properName(productData.product.name) }}</span> <span ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\">Quantity : {{ productData.quantity }}</span> <span class=\"md-body-1\" ng-class=\"{\'md-tiny\' : isSmall}\" ng-if=\"productData.variation && productData.variation.attributes.length > 0\">Size : {{ getVariation(productData) }}</span> <span ng-class=\"{\'md-body-1\' : !isSmall, \'md-caption\' : isSmall}\">Rs. {{ productData.price }}</span></div><div layout=\"column\" layout-align=\"center center\"><span flex=\"\"></span> <span flex=\"\" ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\">Rs. {{ productData.totalPrice }}</span> <span flex=\"\"></span></div></md-list-item><md-list-item ng-repeat-end=\"\" ng-if=\"$index == 3\" layout-align=\"center center\"><p>And {{ order.orderData.products.length - 3 }} more {{(order.orderData.products.length - 3) === 1 ? \'product\' : \'products\'}} ...</p></md-list-item></md-list><hr style=\"border-color: #ffffff75; width: 100%\"><div layout=\"\" layout-align=\"space-between center\"><md-button class=\"md-accent\" ui-sref=\"app.account.singleOrder({orderNum : order.orderNumber })\"><span>View Order Details</span></md-button><md-button class=\"md-accent\" ng-if=\"order.status == \'shipped\' && !isSmall\" ng-click=\"trackOrder(order, $event);\"><md-icon>location_on</md-icon><span>Track Order</span></md-button></div></div></md-list-item></md-list><section class=\"md-padding\" layout=\"\" layout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"fetchOrders();\" ng-disabled=\"fetchingOrders || totalOrders === orders.length\" style=\"width: 250px; border: 1px solid currentColor; border-radius: 32px;\"><div layout=\"\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"20\" ng-if=\"fetchingOrders\"></md-progress-circular><span style=\"margin-left: 8px;\">{{fetchingOrders ? \"Loading Orders .. \" : (totalOrders !== orders.length ? \"View More Orders\" : \"All Orders Loaded\")}}</span></div></md-button></section></div><div flex=\"\" layout=\"\" layout-margin=\"\" layout-align=\"center center\" ng-if=\"ordersLoaded && orders.length == 0\"><div flex=\"40\" layout-padding=\"\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/no-orders.svg\" style=\"width: 200px;\"><h4 class=\"md-body-1\">No Orders Yet</h4></div></div><div flex=\"\" layout-align=\"center center\" ng-if=\"!ordersLoaded\" layout-padding=\"\" layout=\"column\" style=\"min-height: 60vh;\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span class=\"montserrat md-title\">Loading Orders..</span></div>");
$templateCache.put("app/modules/account/orders/partials/review-dialog.html","<md-dialog aria-label=\"cancel order dialog\" flex=\"60\" flex-xs=\"90\" flex-sm=\"80\" flex-md=\"60\" flex-lg=\"40\" flex-xl=\"35\" class=\"review-dialog\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h5>{{!allProductReviewed ? \'Review Products (\' + (trackingIndex === 0 ? (trackingIndex + 1) : trackingIndex ) + \' of \' + reviews.length + \')\': \'All Products reviewed\'}}</h5><md-button class=\"md-icon-button\" ng-click=\"close();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-divider></md-divider><md-dialog-content class=\"md-padding\"><md-card ng-if=\"!allProductReviewed\" class=\"md-padding\" layout=\"column\" layout-align=\"stretch center\"><div layout-sm=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\"><div layout=\"\" layout-align=\"center center\"><img ng-src=\"{{ mediaUrl + reviews[index].lineItem.image }}\"></div><div layout=\"column\" layout-align=\"center center\" flex-offset=\"5\"><span flex=\"\" class=\"montserrat center-text\" ng-class=\"{\'md-subhead\' : !isSmall, \'md-body-1\' : isSmall}\">{{ reviews[index].lineItem.name }}</span><star-rating class=\"md-padding\" rating-value=\"reviews[index].ratings[0].value\" on-rating-selected=\"updateRating(data)\"></star-rating></div></div><md-input-container class=\"suggestion-box\" md-theme=\"indigo\"><label>Your Review (Optional)</label> <textarea ng-model=\"reviews[index].comment\" placeholder=\"Hey, Let us know what you think about this product\" col=\"30\" rows=\"3\" md-maxlength=\"150\"></textarea></md-input-container></md-card><md-card class=\"fake-slider-card\" ng-if=\"review.showTransition\"></md-card><md-card ng-if=\"allProductReviewed\" layout=\"column\" layout-align=\"stretch center\"><div class=\"md-padding\" layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\" class=\"thank-you-section\"><p class=\"md-caption\">Thank you for reviewing us</p><img src=\"/assets/images/aarida_thank-you.svg\" class=\"thank-you-image\"></div><div layout=\"\" layout-align=\"stretch center\" style=\"width: 100%\"><md-list style=\"width: 100%\"><md-list-item ng-repeat=\"review in reviews track by $index\"><div layout=\"\" layout-align=\"space-between center\" style=\"width: 100%\"><div><p>{{$index + 1}}. {{review.lineItem.name}}</p></div><div>{{review.ratings[0].value}}<md-icon class=\"rating-icon\">star</md-icon></div></div></md-list-item></md-list></div></div></md-card><section class=\"loading-overlay\" layout=\"\" layout-align=\"center center\" ng-if=\"review.showOverlay\"><div layout=\"column\" layout-align=\"center center\" ng-if=\"review.savingData\"><md-progress-circular class=\"md-accent\"></md-progress-circular><p>Saving Review ...</p></div><div ng-if=\"review.showThankyouPage\" layout=\"column\" layout-align=\"center center\"><svg class=\"checkmark\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 52 52\"><circle class=\"checkmark__circle\" cx=\"26\" cy=\"26\" r=\"25\" fill=\"none\"></circle><path class=\"checkmark__check\" fill=\"none\" d=\"M14.1 27.2l7.1 7.2 16.7-16.8\"></path></svg><p>Thank you for your review</p></div></section></md-dialog-content><md-dialog-actions><md-button class=\"md-accent\" ng-if=\"!allProductReviewed\" ng-disabled=\"savingReview\" ng-click=\"saveReview($event)\"><div layout=\"\" layout-align=\"center center\"><div ng-if=\"!savingReview\">Save Review</div><md-progress-circular md-diameter=\"20\" class=\"md-accent\" ng-if=\"review.savingData\"></md-progress-circular></div></md-button><md-button class=\"md-accent\" ng-if=\"allProductReviewed\" ng-click=\"goBack($event)\"><div layout=\"\" layout-align=\"center center\"><div>Back To Order</div></div></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/account/orders/partials/thank-you.html","<div layout=\"\" layout-fill=\"\"><md-card flex=\"\" ng-class=\"{\'no-margin margin-top\' : isSmall}\"><md-card-content layout=\"column\"><div layout=\"\" layout-margin=\"\" layout-align=\"center center\"><svg class=\"checkmark\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 52 52\"><circle class=\"checkmark__circle\" cx=\"26\" cy=\"26\" r=\"25\" fill=\"none\"></circle><path class=\"checkmark__check\" fill=\"none\" d=\"M14.1 27.2l7.1 7.2 16.7-16.8\"></path></svg></div><span class=\"center-text md-title\">Thank you for your order.</span> <span class=\"center-text md-subhead\" style=\"margin-top: 10px;\">Your order has been successfully placed.</span><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-accent\" ui-sref=\"app.account.singleOrder({orderNum : order.orderNumber})\">View Order Details</md-button></div><md-divider layout-margin=\"\"></md-divider><div layout-margin=\"\" layout-gt-sm=\"row\" layout=\"column\" layout-align-gt-sm=\"center center\" flex=\"\"><div flex=\"\" md-whiteframe=\"-1\"><md-card-content layout=\"column\"><span class=\"md-headline center-text\">Order Number</span> <span class=\"md-body-1 center-text\">{{ order.orderNumber }}</span></md-card-content></div><div flex=\"\"><md-card-content layout=\"column\"><span class=\"md-headline center-text\">Order Status</span> <span class=\"md-body-1 center-text\">{{ order.status | uppercase }}</span></md-card-content></div><div flex=\"\"><md-card-content layout=\"column\"><span class=\"md-headline center-text\">Order Date</span> <span class=\"md-body-1 center-text\">{{ order.createdAt | date : \"medium\" }}</span></md-card-content></div></div><md-divider layout-margin=\"\"></md-divider><div layout-margin=\"\" layout-gt-sm=\"row\" layout=\"column\" layout-align-gt-sm=\"center start\" flex=\"\"><div flex=\"\" class=\"md-title center-text\"><md-card-content layout=\"column\"><span>Total Amount</span> <span class=\"md-body-1\">Rs. {{ order.amount }}</span></md-card-content></div><div flex=\"\" class=\"md-title center-text\"><md-card-content layout=\"column\"><span>Payment Mode</span> <span class=\"md-body-1\">{{ getPmString(order.paymentMode); }}</span></md-card-content></div><div flex=\"\"><md-card-content layout=\"column\" layout-align=\"start\" ng-if=\"!order.flags || !order.flags.hideAddress\"><span flex=\"\" class=\"center-text md-title\">Shipping Address</span> <span class=\"md-subhead\">{{ capitalize(order.cachedAddress.name) }}</span> <span class=\"md-body-1\">{{ order.cachedAddress.streetAddress }}, {{ order.cachedAddress.landmark ? order.cachedAddress.landmark + \", \" : \"\" }} {{ order.cachedAddress.city }},{{ order.cachedAddress.state }}- {{ capitalize(order.cachedAddress.pinCode) }}</span> <span class=\"md-body-1\">{{ capitalize(order.cachedAddress.mobile); }}</span></md-card-content><md-card-content ng-if=\"order.flags && order.flags.hideAddress\" layout=\"column\" layout-align=\"center center\" class=\"warehouse-dispatch small\"><span flex=\"\" class=\"center-text md-title\">Shipping Address</span> <img src=\"/assets/images/cart/empty-cart.svg\" alt=\"Dispatch to warehouse\"><p class=\"center-text\">The order will be delivered to you by a representative of the organisation sponsoring this campaign.</p></md-card-content></div></div></md-card-content></md-card></div>");
$templateCache.put("app/modules/account/orders/partials/trackingDialog.html","<md-dialog flex=\"75\"><md-toolbar><div layout=\"\" layout-align=\"space-between center\" class=\"md-toolbar-tools md-accent\"><h6>Track Shipment - {{order.orderNumber}}</h6><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content style=\"background: #efefef;\"><div layout=\"\" layout-align=\"center center\" ng-if=\"fetchingTracking\" class=\"md-dialog-content\"><md-progress-circular></md-progress-circular></div><div ng-if=\"!fetchingTracking && trackingData.status\" layout=\"column\" class=\"md-padding md-dialog-content\"><section layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align=\"stretch center\"><md-card flex=\"\"><div layout=\"\" md-whiteframe=\"2\" layout-align=\"center center\" class=\"md-padding\" style=\"background: #5c3fff;\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">place</md-icon></div><span class=\"md-caption white-text bold-text\" style=\"margin-left: 4px;\">Current Status</span></div><md-card-content layout=\"row\" layout-align=\"center center\"><md-divider></md-divider><span class=\"md-body-1\">{{trackingData.current_status}}</span> <span class=\"md-tiny\">{{trackingData.history.slice(-1).date | date : \"mediumDate\"}}</span></md-card-content></md-card><md-card flex=\"\"><div layout=\"\" md-whiteframe=\"2\" layout-align=\"center center\" class=\"md-padding\" style=\"background: #5c3fff;\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">layers</md-icon></div><span class=\"md-caption white-text bold-text\" style=\"margin-left: 4px;\">AWB Code</span></div><md-divider></md-divider><md-card-content layout=\"row\" layout-align=\"center center\"><span class=\"md-body-1 center-text\">{{trackingData.awb_code}}</span></md-card-content></md-card><md-card flex=\"\"><div layout=\"\" md-whiteframe=\"2\" layout-align=\"center center\" class=\"md-padding\" style=\"background: #5c3fff;\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">date_range</md-icon></div><span class=\"md-caption white-text bold-text\" style=\"margin-left: 4px;\">Pickup Date</span></div><md-divider></md-divider><md-card-content layout=\"\" layout-align=\"center center\"><span class=\"md-body-1 center-text\">{{trackingData.pickup_date | date : \"medium\"}}</span></md-card-content></md-card><md-card flex=\"\"><div layout=\"\" md-whiteframe=\"2\" layout-align=\"center center\" class=\"md-padding\" style=\"background: #5c3fff;\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"white-text\">pin_drop</md-icon></div><span class=\"md-caption white-text bold-text\" style=\"margin-left: 4px;\">Destination</span></div><md-divider></md-divider><md-card-content layout=\"\" layout-align=\"center center\"><span class=\"md-body-1 center-text\">{{trackingData.destination}}</span></md-card-content></md-card></section><section layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align-gt-sm=\"stretch start\"><div flex-gt-sm=\"66\" flex=\"100\" layout=\"\" layout-align=\"stretch stretch\"><md-card flex=\"\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><div layout=\"\" layout-align=\"center center\"><md-icon>history</md-icon></div><span class=\"md-caption bold-text\" style=\"margin-left: 4px;\">History</span></div><md-divider></md-divider><div layout=\"column\" ng-if=\"trackingData.history.length > 0\" class=\"timeline md-margin\" layout-padding=\"\"><div class=\"timeline-item\" ng-repeat=\"history in trackingData.history | orderBy:\'-date\'\" layout=\"column\" style=\"position: relative; margin-left: 20px\"><md-icon style=\"color : green; position: absolute; left: -7px; top: 15px; width: 12px; min-width: 12px; height: 12px; min-height: 12px; font-size: 12px;\">lens</md-icon><span class=\"md-body-1 bold-text\" style=\"margin-left: 10px;\">{{capitalize(history.activity)}}</span> <span class=\"grey-text\" style=\"font-size: 12px; margin-left: 15px; margin-top: 5px;\">{{ history.location}}</span> <span class=\"grey-text bold-text\" style=\"font-size: 10px; margin-left: 15px; margin-top: 5px; font-style: italic;\">{{ history.date | date : \"medium\"}}</span></div></div></md-card></div><div flex=\"\" layout=\"\"><md-card flex=\"\"><div layout=\"\" layout-align=\"center center\" class=\"md-padding\"><div layout=\"\" layout-align=\"center center\"><md-icon>info_outline</md-icon></div><span class=\"md-caption bold-text\" style=\"margin-left: 4px;\">Shipment Information</span></div><md-divider></md-divider><md-card-content><table><tr><th class=\"md-caption grey-text\">Consignee Name</th><td class=\"md-caption\">{{trackingData.consignee_name}}</td></tr><tr><th class=\"md-caption grey-text\">Consignee Address</th><td class=\"md-caption\">{{trackingData.consignee_address}}</td></tr><tr><th class=\"md-caption grey-text\">Origin</th><td class=\"md-caption\">{{trackingData.origin}}</td></tr><tr><th class=\"md-caption grey-text\">Service</th><td class=\"md-caption\">{{trackingData.service}}</td></tr><tr><th class=\"md-caption grey-text\">Shipment Type</th><td class=\"md-caption\">{{trackingData.shipment_type}}</td></tr><tr><th class=\"md-caption grey-text\">Weight</th><td class=\"md-caption\">{{trackingData.weight}}</td></tr><tr><th class=\"md-caption grey-text\">Package Count</th><td class=\"md-caption\">{{trackingData.packages}}</td></tr></table></md-card-content></md-card></div></section></div><div ng-if=\"!fetchingTracking && !trackingData.status\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\" flex=\"\"><div layout=\"\" layout-align=\"center center\"><md-icon class=\"md-warn\">error</md-icon></div><span class=\"center-text\">Order Tracking generally starts 24 hours after being shipped.<br>Please check back later.</span></div></md-dialog-content></md-dialog>");
$templateCache.put("app/modules/account/quotations/all/all.html","<div flex-gt-sm=\"80\" flex-offset-gt-sm=\"10\" layout=\"column\" ng-if=\"!quotationsLoading && quotations.length\"><h1 class=\"center-text\">All Quotations</h1><div layout=\"\" layout-align=\"end\"><md-button class=\"md-accent md-padding outline\" href=\"https://onboarding.aarida.com/custom-quote?utm_source=AaridaWebsite&utm_content=RequestNewQuotation&ref=Aarida\"><md-icon>add</md-icon><span>Request New Quotation</span></md-button></div><div layout=\"\" layout-wrap=\"\"><section flex-lg=\"25\" flex-md=\"33\" flex-sm=\"50\" flex-xl=\"25\" flex-xs=\"100\" ng-repeat=\"quotation in quotations\"><md-card class=\"pointer\" md-ink-ripple=\"\" ui-sref=\"app.account.singleQuotation({slug : quotation.slug})\"><md-card-header><md-card-header-text><span class=\"md-subhead bold-text black-text\">{{quotation.quotationNumber}}</span> <span class=\"md-caption\">{{quotation.status | uppercase}}</span></md-card-header-text></md-card-header><img alt=\"{{quotation.category.name}}\" class=\"md-card-image\" ng-src=\"{{quotation.category.imageUrl}}\"></md-card></section></div></div><div flex=\"\" layout=\"\" layout-align=\"center center\" layout-margin=\"\" ng-if=\"!quotationsLoading && !quotations.length\"><div flex=\"40\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><img src=\"assets/images/no-orders.svg\" style=\"width: 200px;\"><h4 class=\"md-body-1\">No Quotations Yet</h4><md-button class=\"md-accent md-raised\" href=\"https://onboarding.aarida.com/custom-quote?utm_source=AaridaWebsite&utm_content=RequestNewQuotation&ref=Aarida\">Request New Quotation</md-button></div></div><div flex=\"\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\" ng-if=\"quotationsLoading\" style=\"min-height: 60vh;\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular><span class=\"montserrat md-title\">Loading Quotations..</span></div>");
$templateCache.put("app/modules/account/quotations/single/single.html","<div class=\"single-quotations\"><section ng-show=\"!invalidSlug\"><section class=\"loading\" layout=\"column\" layout-align=\"center center\" ng-if=\"loading\"><md-progress-circular class=\"md-accent\"></md-progress-circular><p>Loading Quotation Details...</p></section><div class=\"quotations-error\" layout=\"column\" layout-align=\"center center\" ng-if=\"!loading && error\"><img src=\"assets/images/error.svg\"><p class=\"md-margin\">{{unauthorized ? \'You are not authorized to view this page\' : \'Something is broken. Try again?\'}}</p><md-button class=\"round small md-accent md-raised\" ng-click=\"fetchQuotationDetails()\" ng-if=\"!unauthorized\">Retry</md-button></div><div class=\"quotation-details\" ng-if=\"!loading && !error && !unauthorized\"><div class=\"md-padding\" layout=\"\" layout-align=\"start center\"><md-button class=\"md-accent\" ui-sref=\"app.account.quotations\"><md-icon>keyboard_arrow_left</md-icon><span>Back to Quotations</span></md-button></div><section class=\"quotation-wrapper\" layout=\"\" layout-wrap=\"\"><div flex-lg=\"40\" flex-md=\"40\" flex-sm=\"100\" flex-xl=\"33\" flex-xs=\"100\"><md-card md-whiteframe=\"6\"><h1 class=\"center-text md-subhead\">Quotation Number : {{quotation.quotationNumber}}</h1><div class=\"md-padding\" layout=\"\" layout-align=\"center\"><span class=\"current-status-chip\">Current Status : {{quotation.status | uppercase}}</span></div><md-divider></md-divider><div class=\"md-padding\" layout=\"\" layout-align=\"center center\"><whatsapp-button shape=\"square\"></whatsapp-button><md-button class=\"md-accent\" ui-sref=\"app.contact_us\">Contact Support</md-button></div><md-divider></md-divider><md-subheader>Quotation Info</md-subheader><md-list class=\"md-2-line quotation-option-list\"><md-list-item><img alt=\"{{quotation.category.name}}\" class=\"md-avatar\" ng-if=\"quotation.category.imageUrl\" ng-src=\"{{quotation.category.imageUrl}}\"><div class=\"md-list-item-text\" layout=\"column\"><p>{{ quotation.category.name }}</p></div><p class=\"md-caption md-secondary\">Category</p></md-list-item><md-divider></md-divider><md-list-item><img alt=\"{{quotation.productType.name}}\" class=\"md-avatar\" ng-if=\"quotation.productType.imageUrl\" ng-src=\"{{quotation.productType.imageUrl}}\"><div class=\"md-list-item-text\" layout=\"column\"><p>{{ quotation.productType.name }}</p></div><p class=\"md-caption md-secondary\">Product Type</p></md-list-item><md-divider ng-if=\"quotation.option && quotation.option.name\"></md-divider><md-list-item ng-if=\"quotation.option && quotation.option.name\"><img alt=\"{{quotation.option.name}}\" class=\"md-avatar\" ng-if=\"quotation.option.imageUrl\" ng-src=\"{{quotation.option.imageUrl}}\"><div class=\"md-list-item-text\" layout=\"column\"><p>{{ quotation.option.name }}</p></div><p class=\"md-caption md-secondary\">Option</p></md-list-item><md-divider ng-if=\"quotation.height\"></md-divider><md-list-item ng-if=\"quotation.height\"><div class=\"md-list-item-text\" layout=\"column\"><p>{{ quotation.height }}</p></div><p class=\"md-caption md-secondary\">Height</p></md-list-item><md-divider ng-if=\"quotation.size\"></md-divider><md-list-item ng-if=\"quotation.size\"><div class=\"md-list-item-text\" layout=\"column\"><p>{{ quotation.size }}</p></div><p class=\"md-caption md-secondary\">Size</p></md-list-item></md-list><md-divider></md-divider><md-card-actions class=\"md-padding\" layout=\"\" layout-align=\"center center\"><md-button class=\"md-warn md-raised\" ng-click=\"cancelQuotationDialog($event)\" ng-if=\"quotation.status !== \'completed\' && quotation.status !== \'cancelled\'\">Cancel Quotation</md-button></md-card-actions></md-card></div><div flex-lg=\"\" flex-md=\"\" flex-sm=\"100\" flex-xl=\"\" flex-xs=\"100\"><md-card class=\"quotation-gallery\"><md-card-header><md-card-header-text>Design Approval ({{quotation.gallery.length}})</md-card-header-text></md-card-header><md-divider></md-divider><md-card-content><div layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/no-orders.svg\" style=\"width: 100px; height: auto;\"><p class=\"center-text grey-text md-caption\">Designs for approvals will appear here once they are ready.</p></div><md-content md-scroll-x=\"\"><div layout=\"\"><section flex-lg=\"20\" flex-md=\"25\" flex-sm=\"33\" flex-xl=\"20\" flex-xs=\"50\" ng-repeat=\"galleryItem in quotation.gallery\"><md-img md-src=\"{{galleryItem.image.urls.medium}}\"></md-img></section></div></md-content></md-card-content></md-card><md-card class=\"flat\"><p class=\"center-text bold-text\">Aarida Chat</p><md-card-content class=\"message-content-wrapper\"><md-list class=\"md-2-line\" ng-if=\"quotation.notes && quotation.notes.length\"><md-list-item class=\"message-full-wrapper\" ng-class=\"{\'align-left\' : note.by !== currentUser._id, \'align-right\' : note.by === currentUser._id}\" ng-repeat-start=\"note in quotation.notes\"><div class=\"message\" layout=\"column\" ng-class=\"{\'others\' : note.by !== user._id, \'me\' : note.by === user._id}\"><div class=\"message-images-container\" layout=\"\" ng-class=\"{\'layout-align-start-center\' : note.by !== user._id, \'layout-align-end-center\' : note.by === user._id}\" ng-if=\"note.images && note.images.length\"><md-img class=\"message-image\" md-src=\"{{note.images[0].urls.medium}}\" ng-click=\"openImages($event, note.images)\"></md-img></div><p class=\"comment\">{{note.comment}}</p><section class=\"comment-meta\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-tiny\">By {{note.byName}}</span> <span class=\"md-tiny date grey-text\" ng-if=\"!note.saving && !note.error\">{{dateAgo(note.date) }}</span><md-icon class=\"bug-icon\" ng-if=\"!note.saving && note.error\">bug</md-icon><bubble-loader class=\"save-loader\" ng-if=\"note.saving\"></bubble-loader></section></div></md-list-item><div class=\"align-clear\" ng-repeat-end=\"\"></div></md-list><div layout=\"column\" layout-align=\"center center\" ng-if=\"!quotation.notes || !quotation.notes.length\"><img src=\"assets/images/no-orders.svg\" style=\"width: 100px; height: auto;\"><p>No Comments Yet</p></div></md-card-content><md-card-actions class=\"relative\" layout=\"\" layout-align=\"stretch center\"><md-input-container class=\"no-error-spacer ui-mention-container\" flex=\"\" md-no-float=\"\" md-theme=\"black\"><textarea ng-disabled=\"quotation.status === \'cancelled\'\" ng-model=\"$parent.message\" placeholder=\"Comment\" rows=\"2\"></textarea></md-input-container><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-icon-button md-fab md-mini\" ng-click=\"publishComment()\" ng-disabled=\"!$parent.message\"><md-icon>send</md-icon></md-button></div></md-card-actions></md-card></div></section></div></section><section ng-show=\"invalidSlug\"><div class=\"quotations-error\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/error.svg\"><p class=\"md-margin\">This link has no power here.</p><md-button class=\"round small md-raised md-accent\" ui-sref=\"app.home\">Go to Home</md-button></div></section></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"cancel-quotation-dialog\"><md-dialog aria-label=\"cancel order dialog\" flex=\"30\" flex-lg=\"30\" flex-md=\"40\" flex-sm=\"60\" flex-xl=\"20\" flex-xs=\"90\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"\" layout-align=\"space-between center\"><h5>Cancel Quotation</h5><md-button class=\"md-icon-button\" ng-click=\"close();\"><md-icon>close</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><p class=\"md-caption grey-text center-text\">Select a reason for Cancellation</p><form name=\"cancelForm\"><md-radio-group ng-model=\"cancelReason\" required=\"\"><md-list><md-list-item ng-repeat-start=\"reason in reasons\"><md-radio-button aria-label=\"{{reason}}\" ng-value=\"reason\" style=\"margin-bottom: 0\"><span class=\"md-body-1\">{{reason}}</span></md-radio-button></md-list-item><md-divider ng-if=\"!$last\" ng-repeat-end=\"\"></md-divider></md-list></md-radio-group><md-input-container class=\"md-block\" md-theme=\"black\" ng-if=\"cancelReason === \'Others\'\"><label>Reason for Cancellation</label> <textarea ng-model=\"otherReason\" placeholder=\"Tell us why you feel like cancelling this order\" required=\"\" rows=\"5\"></textarea></md-input-container></form></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=\"\" layout-align=\"space-between\"><md-button ng-click=\"close()\">Close</md-button><md-button class=\"md-warn\" ng-click=\"cancelQuotation();\" ng-disabled=\"cancelForm.$invalid || cancelling\"><span ng-if=\"!cancelling\">Cancel Quotation</span><bubble-loader ng-if=\"cancelling\"></bubble-loader></md-button></md-dialog-actions></md-dialog></div></div>");
$templateCache.put("app/modules/base/directives/back-button/back-button.directive.tpl.html","<md-button style=\"min-width: 60px; height: 60px; margin: 0;\" class=\"md-icon-button\" ng-click=\"goBack()\"><md-icon>keyboard_backspace</md-icon></md-button>");
$templateCache.put("app/modules/base/directives/bubble-loader/bubble-loader.html","<div class=\"bubble-loader\"><div class=\"bubble\"></div><div class=\"bubble\"></div><div class=\"bubble\"></div><div class=\"bubble\"></div></div>");
$templateCache.put("app/modules/base/directives/count-down-timer/count-down-timer.html","<section class=\"countdown-timer\" layout=\"column\" layout-align=\"center center\" ng-show=\"showTimer\"><span class=\"md-subhead center-text black-text\">{{titleText}}</span><div class=\"countdown\" id=\"{{\'timer-\' + id}}\" layout=\"\" layout-align=\"center center\"><div class=\"bloc-time days\" data-init-value=\"24\" flex=\"33\"><span class=\"count-title\">Days</span><section layout=\"\" layout-align=\"center center\"><div class=\"figure days days-1\"><span class=\"top\">2</span> <span class=\"top-back\"><span>2</span></span> <span class=\"bottom\">2</span> <span class=\"bottom-back\"><span>2</span></span></div><div class=\"figure days days-2\"><span class=\"top\">4</span> <span class=\"top-back\"><span>4</span></span> <span class=\"bottom\">4</span> <span class=\"bottom-back\"><span>4</span></span></div></section></div><div class=\"bloc-time hours\" data-init-value=\"24\" flex=\"33\"><span class=\"count-title\">Hours</span><section layout=\"\" layout-align=\"center center\"><div class=\"figure hours hours-1\"><span class=\"top\">2</span> <span class=\"top-back\"><span>2</span></span> <span class=\"bottom\">2</span> <span class=\"bottom-back\"><span>2</span></span></div><div class=\"figure hours hours-2\"><span class=\"top\">4</span> <span class=\"top-back\"><span>4</span></span> <span class=\"bottom\">4</span> <span class=\"bottom-back\"><span>4</span></span></div></section></div><div class=\"bloc-time min\" data-init-value=\"0\" flex=\"33\"><span class=\"count-title\">Minutes</span><section layout=\"\" layout-align=\"center center\"><div class=\"figure min min-1\"><span class=\"top\">0</span> <span class=\"top-back\"><span>0</span></span> <span class=\"bottom\">0</span> <span class=\"bottom-back\"><span>0</span></span></div><div class=\"figure min min-2\"><span class=\"top\">0</span> <span class=\"top-back\"><span>0</span></span> <span class=\"bottom\">0</span> <span class=\"bottom-back\"><span>0</span></span></div></section></div><div class=\"bloc-time sec\" data-init-value=\"0\" flex=\"33\" style=\"display: none\"><span class=\"count-title\">Seconds</span><section layout=\"\" layout-align=\"center center\"><div class=\"figure sec sec-1\"><span class=\"top\">0</span> <span class=\"top-back\"><span>0</span></span> <span class=\"bottom\">0</span> <span class=\"bottom-back\"><span>0</span></span></div><div class=\"figure sec sec-2\"><span class=\"top\">0</span> <span class=\"top-back\"><span>0</span></span> <span class=\"bottom\">0</span> <span class=\"bottom-back\"><span>0</span></span></div></section></div></div></section>");
$templateCache.put("app/modules/base/directives/customisable-product-card/customisable-product-card.html","<md-card class=\"customisable-product-card\" ng-class=\"{\'desktop\' : !isSmall}\" layout=\"column\"><section class=\"product-details-section md-padding\" layout-gt-sm=\"row\" layout-sm=\"column\" layout-xs=\"column\" ng-show=\"product\"><a flex-xs=\"100\" flex-sm=\"100\" flex-gt-sm=\"30\" layout=\"\" layout-align=\"center center\" class=\"relative\" md-ink-ripple=\"#efefef\" ng-click=\"onNavigate()\" ui-sref=\"app.customisationEditor({slug : product.slug, flags : \'none\'})\"><md-image-gallery gallery=\"product.gallery\" image-size=\"\'large\'\" ng-if=\"product && product.gallery && product.gallery.length\" selected-index=\"0\" selected=\"product.featured_image\"></md-image-gallery><hand-embroidery-badge ng-if=\"product.hasEmbroidery\"></hand-embroidery-badge></a><div flex=\"\" flex-offset=\"5\" layout=\"column\" layout-align=\"stretch start\"><h4 class=\"product-name\" ng-class=\"{\'small\' : isSmall}\">{{ product.name }}</h4><div layout=\"\" ng-class=\"{\'layout-align-center-center\' : isSmall, \'layout-align-start-end\' : !isSmall}\"><s ng-if=\"product.isOnSale\" class=\"product-mrp red-text md-body-1\" ng-class=\"{\'small\' : isSmall}\">₹{{product.mrp}}</s> <span class=\"product-price md-title\" ng-class=\"{\'small\' : isSmall}\">₹{{product.price}}</span> <span ng-if=\"product.isOnSale\" class=\"product-price-discount bold-text md-caption\">({{product.discountPercentText}} off)</span></div><div ng-if=\"!isSmall\" flex=\"\" ng-class=\"{\'md-caption small\' : isSmall}\" class=\"product-customisation-container\" layout=\"column\" layout-align=\"center stretch\"><p class=\"bold-text product-customisation-title\" ng-class=\"{\'md-caption small\' : isSmall}\">Available Customisations :</p><span class=\"md-caption product-customisation\">{{product.availableOptions}}</span></div><md-button class=\"md-accent md-hue-2 aarida-stroked-button customise-button\" ng-click=\"onNavigate()\" ui-sref=\"app.customisationEditor({slug : product.slug, flags : \'none\'})\"><span>Start Customising</span><md-icon>arrow_right_alt</md-icon></md-button></div></section><section layout=\"column\" ng-if=\"product && product.templates && product.templates.length\"><div layout=\"\" layout-align=\"space-between center\" class=\"md-padding more-looks-section\"><span class=\"montserrat\">More Looks for this product</span></div><div class=\"product-templates-section\"><section class=\"inner-scroller\"><a ng-repeat=\"template in product.templates\" class=\"single-template\" md-ink-ripple=\"\" ng-click=\"onNavigate()\" ui-sref=\"app.customisationEditor({slug : product.slug, ucSlug: template.slug})\"><div class=\"page-indicator-container\" layout=\"\" layout-align=\"center center\"><span class=\"page-indicator-text\">{{$index + 1}} of {{product.templates.length}}</span></div><img md-preload=\"\" md-src=\"template.image\" item-index=\"$index\" key=\"medium\" class=\"product-image\"><p class=\"center-text md-caption\">{{template.name}}</p><p class=\"center-text\">₹{{template.price}}</p></a></section></div></section></md-card>");
$templateCache.put("app/modules/base/directives/customisation-measurement/custom-measurement-directive.tpl.html","<section class=\"relative\"><form flex=\"\" layout=\"column\" class=\"measurement-container\"><md-radio-group ng-model=\"selectedVariation\"><md-card id=\"{{\'size--\' + $index}}\" ng-repeat=\"variation in variations\" class=\"size-single-item\"><md-card-content ng-init=\"value = getVariationValue(variation)\"><md-radio-button class=\"pointer\" ng-value=\"variation._id\" ng-disabled=\"variation.inCart\"><span>{{value}}</span> <i class=\"md-tiny\" ng-show=\"variation.inCart\">(Already In Cart)</i> <span class=\"md-tiny grey-text\" style=\"margin-left: 8px\" ng-show=\"!variation.inCart && sizeObj[value]\">Custom Sizes Available</span></md-radio-button><div ng-show=\"variation._id === selectedVariation\" ng-class=\"{\'active\' : variation._id === selectedVariation}\" ng-init=\"sizeData = sizeObj[value];\" class=\"expandable-trap\"><section ng-show=\"sizeData\"><div layout=\"column\" layout-align=\"center center\"><p class=\"md-body-1 center-text custom-size-text\">Now you can enter your own precise measurements using the custom sizes option.<br><strong>Its easy and absolutely free of cost.</strong></p><md-switch class=\"enchanted-switch\" ng-model=\"variation.openEditView\" ng-if=\"sizeData\">{{!variation.openEditView ? \'Switch to Custom Sizes\' : \'Switch to Standard Sizes\'}}</md-switch></div><div layout=\"\" layout-align=\"center center\" ng-show=\"!variation.openEditView && sizeData\"><table md-table=\"\"><tr md-row=\"\" ng-repeat=\"chart in sizeData\"><th md-column=\"\">{{chart.key}}</th><td md-cell=\"\">{{chart.value}}\"</td></tr></table></div><div ng-show=\"variation.openEditView\"><div flex=\"\" ng-repeat=\"chart in sizeData\" class=\"size-section\"><div layout=\"\" layout-align=\"start center\"><h4 class=\"order-measurements-header center-text\">{{chart.key}}</h4><span class=\"md-caption grey-text\"></span></div><md-slider-container class=\"slider-container\" ng-init=\"val = variation.measurements[chart.key]\"><span class=\"md-tiny min-value\">{{val - 6}}\"</span><md-slider md-discrete=\"\" step=\"0.5\" ng-model=\"variation.measurements[chart.key]\" aria-label=\"{{chart.key}}\" min=\"{{val - 6}}\" max=\"{{val}}\"></md-slider><span class=\"md-tiny max-value\">{{val}}\"</span><p>{{variation.measurements[chart.key]}}\"</p></md-slider-container></div><div flex=\"\" class=\"size-section\"><div layout=\"\" layout-align=\"start center\"><h4 class=\"order-measurements-header center-text\">YOUR HEIGHT</h4></div><md-select ng-model=\"variation.measurements.HEIGHT\" placeholder=\"Set Your Height\"><md-option ng-value=\"\">Your Height</md-option><md-option ng-value=\"height\" ng-repeat=\"height in heightList\">{{height}}</md-option></md-select></div></div><div layout=\"column\" layout-align=\"center center\" class=\"md-padding\" ng-if=\"!variation.openEditView && sizeData\"><p class=\"md-body-1\">Want to make it a perfect fit?</p><a class=\"pink-text pointer\" ng-click=\"variation.openEditView = true\">Enter Custom Sizes</a></div><div layout=\"\" layout-align=\"center center\"><i class=\"center-text md-caption grey-text\">*All sizes in inches</i></div></section><div layout=\"\" layout-align=\"end center\" class=\"add-to-cart-button-container\"><md-button class=\"md-accent md-raised md-hue-1 large-btn\" ng-if=\"!addedToCart\" ng-click=\"addToCart(variation);\" ng-disabled=\"product.outOfStock || savingData\"><span>Add To Cart</span><md-icon>arrow_right_alt</md-icon></md-button></div></div></md-card-content></md-card></md-radio-group></form><div ng-if=\"savingData\" class=\"loading-overlay\" layout=\"\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\"></md-progress-circular></div></section>");
$templateCache.put("app/modules/base/directives/customisation-notification/index.html","<section class=\"customisation-notification-container\"><div class=\"custom-design-notification-main center-text\" layout-gt-sm=\"row\" ng-if=\"!hideMainSection\" layout-lt-md=\"column\" layout-align=\"center center\"><section layout=\"\" layout-align=\"center center\" layout-gt-xs=\"row\" layout-xs=\"column\"><img src=\"assets/images/home/customisation-art.svg\" class=\"reference-image\" ng-class=\"{\'small\' : isSmall}\" alt=\"Custom Design Image\"><div layout=\"column\" flex-offset=\"10\" flex=\"60\" layout-align=\"center stretch\" class=\"info-section\"><h2 class=\"section-title bold-text\">FREEDOM TO DESIGN YOUR OWN CLOTHES</h2><section layout=\"\" layout-align=\"stretch center\"><md-button class=\"get-started-button\" ui-sref=\"app.collection({categoryName : \'customisable_products\'})\">GET STARTED</md-button></section></div></section></div><div class=\"relative card custom-design-notification\" layout=\"column\" layout-align=\"center center\" ng-if=\"!hideNotificationSection\"><h1 class=\"center-text md-display-1 bold-text\">Couldn\'t find what you were looking for?</h1><section class=\"md-padding\" layout=\"\" layout-align=\"center center\"><p class=\"md-link center-text\">If you have a design in mind, you can purchase it directly from us. Our designers will help you during the entire process. We promise that we will create the product just the way you want it to be.</p></section><md-button id=\"new-product-requestor\" class=\"md-raised md-primary montserrat\" href=\"https://goo.gl/forms/PhNi2KCphb02VmYJ3\" target=\"_blank\">Request Custom Design</md-button></div></section>");
$templateCache.put("app/modules/base/directives/customisation-process/customisation-process.html","<div class=\"customisation-process\" layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><h3 class=\"md-title center-text montserrat header-title-text\">Introducing the next evolution in apparel shopping</h3><div class=\"subtitle text-center\"><p class=\"md-headline question\">Are you <b>tired</b> of visiting 100s of websites/stores looking for that <b>one perfect dress?</b></p><p class=\"solution\"><br>How many times have you found the perfect outfit after spending hours but wished the <b>neck line was different</b> or the color was <b>slightly darker</b>? Introducing the <b>Customisable Clothing Collection</b> by Aarida. Now you can customise the apparel the way you want it to look in <b>four easy steps</b>.</p></div><p class=\"md-headline center-text allura header-subtitle-text\">The Customisation Process!</p><span flex=\"10\"></span><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"space-around\" class=\"md-padding md-margin\"><md-card flex=\"\" layout=\"column\" layout-align=\"center center\" class=\"customisation-item\" ng-class=\"{\'md-whiteframe-16dp\' : data.active, \'md-whiteframe-2dp\' : !data.active}\" ng-mouseenter=\"data.active = true\" ng-mouseleave=\"data.active = false\" ng-repeat=\"data in howCustomisationWorks track by data.id\"><md-card-content layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><div layout=\"column\" layout-align=\"center center\"><span class=\"md-caption grey-text\">{{ ::data.subText }}</span> <span class=\"md-title\" style=\"font-weight: 700\">{{ ::data.headText }}</span></div><div ng-mouseenter=\"highlight(data);\" style=\"width: 75px; position: relative;\"><img ng-src=\"{{ data.hover ? data.image : (data.image_init ? data.image_init : data.image )}}\" style=\"width: 75px; height: auto;\"></div><span flex=\"\" class=\"center-text md-caption\" style=\"margin: 10px 10% 0 10%\">{{ :: data.text }}</span></md-card-content></md-card></div><div layout=\"\" layout-align=\"center center\" ng-if=\"!hideGetStarted\"><md-button class=\"md-accent md-raised\" style=\"width: 200px; line-height: 44px;\" ui-sref=\"app.collection({\'categoryName\' : \'customisable_products\'})\"><md-icon>open_in_new</md-icon><span>Get Started</span></md-button></div></div>");
$templateCache.put("app/modules/base/directives/hand-embroidery-badge/hand-embroidery.html","<section ng-class=\"{\'shown\' : shown}\" class=\"hand-embroidery-badge-container\" layout=\"\" layout-align=\"center center\"><div class=\"hand-embroidery-badge md-whiteframe-4dp\"><span>Hand Embroidered</span></div></section>");
$templateCache.put("app/modules/base/directives/new-arrivals/index.html","<div layout=\"\" layout-xs=\"column\" class=\"new-arrivals\"><section layout=\"column\" layout-align=\"center center\" flex-gt-xs=\"65\" flex-offset-gt-xs=\"5\" class=\"info-section\"><h2 class=\"bold-text new-arrivals-text\" ng-class=\"{\'md-display-1 small\' : isSmall, \'md-display-3\' : !isSmall}\"><span>For the Love of Solids</span></h2><div layout=\"\" layout-align=\"center center\"><md-button class=\"shop-now-button\" ui-sref=\"app.collection({\'categoryName\' : \'new_arrivals\'})\">Shop Now</md-button></div></section><section class=\"image-section\" layout=\"\" layout-align=\"center center\" ng-class=\"{\'small\' : isSmall}\"><img src=\"assets/images/home/solids.jpg\" alt=\"new-arrivals\"></section></div>");
$templateCache.put("app/modules/base/directives/templates/aadiraCard.tpl.html","<div class=\"card\"><div class=\"card-content\"><ng-transclude></ng-transclude></div></div>");
$templateCache.put("app/modules/base/directives/templates/mdCarousel.tpl.html","<div><div flex=\"\" layout=\"column\" ng-if=\"drawn\" ng-style=\"{\'margin\': padding ? padding : \'16px\'}\" style=\"position:relative; transition:transform 1s ease-in-out; overflow: hidden;\"><div layout=\"row\" ng-style=\"style\"><md-card ng-repeat=\"item in data\" ng-style=\"{\'max-width\': singleItemWidth + \'px\', \'transition\': \'transform 0.5s ease-in-out\', \'min-width\': singleItemWidth + \'px\', \'padding\': 0, \'max-height\': itemHeight + \'px\', \'min-height\': itemHeight + \'px\', \'transform\': \'translateX(-\' + margin_left + \'px)\'}\"><div layout=\"\" ng-transclude=\"\" ng-style=\"{\'height\': itemHeight + \'px\'}\"></div></md-card></div><div style=\"position: absolute; left: 0; line-height: {{ itemHeight }}px; height: 25px; vertical-align: middle;\"><a md-whiteframe=\"8\" style=\"max-height: 25px; position: relative; max-width: 50px; background: white; cursor: pointer; padding: 25px 5px 25px 5px;\" ng-click=\"controlSlider(\'previous\');\" md-ink-ripple=\"\" ng-if=\"margin_left != 0\" class=\"md-raised\"><md-icon md-svg-src=\"assets/images/previous.svg\"></md-icon></a></div><div style=\"position: absolute; right: 0; line-height: {{ itemHeight }}px; height: {{ itemHeight }}px; vertical-align: middle;\"><a md-whiteframe=\"8\" style=\"max-height: 25px;position: relative; max-width: 50px; background: white; cursor: pointer; padding: 25px 5px 25px 5px;\" md-ink-ripple=\"\" ng-click=\"controlSlider(\'next\');\" ng-if=\"margin_left <= totalMarginLeft\" class=\"md-raised\"><md-icon md-svg-src=\"assets/images/next.svg\"></md-icon></a></div></div><div ng-if=\"!drawn\" layout=\"\" layout-fill=\"\" layout-align=\"center center\" style=\"min-height: 200px;\"><md-progress-circular></md-progress-circular></div></div>");
$templateCache.put("app/modules/base/directives/templates/mdImageGallery.tpl.html","<section class=\"relative gallery-slider\" md-swipe-left=\"moveRight(\'swipe\', $event)\" md-swipe-right=\"moveLeft(\'swipe\', $event)\" ng-style=\"{\'visibility\' : startRendering? \'shown\' : \'hidden\'}\"><div layout=\"row\" class=\"slider-image-scroller\" ng-style=\"{\'width\' : totalWidth + \'px\', \'min-width\' : totalWidth + \'px\', \'transform\' : \'translateX(\' + moveX + \'px)\'}\"><div flex=\"\" flex-order-gt-sm=\"1\" flex-order-sm=\"-1\" layout=\"\" layout-align=\"center center\" class=\"slider-image-container\" ng-class=\"{\'zoom-pointer\' : showZoomCursor}\" ng-style=\"{\'width\' : containerWidth + \'px\'}\" ng-repeat=\"image in images track by $index\" attr=\"{{image}}\" ng-click=\"onImageClick({event : $event})\" flex-order-xs=\"-1\"><img ng-src=\"{{ mediaUrl + image.urls[image.imageSize] }}\" ng-mousemove=\"onMouseMove({event : $event})\" ng-style=\"{\'width\' : width + \'px\', \'height\' : height + \'px\', \'background-color\' : image.swatch.css}\" ng-mouseleave=\"onMouseOut({event : $event})\" style=\"width: 100%;\"></div></div><div class=\"indicators bottom-indicator\" layout=\"row\" ng-if=\"images.length > 1\" layout-align=\"center center\" ng-style=\"{\'bottom\' : isSmall ? \'6px\' : \'-6px\'}\"><div layout=\"\"><md-icon ng-class=\"{\'active\' : $index === selectedIndex}\" ng-click=\"selectImage(image, $index, $event)\" ng-repeat=\"image in images track by $index\" class=\"pointer indicator-icon\">lens</md-icon></div></div><div layout=\"\" ng-if=\"images.length > 1\" layout-align=\"center center\" class=\"control-button left-arrow\"><md-button class=\"md-fab md-primary md-mini\" ng-click=\"moveLeft(\'button\', $event);\"><md-icon>keyboard_arrow_left</md-icon></md-button></div><div layout=\"\" ng-if=\"images.length > 1\" layout-align=\"center center\" class=\"control-button right-arrow\"><md-button class=\"md-fab md-primary md-mini\" ng-click=\"moveRight(\'button\', $event);\"><md-icon>keyboard_arrow_right</md-icon></md-button></div></section>");
$templateCache.put("app/modules/base/directives/templates/mdSlider.tpl.html","<div layout=\"\" layout-fill=\"\" class=\"slider\" ng-style=\"{\'height\': heightPx}\" md-swipe-left=\"onSwipeLeft();\" md-swipe-right=\"onSwipeRight();\"><div class=\"swap-animation image hide pointer\" ng-animate-swap=\"currentItem\" ng-class=\"{\'show\' : $index === currentItem}\" ng-repeat=\"src in srcList track by $index\" ng-style=\"{\'background\': \'url(\' + getUrl(src.image.urls.full) + \')\'}\"></div><section ng-if=\"controls\"><div layout=\"\" layout-align=\"center center\" class=\"control-button left-arrow\"><md-button class=\"md-fab md-primary md-mini\" ng-click=\"previous();\"><md-icon>keyboard_arrow_left</md-icon></md-button></div><div layout=\"\" layout-align=\"center center\" class=\"control-button right-arrow\"><md-button class=\"md-fab md-primary md-mini\" ng-click=\"next();\"><md-icon>keyboard_arrow_right</md-icon></md-button></div></section><div flex=\"\" ng-repeat=\"src in srcList track by $index\" ng-class=\"getClass($index);\" ng-if=\"$index === currentItem\" layout=\"\" layout-padding=\"\" style=\"z-index: 3;margin: 64px;\"><div layout=\"column\" layout-align=\"center center\" class=\"swap-animation text\" ng-animate-swap=\"currentItem\"><span class=\"white-text center-text md-title\" style=\"font-weight: 700;\">{{ src.heading | uppercase }}</span> <span class=\"white-text\" ng-class=\"{\'md-title\' : !isSmall, \'md-body-1 center-text\' : isSmall}\">{{ src.text }}</span><md-button ng-if=\"src.button\" ui-sref=\"{{src.buttonSref}}\" style=\"margin-top: 24px;\" ng-style=\"src.buttonStyle\" class=\"md-raised\" ng-class=\"getButtonClass($index);\">{{ src.buttonText }}</md-button></div></div><div layout=\"row\" class=\"bottom-indicator\" layout-align=\"center center\" ng-if=\"!hideIndicator\"><div layout=\"\"><md-icon ng-class=\"{\'active\' : $index === currentItem}\" ng-click=\"change($index);\" ng-repeat=\"i in srcList track by $index\" class=\"pointer indicator-icon\">lens</md-icon></div></div><a ng-style=\"{\'background\' : overlay ? rgba(1,1,1,0.2) : \'\'}\" ng-href=\"{{buildUrl();}}\" class=\"overlay-link\" ng-if=\"fullLink || overlay\"></a></div>");
$templateCache.put("app/modules/base/directives/templates/spinWheel.tpl.html","<div layout=\"column\" layout-padding=\"\" flex=\"\"><div class=\"relative\" ng-show=\"!contestComplete\"><img id=\"circle\" src=\"assets/images/spinwheel-contest/spinwheel.svg\"><div style=\"position: absolute; top: 30%; bottom: 35%; left: 30%; right: 30%;\" layout=\"\" layout-align=\"center center\"><img src=\"assets/images/spinwheel-contest/arrow.svg\"></div></div><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-if=\"!contestComplete\" style=\"height: 44px; width: 150px; line-height: 44px; border-radius:32px;\" ng-click=\"spin();\" ng-disabled=\"spinning;\">{{tries === 0 ? \"Spin Now\" : \"Spin Again\"}}</md-button></div><div class=\"md-padding\" layout=\"\" layout-align=\"center center\"><section ng-repeat=\"coupon in coupons\" id=\"cp{{coupon.chance + \'-\'+ coupon.coupon}}\" flex=\"33\" layout=\"column\" layout-align=\"center center\" class=\"relative\" style=\"margin: 0 4px;\"><span class=\"md-caption white-text center-text\">Attempt {{coupon.chance + 1}}</span> <img src=\"assets/images/spinwheel-contest/discount.svg\"><div layout=\"column\" layout-align=\"center center\" style=\"position: absolute; top: 0; bottom: 0; left: 0; right: 0; margin: 8px;\"><span class=\"md-title bold-text\" style=\"color: #40596B; margin-bottom: 10px; margin-left: 3px;\">{{coupon.coupon}}%</span></div></section></div></div>");
$templateCache.put("app/modules/base/directives/testimonials/testimonials.tmpl.html","<div class=\"testimonials\"><h2 class=\"center-text title\">Customers Speak</h2><section style=\"overflow: hidden\"><div class=\"slider-container\"><section class=\"single-testimonial-item\" layout=\"\"><md-card class=\"testimonial-card\" flex=\"\"><md-card-content layout=\"column\"><p class=\"md-body-1 description\"><i>{{selectedTestimonial.description}}</i></p><div class=\"caption\" layout=\"column\" layout-align=\"center end\"><h5 class=\"md-body-1 montserrat no-margin\">{{selectedTestimonial.title}}</h5><p class=\"md-body-1 subtitle\">{{selectedTestimonial.subtitle}}</p></div><span flex=\"\"></span><div layout=\"row\" layout-align=\"space-between center\" class=\"links\"><md-button target=\"_blank\" ng-show=\"selectedTestimonial.productLink\" class=\"md-link\" href=\"{{selectedTestimonial.productLink}}\"><span>View Product</span></md-button><span ng-show=\"!selectedTestimonial.productLink\" flex=\"\"></span><md-button class=\"md-link\" target=\"_blank\" href=\"{{selectedTestimonial.link}}\"><span>Read More</span></md-button></div></md-card-content></md-card><section class=\"testimonial-image\" flex=\"\" ng-style=\"{\'background\': \'url(\' + selectedTestimonial.image + \')\'}\"></section></section></div><div class=\"testimonial-images\" layout=\"\" layout-align=\"center center\"><div class=\"testimonial-outline-image pointer\" ng-click=\"selectTestimonial(testimonial)\" ng-class=\"{\'active\' : selectedTestimonial.id === testimonial.id}\" ng-repeat=\"testimonial in testimonials\" ng-style=\"{\'background\': \'url(\' + testimonial.image + \')\'}\"></div></div></section></div>");
$templateCache.put("app/modules/base/directives/whatsapp-button/whatsapp-button.html","<md-button class=\"md-icon-button\" ng-href=\"{{url}}\" target=\"_blank\"><md-icon md-svg-src=\"{{iconSrc}}\"></md-icon><md-tooltip>Aarida Support on WhatsApp</md-tooltip></md-button>");
$templateCache.put("app/modules/customisation/directives/templates/cp-view.tpl.html","<div class=\"preview-container\" ng-style=\"style\"><div class=\"center black-text\" ng-show=\"!customisation.baseImage.urls\"></div><div class=\"preview\" alt=\"customisation.pattern\" ng-show=\"customisation.data[0].preview && customisation.data[0].name === \'Fabric\'\" style=\"background-size: {{backgroundScale}}; background: url(\'{{ selectedIndex != 0 ? mediaUrl +customisation.data[0].default.image.urls[key] : mediaUrl +customisation.data[0].options[currentIndex].image.urls[key]}}\') {{position}};\"></div><div class=\"preview\" alt=\"customisation.baseImage\" data-layer=\"Base Image\" ng-show=\"customisation.baseImage.urls\" style=\"background: url(\'{{ mediaUrl +customisation.baseImage.urls[key] }}\') {{position}}; background-size: {{backgroundScale}};\"></div><div class=\"preview\" data-layer=\"{{layer.name}}\" data-default=\"{{layer.default.name}}\" ng-repeat=\"layer in customisation.data | limitTo: getLimit()\" alt=\"{{ layer.name + \'-\'+ $index}}\" ng-show=\"layer.default.image.urls && layer.preview && previewsData[$index]\" style=\"background-image: url(\'{{ (selectedIndex) != $index ? (mediaUrl + layer.default.image.urls[key]) : (mediaUrl +customisation.data[selectedIndex].options[currentIndex].image.urls[key])}}\'); background-position: {{position}}; background-size: {{backgroundScale}};\"></div><div class=\"preview\" ng-show=\"!layer.preview\" data-layer=\"{{layer.name}}\" data-default=\"{{layer.default.name}}\" ng-init=\"layer = customisation.data[selectedIndex]\" alt=\"{{ layer.name + \'-\'+ currentIndex}}\" style=\"background: url(\'{{ mediaUrl +layer.options[currentIndex].image.urls[key]}}\') {{position}}; background-size: cover;\"></div></div>");
$templateCache.put("app/modules/customisation/directives/templates/cp.tpl.html","<div class=\"cp-container\" ng-style=\"style\" md-whiteframe=\"{{ whiteFrameValue }}\" id=\"{{ name }}\"><div class=\"center black-text\" ng-show=\"!customisation.baseImage.urls\"><img ng-src=\"{{ mediaUrl + fallback }}\" alt=\"Fallback Image\" ng-if=\"fallback\"></div><div class=\"viewer\"><img ng-src=\"{{ mediaUrl +customisation.data[0].default.image.urls[key] }}\" alt=\"Non Base Image\" ng-if=\"customisation.data[0].default.image.urls && customisation.data[0].preview && customisation.data[0].name === \'Fabric\'\"></div><div class=\"viewer\"><img ng-src=\"{{ mediaUrl +customisation.baseImage.urls[key] }}\" alt=\"Base Image\" ng-if=\"customisation.baseImage.urls\"></div><div class=\"viewer\" ng-if=\"customisation.data[0].name === \'Fabric\'\" ng-repeat=\"layer in customisation.data | limitTo: (1 - customisation.data.length)\"><img class=\"fade-image\" ng-src=\"{{ mediaUrl +layer.default.image.urls[key] }}\" alt=\"Fabric Layer\" ng-if=\"layer.default.image.urls && layer.preview\"></div><div class=\"viewer\" ng-if=\"customisation.data[0].name !== \'Fabric\'\" ng-repeat=\"layer in customisation.data\"><img class=\"fade-image\" ng-src=\"{{ mediaUrl +layer.default.image.urls[key] }}\" alt=\"Non Fabric Layer\" ng-if=\"layer.default.image.urls && layer.preview\"></div></div>");
$templateCache.put("app/modules/customisation/partials/sub-partials/bottom-toolbar.html","<md-toolbar class=\"bottom-toolbar\" ng-class=\"{screenIsSmall : \'mobile-fixed-footer\'}\" layout=\"row\" layout-padding=\"\" layout-align=\"center center\"><span class=\"md-title\" flex=\"\">{{ product.name }} :</span> <span flex=\"15\" class=\"md-caption\">Base Price - ₹{{ product.customisation.basePrice }}</span> <span ng-repeat=\"data in product.customisation.data\" flex=\"\" class=\"md-caption\">{{ data.name }} : {{ data.options[data.default].price ? \"₹\" + data.options[data.default].price : \"Free\" }}</span> <span flex=\"15\" class=\"md-subhead\">Total - ₹{{ totalPrice }}</span><md-button flex=\"\" ng-click=\"addToCart();\" class=\"md-raised md-accent md-hue-1\">Add To Cart</md-button></md-toolbar>");
$templateCache.put("app/modules/customisation/partials/sub-partials/data.html","<div layout=\"row\" style=\"padding: 10px 0px; margin-left: -44px;\"><div class=\"action-btn\" ng-repeat=\"datum in product.customisation.data track by $index\" layout=\"row\"><md-button md-ink-ripple=\"false\" ng-click=\"selectData(datum, $index);\" ng-class=\"{\'md-primary active bold-text\' : selectedData._id === datum._id}\" layout=\"\" layout-align=\"center center\" class=\"md-no-ripple\"><span class=\"md-body-1\" style=\"font-weight: inherit; font-size: 10px\">{{$index + 1}}.{{datum.name}}</span></md-button></div></div>");
$templateCache.put("app/modules/customisation/partials/sub-partials/desktop-editor.html","<section layout=\"column\" flex=\"100\"><div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\" flex=\"\" layout-align=\"center start\"><div flex-sm=\"25\" class=\"options-container\" flex=\"\" flex-order=\"1\" static-include=\"app/modules/customisation/partials/sub-partials/options.html\"></div><div flex=\"\" flex-gt-sm=\"\" flex-order-gt-sm=\"1\" flex-order=\"-1\" layout-align=\"center center\" layout-align-gt-sm=\"center center\" class=\"relative cp-preview-container\" layout=\"\" ng-style=\"{\'margin-top\' : isSmall ? \'auto\' : \'10px\'}\"><customisable-product size=\"responsive\" white-frame=\"false\" fallback=\"{{product.featured_image.urls.large}}\" name=\"customisable-main\" customisation=\"product.customisation\"></customisable-product><section class=\"loading-overlay\" ng-show=\"showLoader\" layout=\"\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\"></md-progress-circular></section></div><section flex=\"35\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div layout=\"column\" class=\"md-padding\"><div layout=\"row\" layout-align=\"start center\"><h2 style=\"line-height: 1.5em\" class=\"montserrat bold-text no-margin no-padding\" flex=\"\">{{ product.name}}</h2></div><section layout=\"\" layout-align=\"start center\" style=\"padding: 8px 0\"><span class=\"md-body-1 grey-text\">SKU : {{product.sku}}</span></section><ul><li ng-repeat=\"attributeData in product.attributes\" ng-if=\"attributeData.featured || isAHotAttribute(attributeData.attribute)\"><span class=\"md-caption grey-text\">{{attributeData.attribute.meta_key}} -</span> <span class=\"md-body-2 bold-text\" ng-repeat-start=\"meta_value in attributeData.selectedValues\">{{ meta_value.value }}</span> <span class=\"md-body-2 bold-text\" ng-repeat-end=\"\" ng-if=\"!$last\">,</span></li></ul><md-divider></md-divider><div layout=\"\" layout-align=\"start center\"><span class=\"md-tiny grey-text\" style=\"margin-right: 20px;\">Total Price</span><section layout=\"\" layout-align=\"center center\" style=\"background: url(\'assets/images/rounded-border.svg\') no-repeat center center;\"><span style=\"min-width: 100px;\" class=\"bold-text md-headline md-padding\">₹ {{ totalPrice }}</span></section></div><md-divider></md-divider><div layout=\"row\"><section flex=\"\" layout=\"\" layout-align=\"center center\" ng-if=\"product.outOfStock\" class=\"md-padding\"><span class=\"md-title red-text center-text\">Out of Stock</span></section></div><div ng-if=\"!isUserData\"><custom-measurement size-chart=\"product.sizeChart\" product=\"product\" uc-data=\"ucData\" on-added=\"onAddToCart(data)\" return-data=\"true\" ctx=\"ctx\" variations=\"product.variations\" open-edit-view=\"openEditView\" selected-variation=\"null\"></custom-measurement></div><div layout=\"column\" layout-align=\"center center\" style=\"margin-top: 30px; margin-bottom: 30px;\" ng-if=\"isUserData\"><md-button style=\"width: 75%\" class=\"md-raised md-accent large-btn\" ng-click=\"openCart()\"><md-icon class=\"productSizeBtn\" md-svg-icon=\"assets/images/basket.svg\"></md-icon><span class=\"md-caption\" style=\"font-weight: bold;\">View Cart</span></md-button><span class=\"md-caption md-warn\">Changes will be saved automatically</span><div layout=\"row\" layout-align=\"center center\" layout-padding=\"\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"12\" flex=\"20\" ng-show=\"savingData\"></md-progress-circular><span class=\"center-text md-body-1 bold-text md-accent\">{{ savingData ? \'Saving\' : \'All changes saved\' }}</span></div></div><div layout=\"row\" ng-if=\"saving\"><md-progress-circular md-diameter=\"40\" md-mode=\"indeterminate\"></md-progress-circular><span>Adding product to cart</span></div></div></section></div></section><md-card ng-if=\"!everythingLoaded\"><md-card-content style=\"min-height: 50vh;\" layout=\"column\" layout-margin=\"\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\"></md-progress-circular><span>Loading the editor ...</span> <img src=\"assets/images/aadira-logo.svg\"></md-card-content></md-card>");
$templateCache.put("app/modules/customisation/partials/sub-partials/mobile-editor.html","<div class=\"customisation-editor-mobile-main-content\" device-detector=\"\" layout=\"column\"><div class=\"main-mobile-editor-area\" flex=\"\" layout=\"column\"><div class=\"image-browser relative\" flex=\"\" layout=\"\" layout-align=\"center center\"><customisable-product size=\"responsive\" flex=\"\" white-frame=\"false\" ng-show=\"!showGallery\" is-mobile=\"isSmall\" fallback=\"{{product.featured_image.urls.large}}\" name=\"customisable-main\" customisation=\"product.customisation\"></customisable-product><md-image-gallery gallery=\"product.gallery\" image-size=\"imageSize\" selected-index=\"0\" ng-show=\"showGallery\" on-image-click=\"openFullScreenZoomer(event)\" on-selection-change=\"changeSelectedImage(image)\" selected=\"product.featured_image\"></md-image-gallery><div class=\"gallery-switcher layout-column layout-align-start-start\"><md-button class=\"md-accent md-hue-1 md-fab\" ng-class=\"{\'active\' : showGallery}\" ng-click=\"toggleGallery(true); hideOnboarding()\" aria-label=\"Add a category\"><md-icon>photo_library</md-icon></md-button><md-button class=\"md-accent md-hue-1 md-fab\" ng-class=\"{\'active\' : !showGallery}\" ng-click=\"toggleGallery(false); hideOnboarding()\" aria-label=\"Add a category\"><md-icon md-svg-src=\"assets/images/dress.svg\">photo</md-icon></md-button></div><section class=\"loading-overlay\" ng-show=\"showLoader\" layout=\"\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\"></md-progress-circular></section></div><section class=\"product-info\"><md-card class=\"customisation-card\"><md-card-content><p class=\"center-text allura md-headline\">Customise this product</p><section class=\"relative layer-options-container\"><div class=\"options-selector\" ng-repeat=\"datum in product.customisation.data\" ng-init=\"parentIndex = $index\" ng-class=\"{\'shown\' : optionsLayerActive, \'slow\' : !initComplete}\"><div class=\"layer-header pointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"toggleSection(datum)\"><span class=\"bold-text montserrat layer-title\">Select {{datum.name}}</span><div layout=\"\" layout-align=\"center center\" class=\"expanded-icon\"><md-icon>{{datum.expanded ? \'keyboard_arrow_up\' : \'keyboard_arrow_down\'}}</md-icon></div></div><div layout=\"\" class=\"scroll-container\" ng-class=\"{\'expanded\' : datum.expanded}\"><section style=\"min-width: 130px\" class=\"relative pointer md-margin option-item\" ng-click=\"updateLayer(option, $index, parentIndex)\" ng-class=\"{\'active\': datum.default._id === option._id, \'disabled\' : option.disabled}\" ng-repeat=\"option in datum.options\"><customisable-product-view ng-if=\"datum.name !== \'Fabric\'\" size=\"thumbnail-2x\" md-ink-ripple=\"\" selected-index=\"parentIndex\" current-index=\"$index\" background-scale=\"getBackgroundScale(datum)\" position=\"getSelectedPosition(datum);\" customisation=\"product.customisation\"></customisable-product-view><div class=\"selected-attribute\" ng-class=\"{\'active\': datum.default._id === option._id}\" layout=\"\" layout-align=\"space-around center\"><md-icon md-svg-src=\"assets/images/checked.svg\"></md-icon><span class=\"selection-text montserrat\">SELECTED</span></div><div layout=\"\" layout-align=\"space-between center\" class=\"option-info\" data-json=\"{{option.stockAndPrice}}\"><span class=\"md-tiny layer-option-name\">{{option.name}}</span> <span class=\"layer-option-price bold-text md-body-1\">{{option.stockAndPrice.price.salePrice ? \'+ ₹ \' + option.stockAndPrice.price.salePrice : \'Free\'}}</span></div></section></div></div><div class=\"options-selector\"><div class=\"layer-header pointer\" layout=\"\" layout-align=\"space-between center\"><span class=\"bold-text montserrat layer-title\">Product Price</span></div><product-price total-price=\"totalPrice\" product=\"product\"></product-price></div><div class=\"options-selector\" ng-if=\"!isUserData\"><div class=\"layer-header pointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"sizeExpanded !== !sizeExpanded\"><span class=\"bold-text montserrat layer-title\">Select Size</span></div><custom-measurement size-chart=\"product.sizeChart\" product=\"product\" uc-data=\"ucData\" on-added=\"onAddToCart(data)\" return-data=\"true\" ctx=\"ctx\" variations=\"product.variations\" open-edit-view=\"openEditView\" selected-variation=\"null\"></custom-measurement></div><div layout=\"column\" layout-align=\"center center\" style=\"margin-top: 30px; margin-bottom: 30px;\" ng-if=\"isUserData\"><span class=\"md-subhead md-warn\">Changes will be saved automatically.</span><div layout=\"row\" layout-align=\"center center\" layout-padding=\"\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"12\" flex=\"20\" ng-show=\"savingData\"></md-progress-circular><span class=\"center-text md-title green-text bold-text md-accent\">{{ savingData ? \'Saving\' : \'All changes saved.\' }}</span></div><md-button style=\"width: 75%\" class=\"md-raised md-accent large-btn\" ng-click=\"openCart()\"><md-icon class=\"productSizeBtn\" md-svg-icon=\"assets/images/basket.svg\"></md-icon><span class=\"md-caption\" style=\"font-weight: bold;\">View Cart</span></md-button></div><div layout=\"row\" ng-if=\"saving\"><md-progress-circular md-diameter=\"40\" md-mode=\"indeterminate\"></md-progress-circular><span>Adding product to cart</span></div></section></md-card-content></md-card><product-overview total-price=\"totalPrice\" product-loaded=\"productLoaded\" product=\"product\" ng-if=\"!isUserData\"></product-overview><div layout=\"\" layout-align=\"stretch center\" ng-if=\"!isUserData\"><md-button class=\"md-accent md-raised md-hue-1 large-btn\" flex=\"\" ng-click=\"openCustomMeasurements($event)\"><span>Add to Cart</span><md-icon>arrow_right_alt</md-icon></md-button></div><shipping-box product=\"product\" ng-if=\"!isUserData\"></shipping-box><product-details product=\"product\" ng-if=\"!isUserData\"></product-details><customisation-process hide-get-started=\"true\" ng-if=\"!isUserData\"></customisation-process><aarida-testimonials></aarida-testimonials></section></div><div class=\"scroll-top-button layout-row layout-align-center-center\"><md-button class=\"md-accent md-raised\" ng-show=\"showPreviewButton\" ng-click=\"scrollToTop();\" aria-label=\"Add a category\"><md-icon>keyboard_arrow_up</md-icon><span>See Preview</span></md-button></div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"onboardingGuide\"><md-dialog class=\"onboarding-guide\"><md-dialog-content><md-button class=\"md-icon-button close-button md-fab md-mini\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button><div class=\"gallery-switcher layout-column layout-align-start-start\"><md-button aria-label=\"Add a category\" class=\"md-accent md-hue-1 md-fab\" ng-class=\"{\'active\' : showGallery}\" ng-click=\"toggleGallery(true); hideOnboarding()\"><md-icon>photo_library</md-icon></md-button><md-button aria-label=\"Add a category\" class=\"md-accent md-hue-1 md-fab\" ng-class=\"{\'active\' : !showGallery}\" ng-click=\"toggleGallery(false); hideOnboarding()\"><md-icon md-svg-src=\"assets/images/dress.svg\">photo</md-icon></md-button></div><img class=\"guide-image\" src=\"assets/images/right-drawn-arrow.svg\"><div class=\"content md-padding\" flex=\"\" layout=\"column\" layout-align=\"center center\"><md-icon class=\"hint\">info</md-icon><p class=\"info-text\">Toggle between the product actual images and customisation preview image using these buttons.</p><md-button class=\"md-raised round medium\" ng-click=\"hideOnboarding()\">I understand</md-button><span class=\"object\"></span></div></md-dialog-content></md-dialog></div></div><div style=\"visibility: hidden\" ng-if=\"productLoaded\"><div class=\"md-dialog-container\" id=\"imageBoxDialog\"><md-dialog flex=\"100\" style=\"height: 100vh; position: relative;\"><md-dialog-content><section layout=\"column\"><div flex=\"\" layout=\"\" layout-align=\"center center\" style=\"position: relative;\" ng-click=\"toggleZoomer()\"><img ng-src=\"{{ mediaUrl + modalImage.urls.full }}\" alt=\"{{modalImage.urls.full}}\" id=\"showcaseImage\" on-image-load=\"hideProgress()\"><div style=\"position: absolute; top: 200px;\" ng-if=\"zoomProgressLoader\"><md-progress-circular class=\"md-accent\" md-diameter=\"30\"></md-progress-circular></div></div></section></md-dialog-content><div style=\"position: absolute; top: 0; width: 100%; height: 64px;\"><section class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"cancel();\"><md-icon>keyboard_arrow_left</md-icon>Back</md-button><md-button class=\"md-icon-button\" ng-click=\"cancel();\"><md-icon>close</md-icon></md-button></section></div><div layout=\"row\" class=\"md-padding\" flex=\"\" layout-align=\"center center\" layout-padding=\"\" style=\"background: rgba(1,1,1,0.1); position: absolute; bottom: 0; width: 100%;\"><section ng-repeat=\"image in product.gallery\" class=\"image-thumbnail\" style=\"width: 100px; height: auto; position: relative;\"><md-img md-src=\"{{ image.urls.thumbnail }}\" ng-click=\"selectModalImage(image);\" md-ink-ripple=\"\" md-colors=\"{\'borderColor\' : modalImage === image ? \'awesome-accent-500-1\' : \'awesome-accent-50-0.1\'}\" style=\"outline: none; cursor: pointer; position: relative; width: 100%; height: auto; border: 2px solid;\"></md-img></section></div></md-dialog></div></div>");
$templateCache.put("app/modules/customisation/partials/sub-partials/options.html","<div layout=\"column\" style=\"max-height: calc(100vh - 48px);\"><div ng-if=\"selectedData.name == \'Fabric\'\" layout=\"row\" hide=\"\"><div flex=\"33\" style=\"background: white;\" layout=\"\"><md-input-container md-no-float=\"\" style=\"height: 44px; margin: 0;\" flex=\"\"><input type=\"search\" ng-model=\"user.title\" placeholder=\"Search Patterns\" style=\"height: 40px;\"></md-input-container></div></div><md-content style=\"height: 70vh;\" class=\"md-margin\"><md-subheader layout=\"\" layout-align=\"center center\"><span class=\"center-text\">Select {{product.customisation.data[(app.selectedIndex)].name}}</span></md-subheader><md-divider <md-list=\"\"><md-list-item class=\"desktop-option-item\" ng-repeat=\"option in selectedData.options\" ng-class=\"{\'disabled\' : option.disabled}\"><md-card flex=\"\" ng-class=\"{\'disabled\' : option.disabled}\"><div layout=\"\"><section flex=\"25\" style=\"position: relative;\"><customisable-product-view selected-index=\"app.selectedIndex\" current-index=\"$index\" class=\"md-media-sm card-media\" size=\"thumbnail-2x\" position=\"getSelectedPosition(selectedData);\" background-scale=\"getBackgroundScale(selectedData);\" customisation=\"product.customisation\"></customisable-product-view></section><section flex=\"\" layout=\"column\"><div class=\"md-padding\" layout=\"column\" layout-align=\"center center\"><span class=\"md-body-1\">{{ option.name ? option.name : \"Unnamed \" + product.customisation.data[(app.selectedIndex)].name}}</span><span class=\"md-title bold-text md-padding\">{{ getPrice(option.stockAndPrice);}}</span></div><span flex=\"\"></span><md-divider style=\"position: relative;\"></md-divider><md-card-actions layout=\"row\" layout-align=\"space-around center\"><md-button style=\"width: 200px; border: 1px solid currentColor; border-radius: 32px;\" ng-disabled=\"option.disabled\" ng-class=\"{\'md-accent md-raised no-border\' : selectedData.default._id === option._id}\" ng-click=\"updateLayer(option, $index);\"><div layout=\"\" layout-align=\"center center\"><section layout=\"\" layout-align=\"center center\" style=\"margin-right: 15px;\"><md-icon ng-if=\"selectedData.default._id === option._id\" md-svg-src=\"assets/images/success.svg\"></md-icon></section><span class=\"bold-text\">{{selectedData.default._id === option._id ? \"Applied\" : \"Apply\"}}</span></div></md-button></md-card-actions></section></div></md-card></md-list-item></md-divider></md-content><div layout=\"\" layout-align=\"space-between center\"><md-button ng-click=\"selectData(product.customisation.data[(app.selectedIndex-1)],app.selectedIndex-1)\" class=\"md-accent flex-40 aarida-stroked-button\" ng-if=\"app.selectedIndex !== 0\"><md-icon>keyboard_arrow_left</md-icon><span class=\"bold-text\">Back : Edit {{getPrevLayerName();}}</span></md-button><span flex=\"\"></span><md-button class=\"md-accent flex-40 aarida-stroked-button\" ng-if=\"product.customisation.data.length - 1 !== app.selectedIndex\" ng-click=\"selectData(product.customisation.data[(app.selectedIndex+1)],app.selectedIndex+1)\"><span class=\"bold-text\">Next : Edit {{getNextLayerName();}}</span><md-icon>keyboard_arrow_right</md-icon></md-button></div></div>");
$templateCache.put("app/modules/home/directives/instagram/instagram.tmpl.html","<div md-whiteframe=\"-1\" style=\"margin: 0; width: 100%;\" ng-class=\"{\'no-padding\' : isSmall}\"><div layout=\"column\" layout-align=\"center center\"><section layout=\"\" layout-align=\"center center\" style=\"margin: 20px\"><div layout=\"\" layout-align=\"center center\" style=\"padding: 0 8px;\"><md-icon md-svg-src=\"assets/images/instagram.svg\"></md-icon></div><span flex=\"\" class=\"montserrat bold-text\" ng-class=\"{\'md-title\' : !isSmall, \'md-body-1\' : isSmall}\">FOLLOW US ON INSTAGRAM</span></section><md-divider></md-divider></div><section layout=\"\" layout-align=\"center center\"><div layout=\"\" layout-wrap=\"\" flex-gt-sm=\"75\" flex=\"100\" ng-if=\"instafeedFetched\"><a flex-gt-md=\"20\" flex-md=\"20\" flex-sm=\"25\" flex-xs=\"50\" ng-href=\"{{feed.link}}\" ng-repeat=\"feed in instafeed\" target=\"_blank\"><md-card class=\"relative\" md-ink-ripple=\"\"><md-img md-src=\"{{feed.image.url}}\" class=\"md-card-image\"></md-img></md-card></a></div><div layout=\"column\" layout-align=\"center center\" layout-padding=\"\" ng-if=\"!instafeedFetched\"><md-progress-circular class=\"md-accent\" md-diameter=\"40\"></md-progress-circular><span class=\"md-caption grey-text\">Fetching Instagram Feed ...</span></div></section><div layout=\"\" layout-align=\"center center\"><md-button class=\"md-accent aarida-stroked-button aarida-rounded-btn\" href=\"https://www.instagram.com/aaridaFashion/\" target=\"_blank\">View More @aaridafashion</md-button></div></div>");
$templateCache.put("app/modules/static/promotions/partials/allPromotions.html","<div class=\"all-promotions-page\"><section layout=\"column\" layout-align=\"center center\" class=\"md-padding md-margin\"><h1>All Promotions</h1><p class=\"subtitle center-text\">Check out our Exciting Promotions</p></section></div>");
$templateCache.put("app/modules/static/promotions/partials/promotion.tmpl.html","<div class=\"promotions\"><section layout=\"column\" layout-align=\"center center\" class=\"md-padding md-margin\"><h1>Upcoming Collections</h1><p class=\"subtitle center-text\">Check out upcoming collections</p></section><section layout=\"\" layout-align=\"center center\" layout-wrap=\"\"><div layout=\"column\" layout-align=\"start center\" flex=\"25\" ng-repeat=\"collection in localCollections track by $index\" class=\"md-padding\"><img src=\"{{collection.image}}\"><p class=\"md-caption\">{{collection.name}}</p><p class=\"md-caption\">SKU: {{collection.sku}}</p><div layout=\"column\"><md-button class=\"md-accent medium outline md-block\" ng-click=\"upvote($index, collection)\"><span>Vote<md-icon class=\"md-accent\">arrow_drop_up</md-icon></span></md-button><md-button class=\"md-accent medium md-raised flat\" ng-if=\"!collection.preOrder\" ng-click=\"preOrder($index, collection)\"><span>Pre-Order for ₹ {{collection.price}}</span></md-button><p ng-if=\"collection.preOrder\">Pre Ordered</p></div></div></section><section layout=\"\" layout-align=\"center center\" class=\"md-padding\"><md-button class=\"md-accent md-raised\" ui-sref=\"app.all_promotions\">View All Active Promotions</md-button></section></div>");
$templateCache.put("app/modules/static/promotions/preOrderDialog/preOrderDialog.tmpl.html","<md-dialog flex=\"70\"><md-toolbar layout=\"row\" md-whiteframe=\"1\" class=\"md-toolbar-tools\" layout-align=\"center center\" ng-cloak=\"\"><span>Order Now</span> <span flex=\"\"></span><md-button ng-click=\"cancel();\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"\" layout-align=\"center center\" class=\"md-padding md-margin\"><img src=\"{{product.image}}\"><div layout=\"column\" layout-align=\"start center\" flex-offset=\"10\"><p class=\"md-caption\">{{product.name}}</p><p class=\"md-caption\">SKU: {{product.sku}}</p></div><div ng-repeat=\"\"></div></div></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=\"\" layout-align=\"center center\"><md-button class=\"md-warn md-raised\" ng-click=\"cancel()\">Cancel</md-button><span flex=\"\"></span><md-button class=\"md-accent md-raised\" ng-click=\"preOrder(product._id)\">Pre Order</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/static/promotions/voteProductDialog/voteProduct.tmpl.html","<md-dialog flex=\"70\"><md-toolbar layout=\"row\" md-whiteframe=\"1\" class=\"md-toolbar-tools\" layout-align=\"center center\" ng-cloak=\"\"><span>Vote Product</span> <span flex=\"\"></span><md-button ng-click=\"close();\" class=\"md-icon-button\"><md-icon>close</md-icon></md-button></md-toolbar><md-divider></md-divider><md-dialog-content><div layout=\"column\" layout-align=\"center center\"><div layout=\"\" layout-align=\"center center\"><p class=\"md-caption green-text\">You have up-voted this product successfully.</p></div><div layout=\"\" layout-align=\"center center\" style=\"width: 70%\" class=\"md-padding\"><img src=\"{{product.image}}\"><div layout=\"column\" layout-align=\"center center\" flex-offset=\"5\"><p class=\"md-caption\">{{product.name}}</p><p class=\"md-caption\">SKU: {{product.sku}}</p></div></div></div><div layout=\"\" layout-align=\"center center\"><md-input-container flex=\"80\"><label class=\"md-tiny\">Would you like to suggest a price for this product?</label> <input type=\"text\" placeholder=\"Suggested Price\" ng-model=\"suggestedPrice\" ng-change=\"saveSuggestedPrice(suggestedPrice)\"></md-input-container></div><div layout=\"column\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-click=\"preOrder()\">Pre Order</md-button><md-list><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><span class=\"md-tiny\">Lorem ipsum dolor sit amet</span></div></md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><span class=\"md-tiny\">consectetur adipiscing elit</span></div></md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><span class=\"md-tiny\">sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></div></md-list-item></md-list></div></md-dialog-content><md-divider></md-divider><md-dialog-actions layout=\"\" layout-align=\"end center\"><md-button class=\"md-warn md-raised\" ng-click=\"close()\">Cancel</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/modules/account/orders/directives/template/star-rating.html","<div layout=\"column\"><div class=\"col-md-12\" layout=\"\" layout-align=\"center center\"><div><md-button ng-repeat=\"star in stars\" class=\"md-icon-button rating-button\" ng-click=\"toggle($index)\"><md-icon class=\"md-accent rating-icon\">{{star.filled ? \'star\' : \'star_border\'}}</md-icon></md-button></div></div></div>");
$templateCache.put("app/modules/base/directives/product/add-to-wishlist-button/add-to-wishlist-button.html","<md-button class=\"md-icon-button\" ng-if=\"!isSmall\" ng-disabled=\"product.outOfStock\" ng-click=\"wishlistClick($event)\"><md-icon ng-class=\"{\'grey-text\' : product.outOfStock, \'pink-text\' : !product.outOfStock}\">{{product.inWishlist ? \'favorite\' : \'favorite_outline\'}}</md-icon></md-button>");
$templateCache.put("app/modules/base/directives/product/product-details/product-details.html","<div layout=\"column\"><md-divider></md-divider><div layout=\"\" layout-align=\"center center\"><p class=\"md-headline montserrat bold-text\">Product Details</p></div><div layout=\"column\" layout-align=\"center center\" class=\"overview-tab md-padding\" flex=\"\"><table class=\"product-attributes-table\"><tr ng-repeat=\"attribute in product.attributes\" ng-if=\"attribute.visible\"><th>{{attribute.attribute.meta_key}}</th><td><span ng-repeat-start=\"meta_value in attribute.selectedValues\">{{meta_value.value}}</span> <span ng-repeat-end=\"\" ng-if=\"!$last\">,</span></td></tr></table><div layout=\"column\" ng-repeat=\"attribute in imageAttributes\"><h4 class=\"center-text\">{{attribute.key}}</h4><div layout=\"\" layout-align=\"space-around stretch\" layout-wrap=\"\"><section layout=\"column\" class=\"image-attribute\" layout-align=\"start center\" ng-repeat=\"value in attribute.selectedValues\"><img class=\"attribute-image\" ng-src=\"{{mediaUrl + value.image.urls.thumbnail}}\" alt=\"{{value.value}}\"><p class=\"attribute-value md-caption center-text\">{{value.value}}</p></section></div></div><div ng-if=\"product.showDescription && product.description\"><div ng-bind-html=\"product.description\" class=\"scoped-product-description aarida-editor\"></div></div></div></div>");
$templateCache.put("app/modules/base/directives/product/product-overview/product-overview.html","<section class=\"product-overview\"><div layout=\"row\" layout-align=\"start center\"><h1 flex=\"\" ng-class=\"{\'md-title center-text\' : isSmall}\" class=\"montserrat bold-text md-headline\">{{ product.name }}</h1></div><section layout=\"\" ng-class=\"{\'layout-align-center-center\' : isSmall,\'layout-align-start-center\' : !isSmall }\"><span class=\"md-caption bold-text grey-text\" ng-class=\"{\'center-text\' : isSmall}\">SKU : {{product.sku}}</span></section><md-list ng-if=\"productLoaded && isSmall\" class=\"product-hot-attributes small\"><md-list-item ng-repeat-start=\"attributeData in product.attributes\" ng-if=\"attributeData.featured || isAHotAttribute(attributeData.attribute)\"><span class=\"md-body-2 bold-text\">{{attributeData.attribute.meta_key}}</span> <span class=\"md-caption md-secondary\">{{attributeData.valueText}}</span></md-list-item><md-divider class=\"md-accent\" ng-repeat-end=\"\" ng-if=\"(attributeData.featured || isAHotAttribute(attributeData.attribute))\"></md-divider></md-list><ul ng-if=\"productLoaded && !isSmall\" class=\"product-hot-attributes\"><li ng-repeat=\"attributeData in product.attributes\" ng-if=\"attributeData.featured || isAHotAttribute(attributeData.attribute)\"><span class=\"md-body-2 bold-text\">{{attributeData.attribute.meta_key}} :</span> <span class=\"md-body-2\">{{attributeData.valueText}}</span></li></ul><div class=\"md-padding\" ng-if=\"!productLoaded\" layout=\"\" layout-align=\"center center\"><md-progress-circular md-diameter=\"20\" class=\"md-accent\"></md-progress-circular></div><div ng-if=\"product.productType === 1\" class=\"made-to-order\" layout=\"column\" layout-align=\"center start\"><p class=\"allura md-headline title bold-text\">Made to order</p><span class=\"md-caption description\">This product will be tailored after the order has been placed. This ensures that we can make an outfit with the perfect fit for you while supporting the customisation options you opt-for. Processing time may vary.</span></div><product-price total-price=\"totalPrice\" product=\"product\"></product-price><div layout=\"row\"><section flex=\"\" layout=\"\" layout-align=\"center center\" ng-if=\"product.outOfStock\" class=\"md-padding\"><span class=\"md-title red-text center-text\">Out of Stock</span></section><section ng-if=\"!product.published\" layout=\"\" layout-align=\"center center\" layout-padding=\"\"><span class=\"md-title\">Coming Soon</span></section></div></section>");
$templateCache.put("app/modules/base/directives/product/product-price/product-price.html","<div layout=\"\" ng-class=\"{\'layout-align-center-center\' : isSmall,\'layout-align-start-center\' : !isSmall }\" class=\"price\"><p style=\"padding-top: 0; margin-right: 8px;\" class=\"center-text md-headline bold-text\">₹{{ totalPrice }}</p><s class=\"md-body-1 red-text bold-text\" ng-if=\"product.isOnSale\">₹{{product.mrp}}</s> <span class=\"discount bold-text\" ng-if=\"product.isOnSale\" ng-class=\"{\'md-caption\' : !isSmall, \'md-tiny\' : isSmall}\">( {{calculateDiscount(product.mrp, totalPrice)}}% off )</span><div md-whiteframe=\"1\" layout=\"\" layout-align=\"center center\" ng-if=\"product.isOnSale\" style=\"background: #1eba6a; margin-left: 10px; max-height: 24px;\"><span class=\"md-caption white-text bold-text md-padding\">SALE</span></div></div>");
$templateCache.put("app/modules/base/directives/product/shipping-box/shipping-box.html","<div layout=\"column\" class=\"md-padding shipping-box\"><form name=\"pinCodeForm\" layout=\"\" layout-align=\"start center\" ng-if=\"!delivery.fetched\"><md-input-container class=\"md-block md-primary no-error-spacer\" md-theme=\"black\"><label>Pin Code</label> <input name=\"postalCode\" ng-model=\"delivery.pinCode\" ng-disabled=\"checkingAvailability\" placeholder=\"123456\" required=\"\" ng-pattern=\"/^[0-9]{6}$/\" md-maxlength=\"6\"></md-input-container><md-button class=\"md-raised md-accent\" ng-disabled=\"pinCodeForm.$invalid || checkingAvailability\" ng-click=\"checkAvailability()\"><div layout=\"\" layout-align=\"center center\"><md-progress-circular class=\"md-accent\" ng-if=\"checkingAvailability\" md-diameter=\"20\"></md-progress-circular><span ng-if=\"!checkingAvailability\">Check</span></div></md-button></form><div layout=\"\" ng-if=\"delivery.pinCode && delivery.fetched\"><section layout=\"column\"><span><md-icon ng-class=\"{\'green-text\' : delivery.servicable, \'red-text\' : !delivery.servicable}\">{{delivery.servicable ? \'check_circle\' : \'close_circle\'}}</md-icon><span class=\"md-caption delivery-text\">{{delivery.servicable ? \'Delivers\' : \'Does not deliver\'}} to {{delivery.pinCode}}</span></span> <span><md-icon ng-class=\"{\'green-text\' : delivery.codAvailable, \'red-text\' : !delivery.codAvailable}\">{{delivery.codAvailable ? \'check_circle\' : \'close_circle\'}}</md-icon><span class=\"md-caption delivery-text\">Cash on Delivery {{delivery.codAvailable ? \'available\' : \' not available\'}}</span></span></section><md-button class=\"md-accent\" ng-click=\"delivery.pinCode = \'\'; delivery.fetched=false\">Change</md-button></div><ul layout=\"column\"><li class=\"shipping-info md-caption bold-text\"><strong ng-if=\"product.productType === 0\">Ships in 2 days</strong> <strong ng-if=\"product.productType === 1\">Ships in 6-12 days</strong></li><li class=\"shipping-info md-caption bold-text\">Free Shipping on orders above Rs 500</li><li class=\"shipping-info md-caption bold-text\">7 day returns when using Cash on Delivery</li><li class=\"shipping-info md-caption bold-text\">14 day returns when payment is done online</li></ul></div>");}]);